import { jsx as s, jsxs as x, Fragment as It } from "react/jsx-runtime";
import * as _ from "react";
import F, { forwardRef as m, useId as V1, useState as Q, useLayoutEffect as qo, useRef as ye, createContext as W1, useContext as j1, useCallback as _e, useEffect as je, isValidElement as Da, cloneElement as hs, useMemo as Hn, createRef as hr, Children as Po } from "react";
import * as Aa from "react-dom";
import { createPortal as gs } from "react-dom";
const ps = "rgb(4, 15, 236)", ms = "rgb(20, 29, 37)", vs = "rgb(36, 45, 53)", ws = "rgb(25, 35, 43)", bs = "rgb(25, 35, 43)", ys = "rgb(36, 45, 53)", Cs = "rgb(20, 29, 37)", xs = "rgb(10, 42, 33)", Ms = "rgb(54, 15, 20)", _s = "rgb(235, 236, 236)", Rs = "rgb(119, 123, 132)", Ss = "rgb(36, 45, 53)", ks = "rgb(47, 53, 61)", Ds = "rgba(255, 255, 255, 0.1)", As = "rgb(36, 45, 53)", Os = "rgb(47, 53, 61)", Ps = "rgb(67, 72, 78)", Ns = "rgb(235, 236, 236)", Es = "rgb(176, 180, 186)", Ls = "rgb(90, 97, 105)", zs = "rgb(235, 236, 236)", Ts = "rgb(73, 122, 246)", Is = "rgb(176, 180, 186)", Bs = "rgb(20, 29, 37)", $s = "rgb(67, 72, 78)", Hs = "rgb(235, 236, 236)", Fs = "rgb(20, 29, 37)", Vs = "rgb(235, 236, 236)", Ws = "rgb(235, 236, 236)", js = "rgb(4, 42, 208)", qs = "rgb(2, 31, 171)", Ys = "rgb(1, 23, 145)", Us = "rgb(176, 180, 186)", Ks = "rgb(73, 122, 246)", Gs = "rgb(4, 42, 208)", Js = "rgb(4, 42, 208)", Zs = "rgb(5, 44, 192)", Xs = "rgb(5, 44, 192)", Qs = "rgb(139, 180, 255)", e0 = "rgb(235, 236, 236)", t0 = "rgb(67, 72, 78)", n0 = "rgb(105, 110, 119)", o0 = "rgb(36, 45, 53)", r0 = "rgb(36, 45, 53)", a0 = "rgb(119, 123, 132)", i0 = "rgb(4, 42, 208)", s0 = "rgb(2, 32, 171)", l0 = "rgb(2, 31, 171)", c0 = "rgb(25, 35, 43)", d0 = "rgb(20, 29, 37)", u0 = "rgb(67, 72, 78)", f0 = "rgb(115, 119, 120)", h0 = "rgb(36, 45, 53)", g0 = "rgb(47, 53, 61)", p0 = "rgb(219, 50, 50)", m0 = "rgb(138, 52, 55)", v0 = "rgb(77, 13, 24)", w0 = "rgb(113, 36, 42)", b0 = "rgb(255, 143, 135)", y0 = "rgb(180, 70, 70)", C0 = "rgb(203, 29, 36)", x0 = "rgb(0, 170, 139)", M0 = "rgb(27, 216, 169)", _0 = "rgb(24, 86, 71)", R0 = "rgb(0, 158, 127)", S0 = "rgb(171, 126, 31)", k0 = "rgb(163, 117, 18)", D0 = "rgb(44, 33, 11)", A0 = "rgb(207, 154, 48)", O0 = "rgb(171, 126, 31)", P0 = "rgb(105, 110, 119)", N0 = "rgb(90, 97, 105)", E0 = "rgb(67, 72, 78)", L0 = "rgb(105, 110, 119)", z0 = "rgb(90, 97, 105)", T0 = "rgb(67, 72, 78)", I0 = "rgb(90, 97, 105)", B0 = "rgb(67, 72, 78)", $0 = "rgb(39, 126, 107)", H0 = "rgb(180, 70, 70)", F0 = "rgb(90, 97, 105)", V0 = "rgb(67, 72, 78)", W0 = "rgb(36, 45, 53)", j0 = "rgb(36, 45, 53)", q0 = "rgb(184, 138, 45)", Y0 = "rgb(171, 126, 28)", U0 = "rgb(12, 20, 28)", K0 = "rgb(20, 29, 37)", G0 = "rgba(0, 12, 21, 0.9)", J0 = "rgba(0, 12, 21, 0.6)", Z0 = "rgba(0, 12, 21, 0.85)", X0 = "rgb(12, 20, 28)", Q0 = "linear-gradient(-90deg, #1f293100 0%, #1f2931 25%, #1f2931 65%, #1f293100 100%)", el = "rgba(0, 12, 21, 0.3)", tl = "rgba(15, 27, 35, 0.2)", ty = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ColorAccentAlternative: s0,
  ColorAccentDefault: i0,
  ColorAccentDisabled: l0,
  ColorAccessoryAlternative: q0,
  ColorAccessoryContrast: Y0,
  ColorAccessoryDefault: F0,
  ColorAccessoryDefaultAlternative: V0,
  ColorAccessoryReduced: W0,
  ColorAccessoryReducedAlternative: j0,
  ColorActionPrimaryAlternative: Ks,
  ColorActionPrimaryAlternativeDisabled: Zs,
  ColorActionPrimaryAlternativeHovered: Qs,
  ColorActionPrimaryAlternativePressed: Js,
  ColorActionPrimaryAlternativePressedReduced: Gs,
  ColorActionPrimaryDefault: js,
  ColorActionPrimaryDefaultDisabled: Ys,
  ColorActionPrimaryDefaultHovered: Xs,
  ColorActionPrimaryDefaultPressed: qs,
  ColorActionPrimaryDisabledAlternative: Us,
  ColorActionSecondaryDefault: e0,
  ColorActionSecondaryDisabled: t0,
  ColorActionSecondaryDisabledAlternative: r0,
  ColorActionSecondaryHovered: a0,
  ColorActionSecondaryPressed: n0,
  ColorActionSecondaryPressedReduced: o0,
  ColorBackgroundAlternative: K0,
  ColorBackgroundDefault: U0,
  ColorBackgroundDimmedDefault: G0,
  ColorBackgroundDimmedReduced: J0,
  ColorBackgroundDimmedReducedAlternative: Z0,
  ColorBackgroundFixedDefault: X0,
  ColorBorderOnActionSecondaryDefault: P0,
  ColorBorderOnActionSecondaryDisabled: N0,
  ColorBorderOnControlDefault: z0,
  ColorBorderOnControlDisabled: T0,
  ColorBorderOnCriticalDefault: H0,
  ColorBorderOnInputActive: L0,
  ColorBorderOnInputDefault: E0,
  ColorBorderOnSelectedDefault: I0,
  ColorBorderOnSelectedDisabled: B0,
  ColorBorderOnSuccessDefault: $0,
  ColorButtonActive: ps,
  ColorContentDefault: Ns,
  ColorContentDisabled: Ls,
  ColorContentOnAccentDefault: Hs,
  ColorContentOnActionPrimaryDefault: zs,
  ColorContentOnActionPrimaryDisabled: Ts,
  ColorContentOnActionPrimaryDisabledAlternative: Is,
  ColorContentOnActionSecondaryDefault: Bs,
  ColorContentOnActionSecondaryDisabled: $s,
  ColorContentOnBackgroundFixedDefault: Ws,
  ColorContentOnContrastCriticalSuccessDefault: Fs,
  ColorContentOnContrastCriticalSuccessDefaultAlternative: Vs,
  ColorContentReduced: Es,
  ColorControlsAlternative: f0,
  ColorControlsDefault: u0,
  ColorControlsDisabled: h0,
  ColorControlsPressed: g0,
  ColorCriticalAlternative: w0,
  ColorCriticalContrast: b0,
  ColorCriticalDefault: p0,
  ColorCriticalDisabled: v0,
  ColorCriticalHovered: y0,
  ColorCriticalOnContrastDefault: C0,
  ColorCriticalPressed: m0,
  ColorInputDefault: c0,
  ColorInputDisabled: d0,
  ColorShadowDefault: el,
  ColorShadowReduced: tl,
  ColorShimmerDefault: Q0,
  ColorSuccessAlternative: _0,
  ColorSuccessContrast: M0,
  ColorSuccessDefault: x0,
  ColorSuccessOnContrastDefault: R0,
  ColorSurfaceContrastDefault: _s,
  ColorSurfaceContrastPressed: Rs,
  ColorSurfaceCritical: Ms,
  ColorSurfaceDefault: ms,
  ColorSurfaceDimmedDefault: Ds,
  ColorSurfaceHovered: bs,
  ColorSurfaceOverlayDefault: As,
  ColorSurfaceOverlayHovered: Os,
  ColorSurfaceOverlayPressed: Ps,
  ColorSurfacePressed: ys,
  ColorSurfacePressedAlternative: Cs,
  ColorSurfaceReduced: vs,
  ColorSurfaceReducedAlternative: ws,
  ColorSurfaceSelectedDefault: Ss,
  ColorSurfaceSelectedPressed: ks,
  ColorSurfaceSuccess: xs,
  ColorWarningAlternative: D0,
  ColorWarningContrast: A0,
  ColorWarningDefault: S0,
  ColorWarningOnContrastDefault: O0,
  ColorWarningPressed: k0
}, Symbol.toStringTag, { value: "Module" })), nl = "rgb(4, 15, 236)", ol = "rgb(255, 255, 255)", rl = "rgb(239, 240, 241)", al = "rgb(230, 232, 233)", il = "rgb(230, 232, 233)", sl = "rgb(239, 240, 241)", ll = "rgb(184, 188, 191)", cl = "rgb(225, 248, 240)", dl = "rgb(255, 235, 233)", ul = "rgb(0, 12, 21)", fl = "rgb(97, 100, 103)", hl = "rgb(250, 248, 245)", gl = "rgb(244, 241, 234)", pl = "rgba(0, 12, 21, 0.1)", ml = "rgb(255, 255, 255)", vl = "rgb(239, 240, 241)", wl = "rgb(230, 232, 233)", bl = "rgb(0, 12, 21)", yl = "rgb(97, 100, 103)", Cl = "rgb(184, 188, 191)", xl = "rgb(255, 255, 255)", Ml = "rgb(224, 233, 255)", _l = "rgb(255, 255, 255)", Rl = "rgb(255, 255, 255)", Sl = "rgb(184, 188, 191)", kl = "rgb(255, 255, 255)", Dl = "rgb(255, 255, 255)", Al = "rgb(255, 255, 255)", Ol = "rgb(255, 255, 255)", Pl = "rgb(5, 50, 255)", Nl = "rgb(141, 164, 239)", El = "rgb(230, 232, 233)", Ll = "rgb(4, 15, 236)", zl = "rgb(5, 50, 255)", Tl = "rgb(4, 15, 236)", Il = "rgb(193, 208, 255)", Bl = "rgb(141, 164, 239)", $l = "rgb(4, 15, 236)", Hl = "rgb(4, 15, 236)", Fl = "rgb(0, 12, 21)", Vl = "rgb(97, 100, 103)", Wl = "rgb(128, 131, 134)", jl = "rgb(184, 188, 191)", ql = "rgb(239, 240, 241)", Yl = "rgb(239, 240, 241)", Ul = "rgb(5, 50, 255)", Kl = "rgb(4, 15, 236)", Gl = "rgb(141, 164, 239)", Jl = "rgb(250, 248, 245)", Zl = "rgb(244, 241, 234)", Xl = "rgb(240, 236, 228)", Ql = "rgb(255, 255, 255)", ec = "rgb(221, 219, 211)", tc = "rgb(250, 248, 245)", nc = "rgb(216, 50, 50)", oc = "rgb(200, 30, 36)", rc = "rgb(246, 168, 160)", ac = "rgb(255, 235, 233)", ic = "rgb(209, 42, 44)", sc = "rgb(209, 42, 44)", lc = "rgb(216, 50, 50)", cc = "rgb(0, 170, 139)", dc = "rgb(0, 129, 101)", uc = "rgb(74, 187, 159)", fc = "rgb(225, 248, 240)", hc = "rgb(236, 191, 102)", gc = "rgb(242, 212, 153)", pc = "rgb(252, 247, 235)", mc = "rgb(188, 136, 32)", vc = "rgb(234, 183, 82)", wc = "rgb(184, 188, 191)", bc = "rgb(184, 188, 191)", yc = "rgb(221, 219, 211)", Cc = "rgb(209, 207, 197)", xc = "rgb(221, 219, 211)", Mc = "rgb(240, 236, 228)", _c = "rgb(221, 219, 211)", Rc = "rgb(240, 236, 228)", Sc = "rgb(74, 187, 159)", kc = "rgb(237, 142, 132)", Dc = "rgb(221, 219, 211)", Ac = "rgb(240, 236, 228)", Oc = "rgb(233, 230, 221)", Pc = "rgb(250, 248, 245)", Nc = "rgb(230, 170, 51)", Ec = "rgb(219, 159, 34)", Lc = "rgb(250, 248, 245)", zc = "rgb(255, 255, 255)", Tc = "rgba(0, 12, 21, 0.6)", Ic = "rgba(221, 219, 211, 0.4)", Bc = "rgba(255, 255, 255, 0.85)", $c = "rgb(0, 12, 21)", Hc = "linear-gradient(-90deg, #f0f0f100 0%, #f0f0f1 27.6%, #f0f0f1 65.63%, #f0f0f100 100%)", Fc = "rgba(140, 146, 150, 0.2)", Vc = "rgba(221, 219, 211, 0.5)", ny = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ColorAccentAlternative: Kl,
  ColorAccentDefault: Ul,
  ColorAccentDisabled: Gl,
  ColorAccessoryAlternative: Nc,
  ColorAccessoryContrast: Ec,
  ColorAccessoryDefault: Dc,
  ColorAccessoryDefaultAlternative: Ac,
  ColorAccessoryReduced: Oc,
  ColorAccessoryReducedAlternative: Pc,
  ColorActionPrimaryAlternative: zl,
  ColorActionPrimaryAlternativeDisabled: Bl,
  ColorActionPrimaryAlternativeHovered: Hl,
  ColorActionPrimaryAlternativePressed: Tl,
  ColorActionPrimaryAlternativePressedReduced: Il,
  ColorActionPrimaryDefault: Pl,
  ColorActionPrimaryDefaultDisabled: Nl,
  ColorActionPrimaryDefaultHovered: $l,
  ColorActionPrimaryDefaultPressed: Ll,
  ColorActionPrimaryDisabledAlternative: El,
  ColorActionSecondaryDefault: Fl,
  ColorActionSecondaryDisabled: jl,
  ColorActionSecondaryDisabledAlternative: Yl,
  ColorActionSecondaryHovered: Vl,
  ColorActionSecondaryPressed: Wl,
  ColorActionSecondaryPressedReduced: ql,
  ColorBackgroundAlternative: zc,
  ColorBackgroundDefault: Lc,
  ColorBackgroundDimmedDefault: Tc,
  ColorBackgroundDimmedReduced: Ic,
  ColorBackgroundDimmedReducedAlternative: Bc,
  ColorBackgroundFixedDefault: $c,
  ColorBorderOnActionSecondaryDefault: wc,
  ColorBorderOnActionSecondaryDisabled: bc,
  ColorBorderOnControlDefault: xc,
  ColorBorderOnControlDisabled: Mc,
  ColorBorderOnCriticalDefault: kc,
  ColorBorderOnInputActive: Cc,
  ColorBorderOnInputDefault: yc,
  ColorBorderOnSelectedDefault: _c,
  ColorBorderOnSelectedDisabled: Rc,
  ColorBorderOnSuccessDefault: Sc,
  ColorButtonActive: nl,
  ColorContentDefault: bl,
  ColorContentDisabled: Cl,
  ColorContentOnAccentDefault: kl,
  ColorContentOnActionPrimaryDefault: xl,
  ColorContentOnActionPrimaryDisabled: Ml,
  ColorContentOnActionPrimaryDisabledAlternative: _l,
  ColorContentOnActionSecondaryDefault: Rl,
  ColorContentOnActionSecondaryDisabled: Sl,
  ColorContentOnBackgroundFixedDefault: Ol,
  ColorContentOnContrastCriticalSuccessDefault: Dl,
  ColorContentOnContrastCriticalSuccessDefaultAlternative: Al,
  ColorContentReduced: yl,
  ColorControlsAlternative: Ql,
  ColorControlsDefault: Xl,
  ColorControlsDisabled: tc,
  ColorControlsPressed: ec,
  ColorCriticalAlternative: ac,
  ColorCriticalContrast: ic,
  ColorCriticalDefault: nc,
  ColorCriticalDisabled: rc,
  ColorCriticalHovered: sc,
  ColorCriticalOnContrastDefault: lc,
  ColorCriticalPressed: oc,
  ColorInputDefault: Jl,
  ColorInputDisabled: Zl,
  ColorShadowDefault: Fc,
  ColorShadowReduced: Vc,
  ColorShimmerDefault: Hc,
  ColorSuccessAlternative: fc,
  ColorSuccessContrast: dc,
  ColorSuccessDefault: cc,
  ColorSuccessOnContrastDefault: uc,
  ColorSurfaceContrastDefault: ul,
  ColorSurfaceContrastPressed: fl,
  ColorSurfaceCritical: dl,
  ColorSurfaceDefault: ol,
  ColorSurfaceDimmedDefault: pl,
  ColorSurfaceHovered: rl,
  ColorSurfaceOverlayDefault: ml,
  ColorSurfaceOverlayHovered: vl,
  ColorSurfaceOverlayPressed: wl,
  ColorSurfacePressed: al,
  ColorSurfacePressedAlternative: ll,
  ColorSurfaceReduced: il,
  ColorSurfaceReducedAlternative: sl,
  ColorSurfaceSelectedDefault: hl,
  ColorSurfaceSelectedPressed: gl,
  ColorSurfaceSuccess: cl,
  ColorWarningAlternative: pc,
  ColorWarningContrast: mc,
  ColorWarningDefault: hc,
  ColorWarningOnContrastDefault: vc,
  ColorWarningPressed: gc
}, Symbol.toStringTag, { value: "Module" })), Wc = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.03 9.257a1 1 0 0 1 1.213-.727l3.272.818a2 2 0 0 0 .97 0l3.273-.818a1 1 0 1 1 .485 1.94L13 11.28v1.9l2.314 3.239a1 1 0 1 1-1.628 1.162L12 15.221l-1.686 2.36a1 1 0 0 1-1.628-1.162L11 13.179v-1.898l-3.243-.81a1 1 0 0 1-.727-1.214",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M13.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" })
    ]
  }
);
m(Wc);
const jc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1a1 1 0 0 1 .912.589L15.804 8H22a1 1 0 0 1 .673 1.74l-5.018 4.562 1.794 5.382a1 1 0 0 1-1.368 1.224L15 19.486V22a1 1 0 1 1-2 0v-3.437l-1-.462-1 .462V22a1 1 0 1 1-2 0v-2.514l-3.08 1.422a1 1 0 0 1-1.369-1.224l1.794-5.382L1.327 9.74A1 1 0 0 1 2 8h6.196l2.893-6.411A1 1 0 0 1 12 1m0 3.432-2.246 4.98a1 1 0 0 1-.912.588H4.587l3.586 3.26a1 1 0 0 1 .276 1.056l-1.27 3.807 4.402-2.031a1 1 0 0 1 .838 0l4.401 2.031-1.269-3.807a1 1 0 0 1 .276-1.056L19.413 10h-4.255a1 1 0 0 1-.912-.589z",
        clipRule: "evenodd"
      }
    )
  }
);
m(jc);
const qc = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M22 8a1 1 0 0 1-1 1h-8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M10 6a1 1 0 0 0-2 0v1H3a1 1 0 0 0 0 2h5v1a1 1 0 1 0 2 0zM16 14a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-1h5a1 1 0 1 0 0-2h-5z"
        }
      )
    ]
  }
);
m(qc);
const Yc = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v4a1 1 0 1 1-2 0V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.5a1 1 0 1 1 0 2H6a4 4 0 0 1-4-4z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M6 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.631 13a3.33 3.33 0 0 0-2.131.77 3.34 3.34 0 0 0-2.131-.77c-.9 0-1.759.365-2.389 1.007a3.44 3.44 0 0 0-.98 2.407c0 .9.35 1.766.98 2.407l3.628 3.697c.49.5 1.294.5 1.784 0l3.628-3.697c.312-.317.558-.694.726-1.106a3.45 3.45 0 0 0-.726-3.708 3.4 3.4 0 0 0-1.093-.744A3.3 3.3 0 0 0 19.63 13m-.517 2.105a1.33 1.33 0 0 1 1.478.303c.128.13.231.286.301.459a1.45 1.45 0 0 1-.3 1.554L17.5 20.572l-3.092-3.151A1.44 1.44 0 0 1 14 16.414c0-.38.149-.743.408-1.006.258-.263.604-.408.96-.408.357 0 .704.145.962.408L17.5 16.6l1.17-1.193c.128-.13.279-.232.444-.302",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Yc);
const Uc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M8.23 2.76a10.16 10.16 0 0 1 5.823-.568 10.1 10.1 0 0 1 5.157 2.731L21 6.648V5a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4.5a1 1 0 1 1 0-2h2.02l-1.703-1.641-.01-.01a8.1 8.1 0 0 0-4.141-2.194 8.16 8.16 0 0 0-4.677.455 8.07 8.07 0 0 0-3.628 2.948A7.94 7.94 0 0 0 4 12c0 1.58.473 3.126 1.36 4.442a8.07 8.07 0 0 0 3.63 2.948 8.16 8.16 0 0 0 4.676.456 8.1 8.1 0 0 0 4.14-2.195 1 1 0 0 1 1.409 1.42 10.1 10.1 0 0 1-5.162 2.737c-1.955.385-3.98.188-5.823-.567a10.07 10.07 0 0 1-4.527-3.68A9.94 9.94 0 0 1 2 12a9.94 9.94 0 0 1 1.703-5.56A10.07 10.07 0 0 1 8.23 2.76"
      }
    )
  }
);
m(Uc);
const Kc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M15.77 2.76a10.16 10.16 0 0 0-5.823-.568A10.1 10.1 0 0 0 4.79 4.923L3 6.648V5a1 1 0 0 0-2 0v4a.997.997 0 0 0 1 1h4.5a1 1 0 0 0 0-2H4.48l1.703-1.641.01-.01a8.1 8.1 0 0 1 4.141-2.194 8.16 8.16 0 0 1 4.677.455 8.07 8.07 0 0 1 3.629 2.948A7.94 7.94 0 0 1 20 12c0 1.58-.473 3.126-1.36 4.442a8.07 8.07 0 0 1-3.63 2.948 8.16 8.16 0 0 1-4.676.456 8.1 8.1 0 0 1-4.14-2.195 1 1 0 0 0-1.409 1.42 10.1 10.1 0 0 0 5.162 2.737c1.955.385 3.98.188 5.823-.567a10.07 10.07 0 0 0 4.528-3.68A9.94 9.94 0 0 0 22 12a9.94 9.94 0 0 0-1.703-5.56 10.07 10.07 0 0 0-4.527-3.68"
      }
    )
  }
);
m(Kc);
const Gc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(Gc);
const Jc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.707 4.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L5.414 13H21a1 1 0 1 0 0-2H5.414l5.293-5.293a1 1 0 0 0 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), Zc = m(Jc), Xc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), Oa = m(Xc), Qc = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 7.414v8.18a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1h10.5a1 1 0 1 1 0 2H7.414l12.293 12.293a1 1 0 0 1-1.414 1.414z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Qc);
const e2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 .707.293l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l7-7A1 1 0 0 1 12 2",
        clipRule: "evenodd"
      }
    )
  }
);
m(e2);
const t2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M5.414 20H9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-6a1 1 0 1 1 2 0v3.586l5.293-5.293a1 1 0 0 1 1.414 1.414zM15 2a1 1 0 1 0 0 2h3.586l-5.293 5.293a1 1 0 0 0 1.414 1.414L20 5.414V9a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1z"
      }
    )
  }
);
m(t2);
const n2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "m16.414 9 5.293-5.293a1 1 0 0 0-1.414-1.414L15 7.586V4a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2zM9 20a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h3.586l-5.293 5.293a1 1 0 1 0 1.414 1.414L9 16.414z"
      }
    )
  }
);
m(n2);
const o2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.53 1.68a3 3 0 0 1 2.94 0l6 3.375A3 3 0 0 1 21 7.67v5.66a3 3 0 0 1-1.36 2.512l1.357 2.348a1.5 1.5 0 0 1-1.085 2.235l-1.538.222-.962 1.221a1.5 1.5 0 0 1-2.477-.177l-1.392-2.411-.072.04a3 3 0 0 1-2.942 0l-.072-.04-1.392 2.41a1.5 1.5 0 0 1-2.477.178l-.961-1.221-1.539-.222a1.5 1.5 0 0 1-1.085-2.235l1.356-2.348A3 3 0 0 1 3 13.33V7.67a3 3 0 0 1 1.53-2.615zm4.756 16.619 1.011 1.752 1-1.27 1.598-.23-.994-1.723zm-9.187-1.47 2.615 1.47-1.011 1.752-1-1.27-1.598-.23zM12.49 3.422a1 1 0 0 0-.98 0l-6 3.375A1 1 0 0 0 5 7.67v5.66a1 1 0 0 0 .51.872l6 3.375a1 1 0 0 0 .98 0l6-3.375a1 1 0 0 0 .51-.872V7.67a1 1 0 0 0-.51-.872z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.12 6.024a1.01 1.01 0 0 1 1.76 0l1.036 1.839 2.069.417a1.01 1.01 0 0 1 .543 1.674L15.1 11.507l.242 2.097a1.01 1.01 0 0 1-1.423 1.034L12 13.76l-1.919.878a1.01 1.01 0 0 1-1.423-1.034l.242-2.097-1.428-1.553a1.01 1.01 0 0 1 .543-1.674l2.069-.417zM12 8.537l-.396.703a1.01 1.01 0 0 1-.68.494l-.791.16.546.593c.198.216.293.508.26.8l-.093.801.734-.335a1.01 1.01 0 0 1 .84 0l.734.335-.093-.801a1.01 1.01 0 0 1 .26-.8l.546-.594-.79-.16a1.01 1.01 0 0 1-.68-.493z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(o2);
const r2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.152 8.126a1 1 0 0 1 .389 1.36L10.7 11H13a1 1 0 0 1 .874 1.486l-1.667 3a1 1 0 1 1-1.748-.972L11.3 13H9a1 1 0 0 1-.874-1.486l1.667-3a1 1 0 0 1 1.36-.388",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(r2);
const a2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
        clipRule: "evenodd"
      }
    )
  }
);
m(a2);
const i2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M7 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M11 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M16 9a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM4 7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"
        }
      )
    ]
  }
);
m(i2);
const s2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 7a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M3 7a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1.5a1 1 0 0 1-2 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.336 11.263a3.33 3.33 0 0 1 3.684.744 3.454 3.454 0 0 1 0 4.814l-3.628 3.697c-.49.5-1.294.5-1.784 0L1.98 16.822A3.44 3.44 0 0 1 1 14.414c0-.9.35-1.765.98-2.407A3.35 3.35 0 0 1 4.369 11c.782 0 1.534.276 2.13.77.253-.208.534-.38.837-.507M8.63 13a1.33 1.33 0 0 0-.96.408L6.5 14.6l-1.17-1.192A1.35 1.35 0 0 0 4.369 13c-.357 0-.703.145-.961.408A1.44 1.44 0 0 0 3 14.414c0 .381.149.743.408 1.007L6.5 18.572l3.092-3.151a1.453 1.453 0 0 0 0-2.013A1.33 1.33 0 0 0 8.631 13",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(s2);
const l2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(l2);
const c2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M11 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(c2);
const d2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 9a7 7 0 0 1 7-7 1 1 0 1 1 0 2 5 5 0 0 0-5 5v4.048a1 1 0 0 1-.293.707l-1.363 1.362c-.22.22-.344.52-.344.83A1.053 1.053 0 0 0 6.053 17h11.894c.581 0 1.053-.471 1.053-1.052 0-.312-.124-.61-.343-.83l-1.364-1.363a1 1 0 0 1 1.414-1.414l1.365 1.364c.594.595.927 1.4.928 2.241A3.054 3.054 0 0 1 17.947 19h-2.073a4.002 4.002 0 0 1-7.748 0H6.053A3.053 3.053 0 0 1 3 15.947c0-.84.334-1.647.928-2.242L5 12.634zm5.268 10a2 2 0 0 0 3.464 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M18 2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V7h-2a1 1 0 1 1 0-2h2V3a1 1 0 0 1 1-1"
        }
      )
    ]
  }
);
m(d2);
const u2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a7 7 0 0 0-7 7v3.634l-1.072 1.07A3.18 3.18 0 0 0 3 15.948 3.053 3.053 0 0 0 6.053 19h2.073a4.002 4.002 0 0 0 7.748 0h2.073A3.054 3.054 0 0 0 21 15.946c0-.84-.334-1.646-.928-2.241L19 12.634V9a7 7 0 0 0-7-7m1.732 17h-3.464a2 2 0 0 0 3.464 0m-8.424-2.308A1.05 1.05 0 0 1 5 15.947c0-.31.124-.61.344-.83l1.363-1.362A1 1 0 0 0 7 13.048V9a5 5 0 0 1 10 0v4.048a1 1 0 0 0 .293.707l1.363 1.363c.22.22.344.518.344.83 0 .58-.472 1.052-1.053 1.052H6.053c-.28 0-.547-.11-.745-.308",
        clipRule: "evenodd"
      }
    )
  }
);
m(u2);
const f2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.64 1.232A1 1 0 0 0 11 2v7.865L6.64 6.232a1 1 0 0 0-1.28 1.536L10.438 12 5.36 16.232a1 1 0 1 0 1.28 1.536L11 14.135V22a1 1 0 0 0 1.64.768l4.157-3.463a3 3 0 0 0 0-4.61L13.562 12l3.235-2.695a3 3 0 0 0 0-4.61zm2.876 6.536L13 9.865v-5.73l2.516 2.097a1 1 0 0 1 0 1.536M13 19.865v-5.73l2.516 2.097a1 1 0 0 1 0 1.536z",
        clipRule: "evenodd"
      }
    )
  }
);
m(f2);
const h2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.375 1.073a1 1 0 0 1 .617 1.051L13.132 9H20a1 1 0 0 1 .8 1.6l-9 12a1 1 0 0 1-1.792-.724l.86-6.876H4a1 1 0 0 1-.8-1.6l9-12a1 1 0 0 1 1.175-.327M6 13h6a1 1 0 0 1 .992 1.124l-.533 4.263L18 11h-6a1 1 0 0 1-.992-1.124l.533-4.264z",
        clipRule: "evenodd"
      }
    )
  }
);
m(h2);
const g2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 5a2 2 0 0 1 2-2h6a4 4 0 0 1 3 1.354A4 4 0 0 1 15 3h6a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-6a2 2 0 0 0-2 2 1 1 0 1 1-2 0 2 2 0 0 0-2-2H3a2 2 0 0 1-2-2zm10 13.535A4 4 0 0 0 9 18H3V5h6a2 2 0 0 1 2 2zM13 7v11.535A4 4 0 0 1 15 18h6V5h-6a2 2 0 0 0-2 2",
        clipRule: "evenodd"
      }
    )
  }
);
m(g2);
const p2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 1a3 3 0 0 0-3 3v1H3a2 2 0 0 0-2 2v1a1 1 0 0 0 2 0V7h1v11a2 2 0 0 0 2 2v2a1 1 0 1 0 2 0v-2h8v2a1 1 0 1 0 2 0v-2a2 2 0 0 0 2-2V7h1v1a1 1 0 1 0 2 0V7a2 2 0 0 0-2-2h-1V4a3 3 0 0 0-3-3zm11 4V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1zM6 7v5h12V7zm10 8a1 1 0 1 0 0 2h2v1H6v-1h2a1 1 0 1 0 0-2H6v-1h12v1z",
        clipRule: "evenodd"
      }
    )
  }
);
m(p2);
const m2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M7 1a1 1 0 0 1 1 1v1h7V2a1 1 0 1 1 2 0v1h1a4 4 0 0 1 4 4v3a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2h-1v1a1 1 0 1 1-2 0V5H8v1a1 1 0 0 1-2 0V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h1V2a1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M6 9a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zM5 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 15a1 1 0 0 1 1 1v1.586l1.207 1.207a1 1 0 0 1-1.414 1.414l-1.5-1.5A1 1 0 0 1 16 18v-2a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.003 14C14.852 13.997 13 15.848 13 18a4 4 0 1 0 4.003-4m.002-2C13.748 11.996 11 14.743 11 18a6 6 0 1 0 6.005-6m0 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(m2);
const v2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 1a1 1 0 0 1 1 1v1h7V2a1 1 0 1 1 2 0v1h1a4 4 0 0 1 4 4v5a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2h-1v1a1 1 0 1 1-2 0V5H8v1a1 1 0 0 1-2 0V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h1V2a1 1 0 0 1 1-1m-2 9a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m14 1a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(v2);
const w2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M5 10a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M18 16a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2zM19 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M6 14a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 2a1 1 0 0 0-2 0v1H5a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4h-1V2a1 1 0 1 0-2 0v1H8zM6 5v1a1 1 0 0 0 2 0V5h8v1a1 1 0 1 0 2 0V5h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Yo = m(w2), b2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M21 1a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V5h2a1 1 0 1 0 0-2h-2z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a2 2 0 0 1 2-2h8a1 1 0 1 0 0-2H5a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-7a1 1 0 1 0-2 0v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 13a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M4.25 8.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      )
    ]
  }
);
m(b2);
const y2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M16 1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 13a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M4.25 8.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 4a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4zM3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(y2);
const C2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h4V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3zm2 1h2V5H6zm12 0V5h-2v1zM4 8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm12 2.5a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1m-11 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(C2);
const x2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.65 3.024A3 3 0 0 1 10.908 2H19a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7.248a3 3 0 0 1 .742-1.976zM10.908 4a1 1 0 0 0-.753.341L5.204 10H20V5a1 1 0 0 0-1-1zM20 12H4v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-7 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(x2);
const M2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.946 4.967A3 3 0 0 1 8.763 3H20a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3.168a2.165 2.165 0 0 1-2.033-2.91zM7.943 19H20a1 1 0 0 0 1-1v-5H10.193zM21 11H10.193a2 2 0 0 0-1.873 1.298L5.807 19H3.168a.165.165 0 0 1-.155-.222L7.824 5.656A1 1 0 0 1 8.763 5H20a1 1 0 0 1 1 1zm-3.765-4.18-.027-.027a1 1 0 0 0-.707-.293 1 1 0 0 0-.735.32l-1.473 1.473a1 1 0 0 0 1.414 1.414l.793-.793.793.793a1 1 0 0 0 1.414-1.414zm-2.942 7.473a1 1 0 0 1 1.414 0l.793.793.793-.793a1 1 0 0 1 1.414 1.414l-1.472 1.472-.027.028a1 1 0 0 1-.707.293 1 1 0 0 1-.735-.32l-1.473-1.473a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
m(M2);
const _2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v5h1a3 3 0 0 1 3 3v3.5a.5.5 0 0 0 1 0V7.828a1 1 0 0 0-.293-.707l-1.414-1.414a1 1 0 0 1 1.414-1.414l1.414 1.414A3 3 0 0 1 22 7.828V16.5a2.5 2.5 0 0 1-5 0V13a1 1 0 0 0-1-1h-1v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm3.652 4.126a1 1 0 0 1 .389 1.36L8.2 11h2.3a1 1 0 0 1 .874 1.486l-1.667 3a1 1 0 1 1-1.748-.972L8.8 13H6.5a1 1 0 0 1-.874-1.486l1.667-3a1 1 0 0 1 1.36-.388",
        clipRule: "evenodd"
      }
    )
  }
);
m(_2);
const R2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4zm4-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm10 3a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M8 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m4 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(R2);
const S2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm4 0h-2v12h2zM2 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm4 0H4v8h2zm3 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm4 0h-2v6h2zM1 21a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(S2);
const k2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m16.213-2.3a1 1 0 1 0-1.427-1.4L9.75 14.445l-1.434-2.024a1 1 0 1 0-1.632 1.156l2.125 3a1 1 0 0 0 1.53.123z",
        clipRule: "evenodd"
      }
    )
  }
), Pa = m(k2), D2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.2 8.287a1 1 0 0 1 .013 1.414l-6.875 7a1 1 0 0 1-1.529-.123l-2.125-3a1 1 0 1 1 1.632-1.156l1.434 2.024 6.037-6.147a1 1 0 0 1 1.414-.012",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(D2);
const A2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.2 8.287a1 1 0 0 1 .013 1.414l-6.875 7a1 1 0 0 1-1.529-.123l-2.125-3a1 1 0 1 1 1.632-1.156l1.434 2.024 6.037-6.147a1 1 0 0 1 1.414-.012",
        clipRule: "evenodd"
      }
    )
  }
), Na = m(A2), O2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.698 5.284a1 1 0 0 1 .018 1.414l-10.714 11a1 1 0 0 1-1.514-.094l-3.785-5a1 1 0 1 1 1.594-1.208l3.084 4.073 9.903-10.167a1 1 0 0 1 1.414-.018",
        clipRule: "evenodd"
      }
    )
  }
), P2 = m(O2), N2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 15.707a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L12 13.586 7.707 9.293a1 1 0 0 0-1.414 1.414z",
        clipRule: "evenodd"
      }
    )
  }
), Zn = m(N2), E2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 6.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L10.414 12l4.293-4.293a1 1 0 0 0 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), L2 = m(E2), z2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.586 12 9.293 7.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), T2 = m(z2), I2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 8.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L12 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414z",
        clipRule: "evenodd"
      }
    )
  }
), B2 = m(I2), $2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 22a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13.347 4a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm-2.17.928A3 3 0 0 1 13.347 4V2a5 5 0 0 0-3.615 1.546zM16.347 7a3 3 0 0 1-2.989 3l.008 2a5 5 0 0 0 4.98-5z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "m5.977 16.82.962-.27-.001-.005zm4.82-11.97-.924.384v.001zm3.98 9.54-.923.385.005.012zm.92.62-.025 1h.022zm4.313.01-.002 1h.002zM8.857 18a2.01 2.01 0 0 1-1.918-1.45l-1.925.54A4.01 4.01 0 0 0 8.857 20zm-1.919-1.455-2.86-10-1.923.55 2.86 10zm-2.86-10a1.99 1.99 0 0 1 .329-1.755l-1.6-1.2a3.99 3.99 0 0 0-.652 3.505zm.329-1.755c.376-.502.957-.79 1.6-.79V2a3.97 3.97 0 0 0-3.2 1.59zm1.6-.79h2.02V2h-2.02zm7.852 10.787a2.03 2.03 0 0 0 1.813 1.223l.05-2a.03.03 0 0 1-.028-.017zm1.835 1.223 4.314.01.004-2-4.313-.01zm4.316.01c.538 0 .99.452.99.99h2a3 3 0 0 0-2.99-2.99zm.99.99c0 .548-.442.99-.99.99v2A2.99 2.99 0 0 0 23 17.01zm-.99.99H8.857v2H20.01zM8.027 4c.658 0 1.248.31 1.616.821l1.623-1.17A3.98 3.98 0 0 0 8.026 2zm1.616.821q.136.188.23.413l1.847-.768a4 4 0 0 0-.454-.814zm.23.414 3.98 9.54 1.847-.77-3.98-9.54z"
        }
      )
    ]
  }
);
m($2);
const H2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 12a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M12 14a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M16 10a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-6-2h4v2h-4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(H2);
const F2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.707 11.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 14.586l3.293-3.293a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-6-2h4v2h-4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(F2);
const V2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-6-2h4v2h-4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1M10 10a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M9 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 14a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
      )
    ]
  }
);
m(V2);
const W2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6a1 1 0 0 1 1 1v4.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V7a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.947 2.192a10.16 10.16 0 0 1 5.823.567 10.07 10.07 0 0 1 4.528 3.68A9.94 9.94 0 0 1 22 12a9.94 9.94 0 0 1-1.703 5.56 10.07 10.07 0 0 1-4.527 3.68 10.16 10.16 0 0 1-5.823.568 10.1 10.1 0 0 1-5.162-2.736 1 1 0 0 1 1.408-1.42 8.1 8.1 0 0 0 4.141 2.194c1.57.31 3.198.15 4.677-.456a8.07 8.07 0 0 0 3.629-2.948A7.94 7.94 0 0 0 20 12a7.94 7.94 0 0 0-1.36-4.442 8.07 8.07 0 0 0-3.63-2.948 8.16 8.16 0 0 0-4.676-.455 8.1 8.1 0 0 0-4.14 2.194l-.011.01L4.479 8H7a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v2.648l1.79-1.725a10.1 10.1 0 0 1 5.157-2.73",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(W2);
const j2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13 6a1 1 0 1 0-2 0v5.977a1 1 0 0 0 .65.96l4.979 1.992a1 1 0 0 0 .742-1.857L13 11.323z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M12 1c6.076 0 11 4.924 11 11s-4.924 11-11 11q-1.1-.002-2.146-.21a1 1 0 1 1 .388-1.961A9 9 0 0 0 21 12a9 9 0 0 0-10.758-8.829 1 1 0 0 1-.388-1.962A11 11 0 0 1 12 1M5.887 2.853A1 1 0 1 1 7 4.515 9.1 9.1 0 0 0 4.515 7a1 1 0 0 1-1.662-1.113 11.1 11.1 0 0 1 3.034-3.034M1.21 9.854a1 1 0 1 1 1.961.388 9 9 0 0 0 0 3.516 1 1 0 1 1-1.962.388 11 11 0 0 1 0-4.292M2.853 18.113A1 1 0 0 1 4.515 17 9.1 9.1 0 0 0 7 19.485a1 1 0 0 1-1.113 1.662 11.1 11.1 0 0 1-3.034-3.034"
        }
      )
    ]
  }
);
m(j2);
const q2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 5a1 1 0 0 1 1 1v5.323l4.371 1.749a1 1 0 0 1-.742 1.857l-5-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ea = m(q2), Y2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M5.947 1.106a1 1 0 0 1 .447 1.341L5.618 4l.776 1.553a1 1 0 0 1-1.788.894l-1-2a1 1 0 0 1 0-.894l1-2a1 1 0 0 1 1.341-.447M10.947 1.106a1 1 0 0 1 .447 1.341L10.618 4l.776 1.553a1 1 0 1 1-1.788.894l-1-2a1 1 0 0 1 0-.894l1-2a1 1 0 0 1 1.341-.447M15.947 1.106a1 1 0 0 1 .447 1.341L15.618 4l.776 1.553a1 1 0 1 1-1.788.894l-1-2a1 1 0 0 1 0-.894l1-2a1 1 0 0 1 1.341-.447"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 10a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-1a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm16 9v-9H3v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2m2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Y2);
const U2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h9A2.5 2.5 0 0 1 16 4.5v1a1 1 0 1 1-2 0v-1a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h1a1 1 0 1 1 0 2h-1A2.5 2.5 0 0 1 2 13.5zm6 6A2.5 2.5 0 0 1 10.5 8h9a2.5 2.5 0 0 1 2.5 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 8 19.5zm2.5-.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z",
        clipRule: "evenodd"
      }
    )
  }
), La = m(U2), K2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2h-2v3a3 3 0 0 1-3 3h-1a3 3 0 0 1-3-3V5H2a1 1 0 0 1-1-1m14 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5zM4 10a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm7 5a1 1 0 0 1 1-1h2a2 2 0 0 1 2 2v4h3a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h15v-4h-2a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(K2);
const G2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v3.464c0 .88-.564 1.517-1.088 1.857A2 2 0 0 0 21 12c0 .702.361 1.32.912 1.679.524.34 1.088.977 1.088 1.858V19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3.463c0-.881.565-1.518 1.088-1.858C2.639 13.32 3 12.702 3 12s-.361-1.32-.912-1.679C1.565 9.981 1 9.344 1 8.464zm20 0H3v3.46a.2.2 0 0 0 .019.036c.026.04.079.096.159.148A4 4 0 0 1 5 12a4 4 0 0 1-1.822 3.356.6.6 0 0 0-.16.148.2.2 0 0 0-.018.036V19h18v-3.46a.1.1 0 0 0-.019-.036.6.6 0 0 0-.159-.148A4 4 0 0 1 19 12c0-1.407.727-2.644 1.822-3.356a.6.6 0 0 0 .16-.148A.1.1 0 0 0 21 8.46zm0 3.458v.002zm0 7.084v-.002zm-18 0v-.002zm0-7.084v.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.707 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0M13.75 14.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M7.75 9.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(G2);
const J2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11.78-3.923A4 4 0 0 0 8.127 11H12a1 1 0 1 1 0 2H8.127a4 4 0 0 0 6.701 1.828 1 1 0 0 1 1.415 1.415A6 6 0 0 1 6.083 13H6a1 1 0 1 1 0-2h.084a6 6 0 0 1 10.159-3.243 1 1 0 1 1-1.415 1.415 4 4 0 0 0-2.048-1.095",
        clipRule: "evenodd"
      }
    )
  }
);
m(J2);
const Z2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-7v1h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-1H4a3 3 0 0 1-3-3zm11 11h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Z2);
const X2 = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm10-1h-4v1h4zM8 3v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V3h1a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM7 19a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(X2);
const Q2 = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 19a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1M9.5 7a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 12.414V20a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v3.586l3.707 3.707a1 1 0 0 1-1.414 1.414zM7 6a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Q2);
const ed = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 14a1 1 0 0 1 1 1v3.92A3.08 3.08 0 0 1 17.92 22H6a3 3 0 0 1-3-3v-4a1 1 0 1 1 2 0v4a1 1 0 0 0 1 1h11.92A1.08 1.08 0 0 0 19 18.92V15a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16.707 8.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L11 10.586V3a1 1 0 1 1 2 0v7.586l2.293-2.293a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(ed);
const td = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.293 14.293a1 1 0 0 1 1.262-.125l.945.63.945-.63a1 1 0 0 1 1.11 0l.945.63.945-.63a1 1 0 0 1 1.262.125l1 1a1 1 0 0 1-1.414 1.414l-.42-.42-.818.545a1 1 0 0 1-1.11 0l-.945-.63-.945.63a1 1 0 0 1-1.11 0l-.818-.545-.42.42a1 1 0 0 1-1.414-1.414zM7.793 7.793a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 0 1-1.414-1.414L8.586 10l-.793-.793a1 1 0 0 1 0-1.414M16.207 7.793a1 1 0 0 1 0 1.414l-.793.793.793.793a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414l1.5-1.5a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(td);
const nd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.793 7.793a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414L8.5 9.914l-.793.793a1 1 0 0 1-1.414-1.414zM14.793 7.793a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-.793-.793-.793.793a1 1 0 0 1-1.414-1.414zM6.224 13.369A1 1 0 0 1 7 13h10a1 1 0 0 1 .98 1.203C17.41 16.953 14.937 19 12 19s-5.41-2.047-5.98-4.797a1 1 0 0 1 .204-.834M8.447 15c.706 1.19 2.027 2 3.553 2s2.847-.81 3.553-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(nd);
const od = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(od);
const rd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 15a4 4 0 0 0-2.829 1.172 1 1 0 0 1-1.414-1.415 6 6 0 0 1 8.486 0 1 1 0 1 1-1.415 1.415A4 4 0 0 0 12 15",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(rd);
const ad = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.757 13.828a1 1 0 0 1 1.414 0 4 4 0 0 0 5.657 0 1 1 0 0 1 1.415 1.415 6 6 0 0 1-8.486 0 1 1 0 0 1 0-1.415",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(ad);
const id = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m12-.5a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0zm-1.001 5.25a1.25 1.25 0 1 1 .002-2.5 1.25 1.25 0 0 1-.002 2.5",
        clipRule: "evenodd"
      }
    )
  }
), za = m(id), sd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 12.5a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1M10.75 15.496a1.25 1.25 0 1 0 2.5.007 1.25 1.25 0 0 0-2.5-.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(sd);
const ld = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.707 1.879A3 3 0 0 1 8.828 1h6.344a3 3 0 0 1 2.12.879l4.83 4.828A3 3 0 0 1 23 8.828v6.344a3 3 0 0 1-.879 2.12l-4.828 4.83a3 3 0 0 1-2.121.878H8.828a3 3 0 0 1-2.12-.879l-4.83-4.828A3 3 0 0 1 1 15.172V8.828a3 3 0 0 1 .879-2.12zM8.828 3a1 1 0 0 0-.707.293L3.293 8.12A1 1 0 0 0 3 8.828v6.344a1 1 0 0 0 .293.707l4.828 4.828a1 1 0 0 0 .707.293h6.344a1 1 0 0 0 .707-.293l4.828-4.828a1 1 0 0 0 .293-.707V8.828a1 1 0 0 0-.293-.707L15.88 3.293A1 1 0 0 0 15.172 3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 13a1 1 0 0 0 1-1V8a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1M10.75 15.996a1.25 1.25 0 1 0 2.5.007 1.25 1.25 0 0 0-2.5-.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(ld);
const cd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M21.924 2.617a1 1 0 0 0-.215-.322l-.004-.004A1 1 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.586l-6.293 6.293a1 1 0 0 0 1.414 1.414L20 5.414V9a1 1 0 1 0 2 0V2.997a1 1 0 0 0-.076-.38"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13 5a1 1 0 0 0-1-1H6a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-5a1 1 0 1 0-2 0v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6a1 1 0 0 0 1-1"
        }
      )
    ]
  }
);
m(cd);
const dd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.707 7.293a1 1 0 0 0-1.414 1.414L2 8l-.707.707.001.001.002.002.004.004.013.013a5 5 0 0 0 .2.187c.135.122.33.29.581.492.337.27.777.598 1.311.945L1.628 13.51a1 1 0 0 0 1.744.98l1.77-3.148c.911.452 1.969.876 3.152 1.182l-.767 3.246a1 1 0 0 0 1.946.46l.788-3.334q.84.102 1.739.104c.71 0 1.206-.01 1.745-.08l.782 3.31a1 1 0 0 0 1.946-.46l-.774-3.276a22 22 0 0 0 3.15-1.166l1.78 3.162a1 1 0 0 0 1.743-.98l-1.777-3.16c.534-.346.974-.674 1.31-.944a13 13 0 0 0 .782-.679l.013-.013.004-.004.002-.002L22 8l.707.707a1 1 0 0 0-1.414-1.414m0 0-.003.003-.026.025-.118.109c-.107.097-.272.24-.49.414-.435.349-1.08.818-1.902 1.288-1.03.588-2.873 1.302-4.472 1.66-.829.186-1.251.208-2.282.208-.813 0-1.587-.08-2.317-.215-1.765-.329-3.272-.988-4.437-1.653a15 15 0 0 1-1.903-1.288 11 11 0 0 1-.607-.523l-.026-.025-.004-.004m0 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(dd);
const ud = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-2.087-2.087A10.3 10.3 0 0 1 12 20c-4.148 0-7.564-2.273-10.252-6.483a2.82 2.82 0 0 1 0-3.034C2.767 8.888 3.89 7.567 5.127 6.541L3.293 4.707a1 1 0 0 1 0-1.414m3.256 4.67c-1.1.88-2.14 2.07-3.115 3.597a.82.82 0 0 0 0 .881C5.872 16.26 8.729 18 12 18a8.3 8.3 0 0 0 3.728-.857l-1.696-1.697a4.001 4.001 0 0 1-5.478-5.478zm3.519 3.52a1.999 1.999 0 0 0 2.45 2.45zM12 6q-.929 0-1.792.184a1 1 0 0 1-.416-1.956A10.6 10.6 0 0 1 12 4c4.148 0 7.564 2.273 10.252 6.483.59.924.591 2.108 0 3.034a19.6 19.6 0 0 1-1.561 2.13 1 1 0 1 1-1.525-1.294q.721-.85 1.4-1.913a.82.82 0 0 0 0-.881C18.128 7.74 15.272 6 12 6",
        clipRule: "evenodd"
      }
    )
  }
), fd = m(ud), hd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 6c-3.271 0-6.128 1.74-8.566 5.559a.82.82 0 0 0 0 .882C5.872 16.26 8.728 18 12 18c3.271 0 6.128-1.74 8.566-5.559a.82.82 0 0 0 0-.882C18.128 7.74 15.272 6 12 6M1.748 10.483C4.436 6.273 7.852 4 12 4s7.564 2.273 10.252 6.483c.59.925.59 2.11 0 3.034C19.564 17.727 16.148 20 12 20s-7.564-2.273-10.252-6.483a2.82 2.82 0 0 1 0-3.034M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
        clipRule: "evenodd"
      }
    )
  }
), gd = m(hd), pd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-1.5a1 1 0 1 1 0-2H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-6v2h.5a1 1 0 1 1 0 2H13v1h.5a1 1 0 1 1 0 2H13v1h.5a1 1 0 1 1 0 2H13a1 1 0 1 1-2 0v-1h-.5a1 1 0 0 1 0-2h.5v-1h-.5a1 1 0 1 1 0-2h.5V7h-.5a1 1 0 0 1 0-2h.5V4zm7 14a1 1 0 0 0-1 1v2h2v-2a1 1 0 0 0-1-1m-2.121-1.121A3 3 0 0 1 15 19v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a3 3 0 0 1 .879-2.121",
        clipRule: "evenodd"
      }
    )
  }
);
m(pd);
const md = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3.75A2.75 2.75 0 0 1 5.75 1h1.42a1 1 0 1 1 0 2H5.75a.75.75 0 0 0-.75.75V5a1 1 0 1 1-2 0zM9.58 2a1 1 0 0 1 1-1H12v2h-1.42a1 1 0 0 1-1-1M4 7a1 1 0 0 1 1 1v2.5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m17 3v.722a1 1 0 1 1-2 0V10zM4 12.5a1 1 0 0 1 1 1V16a1 1 0 1 1-2 0v-2.5a1 1 0 0 1 1-1m16 .153a1 1 0 0 1 1 1v2.444a1 1 0 1 1-2 0v-2.444a1 1 0 0 1 1-1M4 18a1 1 0 0 1 1 1v1.25c0 .414.336.75.75.75h1.42a1 1 0 1 1 0 2H5.75A2.75 2.75 0 0 1 3 20.25V19a1 1 0 0 1 1-1m16 .028a1 1 0 0 1 1 1v1.222A2.75 2.75 0 0 1 18.25 23h-1.42a1 1 0 0 1 0-2h1.42a.75.75 0 0 0 .75-.75v-1.222a1 1 0 0 1 1-1M9.58 22a1 1 0 0 1 1-1h2.84a1 1 0 1 1 0 2h-2.84a1 1 0 0 1-1-1M12 3V1h2.172a3 3 0 0 1 2.12.879l3.83 3.828A3 3 0 0 1 21 7.828V10h-6a3 3 0 0 1-3-3zm2 0v4a1 1 0 0 0 1 1h4v-.172a1 1 0 0 0-.293-.707L14.88 3.293A1 1 0 0 0 14.172 3z",
        clipRule: "evenodd"
      }
    )
  }
);
m(md);
const vd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-4a2 2 0 0 1-2-2V3zm9 .414V7h3.586zM21 7a1 1 0 0 0-.293-.707l-5-5A1 1 0 0 0 15 1H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7M7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(vd);
const wd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10h-4a3 3 0 0 1-3-3V3zm8 0v4a1 1 0 0 0 1 1h4v-.172a1 1 0 0 0-.293-.707L14.88 3.293A1 1 0 0 0 14.172 3zm7 4.828a3 3 0 0 0-.879-2.12l-3.828-3.83A3 3 0 0 0 14.172 1H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3z",
        clipRule: "evenodd"
      }
    )
  }
);
m(wd);
const bd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.995h-3.5a2.5 2.5 0 0 1-2.5-2.5V3zm5 0v3.495a.5.5 0 0 0 .5.5H19v-.13a1 1 0 0 0-.282-.697L17.29 4.695l-1.38-1.398A1 1 0 0 0 15.2 3zM7 4a3 3 0 0 1 3-3h5.199a3 3 0 0 1 2.135.892L18.722 3.3l1.432 1.477A3 3 0 0 1 21 6.864V17a3 3 0 0 1-3 3h-1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm0 2H6a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1h-5a3 3 0 0 1-3-3z",
        clipRule: "evenodd"
      }
    )
  }
);
m(bd);
const yd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m3 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m3 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(yd);
const Cd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.693 3.355a2 2 0 0 1 2.45-1.415l9.659 2.589a3 3 0 0 1 2.12 3.674l-1.552 5.795a3 3 0 0 1-3.674 2.122l-9.66-2.589-2.07 7.728a1 1 0 0 1-1.932-.518zM6.554 11.6l9.66 2.588a1 1 0 0 0 1.224-.707l1.553-5.796a1 1 0 0 0-.707-1.225l-9.66-2.588zm2.519-5.537a1 1 0 0 1 1.225-.707l.966.259a1 1 0 1 1-.518 1.931l-.966-.258a1 1 0 0 1-.707-1.225m5.795 1.553a1 1 0 0 1 1.225-.707l.966.259a1 1 0 1 1-.518 1.931l-.965-.258a1 1 0 0 1-.708-1.225M11.453 8.77a1 1 0 0 1 1.225-.707l.966.259a1 1 0 0 1-.518 1.932l-.966-.26a1 1 0 0 1-.707-1.224M8.038 9.927a1 1 0 0 1 1.224-.708l.966.26a1 1 0 0 1-.517 1.931l-.966-.259a1 1 0 0 1-.707-1.224m5.795 1.553a1 1 0 0 1 1.225-.708l.966.26a1 1 0 1 1-.518 1.931l-.966-.259a1 1 0 0 1-.707-1.225",
        clipRule: "evenodd"
      }
    )
  }
);
m(Cd);
const xd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.222 4.222a1 1 0 0 1 1.414 0L12 10.586l6.364-6.364a1 1 0 1 1 1.414 1.414L13.414 12l6.364 6.364a1 1 0 0 1-1.414 1.414L12 13.414l-6.364 6.364a1 1 0 1 1-1.414-1.414L10.586 12 4.222 5.636a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(xd);
const Md = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.968 6.382A8.96 8.96 0 0 0 3 12a9 9 0 0 0 9 9 8.96 8.96 0 0 0 5.618-1.968zm-.746-2.16A10.97 10.97 0 0 0 1 12c0 6.076 4.924 11 11 11 3.037 0 5.786-1.23 7.776-3.22l.002-.002.002-.001C21.77 17.787 23 15.037 23 12c0-6.076-4.924-11-11-11a10.97 10.97 0 0 0-7.778 3.222m2.16.746 12.65 12.65A8.96 8.96 0 0 0 21 12a9 9 0 0 0-9-9 8.96 8.96 0 0 0-5.618 1.968",
        clipRule: "evenodd"
      }
    )
  }
);
m(Md);
const _d = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.459 4.313a.98.98 0 0 0-1.434 0 1.177 1.177 0 0 0 0 1.606c.528.55 1.3.844 1.97.981a9 9 0 0 0 .002-.586 5.5 5.5 0 0 0-.158-1.22c-.1-.38-.237-.633-.38-.782M12 3.035l-.099-.108a2.98 2.98 0 0 0-4.318 0A3.18 3.18 0 0 0 7.325 7H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.325a3.18 3.18 0 0 0-.258-4.073A2.98 2.98 0 0 0 12 3.035m1 3.616v-.167l.003-.17c.013-.423.06-.85.158-1.22.1-.38.237-.633.38-.781a.98.98 0 0 1 1.434 0 1.177 1.177 0 0 1 0 1.606c-.528.55-1.3.844-1.97.981zM11 9H4v2h7zm0 4H6v7h5zm2 7v-7h5v7zm5.995-9H13V9h7v2h-1.005",
        clipRule: "evenodd"
      }
    )
  }
);
m(_d);
const Rd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.918 1.003Q10.958 1 11 1h4.3c1.152 0 2.204.658 2.701 1.697l.001.002L18.63 4H22a1 1 0 0 1 1 1v1.76a3 3 0 0 1-1.662 2.684L19 10.617V11h1a1 1 0 1 1 0 2h-.674l1.458 5.104A3.01 3.01 0 0 1 23 21v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-.962-.726L14.535 17h-1.12l-1.24 1.24A3.01 3.01 0 0 1 14 21v1a1 1 0 0 1-1 1H5c-1.652 0-3-1.348-3-3v-8.586l-.707-.707a1 1 0 0 1 1.414-1.414l1 1A1 1 0 0 1 4 11v2.706l2.275-2.395a1 1 0 0 1 1.45 1.378l-3.41 3.59-.027.027A.97.97 0 0 0 4 17v3c0 .548.452 1 1 1h7c0-.548-.452-1-1-1h-1a1 1 0 0 1-.707-1.707l3-3A1 1 0 0 1 13 15h2.29a1 1 0 0 1 .962.726L17.755 21H21c0-.548-.452-1-1-1a1 1 0 0 1-.962-.725L17.246 13H10a1 1 0 1 1 0-2h7v-1a1 1 0 0 1 .552-.894l2.89-1.45A1 1 0 0 0 21 6.76V6h-3a1 1 0 0 1-.901-.566l-.9-1.87-.001-.003A.99.99 0 0 0 15.3 3h-2.24v6a1 1 0 0 1-1 1h-1c-1.652 0-3-1.348-3-3V4a3.006 3.006 0 0 1 2.858-2.997M10.06 4c0-.548.452-1 1-1v5c-.548 0-1-.452-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M1.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414"
        }
      )
    ]
  }
);
m(Rd);
const Sd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 2.293A1 1 0 0 1 5 2h7a1 1 0 0 1 1 1v3.007l6.007.043a1 1 0 0 1 .694.287l3 2.95a1 1 0 0 1 .007 1.419l-3 3.01a1 1 0 0 1-.708.294h-6V22a1 1 0 1 1-2 0V10H5a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 0-1.414zM11 7V8H5.414l-2-2 2-2H11v3m2 5.009h5.585l1.996-2.003-1.993-1.96L13 8.007z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Sd);
const kd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1v2a3 3 0 0 1-3 3h-1.17A3 3 0 0 1 13 23h-2a3 3 0 1 1 0-6h2c1.306 0 2.418.835 2.83 2H17a1 1 0 0 0 1-1V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1zm10 14a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1M4 10H3v4h1zm16 0v4h1v-4z",
        clipRule: "evenodd"
      }
    )
  }
);
m(kd);
const Dd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M11.36 4.335a1 1 0 0 1 1.28 0l7 5.834a1 1 0 0 1 .36.768V19a1 1 0 0 1-1 1h-3a1 1 0 1 0 0 2h3a3 3 0 0 0 3-3v-8.063a3 3 0 0 0-1.08-2.305l-7-5.833a3 3 0 0 0-3.84 0l-7 5.833A3 3 0 0 0 2 10.937V19a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-4.585l1.293 1.292a1 1 0 1 0 1.414-1.414l-2.973-2.972a1 1 0 0 0-1.469 0l-2.972 2.972a1 1 0 1 0 1.414 1.414L11 14.414V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.063a1 1 0 0 1 .36-.768z"
      }
    )
  }
);
m(Dd);
const Ad = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l3.044 3.044-2.258 1.881A3 3 0 0 0 2 10.937V19a3 3 0 0 0 3 3h15.586l.707.707a1 1 0 0 0 1.414-1.414zM18.586 20 6.756 8.171 4.36 10.169a1 1 0 0 0-.36.768V19a1 1 0 0 0 1 1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13.92 2.799a3 3 0 0 0-3.84 0L8.767 3.892a1 1 0 1 0 1.28 1.536l1.312-1.093a1 1 0 0 1 1.28 0l7 5.834a1 1 0 0 1 .36.768V16a1 1 0 1 0 2 0v-5.063a3 3 0 0 0-1.08-2.305z"
        }
      )
    ]
  }
);
m(Ad);
const Od = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.64 4.335a1 1 0 0 0-1.28 0l-7 5.834a1 1 0 0 0-.36.768V19a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8.063a1 1 0 0 0-.36-.768zM10.08 2.8a3 3 0 0 1 3.84 0l7 5.833A3 3 0 0 1 22 10.937V19a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8.063a3 3 0 0 1 1.08-2.305z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Od);
const Pd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 .65.937L8.585 14a2 2 0 0 1 2.828 0l1.086 1.086L15.586 12a2 2 0 0 1 2.828 0L21 14.586V6a1 1 0 0 0-1-1zm17 12.414-4-4-3.793 3.793a1 1 0 0 1-1.414 0L10 15.414 6.414 19H20a1 1 0 0 0 1-1zM7 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(Pd);
const Nd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m10.999-5.25a1.25 1.25 0 1 0 .002 2.5A1.25 1.25 0 0 0 12 6.75M13 12a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z",
        clipRule: "evenodd"
      }
    )
  }
), Ed = m(Nd), Ld = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.75 8.004a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 11a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ta = m(Ld), zd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13.585 10.058A3 3 0 0 0 10.172 12H13a1 1 0 1 1 0 2h-2.828a3 3 0 0 0 3.413 1.942 3 3 0 0 0 1.536-.82 1 1 0 0 1 1.414 1.413A5 5 0 0 1 8.102 14H8a1 1 0 1 1 0-2h.101a4.999 4.999 0 0 1 8.434-2.536 1 1 0 1 1-1.414 1.415 3 3 0 0 0-1.536-.821M7 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm16 0H5v18h14z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(zd);
const Td = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm3 11a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M7.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M7.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M11.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M11.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M19.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M19.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      )
    ]
  }
);
m(Td);
const Id = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6a5 5 0 0 0-2.903 9.071c.509.364.903.973.903 1.703V17h4v-.226c0-.73.394-1.339.903-1.703A5 5 0 0 0 12 6m-7 5a7 7 0 1 1 11.066 5.699.2.2 0 0 0-.06.063l-.006.014V17a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-.224l-.006-.014a.2.2 0 0 0-.06-.063A7 7 0 0 1 5 11M9 21a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M3.84 5.134a1 1 0 0 0-1 1.732l.866.5a1 1 0 1 0 1-1.732zM2 10a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM21 10a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM18.928 15a1 1 0 0 1 1.366-.366l.866.5a1 1 0 0 1-1 1.732l-.866-.5A1 1 0 0 1 18.928 15M18.928 7a1 1 0 0 1 .366-1.366l.866-.5a1 1 0 0 1 1 1.732l-.866.5A1 1 0 0 1 18.928 7M2.84 15.134a1 1 0 1 0 1 1.732l.866-.5a1 1 0 1 0-1-1.732z"
        }
      )
    ]
  }
);
m(Id);
const Bd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.828 4.858a4 4 0 0 1 5.657 0L21.9 6.272a4 4 0 0 1 0 5.657l-5.657 5.657a4 4 0 0 1-5.657 0l-1.414-1.414a4 4 0 0 1 0-5.657l.707-.707a1 1 0 0 1 1.414 1.414l-.707.707a2 2 0 0 0 0 2.828L12 16.172a2 2 0 0 0 2.828 0l5.657-5.657a2 2 0 0 0 0-2.829l-1.414-1.414a2 2 0 0 0-2.828 0 1 1 0 1 1-1.415-1.414M12 7.828a2 2 0 0 0-2.828 0l-5.657 5.657a2 2 0 0 0 0 2.829l1.414 1.414a2 2 0 0 0 2.828 0 1 1 0 0 1 1.415 1.414 4 4 0 0 1-5.657 0L2.1 17.728a4 4 0 0 1 0-5.657l5.656-5.657a4 4 0 0 1 5.657 0l1.414 1.414a4 4 0 0 1 0 5.657l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a2 2 0 0 0 0-2.828z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Bd);
const $d = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 9a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2a4 4 0 0 1-4 4h-1a1 1 0 1 1 0-2h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2 1 1 0 1 1 0 2 4 4 0 0 1-4-4zm10 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2 1 1 0 1 1 0-2 4 4 0 0 1 4 4v2a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4h1a1 1 0 1 1 0 2z",
        clipRule: "evenodd"
      }
    )
  }
);
m($d);
const Hd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 18.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M8 5.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M6 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M6 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M6 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
      )
    ]
  }
);
m(Hd);
const Fd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 1a4 4 0 0 0-4 4 1 1 0 0 0 2 0 2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1V5a4 4 0 0 0-4-4zM6 11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Fd);
const Vd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 1a4 4 0 0 0-4 4v4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1V5a4 4 0 0 0-4-4zm4 8V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4zm-9 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Vd);
const Wd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 3a1 1 0 0 1 1-1h4a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-4a1 1 0 1 1 0-2h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4a1 1 0 0 1-1-1M9.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L12.586 13H3a1 1 0 1 1 0-2h9.586L9.293 7.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
m(Wd);
const jd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h4a1 1 0 0 1 0 2zm10.293 2.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 13H9a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
);
m(jd);
const qd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M15.207 9.207a1 1 0 0 0-1.414-1.414L11.5 10.086l-.793-.793a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414 0z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.176 2.618a3 3 0 0 1 3.648 0l7 5.36A3 3 0 0 1 22 10.36V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8.64A3 3 0 0 1 3.176 7.98zm2.432 1.588a1 1 0 0 0-1.216 0L4.788 9.263l6.61 5.283a1 1 0 0 0 1.203 0l6.603-5.289zM4 19v-7.806l6.16 4.922.015.013a3 3 0 0 0 3.65 0l.017-.014L20 11.183V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(qd);
const Yd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 4a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm2 4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.136 8.496a1 1 0 0 1 1.368-.36L12 11.342l5.496-3.206a1 1 0 0 1 1.008 1.728l-5.496 3.206a2 2 0 0 1-2.016 0L5.496 9.864a1 1 0 0 1-.36-1.368",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Yd);
const Ud = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.684 2.051a1 1 0 0 1 .632 0l5.317 1.772A2 2 0 0 1 22 5.721V10a1 1 0 1 1-2 0V5.72l-4-1.333V10a1 1 0 1 1-2 0V4.387l-4 1.334V11a1 1 0 1 1-2 0V5.72L4 4.388v13.92l3.351 1.257a1 1 0 1 1-.702 1.872L3.298 20.18A2 2 0 0 1 2 18.307V4.387A2 2 0 0 1 4.632 2.49L9 3.946zM10 15.5a2.5 2.5 0 0 1 2.5-2.5h1a2.5 2.5 0 0 1 2.5 2.5V21a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0zm2 1.5h2v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm5-2.75c0-.69.56-1.25 1.25-1.25H20a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-1.75c-.69 0-1.25-.56-1.25-1.25zm2 .75v5h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Ud);
const Kd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1a9 9 0 0 0-6 15.709l5.142 4.856a1.25 1.25 0 0 0 1.716 0L18 16.708q.186-.167.364-.344A9 9 0 0 0 12 1m-7 9a7 7 0 1 1 11.658 5.226l-.011.01-.01.009L12 19.625l-4.637-4.38-.01-.01-.01-.01A7 7 0 0 1 5 10m8-3a1 1 0 1 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Kd);
const Gd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3C9.334 3 7.222 5.093 7.222 7.618c0 .832.288 1.745.787 2.689.495.937 1.167 1.846 1.86 2.652a24 24 0 0 0 2.13 2.168l.226-.205c.522-.48 1.215-1.16 1.905-1.963.693-.806 1.365-1.715 1.86-2.652.5-.944.787-1.857.787-2.69C16.777 5.094 14.665 3 12 3m0 14.22-.625.006-.002-.002-.004-.004-.016-.012-.054-.044-.196-.164a25.812 25.812 0 0 1-2.751-2.737c-.751-.875-1.524-1.91-2.112-3.022-.584-1.106-1.018-2.349-1.018-3.623C5.222 3.936 8.282 1 12 1c3.716 0 6.777 2.936 6.777 6.618 0 1.274-.434 2.517-1.018 3.623-.588 1.113-1.36 2.147-2.112 3.022a26 26 0 0 1-3.001 2.945l-.015.012-.005.004-.001.001zm0 0 .625.005a1 1 0 0 1-1.25 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.654 7.123a.926.926 0 1 0-1.31 1.31.926.926 0 0 0 1.31-1.31m1.413-1.415a2.926 2.926 0 1 0-4.138 4.137 2.926 2.926 0 0 0 4.139-4.136zM17.722 13.565a1 1 0 0 1 1.273-.616c1.086.378 2.044.862 2.749 1.458.701.593 1.256 1.39 1.256 2.37 0 1.386-1.079 2.403-2.269 3.074-1.248.704-2.943 1.224-4.854 1.523a1 1 0 0 1-.31-1.976c1.768-.276 3.211-.742 4.182-1.29 1.03-.58 1.251-1.08 1.251-1.33 0-.17-.092-.458-.547-.843-.452-.382-1.161-.765-2.115-1.097a1 1 0 0 1-.616-1.273M6.278 13.565a1 1 0 0 1-.616 1.273c-.954.332-1.663.715-2.115 1.097-.455.385-.547.674-.547.843 0 .162.08.426.463.777.382.352.991.715 1.828 1.04 1.122.437 2.563.771 4.2.943a1 1 0 0 1 1.55-1.245l1.666 1.666a1 1 0 0 1 0 1.415L11.04 23.04a1 1 0 1 1-1.414-1.414l.06-.06c-1.946-.172-3.71-.558-5.12-1.106-.972-.379-1.828-.854-2.457-1.432-.63-.58-1.109-1.339-1.109-2.25 0-.98.555-1.778 1.256-2.37.705-.597 1.663-1.081 2.749-1.46a1 1 0 0 1 1.273.617",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Gd);
const Jd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 10a9 9 0 1 1 15 6.709l-5.142 4.856a1.25 1.25 0 0 1-1.716 0L6 16.708A8.975 8.975 0 0 1 3 10m9-7a7 7 0 0 0-4.658 12.226l.011.01L12 19.623l4.647-4.389.01-.01q.15-.132.293-.275A7 7 0 0 0 12 3m0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(Jd);
const Zd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.684 2.051a1 1 0 0 1 .632 0l5.317 1.772A2 2 0 0 1 22 5.721v13.892a2 2 0 0 1-2.633 1.897L15 20.054 9.316 21.95a1 1 0 0 1-.632 0l-5.316-1.772A2 2 0 0 1 2 18.279V4.387A2 2 0 0 1 4.632 2.49L9 3.946zM8 5.721 4 4.387V18.28l4 1.334zm2 13.892 4-1.334V4.387l-4 1.334zm6-15.226V18.28l4 1.334V5.72z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Zd);
const Xd = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 9a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(Xd);
const Qd = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M6.999 9.5a1.5 1.5 0 1 0 .003 3 1.5 1.5 0 0 0-.003-3M10.5 11.004a1.5 1.5 0 1 1 3-.008 1.5 1.5 0 0 1-3 .008M16.999 9.5a1.5 1.5 0 1 0 .003 3 1.5 1.5 0 0 0-.003-3"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 3a3 3 0 0 0-3 3v14.006c0 1.692 1.97 2.62 3.273 1.542l2.81-2.32A1 1 0 0 1 7.718 19H20a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM3 6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7.719a3 3 0 0 0-1.91.687L3 20.007z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Qd);
const eu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 0 0-2 2 1 1 0 0 1-2 0 4 4 0 0 1 8 0v5c0 .395-.058.787-.173 1.165a1 1 0 0 1-1.914-.582A2 2 0 0 0 14 10V5a2 2 0 0 0-2-2m-8.707.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-3.606-3.606a8 8 0 0 1-2.687.838V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-3.061a8 8 0 0 1-7-7.94A1 1 0 1 1 6 10a6 6 0 0 0 8.178 5.592l-1.627-1.627A4 4 0 0 1 8 10.002v-.588L3.293 4.707a1 1 0 0 1 0-1.414M18.996 9a1 1 0 0 1 1.002.998 7.97 7.97 0 0 1-1.317 4.403 1 1 0 0 1-1.67-1.102 5.97 5.97 0 0 0 .987-3.297A1 1 0 0 1 18.996 9",
        clipRule: "evenodd"
      }
    )
  }
);
m(eu);
const tu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a2 2 0 0 0-2 2v5a2 2 0 0 0 4 0V5a2 2 0 0 0-2-2m-2.828-.828A4 4 0 0 1 16 5v5a4 4 0 1 1-8 0V5a4 4 0 0 1 1.172-2.828",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M5 9a1 1 0 0 1 1 1 6 6 0 1 0 12 0 1 1 0 1 1 2 0 8 8 0 0 1-7 7.937V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-3.063A8 8 0 0 1 4 10a1 1 0 0 1 1-1"
        }
      )
    ]
  }
);
m(tu);
const nu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m15 1a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2z",
        clipRule: "evenodd"
      }
    )
  }
);
m(nu);
const ou = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 12a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(ou);
const ru = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), au = m(ru), iu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.731 2.39a1 1 0 0 1 .09 1.081 7 7 0 0 0 9.471 9.471 1 1 0 0 1 1.444 1.11c-1.035 4.42-5 7.71-9.736 7.71-5.523 0-10-4.476-10-10 0-4.735 3.291-8.7 7.71-9.736a1 1 0 0 1 1.021.365M8.238 4.7a8 8 0 1 0 10.825 10.825A9 9 0 0 1 8.237 4.7",
        clipRule: "evenodd"
      }
    )
  }
);
m(iu);
const su = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M22 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      }
    )
  }
);
m(su);
const lu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4M12 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4M12 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      }
    )
  }
);
m(lu);
const cu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M20.243 5.366c.377-1.005-.604-1.986-1.61-1.61L3.81 9.317c-1.103.413-1.074 1.983.044 2.356l6.355 2.119 2.119 6.355c.373 1.118 1.943 1.147 2.356.044z"
      }
    )
  }
);
m(cu);
const du = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m14.828 9.172-6.524 2.372 2.965 1.187 1.187 2.965zm1.129-2.539c.878-.319 1.729.532 1.41 1.41l-3.838 10.553c-.345.949-1.68.97-2.055.032L9.731 14.27l-4.36-1.743c-.937-.375-.916-1.71.033-2.055z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(du);
const uu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m10.608 1.577-9.031 9.03a1.97 1.97 0 0 0 0 2.786l9.03 9.03c.77.77 2.016.77 2.786 0l9.03-9.03a1.97 1.97 0 0 0 0-2.786l-9.03-9.03a1.97 1.97 0 0 0-2.786 0m3.601 5.215a1 1 0 1 0-1.414 1.414L13.59 9h-1.586a4 4 0 0 0-4 4v3a1 1 0 1 0 2 0v-3a2 2 0 0 1 2-2h1.585l-.793.793a1 1 0 0 0 1.414 1.414l2.474-2.473.027-.027a.997.997 0 0 0-.027-1.442z",
        clipRule: "evenodd"
      }
    )
  }
);
m(uu);
const fu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 5a3 3 0 1 1 4.974 2.26l.774 1.75Q11.873 9 12 9c.874 0 1.659.373 2.206.967l1.8-.771a3 3 0 1 1 .788 1.838l-1.8.772Q15 11.902 15 12c0 .382-.072.747-.202 1.083l2.705 2.317a3 3 0 1 1-1.302 1.518L13.496 14.6c-.44.253-.951.399-1.496.399a3 3 0 0 1-1.496-.4L7.8 16.919A3 3 0 1 1 6.497 15.4l2.705-2.317A3 3 0 0 1 9 12c0-.852.356-1.62.925-2.166l-.812-1.836L9 8a3 3 0 0 1-3-3m13 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-7 3q-.226.002-.414.09A1 1 0 1 0 12 11m-7 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m14 0a.996.996 0 0 0-1 1 1 1 0 1 0 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(fu);
const hu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.455 4.162a1 1 0 0 1 .951-.076L10 7.461V5a1 1 0 1 1 2 0v4a1 1 0 0 1-1.406.914L3 6.539V9a1 1 0 1 1-2 0V5a1 1 0 0 1 .455-.838M13 7c0-1.652 1.348-3 3-3h4c1.652 0 3 1.348 3 3s-1.348 3-3 3h-4c-1.652 0-3-1.348-3-3m3-1c-.548 0-1 .452-1 1s.452 1 1 1h4c.548 0 1-.452 1-1s-.452-1-1-1zM1 14c0-1.652 1.348-3 3-3h2a1 1 0 1 1 0 2H4c-.548 0-1 .452-1 1v3c0 .548.452 1 1 1h2a1 1 0 1 1 0 2H4c-1.652 0-3-1.348-3-3zm7 0c0-1.652 1.348-3 3-3h1c1.652 0 3 1.348 3 3v3c0 1.652-1.348 3-3 3h-1c-1.652 0-3-1.348-3-3zm3-1c-.548 0-1 .452-1 1v3c0 .548.452 1 1 1h1c.548 0 1-.452 1-1v-3c0-.548-.452-1-1-1zm5-1a1 1 0 0 1 1-1h3c1.652 0 3 1.348 3 3s-1.348 3-3 3h-1c-.548 0-1 .452-1 1h4a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1v-1c0-1.652 1.348-3 3-3h1c.548 0 1-.452 1-1s-.452-1-1-1h-3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(hu);
const gu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4zm4-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 6h5a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-4v3a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m1 2v4h4a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(gu);
const pu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M6 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM16 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
      }
    )
  }
);
m(pu);
const mu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 7a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 9a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M14 15a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(mu);
const vu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 8a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M13 14a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3V9a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 1 0 0 2h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3 3 3 0 0 0-3-3zm14 3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(vu);
const wu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.879 2.707a3 3 0 0 1 4.242 0l2.172 2.172a3 3 0 0 1 0 4.242L9 21.414A2 2 0 0 1 7.586 22H4a2 2 0 0 1-2-2v-3.586A2 2 0 0 1 2.586 15zm2.828 1.414a1 1 0 0 0-1.414 0L4 16.414V20h3.586L19.879 7.707a1 1 0 0 0 0-1.414z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13.293 4.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(wu);
const bu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7m-.439 7.818A3 3 0 0 1 9.32 13H14a1 1 0 1 1 0 2H9.319a1 1 0 0 0-.92.606l-2.48 5.788a1 1 0 0 1-1.838-.788zm12.146-.525a1 1 0 0 1 0 1.414L17.414 17H22a1 1 0 1 1 0 2h-4.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(bu);
const yu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7m-.439 7.818A3 3 0 0 1 9.32 13H14a1 1 0 1 1 0 2H9.319a1 1 0 0 0-.92.606l-2.48 5.788a1 1 0 0 1-1.838-.788zM18 15a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(yu);
const Cu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7m-.439 7.818A3 3 0 0 1 9.32 13H13a1 1 0 1 1 0 2H9.319a1 1 0 0 0-.92.606l-2.48 5.788a1 1 0 0 1-1.838-.788zm15.146.475a1 1 0 0 1 0 1.414L19.914 18.5l1.793 1.793a1 1 0 0 1-1.414 1.414L18.5 19.914l-1.793 1.793a1 1 0 1 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 0 1 1.414-1.414l1.793 1.793 1.793-1.793a1 1 0 0 1 1.414 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(Cu);
const xu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10M9 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9.342 15.553a1 1 0 0 1 .894-.553h3.528a1 1 0 0 1 .894.553l3.448 6.894a1 1 0 1 0 1.788-.894l-3.447-6.895A3 3 0 0 0 13.764 13h-3.528a3 3 0 0 0-2.683 1.658l-3.447 6.895a1 1 0 1 0 1.788.894z"
        }
      )
    ]
  }
);
m(xu);
const Mu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "m6.982 2.012-.013.002A5.73 5.73 0 0 0 2 7.695 14.306 14.306 0 0 0 16.305 22a5.732 5.732 0 0 0 5.684-4.982 1.79 1.79 0 0 0-1.071-1.85l-4.598-2.06-.013-.007a1.78 1.78 0 0 0-1.694.155 1 1 0 0 0-.091.07L12.27 15.24c-1.34-.69-2.819-2.152-3.512-3.482l1.924-2.285a1.785 1.785 0 0 0 .356-.916 1.8 1.8 0 0 0-.146-.873l-2.06-4.602a1.78 1.78 0 0 0-1.85-1.07m.104 2.064 1.918 4.285-1.945 2.31a1.781 1.781 0 0 0-.36.95c-.021.307.04.614.172.89l.002.007c.935 1.914 2.732 3.687 4.647 4.61l.005.003c.279.132.587.191.895.168a1.77 1.77 0 0 0 .947-.367l2.278-1.936 4.279 1.918c-.15.829-.526 1.607-1.162 2.164a3.73 3.73 0 0 1-2.457.922A12.304 12.304 0 0 1 4 7.695c0-.904.327-1.776.922-2.457.557-.636 1.335-1.011 2.164-1.162m8.416 10.856.02.007h-.006zM15 6a1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M15 2a1 1 0 1 0 0 2 5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7"
        }
      )
    ]
  }
);
m(Mu);
const _u = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 8c-2.992 0-5.868 1.232-7.995 3.437a3.62 3.62 0 0 0-.997 2.28c-.051.79.152 1.57.569 2.218l4.001-1.582.222-2.842a1.756 1.756 0 0 1 .388-.904c.19-.231.44-.41.726-.516l.006-.002c1.828-.662 4.297-.679 6.133-.024l.007.002c.285.104.535.281.727.51a1.76 1.76 0 0 1 .393.902l.24 2.872 4.003 1.584c.417-.649.62-1.428.57-2.218a3.62 3.62 0 0 0-.997-2.28C17.869 9.233 14.992 8 12 8m-9.434 2.048C5.06 7.461 8.454 6 12 6s6.938 1.46 9.434 4.048a5.62 5.62 0 0 1 1.554 3.54 5.66 5.66 0 0 1-1.082 3.719l-.01.011a1.72 1.72 0 0 1-.91.62 1.7 1.7 0 0 1-1.1-.065l-4.371-1.73-.016-.006a1.7 1.7 0 0 1-.68-.509 1.76 1.76 0 0 1-.357-.76 1 1 0 0 1-.016-.115l-.239-2.863c-1.322-.418-3.107-.408-4.432.02l-.221 2.834a1 1 0 0 1-.015.113c-.055.28-.176.544-.356.769-.181.225-.416.403-.686.515l-.015.006-4.369 1.726a1.7 1.7 0 0 1-1.098.065 1.72 1.72 0 0 1-.912-.62l-.009-.011a5.66 5.66 0 0 1-1.082-3.718 5.62 5.62 0 0 1 1.554-3.54",
        clipRule: "evenodd"
      }
    )
  }
);
m(_u);
const Ru = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M19 2a1 1 0 1 0-2 0v1.631l-1.445-.963a1 1 0 0 0-1.11 1.664L16.197 5.5l-1.752 1.168a1 1 0 0 0 1.11 1.664L17 7.37V9a1 1 0 1 0 2 0V7.369l1.445.963a1 1 0 0 0 1.11-1.664L19.803 5.5l1.752-1.168a1 1 0 0 0-1.11-1.664L19 3.631z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m6.969 2.014.013-.002a1.79 1.79 0 0 1 1.85 1.07l2.06 4.602.006.015c.116.27.165.565.14.858a1.8 1.8 0 0 1-.356.916l-1.924 2.285c.693 1.33 2.172 2.793 3.512 3.482l2.252-1.914a1 1 0 0 1 .091-.07 1.783 1.783 0 0 1 1.693-.154l.014.005 4.598 2.061a1.78 1.78 0 0 1 1.07 1.85l-.002.013A5.73 5.73 0 0 1 16.305 22 14.306 14.306 0 0 1 2 7.695a5.732 5.732 0 0 1 4.969-5.682M9.004 8.36 7.086 4.076c-.829.15-1.607.526-2.164 1.162A3.73 3.73 0 0 0 4 7.695 12.304 12.304 0 0 0 16.305 20c.904 0 1.776-.327 2.457-.922.636-.557 1.011-1.335 1.162-2.164l-4.28-1.918-2.277 1.936a1.774 1.774 0 0 1-.947.367 1.8 1.8 0 0 1-.895-.168l-.005-.002c-1.915-.924-3.712-2.697-4.647-4.611l-.002-.006a1.8 1.8 0 0 1-.172-.89 1.8 1.8 0 0 1 .36-.95zm6.518 6.578-.02-.007.014.007z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Ru);
const Su = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M8 9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm6 0h-4v4h4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 2a1 1 0 0 0-2 0v1.126C5.275 3.57 4 5.136 4 7v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H9zM8 5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Su);
const ku = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M7 1a2 2 0 0 0-2 2v1c0 1.306.835 2.417 2 2.83V10a1 1 0 0 1-1 1 3 3 0 0 0-3 3v1a2 2 0 0 0 2 2h6v5a1 1 0 1 0 2 0v-5h6a2 2 0 0 0 2-2v-1a3 3 0 0 0-3-3 1 1 0 0 1-1-1V6.83A3 3 0 0 0 19 4V3a2 2 0 0 0-2-2z"
      }
    )
  }
);
m(ku);
const Du = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a3 3 0 0 1-2 2.83V10a1 1 0 0 0 1 1 3 3 0 0 1 3 3v1a2 2 0 0 1-2 2h-6v5a1 1 0 1 1-2 0v-5H5a2 2 0 0 1-2-2v-1a3 3 0 0 1 3-3 1 1 0 0 0 1-1V6.83A3 3 0 0 1 5 4zm14 12v-1a1 1 0 0 0-1-1 3 3 0 0 1-3-3V5h1a1 1 0 0 0 1-1V3H7v1a1 1 0 0 0 1 1h1v5a3 3 0 0 1-3 3 1 1 0 0 0-1 1v1z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Du);
const Au = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M5 18.895V5.105c0-2.515 2.974-3.984 5.125-2.53L20.63 9.68c1.859 1.257 1.82 3.903-.076 5.11l-10.505 6.685C7.891 22.848 5 21.371 5 18.894"
      }
    )
  }
);
m(Au);
const Ou = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 3.293a1 1 0 0 1 1.414 0l2.68 2.679A3.98 3.98 0 0 1 10 5h6a2 2 0 0 1 2 2v1h4a1 1 0 1 1 0 2h-4v4h4a1 1 0 1 1 0 2h-4v.586l2.707 2.707a1 1 0 0 1-1.414 1.414L8 9.414V15a2 2 0 0 0 2 2h3a1 1 0 1 1 0 2h-3a4 4 0 0 1-4-4v-2H5a2 2 0 0 0-2 2v3a1 1 0 1 1-2 0v-3a4 4 0 0 1 4-4h1V9c0-.474.083-.93.234-1.352l-2.941-2.94a1 1 0 0 1 0-1.415m5.515 4.1L16 14.587V7h-6c-.447 0-.86.146-1.192.394",
        clipRule: "evenodd"
      }
    )
  }
);
m(Ou);
const Pu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5a4 4 0 0 0-4 4v2H5a4 4 0 0 0-4 4v3a1 1 0 1 0 2 0v-3a2 2 0 0 1 2-2h1v2a4 4 0 0 0 4 4h6a2 2 0 0 0 2-2v-1h4a1 1 0 1 0 0-2h-4v-4h4a1 1 0 1 0 0-2h-4V7a2 2 0 0 0-2-2zm6 2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Pu);
const Nu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m12-4a1 1 0 1 0-2 0v3H8a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Nu);
const Eu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Eu);
const Lu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 6a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H7a1 1 0 1 1 0-2h4V7a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(Lu);
const zu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-3a3 3 0 0 0-1 5.83v8.34A3.001 3.001 0 1 0 7.83 20h8.34A3.001 3.001 0 1 0 20 16.17V7.83A3.001 3.001 0 1 0 16.17 4H7.83A3 3 0 0 0 5 2m13 14.17V7.83A3 3 0 0 1 16.17 6H7.83A3 3 0 0 1 6 7.83v8.34A3 3 0 0 1 7.83 18h8.34A3 3 0 0 1 18 16.17M4 19a1 1 0 1 1 2 0 1 1 0 0 1-2 0M19 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(zu);
const Tu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1a1 1 0 0 1 1 1v1.055A9 9 0 0 1 20.945 11H22a1 1 0 1 1 0 2h-1.055A9 9 0 0 1 13 20.945V22a1 1 0 1 1-2 0v-1.055A9 9 0 0 1 3.055 13H2a1 1 0 1 1 0-2h1.055A9 9 0 0 1 11 3.055V2a1 1 0 0 1 1-1m0 4a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Tu);
const Iu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m4.169 1.961a1 1 0 0 1 1.386-.276 10 10 0 1 1-11.11 0 1 1 0 1 1 1.11 1.663 8 8 0 1 0 8.89 0 1 1 0 0 1-.276-1.387",
        clipRule: "evenodd"
      }
    )
  }
);
m(Iu);
const Bu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M11.607 9.08a1 1 0 0 1 .908.063l5 3 .085.056a1 1 0 0 1-1.024 1.706l-.09-.048L12 11.166l-4.485 2.691a1 1 0 0 1-1.03-1.714l5-3z"
      }
    )
  }
);
m(Bu);
const $u = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M11.607 12.08a1 1 0 0 1 .908.063l5 3 .084.056a1 1 0 0 1-1.023 1.706l-.09-.048L12 14.166l-4.485 2.691a1 1 0 0 1-1.03-1.714l5-3zM11.607 6.08a1 1 0 0 1 .908.063l5 3 .084.056a1 1 0 0 1-1.023 1.706l-.09-.048L12 8.166l-4.485 2.691a1 1 0 0 1-1.03-1.714l5-3z"
      }
    )
  }
);
m($u);
const Hu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M12.393 14.92a1 1 0 0 1-.908-.063l-5-3-.085-.056a1 1 0 0 1 1.024-1.706l.09.048L12 12.834l4.485-2.691a1 1 0 0 1 1.03 1.714l-5 3z"
      }
    )
  }
);
m(Hu);
const Fu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M12.393 11.92a1 1 0 0 1-.908-.063l-5-3-.085-.056a1 1 0 0 1 1.024-1.706l.09.048L12 9.834l4.485-2.691a1 1 0 0 1 1.03 1.714l-5 3zM12.393 17.92a1 1 0 0 1-.908-.063l-5-3-.085-.056a1 1 0 0 1 1.024-1.706l.09.048L12 15.834l4.485-2.691a1 1 0 0 1 1.03 1.714l-5 3z"
      }
    )
  }
);
m(Fu);
const Vu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "m17 8 .102.005a1 1 0 0 1 0 1.99L17 10H7a1 1 0 0 1 0-2zM17 14l.102.005a1 1 0 0 1 0 1.99L17 16H7a1 1 0 1 1 0-2z"
      }
    )
  }
);
m(Vu);
const Wu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M12 7.5a2 2 0 0 0-2 2 1 1 0 1 1-2 0 4 4 0 1 1 5 3.874v.126a1 1 0 1 1-2 0V13c0-.862.681-1.419 1.333-1.527A2 2 0 0 0 12 7.5M13.25 17a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1C5.924 1 1 5.924 1 12s4.924 11 11 11 11-4.924 11-11S18.076 1 12 1M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Wu);
const ju = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M14.053 2.192a10.16 10.16 0 0 0-5.823.567 10.07 10.07 0 0 0-4.527 3.68A1 1 0 0 0 5.36 7.56a8.07 8.07 0 0 1 3.628-2.95 8.16 8.16 0 0 1 4.677-.454 8.1 8.1 0 0 1 4.14 2.194l.011.01L19.521 8H17a1 1 0 1 0 0 2h5a.997.997 0 0 0 1-1V4a1 1 0 1 0-2 0v2.648l-1.79-1.725a10.1 10.1 0 0 0-5.157-2.73M9.947 21.808c1.955.385 3.98.188 5.823-.567a10.07 10.07 0 0 0 4.528-3.68 1 1 0 0 0-1.658-1.12 8.07 8.07 0 0 1-3.63 2.95 8.16 8.16 0 0 1-4.676.455 8.1 8.1 0 0 1-4.14-2.195l-.011-.01L4.479 16H7a1 1 0 1 0 0-2H2a.996.996 0 0 0-1 1v5a1 1 0 1 0 2 0v-2.648l1.79 1.725a10.1 10.1 0 0 0 5.157 2.73"
      }
    )
  }
);
m(ju);
const qu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.783 2.024a1 1 0 0 1 1.193.76l4 18a1 1 0 0 1-1.952.433l-4-18a1 1 0 0 1 .76-1.193m-9.566 0a1 1 0 0 1 .76 1.193l-4 18a1 1 0 1 1-1.953-.434l4-18a1 1 0 0 1 1.193-.76M12 4a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m0 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(qu);
const Yu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9.207 8.207a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414zM14.207 7.093a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0M19.207 8.307a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v4h2a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h2v-4H4a3 3 0 0 1-3-3zm16 13v-4H7v4zm3-6H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Yu);
const Uu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M22 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.5 6a2.5 2.5 0 1 0 0 5h4a4.5 4.5 0 1 1 0 9H9a1 1 0 1 1 0-2h5.5a2.5 2.5 0 0 0 0-5h-4a4.5 4.5 0 1 1 0-9H13a1 1 0 1 1 0 2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M6.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" })
    ]
  }
);
m(Uu);
const Ku = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M20.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.5 6a2.5 2.5 0 1 0 0 5h4a4.5 4.5 0 1 1 0 9H11a1 1 0 1 1 0-2h3.5a2.5 2.5 0 0 0 0-5h-4a4.5 4.5 0 1 1 0-9H15a1 1 0 1 1 0 2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M8 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0" })
    ]
  }
);
m(Ku);
const Gu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a4 4 0 1 0 0 8h14a4 4 0 0 0 0-8zM3 9a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H5a2 2 0 0 1-2-2M12 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(Gu);
const Ju = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.5 6a2.5 2.5 0 1 0 0 5h3a4.5 4.5 0 1 1 0 9H11a1 1 0 1 1 0-2h2.5a2.5 2.5 0 0 0 0-5h-3a4.5 4.5 0 1 1 0-9H13a1 1 0 1 1 0 2zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M19 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(Ju);
const Zu = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M14 6a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0z" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 22a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h11.172a3 3 0 0 1 2.12.879l2.83 2.828A3 3 0 0 1 22 7.828V19a3 3 0 0 1-3 3zM5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1v-4a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4h1a1 1 0 0 0 1-1V7.828a1 1 0 0 0-.293-.707L17 4.414V8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V4zm11 16v-4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4zM14 9a1 1 0 0 0 1-1V4H8v4a1 1 0 0 0 1 1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Zu);
const Xu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1h5a1 1 0 0 1 .931.635l2.584 6.593c.35.896.863 2.398.082 3.72A4.22 4.22 0 0 1 18 17a4.2 4.2 0 0 1-3.591-2.06c-.77-1.32-.263-2.812.085-3.706L16.537 6H13v14h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V6H7.466l2.049 5.228c.35.896.864 2.398.082 3.72A4.22 4.22 0 0 1 6 17a4.2 4.2 0 0 1-3.591-2.06c-.77-1.32-.263-2.812.085-3.706l2.574-6.597A1 1 0 0 1 6 4h5V3a1 1 0 0 1 1-1M6.002 7.746l-1.644 4.215c-.375.96-.456 1.57-.223 1.97A2.2 2.2 0 0 0 6 15c.773 0 1.501-.436 1.875-1.07.235-.397.155-1.008-.222-1.973zm12 0 1.65 4.211c.378.964.458 1.576.223 1.974A2.22 2.22 0 0 1 18 15a2.2 2.2 0 0 1-1.864-1.07c-.234-.398-.153-1.009.222-1.969z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Xu);
const Qu = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.5 3a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M1 9.5a8.5 8.5 0 1 1 15.176 5.262l5.531 5.53a1 1 0 0 1-1.414 1.415l-5.531-5.531A8.5 8.5 0 0 1 1 9.5",
        clipRule: "evenodd"
      }
    )
  }
), ef = m(Qu), tf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.707 1.293a1 1 0 0 1 0 1.414L14.414 7 17 9.586l4.293-4.293a1 1 0 1 1 1.414 1.414L19.914 9.5l.438.437a2.21 2.21 0 0 1 0 3.126l-1.29 1.29a2.2 2.2 0 0 1-1.563.647H15.5a.2.2 0 0 0-.148.062l-.439.438q-.052.052-.106.1a2.21 2.21 0 0 1-.457 2.463l-2.288 2.289A2.21 2.21 0 0 1 9 20.413l-2.294 2.294a1 1 0 0 1-1.414-1.414L7.586 19 5 16.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l2.294-2.294a2.21 2.21 0 0 1 .061-3.062l2.29-2.289A2.21 2.21 0 0 1 8.4 9.192q.046-.054.099-.106l.438-.439A.2.2 0 0 0 9 8.5V6.5c0-.586.233-1.148.647-1.563l1.29-1.29a2.21 2.21 0 0 1 3.126 0l.437.438 2.793-2.793a1 1 0 0 1 1.414 0M13.086 5.5l-.437-.437a.21.21 0 0 0-.297 0l-1.29 1.29A.2.2 0 0 0 11 6.5V8.5a2.2 2.2 0 0 1-.647 1.563l-.439.438 3.586 3.586.438-.439A2.2 2.2 0 0 1 15.502 13H17.5a.2.2 0 0 0 .148-.062l1.29-1.29a.21.21 0 0 0 0-.296l-.437-.438-.086.086a2 2 0 0 1-2.828 0L13 8.414a2 2 0 0 1 0-2.828zM8.5 11.914l-.852-.851a.21.21 0 0 0-.296 0l-2.29 2.288a.21.21 0 0 0 0 .297l5.29 5.29a.21.21 0 0 0 .297 0l2.288-2.29a.21.21 0 0 0 0-.296z",
        clipRule: "evenodd"
      }
    )
  }
);
m(tf);
const nf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M14.707 7.793a1 1 0 1 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414-1.414z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m22.352 7.937-.438-.437.793-.793a1 1 0 0 0-1.414-1.414L19 7.586 16.414 5l2.293-2.293a1 1 0 0 0-1.414-1.414l-.793.793-.437-.438a2.21 2.21 0 0 0-3.126 0l-1.29 1.29A2.2 2.2 0 0 0 11 4.501V6a.2.2 0 0 1-.062.148l-1.29 1.29a2.21 2.21 0 0 0 0 3.126l3.79 3.788a2.21 2.21 0 0 0 3.125 0l1.29-1.29A.2.2 0 0 1 18 13H19.5a2.2 2.2 0 0 0 1.563-.647l1.29-1.29a2.21 2.21 0 0 0 0-3.126M15 3.586a2 2 0 0 0 0 2.828L17.586 9a2 2 0 0 0 2.828 0l.086-.086.437.438a.21.21 0 0 1 0 .296l-1.29 1.29A.2.2 0 0 1 19.5 11H18a2.2 2.2 0 0 0-1.562.647l-1.29 1.29a.21.21 0 0 1-.297 0l-3.79-3.788a.21.21 0 0 1 0-.297l1.29-1.29A2.2 2.2 0 0 0 13 5.999V4.5a.2.2 0 0 1 .062-.148l1.29-1.29a.21.21 0 0 1 .297 0l.437.437zM4 17.414l-1.293 1.293a1 1 0 0 1-1.414-1.414l1.294-1.294a2.21 2.21 0 0 1 .061-3.062l2.29-2.288a2.21 2.21 0 0 1 3.125 0l5.288 5.288a2.21 2.21 0 0 1 0 3.126l-2.288 2.289A2.21 2.21 0 0 1 8 21.413l-1.294 1.294a1 1 0 0 1-1.414-1.414L6.586 20zm5.352 2.523-.645-.644-4.644-4.644a.21.21 0 0 1 0-.297l2.289-2.29a.21.21 0 0 1 .296 0l5.29 5.29a.21.21 0 0 1 0 .296l-2.29 2.29a.21.21 0 0 1-.296 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(nf);
const of = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.75 16.996a1.25 1.25 0 1 0 2.5.007 1.25 1.25 0 0 0-2.5-.007",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1c0 1.55-.881 2.894-2.17 3.558a9 9 0 1 1-15.658 0A4 4 0 0 1 1.999 5zm4.255 5A6.96 6.96 0 0 0 5 13c0 1.958.804 3.728 2.1 4.999a5 5 0 1 1 9.8 0A6.98 6.98 0 0 0 19 13a6.96 6.96 0 0 0-1.255-4zM12 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m8-16H4v1a2 2 0 0 0 2 2h12q.08 0 .16-.006A2 2 0 0 0 20 5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(of);
const rf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.401 2.504c1.155-2.002 4.043-2.002 5.198 0l.393.681a1 1 0 0 0 1.125.467l.76-.204c2.232-.6 4.274 1.443 3.675 3.675l-.204.76a1 1 0 0 0 .467 1.125l.681.393c2.002 1.155 2.002 4.043 0 5.198l-.681.393a1 1 0 0 0-.467 1.125l.204.76c.6 2.232-1.443 4.274-3.675 3.675l-.76-.204a1 1 0 0 0-1.125.467l-.393.681c-1.155 2.002-4.043 2.002-5.198 0l-.393-.681a1 1 0 0 0-1.125-.467l-.76.204c-2.232.6-4.274-1.443-3.675-3.675l.204-.76a1 1 0 0 0-.467-1.125l-.681-.393c-2.002-1.155-2.002-4.043 0-5.198l.681-.393a1 1 0 0 0 .467-1.125l-.204-.76c-.6-2.232 1.443-4.274 3.675-3.675l.76.204a1 1 0 0 0 1.125-.467zm3.465.999a1 1 0 0 0-1.732 0l-.393.682a3 3 0 0 1-3.377 1.398l-.76-.204A1 1 0 0 0 5.38 6.604l.204.76a3 3 0 0 1-1.398 3.377l-.682.393a1 1 0 0 0 0 1.732l.682.393a3 3 0 0 1 1.398 3.377l-.204.76a1 1 0 0 0 1.225 1.225l.76-.204a3 3 0 0 1 3.377 1.398l.393.682a1 1 0 0 0 1.732 0l.393-.682a3 3 0 0 1 3.377-1.398l.76.204a1 1 0 0 0 1.225-1.225l-.204-.76a3 3 0 0 1 1.398-3.377l.682-.393a1 1 0 0 0 0-1.732l-.682-.393a3 3 0 0 1-1.398-3.377l.204-.76a1 1 0 0 0-1.225-1.225l-.76.204a3 3 0 0 1-3.377-1.398z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(rf);
const af = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 1.4 3.04l-3.653 2.558a3.992 3.992 0 0 1 0 2.805l3.654 2.557a4 4 0 1 1-1.148 1.638L8.599 15.04a4 4 0 1 1 0-6.08l3.654-2.558A4 4 0 0 1 12 5m-6 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m10 7a1.997 1.997 0 0 0-2 2 2 2 0 1 0 2-2",
        clipRule: "evenodd"
      }
    )
  }
);
m(af);
const sf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 1.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 4.414V14a1 1 0 1 1-2 0V4.414L8.707 6.707a1 1 0 0 1-1.414-1.414zM7 11c-.548 0-1 .452-1 1v8c0 .548.452 1 1 1h10c.548 0 1-.452 1-1v-8c0-.548-.452-1-1-1h-1a1 1 0 1 1 0-2h1c1.652 0 3 1.348 3 3v8c0 1.652-1.348 3-3 3H7c-1.652 0-3-1.348-3-3v-8c0-1.652 1.348-3 3-3h1a1 1 0 0 1 0 2z",
        clipRule: "evenodd"
      }
    )
  }
);
m(sf);
const lf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.633 3.265a2 2 0 0 0-1.265 0l-6 2A2 2 0 0 0 4 7.162v4.773c.326 2.425 2.382 7.5 8 9.032 5.618-1.531 7.674-6.606 8-9.031V7.161a2 2 0 0 0-1.367-1.897zm-1.898-1.897a4 4 0 0 1 2.53 0l6 2A4 4 0 0 1 22 7.162V12q0 .062-.008.124c-.358 2.862-2.736 8.95-9.487 10.778-.33.089-.68.089-1.01 0-6.75-1.829-9.13-7.916-9.487-10.778A1 1 0 0 1 2 12V7.162a4 4 0 0 1 2.735-3.794z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.226 8.294a1 1 0 0 1-.002 1.414l-6.018 6a1 1 0 0 1-1.538-.153l-2-3a1 1 0 1 1 1.664-1.11l1.324 1.987 5.156-5.14a1 1 0 0 1 1.414.002",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(lf);
const cf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.464 7.05a1 1 0 0 1 0 1.414 5 5 0 0 0 0 7.072A1 1 0 1 1 7.05 16.95a7 7 0 0 1 0-9.9 1 1 0 0 1 1.414 0M15.536 16.95a1 1 0 0 1 0-1.414 5 5 0 0 0 0-7.072A1 1 0 0 1 16.95 7.05a7 7 0 0 1 0 9.9 1 1 0 0 1-1.414 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.636 4.222a1 1 0 0 1 0 1.414 9 9 0 0 0 0 12.728 1 1 0 1 1-1.414 1.414c-4.296-4.296-4.296-11.26 0-15.556a1 1 0 0 1 1.414 0M18.364 19.778a1 1 0 0 1 0-1.414 9 9 0 0 0 0-12.728 1 1 0 1 1 1.414-1.414c4.296 4.296 4.296 11.26 0 15.556a1 1 0 0 1-1.414 0M13 14.83a3.001 3.001 0 1 0-2 0V21a1 1 0 1 0 2 0zM11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(cf);
const df = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m19.235 5.32-.027-.027A1 1 0 0 0 18.501 5a1 1 0 0 0-.735.32l-2.473 2.474a1 1 0 0 0 1.414 1.414l.794-.794V17a1 1 0 0 0 2 0V8.415l.793.793a1 1 0 1 0 1.414-1.414zM2 7a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 17a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(df);
const uf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m19.235 18.683-.027.027a1 1 0 0 1-.707.293 1 1 0 0 1-.735-.32l-2.473-2.474a1 1 0 0 1 1.414-1.414l.794.794V7a1 1 0 0 1 2 0v8.588l.793-.793a1 1 0 1 1 1.414 1.414zM2 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 17a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(uf);
const ff = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a9 9 0 0 0-9 9c0 1.706.474 3.298 1.296 4.656.117.192.366.345.703.345h14.003c.336-.001.586-.154.703-.346A8.95 8.95 0 0 0 21 14a9 9 0 0 0-9-9M1 14C1 7.925 5.925 3 12 3s11 4.925 11 11c0 2.08-.579 4.03-1.585 5.69-.534.884-1.492 1.31-2.413 1.31H4.999c-.921.001-1.879-.425-2.414-1.308A10.95 10.95 0 0 1 1 14m11-5a5 5 0 0 0-4.714 6.667 1 1 0 1 1-1.886.666A7 7 0 0 1 12 7a1 1 0 1 1 0 2m5.207-.207a1 1 0 0 1 0 1.414l-3.275 3.275Q14 13.73 14 14a2 2 0 1 1-1.482-1.932l3.275-3.275a1 1 0 0 1 1.414 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(ff);
const hf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0H4v5h5zM13 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm7 0h-5v5h5zM2 15a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0H4v5h5zM13 15a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm7 0h-5v5h5z",
        clipRule: "evenodd"
      }
    )
  }
);
m(hf);
const gf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M19.553 15.106a1 1 0 0 1 .894 1.789l-8 4a1 1 0 0 1-.894 0l-8-4-.09-.051a1 1 0 0 1 .89-1.78l.094.041L12 18.883zm0-4a1 1 0 0 1 .894 1.789l-8 4a1 1 0 0 1-.894 0l-8-4-.09-.051a1 1 0 0 1 .89-1.78l.094.041L12 14.883zM11.66 3.06a1 1 0 0 1 .787.045l8 4 .121.072a1 1 0 0 1-.12 1.718l-8 4a1 1 0 0 1-.895 0l-8-4a1 1 0 0 1 0-1.79l8-4zM6.236 8 12 10.882 17.764 8 12 5.118z"
      }
    )
  }
);
m(gf);
const pf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M12.905 1.574a1 1 0 0 0-1.81.002L8.24 7.672l-6.39.976a1 1 0 0 0-.565 1.687L5.94 15.1l-1.105 6.74a1 1 0 0 0 1.47 1.036l5.696-3.144 5.711 3.145a1 1 0 0 0 1.47-1.038l-1.105-6.74 4.64-4.764a1 1 0 0 0-.566-1.686l-6.376-.976z"
      }
    )
  }
);
m(pf);
const mf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.999 1a1 1 0 0 1 .906.574l2.87 6.098 6.376.976a1 1 0 0 1 .565 1.686l-4.64 4.764 1.105 6.74a1 1 0 0 1-1.469 1.038l-5.711-3.145-5.696 3.144a1 1 0 0 1-1.47-1.037L5.94 15.1l-4.655-4.764a1 1 0 0 1 .564-1.687l6.391-.976 2.854-6.096A1 1 0 0 1 12 1m.003 3.353L9.825 9.004a1 1 0 0 1-.755.565l-4.993.762 3.646 3.732a1 1 0 0 1 .272.86l-.853 5.206 4.375-2.416a1 1 0 0 1 .965 0l4.393 2.419-.854-5.208a1 1 0 0 1 .27-.86l3.637-3.733-4.982-.762a1 1 0 0 1-.754-.563z",
        clipRule: "evenodd"
      }
    )
  }
);
m(mf);
const vf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m2.055-1A9 9 0 0 1 12 3a9 9 0 0 1 8.945 8h-3.418a3 3 0 0 0-3.001-3H9.474a3 3 0 0 0-3.001 3zM11 20.945A9 9 0 0 1 3.055 13h3.78l.348 1.629A3 3 0 0 0 10.117 17H11zm2 0A9 9 0 0 0 20.945 13h-3.78l-.348 1.629A3 3 0 0 1 13.883 17H13zM13.883 15h-3.766a1 1 0 0 1-.978-.79l-.643-3A1 1 0 0 1 9.474 10h5.052a1 1 0 0 1 .978 1.21l-.643 3a1 1 0 0 1-.978.79",
        clipRule: "evenodd"
      }
    )
  }
);
m(vf);
const wf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M8 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zM13 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zM18 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 2a3 3 0 0 0-3 3v1H5a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-6a4 4 0 0 0-4-4h-2V5a3 3 0 0 0-3-3zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1zM5 8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M5.75 22.004a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M15.75 22.004a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      )
    ]
  }
);
m(wf);
const bf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1a1 1 0 0 1 1 1v1.5a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1m7.778 3.222a1 1 0 0 1 0 1.414l-1.06 1.06a1 1 0 1 1-1.415-1.414l1.061-1.06a1 1 0 0 1 1.414 0m-15.556 0a1 1 0 0 1 1.414 0l1.06 1.06a1 1 0 0 1-1.414 1.415l-1.06-1.061a1 1 0 0 1 0-1.414M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0m16 1h-1.5a1 1 0 1 1 0-2H22a1 1 0 1 1 0 2M1 12a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m5.697 5.303a1 1 0 0 1 0 1.414l-1.06 1.061a1 1 0 0 1-1.415-1.414l1.06-1.06a1 1 0 0 1 1.415 0m10.606 0a1 1 0 0 1 1.414 0l1.061 1.06a1 1 0 0 1-1.414 1.415l-1.06-1.06a1 1 0 0 1 0-1.415M12 19.5a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-1.5a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(bf);
const yf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm2 10v2a1 1 0 0 0 1 1h3v-3zm4-2H3v-3h4zm2 2v3h11a1 1 0 0 0 1-1v-2zm12-2H9v-3h12zm0-5V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v3z",
        clipRule: "evenodd"
      }
    )
  }
);
m(yf);
const Cf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.727 2.836A3 3 0 0 1 13.805 2H19a3 3 0 0 1 3 3v5.172a3 3 0 0 1-.879 2.12l-9.956 9.957a3 3 0 0 1-4.306-.065l-5.226-5.553a3 3 0 0 1 .113-4.226l2.228-2.126.002-.002zM4.65 12.398l-1.523 1.454a1 1 0 0 0-.038 1.409l5.226 5.552a1 1 0 0 0 1.436.022l1.668-1.668zm8.183 5.355 6.874-6.874a1 1 0 0 0 .293-.707V5a1 1 0 0 0-1-1h-5.195a1 1 0 0 0-.693.279l-7.017 6.736z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.25 7.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Cf);
const xf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 0 0-2 2v8.5l-.4.3a4 4 0 1 0 4.799 0L14 13.5V5a2 2 0 0 0-2-2M8 5a4 4 0 1 1 8 0v7.528a6 6 0 1 1-8 0zm4 3a1 1 0 0 1 1 1v5.17a3.001 3.001 0 1 1-2 0V9a1 1 0 0 1 1-1m0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
        clipRule: "evenodd"
      }
    )
  }
);
m(xf);
const Mf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.604 21.805A3.01 3.01 0 0 0 15 23h.12c2.087 0 3.542-2.086 2.807-4.05l-1.484-3.953 3.862-.007.063-.008A3.01 3.01 0 0 0 23 12V5a2.99 2.99 0 0 0-2.774-2.987l-.038-.003L8.001 2C6.349 2 5 3.348 5 5v8c0 1.102.898 2 2 2 .31 0 .607.147.802.403zm1.594-1.208-4.802-6.402A3.01 3.01 0 0 0 7 13V5c0-.548.452-1 1-1l12.105.01A.99.99 0 0 1 21 5v7c0 .486-.347.902-.835.99l-6.608.013 2.496 6.647A1 1 0 0 1 15.12 21H15c-.31 0-.607-.147-.802-.403M2 3a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(Mf);
const _f = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.604 2.195A3.01 3.01 0 0 1 15 1h.12c2.087 0 3.542 2.086 2.807 4.05l-1.484 3.953 3.862.007.063.008A3.01 3.01 0 0 1 23 12v7a2.99 2.99 0 0 1-2.774 2.987l-.038.003L8.001 22C6.349 22 5 20.652 5 19v-8c0-1.102.898-2 2-2 .31 0 .607-.147.802-.403zm1.594 1.208L9.396 9.805A3.01 3.01 0 0 1 7 11v8c0 .547.452 1 1 1l12.105-.01A.99.99 0 0 0 21 19v-7c0-.486-.347-.902-.835-.99l-6.608-.013 2.496-6.647A1 1 0 0 0 15.12 3H15c-.31 0-.607.147-.802.403M2 10a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(_f);
const Rf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18.293 2.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414l-.29-.29-.723.727A9.97 9.97 0 0 1 22 13c0 5.523-4.477 10-10 10S2 18.523 2 13 6.477 3 12 3c2.148 0 4.137.677 5.767 1.83l.821-.828-.295-.295a1 1 0 0 1 0-1.414m-1.096 4.625A8 8 0 1 0 6.803 19.082 8 8 0 0 0 17.197 6.918",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 7a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M14 1a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Rf);
const Sf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s("path", { fill: "currentColor", d: "M13 2a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0z" }),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.5 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M15.5 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M19 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M17 16c0-.548.452-1 1-1h2c.548 0 1 .452 1 1v3a1 1 0 1 0 2 0v-3c0-1.652-1.348-3-3-3h-2c-1.652 0-3 1.348-3 3v3a1 1 0 1 0 2 0zM4.037 15.704l-1.08 3.584a1 1 0 1 1-1.914-.576l1.08-3.585c.856-2.835 4.887-2.836 5.744-.002l1.09 3.584a1 1 0 0 1-1.914.582l-1.09-3.587c-.284-.939-1.632-.939-1.916 0"
        }
      )
    ]
  }
);
m(Sf);
const kf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 0-2 0v9a2 2 0 0 0-2 2v7a3 3 0 1 0 6 0v-7a2 2 0 0 0-2-2zM5 13h2v7a1 1 0 1 1-2 0zm9-10.584a1 1 0 0 0-1.4-.916 6.001 6.001 0 0 0-.6 10.697V20a3 3 0 1 0 6 0v-7.803A6.001 6.001 0 0 0 17.4 1.5a1 1 0 0 0-1.4.916V6.5l-1 .75-1-.75zM11 7c0-1.014.377-1.94 1-2.646V6.5a2 2 0 0 0 .8 1.6l1 .75a2 2 0 0 0 2.4 0l1-.75a2 2 0 0 0 .8-1.6V4.354a4.001 4.001 0 0 1-1.4 6.314 1 1 0 0 0-.6.916V20a1 1 0 1 1-2 0v-8.416a1 1 0 0 0-.6-.916A4 4 0 0 1 11 7",
        clipRule: "evenodd"
      }
    )
  }
);
m(kf);
const Df = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a4 4 0 0 1-3.064 3.89l.93 1.61a1 1 0 1 1-1.732 1L15.691 20H8.309l-1.443 2.5a1 1 0 1 1-1.732-1l.93-1.61A4 4 0 0 1 3 16zm4.751 14H7a2 2 0 0 1-2-2v-2h14v2a2 2 0 0 1-2 2H7.751M19 12V9H5v3zM5 7h14V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1zm3-2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M7 16a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m7 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(Df);
const Af = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M12 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M16 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 5V4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h5a1 1 0 1 1 0 2h-1v12a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7H2a1 1 0 1 1 0-2zm2 0h6V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1zM5 7v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Af);
const Of = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "m18.707 9.707-6 6a1 1 0 0 1-1.414 0l-6-6A1 1 0 0 1 6 8h12a1 1 0 0 1 .707 1.707"
      }
    )
  }
), Pf = m(Of), Nf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M12.768 2.36a1 1 0 0 0-1.536 0l-5 6A1 1 0 0 0 7 10h10a1 1 0 0 0 .768-1.64zM12.768 21.64a1 1 0 0 1-1.536 0l-5-6A1 1 0 0 1 7 14h10a1 1 0 0 1 .768 1.64z"
      }
    )
  }
);
m(Nf);
const Ef = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.707 6.793a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L11 9.914V16.5a1 1 0 1 0 2 0V9.914l1.293 1.293a1 1 0 0 0 1.414-1.414z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M12 1c6.076 0 11 4.924 11 11s-4.924 11-11 11q-1.1-.002-2.146-.21a1 1 0 1 1 .388-1.961A9 9 0 0 0 21 12a9 9 0 0 0-10.758-8.829 1 1 0 0 1-.388-1.962A11 11 0 0 1 12 1M5.887 2.853A1 1 0 1 1 7 4.515 9.1 9.1 0 0 0 4.515 7a1 1 0 0 1-1.662-1.113 11.1 11.1 0 0 1 3.034-3.034M1.21 9.854a1 1 0 1 1 1.961.388 9 9 0 0 0 0 3.516 1 1 0 1 1-1.962.388 11 11 0 0 1 0-4.292M2.853 18.113A1 1 0 0 1 4.515 17 9.1 9.1 0 0 0 7 19.485a1 1 0 0 1-1.113 1.662 11.1 11.1 0 0 1-3.034-3.034"
        }
      )
    ]
  }
);
m(Ef);
const Lf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 14a1 1 0 0 1 1 1v3.92A3.08 3.08 0 0 1 17.92 22H6a3 3 0 0 1-3-3v-4a1 1 0 1 1 2 0v4a1 1 0 0 0 1 1h11.92A1.08 1.08 0 0 0 19 18.92V15a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.293 7.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V13a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Lf);
const zf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.035 1.584a1.99 1.99 0 0 1 2.817 0l5.564 5.564c.779.778.779 2.039 0 2.817l-4.567 4.568.613.614a1.245 1.245 0 0 1 0 1.76l-4.683 4.684a3.985 3.985 0 0 1-5.635 0l-.67-.669-1.785 1.786A.996.996 0 1 1 4.28 21.3l1.786-1.786-1.58-1.58L2.7 19.72a.996.996 0 0 1-1.408-1.409l1.786-1.786-.67-.669a3.984 3.984 0 0 1 0-5.635l4.684-4.683a1.245 1.245 0 0 1 1.761 0l.614.613zm-3.16 5.976 5.565 5.564 4.568-4.568-5.564-5.564zm-2.902-.085L3.817 11.63a1.99 1.99 0 0 0 0 2.818l5.735 5.735c.778.778 2.04.778 2.818 0l4.155-4.156zm8.175-2.113a.996.996 0 0 1 0 1.408l-.996.997a.996.996 0 1 1-1.409-1.41l.996-.995a.996.996 0 0 1 1.409 0m2.49 2.49a.996.996 0 0 1 0 1.409l-.996.996a.996.996 0 1 1-1.408-1.409l.996-.996a.996.996 0 0 1 1.408 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(zf);
const Tf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 4a1 1 0 0 1 1-1h6a3 3 0 0 1 3 3v4a1 1 0 1 1-2 0V6a1 1 0 0 0-1-1h-6a1 1 0 0 1-1-1M4 15a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h5.111a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3v-2a1 1 0 0 1 1-1M5.736 10a1 1 0 0 0-.894.553l-.948 1.894a1 1 0 1 1-1.788-.894l.947-1.895A3 3 0 0 1 5.736 8h1.528a3 3 0 0 1 2.683 1.658l.947 1.895a1 1 0 1 1-1.788.894l-.948-1.894A1 1 0 0 0 7.264 10zM6.5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M16.5 11a4.5 4.5 0 1 0 2.396 8.31l2.397 2.397a1 1 0 0 0 1.414-1.414l-2.397-2.397A4.5 4.5 0 0 0 16.5 11M14 15.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0",
        clipRule: "evenodd"
      }
    )
  }
);
m(Tf);
const If = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m10-3a1 1 0 0 1 1-1 4 4 0 0 1 0 8 1 1 0 1 1 0-2 2 2 0 1 0 0-4 1 1 0 0 1-1-1M7.16 14a1 1 0 0 0-.868.504l-3.424 5.992a1 1 0 1 1-1.736-.992l3.424-5.992A3 3 0 0 1 7.16 12h3.678a3 3 0 0 1 2.605 1.512l3.424 5.992a1 1 0 1 1-1.736.992l-3.424-5.992a1 1 0 0 0-.869-.504zM15 13a1 1 0 0 1 1-1h.84a3 3 0 0 1 2.604 1.512l3.424 5.992a1 1 0 1 1-1.736.992l-3.424-5.992a1 1 0 0 0-.869-.504H16a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(If);
const Bf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 1c-1.652 0-3 1.348-3 3v7c0 1.652 1.348 3 3 3h.17a3.001 3.001 0 1 0 0-2H17c-.548 0-1-.452-1-1V4c0-.548.452-1 1-1h5a1 1 0 1 0 0-2zm2 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0M1 9a1 1 0 0 1 1-1h5.87c1.053 0 2.028.556 2.568 1.456l2.19 3.64c.071.119.177.233.311.325l1.732 1.155.002.001a3 3 0 0 1 1.337 2.493V20a1 1 0 0 1-1 1h-2.18a3.001 3.001 0 0 1-5.66 0H2a1 1 0 1 1 0-2h5.17a3.001 3.001 0 0 1 5.66 0h1.18v-1.93a1 1 0 0 0-.441-.826l-.004-.002-1.747-1.165a3.1 3.1 0 0 1-.905-.952l-2.19-3.64A1 1 0 0 0 7.87 10H2a1 1 0 0 1-1-1m9 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M1 12a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-.707-.293L3.586 16H2a1 1 0 1 1 0-2h2a1 1 0 0 1 .707.293l.707.707H6v-2H2a1 1 0 0 1-1-1M18 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
        }
      )
    ]
  }
);
m(Bf);
const $f = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.815 2.38a1 1 0 1 0-1.85-.76l-1.64 4q-.016.04-.028.077a3 3 0 1 0 2.852-1.694zM19 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M14 1a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V5h-1a1 1 0 1 1 0-2h1V2a1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a1 1 0 1 0 0 2h8.87c.347 0 .672.184.853.485l2.19 3.64c.228.38.54.704.905.952l1.747 1.165.004.002a1 1 0 0 1 .441.826V19h-1.18a3.001 3.001 0 0 0-5.66 0H2a1 1 0 1 0 0 2h8.17a3.001 3.001 0 0 0 5.66 0h2.18a1 1 0 0 0 1-1v-2.93c0-.989-.493-1.934-1.337-2.493l-.002-.001-1.732-1.155a1.1 1.1 0 0 1-.312-.325l-2.19-3.64A3 3 0 0 0 10.87 8zm11 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M2 11a1 1 0 1 0 0 2h7v2h-.586l-.707-.707A1 1 0 0 0 7 14H2a1 1 0 1 0 0 2h4.586l.707.707A1 1 0 0 0 8 17h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
        }
      )
    ]
  }
);
m($f);
const Hf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13.93 1.443a1 1 0 0 1 1.387-.274c.865.58 1.708 1.252 2.482 2.036a16.5 16.5 0 0 1 2.031 2.478 1 1 0 0 1-1.66 1.114 14.5 14.5 0 0 0-1.787-2.18l-.005-.005a14 14 0 0 0-2.175-1.782 1 1 0 0 1-.274-1.387M12.622 4.154a1 1 0 0 1 1.393-.242c.595.418 1.148.897 1.662 1.41.52.52.984 1.072 1.404 1.652a1 1 0 1 1-1.622 1.171q-.538-.748-1.196-1.408a10.7 10.7 0 0 0-1.399-1.19 1 1 0 0 1-.242-1.393M11.763 7.063a1 1 0 0 1 1.414 0l.71.71a1 1 0 1 1-1.414 1.414l-.71-.71a1 1 0 0 1 0-1.414"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a1 1 0 0 0 0 2h6.87c.347 0 .672.184.853.485l2.19 3.64c.228.38.54.704.905.952l1.747 1.165.004.002a1 1 0 0 1 .441.826V19h-1.18a3.001 3.001 0 0 0-5.66 0H2a1 1 0 1 0 0 2h6.17a3.001 3.001 0 0 0 5.66 0h2.18a1 1 0 0 0 1-1v-2.93c0-.989-.493-1.934-1.337-2.493l-.002-.001-1.732-1.155a1.1 1.1 0 0 1-.312-.325l-2.19-3.64A3 3 0 0 0 8.87 8zm8 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M1 12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-.707-.293L4.586 16H2a1 1 0 1 1 0-2h3a1 1 0 0 1 .707.293l.707.707H7v-2H2a1 1 0 0 1-1-1M21 10a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1z"
        }
      )
    ]
  }
);
m(Hf);
const Ff = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 3a1 1 0 0 0 0 2h11.13a.97.97 0 0 1 .836.46l3.187 5.072q.1.157.247.268l3.195 2.396.002.002c.256.195.403.493.403.802v4h-2.126a4.002 4.002 0 0 0-7.748 0H2a1 1 0 1 0 0 2h9.126a4.002 4.002 0 0 0 7.748 0H22a1 1 0 0 0 1-1v-5c0-.95-.452-1.832-1.195-2.396L18.748 9.31 15.67 4.413A2.97 2.97 0 0 0 13.13 3zm11 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M1 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H7.84a3 3 0 0 1-1.665-.508l-1.23-.82A1 1 0 0 0 4.39 13H2a1 1 0 1 1 0-2h2.39a3 3 0 0 1 1.665.508l1.23.82c.17.113.367.172.555.172H9V8H2a1 1 0 0 1-1-1"
        }
      )
    ]
  }
);
m(Ff);
const Vf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2.293 2.293a1 1 0 0 1 1.414 0l18 18a1 1 0 0 1-1.414 1.414l-3.899-3.899A3 3 0 0 1 14 19H4a3 3 0 0 1-3-3V8a3 3 0 0 1 2.61-2.975L2.294 3.707a1 1 0 0 1 0-1.414M5.586 7l9.35 9.35A1 1 0 0 1 14 17H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9 6a1 1 0 0 1 1-1h4a3 3 0 0 1 3 3v.382l4.553-2.276A1 1 0 0 1 23 7v10a1 1 0 0 1-1.484.875l-2.25-1.246a1 1 0 1 1 .968-1.75l.766.424V8.618l-4 2V12a1 1 0 1 1-2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 1-1-1"
        }
      )
    ]
  }
);
m(Vf);
const Wf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-.626l4.516 2.5A1 1 0 0 0 23 17V7a1 1 0 0 0-1.447-.894L17 8.382V8a3 3 0 0 0-3-3zm13 5.618v2.47l4 2.215V8.618zM3 8a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Wf);
const jf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm5.507 3.13a1 1 0 0 1 1.008.013l5 3a1 1 0 0 1 0 1.714l-5 3A1 1 0 0 1 9 15V9a1 1 0 0 1 .507-.87M11 10.766v2.468L13.056 12z",
        clipRule: "evenodd"
      }
    )
  }
);
m(jf);
const qf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-6.894l-3.432 4.863A5 5 0 0 1 7.8 20.83l-4.558 1.14a1 1 0 1 1-.486-1.94l4.56-1.14a3 3 0 0 0 1.723-1.18l4.022-5.698a.894.894 0 0 0-1.403-1.104L9.55 13.317A2 2 0 0 1 8.046 14H6a1 1 0 1 1 0-2h2V8H7a3 3 0 0 0-2.4 1.2l-1.8 2.4a1 1 0 1 1-1.6-1.2L3 8a5 5 0 0 1 4-2h1zm2 4.767.154-.176A2.894 2.894 0 0 1 15.182 12H21V5H10z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 6.402a3 3 0 0 1 4.098 4.098 1 1 0 1 1-1.732-1A1 1 0 0 0 15 8.134a1 1 0 1 1-1-1.732",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(qf);
const Yf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8.5 5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m.867 7-.262 2.101a3 3 0 0 0 .535 2.116l4.546 6.364a1 1 0 1 0 1.628-1.162l-4.546-6.365a1 1 0 0 1-.179-.705L11.383 12H13a1 1 0 0 1 .8.4l.73.974a3 3 0 0 0 3.515.985l2.326-.93a1 1 0 0 0-.742-1.857l-2.327.93a1 1 0 0 1-1.172-.328l-.73-.974A3 3 0 0 0 13 10H8a3 3 0 0 0-2.4 1.2l-2.4 3.2a1 1 0 0 0 1.6 1.2l2.4-3.2A1 1 0 0 1 8 12zM8.6 17.2a1 1 0 0 1 .2 1.4l-3 4a1 1 0 1 1-1.6-1.2l3-4a1 1 0 0 1 1.4-.2",
        clipRule: "evenodd"
      }
    )
  }
);
m(Yf);
const Uf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521M13 13.5a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0zm-1 4.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
        clipRule: "evenodd"
      }
    )
  }
), Kf = m(Uf), Gf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521m9.044-6.186a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 1 0 1.414 1.414L12 15.914l1.793 1.793a1 1 0 0 0 1.414-1.414L13.414 14.5l1.793-1.793a1 1 0 0 0-1.414-1.414L12 13.086z",
        clipRule: "evenodd"
      }
    )
  }
);
m(Gf);
const Jf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521m9.975-13.014L2.886 18.493A1 1 0 0 0 3.748 20h16.504a1 1 0 0 0 .861-1.507L12.862 4.465a1 1 0 0 0-1.724 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.793 11.293a1 1 0 0 1 1.414 0L12 13.086l1.793-1.793a1 1 0 0 1 1.414 1.414L13.414 14.5l1.793 1.793a1 1 0 0 1-1.414 1.414L12 15.914l-1.793 1.793a1 1 0 0 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(Jf);
const Zf = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521m9.975-13.014L2.886 18.493A1 1 0 0 0 3.748 20h16.504a1 1 0 0 0 .861-1.507L12.862 4.465a1 1 0 0 0-1.724 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14.5a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M13.25 17a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      )
    ]
  }
);
m(Zf);
const Xf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M12 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1m9 1.5a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1M3 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m13.5 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(Xf);
const Qf = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        d: "M8.83 3.256a1 1 0 0 0-.074 1.414c1.31 1.456 1.62 3.796.693 5.52l-.011.023c-.181.359-.434.722-.707 1.114-.533.767-1.142 1.644-1.438 2.808-.706 2.282-.086 4.776 1.457 6.527a1 1 0 1 0 1.5-1.324c-1.093-1.24-1.537-3.073-1.049-4.629l.01-.03.008-.03c.152-.618.545-1.206.995-1.878.327-.488.684-1.021.999-1.642 1.35-2.518.926-5.694-.969-7.799a1 1 0 0 0-1.414-.074M18.596 3.569a1 1 0 0 1 .957-.57 1 1 0 0 1 .691.331c1.895 2.105 2.32 5.281.969 7.799-.315.621-.672 1.154-.999 1.642-.45.672-.843 1.26-.995 1.877l-.008.032-.01.029c-.488 1.556-.044 3.389 1.049 4.629a1 1 0 1 1-1.5 1.324c-1.543-1.75-2.163-4.245-1.457-6.527.296-1.164.905-2.04 1.438-2.808.273-.392.525-.755.706-1.114l.012-.024c.927-1.723.617-4.063-.693-5.52a1 1 0 0 1-.16-1.1M14.166 3.057a1 1 0 0 1 1.078.273c1.895 2.105 2.32 5.282.969 7.799-.315.621-.672 1.154-.999 1.642-.45.672-.843 1.26-.995 1.877l-.008.032-.01.029c-.488 1.556-.044 3.389 1.049 4.629a1 1 0 1 1-1.5 1.324c-1.543-1.75-2.164-4.245-1.457-6.527.296-1.164.905-2.04 1.438-2.808.273-.392.525-.755.706-1.114l.012-.023c.927-1.723.617-4.064-.693-5.52a1 1 0 0 1 .074-1.414 1 1 0 0 1 .336-.199M4.166 3.057a1 1 0 0 1 1.078.273c1.895 2.105 2.32 5.282.969 7.799-.315.621-.672 1.154-1 1.642-.449.672-.842 1.26-.994 1.877l-.008.032-.01.029c-.488 1.556-.044 3.389 1.049 4.629a1.001 1.001 0 1 1-1.5 1.324c-1.543-1.75-2.163-4.245-1.457-6.527.296-1.164.905-2.04 1.438-2.808.273-.392.526-.755.707-1.114l.011-.023c.927-1.723.617-4.064-.693-5.52a1 1 0 0 1 .41-1.613"
      }
    )
  }
);
m(Qf);
const eh = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m12.735-2.68-.027-.027a.997.997 0 0 0-1.415 0l-.027.028-2.473 2.473a1 1 0 0 0 1.414 1.414l.794-.794V8a1 1 0 1 0 2 0V5.415l.793.793a1 1 0 0 0 1.414-1.414zM18.999 9a1 1 0 0 1 1 1v2.586l.794-.794a1 1 0 1 1 1.414 1.414l-2.473 2.473-.027.028a.997.997 0 0 1-1.415 0l-.027-.028-2.473-2.473a1 1 0 1 1 1.414-1.414l.793.793V10a1 1 0 0 1 1-1M8 11h2a1 1 0 1 0 0-2H7.25C6.56 9 6 9.56 6 10.25v3.5c0 .69.56 1.25 1.25 1.25h3.514a1 1 0 0 1 .894.553l.018.036 1.468 2.428a1 1 0 0 0 1.712-1.034l-1.429-2.364A3 3 0 0 0 10.764 13H8zm-3.121-.536a1 1 0 0 1 0 1.415A3 3 0 1 0 9.12 16.12a1 1 0 0 1 1.415 1.415 5 5 0 0 1-7.072-7.072 1 1 0 0 1 1.415 0M2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
);
m(eh);
const th = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M5 8.01a1 1 0 0 1 1-1h4.34a2.995 2.995 0 0 1 2.88 3.827l-.267.928a6.5 6.5 0 0 1 1.53 2.19l3.31.025a3.02 3.02 0 0 1 2.649 1.657l.003.006 2.45 4.91a1 1 0 1 1-1.79.893l-2.447-4.904-.001-.002a1.02 1.02 0 0 0-.888-.56l-2.791-.02q.021.267.022.54a6.5 6.5 0 1 1-3.79-5.91l.09-.307a.995.995 0 0 0-.96-1.273H6a1 1 0 0 1-1-1M8.5 12a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9",
        clipRule: "evenodd"
      }
    )
  }
);
m(th);
const nh = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M12 6.252a12.74 12.74 0 0 0-8.945 3.667 1 1 0 0 1-1.404-1.425 14.744 14.744 0 0 1 20.698 0 1 1 0 1 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M9.946 9.927a1 1 0 0 1-.622 1.27A8.3 8.3 0 0 0 6.23 13.1a1 1 0 0 1-1.397-1.431 10.3 10.3 0 0 1 3.843-2.365 1 1 0 0 1 1.27.623M14.054 9.927a1 1 0 0 1 1.27-.623 10.3 10.3 0 0 1 3.843 2.365A1 1 0 1 1 17.77 13.1a8.3 8.3 0 0 0-3.094-1.903 1 1 0 0 1-.622-1.27M14.224 14.684a1 1 0 0 1 1.407-.145q.182.149.352.311a1 1 0 1 1-1.385 1.444 4 4 0 0 0-.23-.203 1 1 0 0 1-.144-1.407M9.776 14.684a1 1 0 0 1-.145 1.407 4 4 0 0 0-.23.203 1 1 0 0 1-1.384-1.444q.17-.163.352-.31a1 1 0 0 1 1.407.144M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M13 9a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
        }
      )
    ]
  }
);
m(nh);
const oh = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 15.249c-.969 0-1.9.374-2.598 1.045a1 1 0 0 1-1.385-1.444 5.753 5.753 0 0 1 7.966 0 1 1 0 1 1-1.385 1.444A3.75 3.75 0 0 0 12 15.249",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 10.751a8.26 8.26 0 0 0-5.77 2.35 1 1 0 0 1-1.397-1.432 10.263 10.263 0 0 1 14.334 0A1 1 0 1 1 17.77 13.1 8.26 8.26 0 0 0 12 10.751",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6.252c-3.348 0-6.56 1.317-8.945 3.667a1 1 0 0 1-1.404-1.425 14.744 14.744 0 0 1 20.698 0 1 1 0 1 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(oh);
const rh = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M5.707 4.293a1 1 0 0 0-1.414 1.414l.453.453A14.7 14.7 0 0 0 1.65 8.494a1 1 0 0 0 1.404 1.425 12.7 12.7 0 0 1 3.167-2.282l1.9 1.899a10.05 10.05 0 0 0-3.29 2.133A1 1 0 0 0 6.23 13.1a8.15 8.15 0 0 1 3.464-1.991l2.143 2.142a5.75 5.75 0 0 0-3.82 1.6 1 1 0 1 0 1.385 1.443A3.75 3.75 0 0 1 12 15.249c.766 0 1.667.23 2.235.593.287.184.496.319.634.452q.037.035.076.065l3.348 3.348a1 1 0 0 0 1.414-1.414L10.72 9.305l-.022-.022zM9.682 6.464A12.74 12.74 0 0 1 20.945 9.92a1 1 0 1 0 1.404-1.425 14.74 14.74 0 0 0-13.03-3.996 1 1 0 1 0 .363 1.966M13.024 9.754a1 1 0 0 1 1.192-.76c1.853.41 3.572 1.329 4.951 2.675A1 1 0 0 1 17.77 13.1a8.26 8.26 0 0 0-3.986-2.154 1 1 0 0 1-.76-1.192"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      )
    ]
  }
);
m(rh);
const ah = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M12 6.252a12.74 12.74 0 0 0-8.945 3.667 1 1 0 0 1-1.404-1.425 14.744 14.744 0 0 1 20.698 0 1 1 0 1 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252M7.305 10.967a1 1 0 0 1-.211 1.399 8 8 0 0 0-.864.734 1 1 0 0 1-1.397-1.431q.508-.495 1.073-.913a1 1 0 0 1 1.399.211M16.695 10.967a1 1 0 0 1 1.399-.21q.565.416 1.073.912A1 1 0 1 1 17.77 13.1a8 8 0 0 0-.864-.734 1 1 0 0 1-.21-1.399M9.464 14.86a1 1 0 0 1-.04 1.413l-.022.02a1 1 0 0 1-1.385-1.443l.033-.031a1 1 0 0 1 1.414.04M14.543 14.863a1 1 0 0 1 1.414-.038l.026.025a1 1 0 1 1-1.385 1.444l-.017-.017a1 1 0 0 1-.038-1.414M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          d: "M8.6 11.4a3.4 3.4 0 0 1 6.8 0c0 1.486-.972 2.267-1.628 2.709-.275.185-.465.345-.59.513A.9.9 0 0 0 13 15.2v.3a1 1 0 1 1-2 0v-.3c0-1.506.984-2.298 1.654-2.75.268-.18.452-.334.572-.496a.87.87 0 0 0 .174-.554 1.4 1.4 0 0 0-2.8 0 1 1 0 1 1-2 0"
        }
      )
    ]
  }
);
m(ah);
const ih = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.586 3.515a7 7 0 0 1 7.59-1.535c.865.352.998 1.431.404 2.026l-3.393 3.393.19 1.225 1.224.189 3.393-3.393c.595-.594 1.674-.461 2.026.404a7.002 7.002 0 0 1-8.836 9.235L7.05 21.193a3 3 0 0 1-4.243-4.243l6.134-6.134a7 7 0 0 1 1.645-7.301m5.657 0a5.002 5.002 0 0 0-5.282 6.972c.202.458.12 1.017-.259 1.397l-6.48 6.48a1 1 0 0 0 1.414 1.414l6.48-6.48c.38-.38.939-.462 1.397-.26a5.002 5.002 0 0 0 6.973-5.281l-2.47 2.47a2 2 0 0 1-1.72.563l-1.225-.19A2 2 0 0 1 13.4 8.93l-.19-1.226a2 2 0 0 1 .563-1.72z",
        clipRule: "evenodd"
      }
    )
  }
);
m(ih);
const sh = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12c0 6.076 4.924 11 11 11s11-4.924 11-11S18.076 1 12 1 1 5.924 1 12m8.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586z",
        clipRule: "evenodd"
      }
    )
  }
);
m(sh);
const lh = (t, e) => /* @__PURE__ */ x(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.293 8.293a1 1 0 0 1 1.414 0L12 10.586l2.293-2.293a1 1 0 1 1 1.414 1.414L13.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
m(lh);
const ch = (t, e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ s(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), Sn = m(ch);
function Ia(t) {
  var e, n, o = "";
  if (typeof t == "string" || typeof t == "number") o += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var r = t.length;
    for (e = 0; e < r; e++) t[e] && (n = Ia(t[e])) && (o && (o += " "), o += n);
  } else for (n in t) t[n] && (o && (o += " "), o += n);
  return o;
}
function T() {
  for (var t, e, n = 0, o = "", r = arguments.length; n < r; n++) (t = arguments[n]) && (e = Ia(t)) && (o && (o += " "), o += e);
  return o;
}
const dh = "_icon_1eov9_1", uh = "_size16_1eov9_6", fh = "_size20_1eov9_11", hh = "_size24_1eov9_16", gh = "_size32_1eov9_21", Ln = {
  icon: dh,
  size16: uh,
  size20: fh,
  size24: hh,
  size32: gh
}, De = ({ children: t, className: e, size: n = 24 }) => {
  const o = T({
    [Ln.size16]: n === 16,
    [Ln.size20]: n === 20,
    [Ln.size24]: n === 24,
    [Ln.size32]: n === 32
  });
  return /* @__PURE__ */ s("div", { className: T(Ln.icon, e, o), children: t });
}, ph = "_base_123ss_1", mh = "_regular_123ss_9", vh = "_emphasized_123ss_12", wh = "_bold_123ss_15", bh = "_lg_123ss_20", yh = "_md_123ss_24", Ch = "_sm_123ss_28", xh = "_critical_123ss_34", Mh = "_success_123ss_37", _h = "_reduced_123ss_43", Wt = {
  base: ph,
  regular: mh,
  emphasized: vh,
  bold: wh,
  lg: bh,
  md: yh,
  sm: Ch,
  critical: xh,
  success: Mh,
  default: "_default_123ss_40",
  reduced: _h
}, qe = m(
  ({
    className: t,
    size: e = "md",
    weight: n = "regular",
    color: o = "default",
    ...r
  }, a) => /* @__PURE__ */ s(
    "span",
    {
      ref: a,
      className: T([
        t,
        Wt.base,
        Wt[e],
        Wt[n],
        Wt[o]
      ]),
      ...r
    }
  )
);
qe.displayName = "Text";
const Rh = "_accordion_zsyqb_1", Sh = "_accordionHeader_zsyqb_6", kh = "_chevronIcon_zsyqb_23", Dh = "_headerContent_zsyqb_34", Ah = "_compact_zsyqb_49", Oh = "_accordionContent_zsyqb_54", gn = {
  accordion: Rh,
  accordionHeader: Sh,
  chevronIcon: kh,
  headerContent: Dh,
  compact: Ah,
  accordionContent: Oh
}, oy = ({
  title: t,
  caption: e,
  disabled: n = !1,
  compact: o = !1,
  open: r = !1,
  children: a
}) => {
  const i = `${t} Accordion`, l = V1(), [c, d] = Q(r), u = () => d((f) => n ? !1 : !f);
  return /* @__PURE__ */ x("div", { className: gn.accordion, children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: T(gn.accordionHeader, { [gn.compact]: o }),
        tabIndex: 0,
        role: "button",
        "aria-disabled": n,
        "aria-expanded": c,
        "aria-controls": l,
        id: i,
        onClick: u,
        onKeyDown: (f) => {
          (f.code === "Enter" || f.code === "Space") && u();
        },
        children: [
          /* @__PURE__ */ x("div", { className: gn.headerContent, children: [
            /* @__PURE__ */ s(qe, { weight: "bold", children: t }),
            e && /* @__PURE__ */ s(qe, { size: "sm", weight: "regular", color: "reduced", children: e })
          ] }),
          /* @__PURE__ */ s("div", { className: gn.chevronIcon, children: /* @__PURE__ */ s(De, { children: c ? /* @__PURE__ */ s(B2, {}) : /* @__PURE__ */ s(
            Zn,
            {
              color: n ? "var(--color-content-disabled)" : "var(--color-content)"
            }
          ) }) })
        ]
      }
    ),
    c && /* @__PURE__ */ s(
      "div",
      {
        className: gn.accordionContent,
        role: "region",
        id: l,
        "aria-labelledby": i,
        children: a
      }
    )
  ] });
}, Ph = "_commonItem_13lzg_1", Nh = "_label_13lzg_13", Eh = "_critical_13lzg_18", Lh = "_commonItemLeading_13lzg_25", zh = "_commonItemTrailing_13lzg_29", Th = "_commonItemLeadingTrailing_13lzg_33", Ih = "_selected_13lzg_90", Bh = "_unselectedPlaceholder_13lzg_94", $h = "_leadingWrapper_13lzg_98", Hh = "_checkbox_13lzg_98", Fh = "_checkboxChecked_13lzg_115", Vh = "_checkboxUnchecked_13lzg_122", Wh = "_leadingWrapperGap_13lzg_131", jh = "_divider_13lzg_135", qh = "_actionItemGroup_13lzg_140", Fe = {
  commonItem: Ph,
  label: Nh,
  critical: Eh,
  commonItemLeading: Lh,
  commonItemTrailing: zh,
  commonItemLeadingTrailing: Th,
  selected: Ih,
  unselectedPlaceholder: Bh,
  leadingWrapper: $h,
  checkbox: Hh,
  checkboxChecked: Fh,
  checkboxUnchecked: Vh,
  leadingWrapperGap: Wh,
  divider: jh,
  actionItemGroup: qh
};
function q1() {
  return typeof window < "u";
}
function Ut(t) {
  return Ba(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Ue(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Rt(t) {
  var e;
  return (e = (Ba(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ba(t) {
  return q1() ? t instanceof Node || t instanceof Ue(t).Node : !1;
}
function fe(t) {
  return q1() ? t instanceof Element || t instanceof Ue(t).Element : !1;
}
function Me(t) {
  return q1() ? t instanceof HTMLElement || t instanceof Ue(t).HTMLElement : !1;
}
function No(t) {
  return !q1() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Ue(t).ShadowRoot;
}
const Yh = /* @__PURE__ */ new Set(["inline", "contents"]);
function Xn(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = Xe(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !Yh.has(r);
}
const Uh = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Kh(t) {
  return Uh.has(Ut(t));
}
const Gh = [":popover-open", ":modal"];
function Y1(t) {
  return Gh.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const Jh = ["transform", "translate", "scale", "rotate", "perspective"], Zh = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Xh = ["paint", "layout", "strict", "content"];
function Uo(t) {
  const e = U1(), n = fe(t) ? Xe(t) : t;
  return Jh.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || Zh.some((o) => (n.willChange || "").includes(o)) || Xh.some((o) => (n.contain || "").includes(o));
}
function Qh(t) {
  let e = Tt(t);
  for (; Me(e) && !Lt(e); ) {
    if (Uo(e))
      return e;
    if (Y1(e))
      return null;
    e = Tt(e);
  }
  return null;
}
function U1() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const e4 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Lt(t) {
  return e4.has(Ut(t));
}
function Xe(t) {
  return Ue(t).getComputedStyle(t);
}
function K1(t) {
  return fe(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Tt(t) {
  if (Ut(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    No(t) && t.host || // Fallback.
    Rt(t)
  );
  return No(e) ? e.host : e;
}
function $a(t) {
  const e = Tt(t);
  return Lt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Me(e) && Xn(e) ? e : $a(e);
}
function jt(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = $a(t), a = r === ((o = t.ownerDocument) == null ? void 0 : o.body), i = Ue(r);
  if (a) {
    const l = Eo(i);
    return e.concat(i, i.visualViewport || [], Xn(r) ? r : [], l && n ? jt(l) : []);
  }
  return e.concat(r, jt(r, [], n));
}
function Eo(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
const qt = Math.min, Ze = Math.max, S1 = Math.round, Cn = Math.floor, _t = (t) => ({
  x: t,
  y: t
}), t4 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, n4 = {
  start: "end",
  end: "start"
};
function Lo(t, e, n) {
  return Ze(t, qt(e, n));
}
function kn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Yt(t) {
  return t.split("-")[0];
}
function Dn(t) {
  return t.split("-")[1];
}
function Ha(t) {
  return t === "x" ? "y" : "x";
}
function Ko(t) {
  return t === "y" ? "height" : "width";
}
const o4 = /* @__PURE__ */ new Set(["top", "bottom"]);
function Pt(t) {
  return o4.has(Yt(t)) ? "y" : "x";
}
function Go(t) {
  return Ha(Pt(t));
}
function r4(t, e, n) {
  n === void 0 && (n = !1);
  const o = Dn(t), r = Go(t), a = Ko(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (i = k1(i)), [i, k1(i)];
}
function a4(t) {
  const e = k1(t);
  return [zo(t), e, zo(e)];
}
function zo(t) {
  return t.replace(/start|end/g, (e) => n4[e]);
}
const gr = ["left", "right"], pr = ["right", "left"], i4 = ["top", "bottom"], s4 = ["bottom", "top"];
function l4(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? pr : gr : e ? gr : pr;
    case "left":
    case "right":
      return e ? i4 : s4;
    default:
      return [];
  }
}
function c4(t, e, n, o) {
  const r = Dn(t);
  let a = l4(Yt(t), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), e && (a = a.concat(a.map(zo)))), a;
}
function k1(t) {
  return t.replace(/left|right|bottom|top/g, (e) => t4[e]);
}
function d4(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Fa(t) {
  return typeof t != "number" ? d4(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function D1(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var u4 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], A1 = /* @__PURE__ */ u4.join(","), Va = typeof Element > "u", _n = Va ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, O1 = !Va && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, P1 = function t(e, n) {
  var o;
  n === void 0 && (n = !0);
  var r = e == null || (o = e.getAttribute) === null || o === void 0 ? void 0 : o.call(e, "inert"), a = r === "" || r === "true", i = a || n && e && t(e.parentNode);
  return i;
}, f4 = function(e) {
  var n, o = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return o === "" || o === "true";
}, Wa = function(e, n, o) {
  if (P1(e))
    return [];
  var r = Array.prototype.slice.apply(e.querySelectorAll(A1));
  return n && _n.call(e, A1) && r.unshift(e), r = r.filter(o), r;
}, ja = function t(e, n, o) {
  for (var r = [], a = Array.from(e); a.length; ) {
    var i = a.shift();
    if (!P1(i, !1))
      if (i.tagName === "SLOT") {
        var l = i.assignedElements(), c = l.length ? l : i.children, d = t(c, !0, o);
        o.flatten ? r.push.apply(r, d) : r.push({
          scopeParent: i,
          candidates: d
        });
      } else {
        var u = _n.call(i, A1);
        u && o.filter(i) && (n || !e.includes(i)) && r.push(i);
        var f = i.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(i), g = !P1(f, !1) && (!o.shadowRootFilter || o.shadowRootFilter(i));
        if (f && g) {
          var h = t(f === !0 ? i.children : f.children, !0, o);
          o.flatten ? r.push.apply(r, h) : r.push({
            scopeParent: i,
            candidates: h
          });
        } else
          a.unshift.apply(a, i.children);
      }
  }
  return r;
}, qa = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, Ya = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || f4(e)) && !qa(e) ? 0 : e.tabIndex;
}, h4 = function(e, n) {
  var o = Ya(e);
  return o < 0 && n && !qa(e) ? 0 : o;
}, g4 = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, Ua = function(e) {
  return e.tagName === "INPUT";
}, p4 = function(e) {
  return Ua(e) && e.type === "hidden";
}, m4 = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, v4 = function(e, n) {
  for (var o = 0; o < e.length; o++)
    if (e[o].checked && e[o].form === n)
      return e[o];
}, w4 = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || O1(e), o = function(l) {
    return n.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = o(window.CSS.escape(e.name));
  else
    try {
      r = o(e.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var a = v4(r, e.form);
  return !a || a === e;
}, b4 = function(e) {
  return Ua(e) && e.type === "radio";
}, y4 = function(e) {
  return b4(e) && !w4(e);
}, C4 = function(e) {
  var n, o = e && O1(e), r = (n = o) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (o && o !== e) {
    var i, l, c;
    for (a = !!((i = r) !== null && i !== void 0 && (l = i.ownerDocument) !== null && l !== void 0 && l.contains(r) || e != null && (c = e.ownerDocument) !== null && c !== void 0 && c.contains(e)); !a && r; ) {
      var d, u, f;
      o = O1(r), r = (d = o) === null || d === void 0 ? void 0 : d.host, a = !!((u = r) !== null && u !== void 0 && (f = u.ownerDocument) !== null && f !== void 0 && f.contains(r));
    }
  }
  return a;
}, mr = function(e) {
  var n = e.getBoundingClientRect(), o = n.width, r = n.height;
  return o === 0 && r === 0;
}, x4 = function(e, n) {
  var o = n.displayCheck, r = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var a = _n.call(e, "details>summary:first-of-type"), i = a ? e.parentElement : e;
  if (_n.call(i, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof r == "function") {
      for (var l = e; e; ) {
        var c = e.parentElement, d = O1(e);
        if (c && !c.shadowRoot && r(c) === !0)
          return mr(e);
        e.assignedSlot ? e = e.assignedSlot : !c && d !== e.ownerDocument ? e = d.host : e = c;
      }
      e = l;
    }
    if (C4(e))
      return !e.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return mr(e);
  return !1;
}, M4 = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var r = n.children.item(o);
          if (r.tagName === "LEGEND")
            return _n.call(n, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, To = function(e, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  P1(n) || p4(n) || x4(n, e) || // For a details element with a summary, the summary element gets the focus
  m4(n) || M4(n));
}, Io = function(e, n) {
  return !(y4(n) || Ya(n) < 0 || !To(e, n));
}, _4 = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, R4 = function t(e) {
  var n = [], o = [];
  return e.forEach(function(r, a) {
    var i = !!r.scopeParent, l = i ? r.scopeParent : r, c = h4(l, i), d = i ? t(r.candidates) : l;
    c === 0 ? i ? n.push.apply(n, d) : n.push(l) : o.push({
      documentOrder: a,
      tabIndex: c,
      item: r,
      isScope: i,
      content: d
    });
  }), o.sort(g4).reduce(function(r, a) {
    return a.isScope ? r.push.apply(r, a.content) : r.push(a.content), r;
  }, []).concat(n);
}, G1 = function(e, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ja([e], n.includeContainer, {
    filter: Io.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: _4
  }) : o = Wa(e, n.includeContainer, Io.bind(null, n)), R4(o);
}, S4 = function(e, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ja([e], n.includeContainer, {
    filter: To.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = Wa(e, n.includeContainer, To.bind(null, n)), o;
}, Ka = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return _n.call(e, A1) === !1 ? !1 : Io(n, e);
};
function Ga() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function Ja() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((e) => {
    let {
      brand: n,
      version: o
    } = e;
    return n + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function Za() {
  return /apple/i.test(navigator.vendor);
}
function Bo() {
  const t = /android/i;
  return t.test(Ga()) || t.test(Ja());
}
function k4() {
  return Ga().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Xa() {
  return Ja().includes("jsdom/");
}
const vr = "data-floating-ui-focusable", D4 = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", co = "ArrowLeft", uo = "ArrowRight", A4 = "ArrowUp", O4 = "ArrowDown";
function wt(t) {
  let e = t.activeElement;
  for (; ((n = e) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    e = e.shadowRoot.activeElement;
  }
  return e;
}
function Ee(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode == null ? void 0 : e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && No(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Ot(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function fo(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function P4(t) {
  return t.matches("html,body");
}
function ze(t) {
  return t?.ownerDocument || document;
}
function Jo(t) {
  return Me(t) && t.matches(D4);
}
function $o(t) {
  return t ? t.getAttribute("role") === "combobox" && Jo(t) : !1;
}
function N4(t) {
  if (!t || Xa()) return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function N1(t) {
  return t ? t.hasAttribute(vr) ? t : t.querySelector("[" + vr + "]") || t : null;
}
function rn(t, e, n) {
  return n === void 0 && (n = !0), t.filter((r) => {
    var a;
    return r.parentId === e && (!n || ((a = r.context) == null ? void 0 : a.open));
  }).flatMap((r) => [r, ...rn(t, r.id, n)]);
}
function E4(t, e) {
  let n, o = -1;
  function r(a, i) {
    i > o && (n = a, o = i), rn(t, a).forEach((c) => {
      r(c.id, i + 1);
    });
  }
  return r(e, 0), t.find((a) => a.id === n);
}
function wr(t, e) {
  var n;
  let o = [], r = (n = t.find((a) => a.id === e)) == null ? void 0 : n.parentId;
  for (; r; ) {
    const a = t.find((i) => i.id === r);
    r = a?.parentId, a && (o = o.concat(a));
  }
  return o;
}
function We(t) {
  t.preventDefault(), t.stopPropagation();
}
function L4(t) {
  return "nativeEvent" in t;
}
function Qa(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : Bo() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function ei(t) {
  return Xa() ? !1 : !Bo() && t.width === 0 && t.height === 0 || Bo() && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function qn(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
var z4 = typeof document < "u", T4 = function() {
}, ve = z4 ? qo : T4;
const I4 = {
  ..._
};
function tt(t) {
  const e = _.useRef(t);
  return ve(() => {
    e.current = t;
  }), e;
}
const B4 = I4.useInsertionEffect, $4 = B4 || ((t) => t());
function Te(t) {
  const e = _.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return $4(() => {
    e.current = t;
  }), _.useCallback(function() {
    for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
      o[r] = arguments[r];
    return e.current == null ? void 0 : e.current(...o);
  }, []);
}
function m1(t, e, n) {
  return Math.floor(t / e) !== n;
}
function Fn(t, e) {
  return e < 0 || e >= t.current.length;
}
function ho(t, e) {
  return $e(t, {
    disabledIndices: e
  });
}
function br(t, e) {
  return $e(t, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function $e(t, e) {
  let {
    startingIndex: n = -1,
    decrement: o = !1,
    disabledIndices: r,
    amount: a = 1
  } = e === void 0 ? {} : e, i = n;
  do
    i += o ? -a : a;
  while (i >= 0 && i <= t.current.length - 1 && M1(t, i, r));
  return i;
}
function H4(t, e) {
  let {
    event: n,
    orientation: o,
    loop: r,
    rtl: a,
    cols: i,
    disabledIndices: l,
    minIndex: c,
    maxIndex: d,
    prevIndex: u,
    stopEvent: f = !1
  } = e, g = u;
  if (n.key === A4) {
    if (f && We(n), u === -1)
      g = d;
    else if (g = $e(t, {
      startingIndex: g,
      amount: i,
      decrement: !0,
      disabledIndices: l
    }), r && (u - i < c || g < 0)) {
      const h = u % i, p = d % i, v = d - (p - h);
      p === h ? g = d : g = p > h ? v : v - i;
    }
    Fn(t, g) && (g = u);
  }
  if (n.key === O4 && (f && We(n), u === -1 ? g = c : (g = $e(t, {
    startingIndex: u,
    amount: i,
    disabledIndices: l
  }), r && u + i > d && (g = $e(t, {
    startingIndex: u % i - i,
    amount: i,
    disabledIndices: l
  }))), Fn(t, g) && (g = u)), o === "both") {
    const h = Cn(u / i);
    n.key === (a ? co : uo) && (f && We(n), u % i !== i - 1 ? (g = $e(t, {
      startingIndex: u,
      disabledIndices: l
    }), r && m1(g, i, h) && (g = $e(t, {
      startingIndex: u - u % i - 1,
      disabledIndices: l
    }))) : r && (g = $e(t, {
      startingIndex: u - u % i - 1,
      disabledIndices: l
    })), m1(g, i, h) && (g = u)), n.key === (a ? uo : co) && (f && We(n), u % i !== 0 ? (g = $e(t, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: l
    }), r && m1(g, i, h) && (g = $e(t, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: l
    }))) : r && (g = $e(t, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: l
    })), m1(g, i, h) && (g = u));
    const p = Cn(d / i) === h;
    Fn(t, g) && (r && p ? g = n.key === (a ? uo : co) ? d : $e(t, {
      startingIndex: u - u % i - 1,
      disabledIndices: l
    }) : g = u);
  }
  return g;
}
function F4(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach((a, i) => {
    let {
      width: l,
      height: c
    } = a;
    if (l > e && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + i + " is greater than grid columns");
    let d = !1;
    for (n && (r = 0); !d; ) {
      const u = [];
      for (let f = 0; f < l; f++)
        for (let g = 0; g < c; g++)
          u.push(r + f + g * e);
      r % e + l <= e && u.every((f) => o[f] == null) ? (u.forEach((f) => {
        o[f] = i;
      }), d = !0) : r++;
    }
  }), [...o];
}
function V4(t, e, n, o, r) {
  if (t === -1) return -1;
  const a = n.indexOf(t), i = e[t];
  switch (r) {
    case "tl":
      return a;
    case "tr":
      return i ? a + i.width - 1 : a;
    case "bl":
      return i ? a + (i.height - 1) * o : a;
    case "br":
      return n.lastIndexOf(t);
  }
}
function W4(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function M1(t, e, n) {
  if (typeof n == "function")
    return n(e);
  if (n)
    return n.includes(e);
  const o = t.current[e];
  return o == null || o.hasAttribute("disabled") || o.getAttribute("aria-disabled") === "true";
}
const Qn = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function ti(t, e) {
  const n = G1(t, Qn()), o = n.length;
  if (o === 0) return;
  const r = wt(ze(t)), a = n.indexOf(r), i = a === -1 ? e === 1 ? 0 : o - 1 : a + e;
  return n[i];
}
function ni(t) {
  return ti(ze(t).body, 1) || t;
}
function oi(t) {
  return ti(ze(t).body, -1) || t;
}
function Vn(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !Ee(n, o);
}
function j4(t) {
  G1(t, Qn()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function yr(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
function Cr(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const a = Pt(e), i = Go(e), l = Ko(i), c = Yt(e), d = a === "y", u = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, g = o[l] / 2 - r[l] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (Dn(e)) {
    case "start":
      h[i] -= g * (n && d ? -1 : 1);
      break;
    case "end":
      h[i] += g * (n && d ? -1 : 1);
      break;
  }
  return h;
}
const q4 = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, l = a.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let d = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: f
  } = Cr(d, o, c), g = o, h = {}, p = 0;
  for (let v = 0; v < l.length; v++) {
    const {
      name: w,
      fn: C
    } = l[v], {
      x: b,
      y,
      data: M,
      reset: S
    } = await C({
      x: u,
      y: f,
      initialPlacement: o,
      placement: g,
      strategy: r,
      middlewareData: h,
      rects: d,
      platform: i,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = b ?? u, f = y ?? f, h = {
      ...h,
      [w]: {
        ...h[w],
        ...M
      }
    }, S && p <= 50 && (p++, typeof S == "object" && (S.placement && (g = S.placement), S.rects && (d = S.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: f
    } = Cr(d, g, c)), v = -1);
  }
  return {
    x: u,
    y: f,
    placement: g,
    strategy: r,
    middlewareData: h
  };
};
async function Zo(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: l,
    strategy: c
  } = t, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: g = !1,
    padding: h = 0
  } = kn(e, t), p = Fa(h), w = l[g ? f === "floating" ? "reference" : "floating" : f], C = D1(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(w))) == null || n ? w : w.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: c
  })), b = f === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), M = await (a.isElement == null ? void 0 : a.isElement(y)) ? await (a.getScale == null ? void 0 : a.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = D1(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: b,
    offsetParent: y,
    strategy: c
  }) : b);
  return {
    top: (C.top - S.top + p.top) / M.y,
    bottom: (S.bottom - C.bottom + p.bottom) / M.y,
    left: (C.left - S.left + p.left) / M.x,
    right: (S.right - C.right + p.right) / M.x
  };
}
const Y4 = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: l,
      middlewareData: c
    } = e, {
      element: d,
      padding: u = 0
    } = kn(t, e) || {};
    if (d == null)
      return {};
    const f = Fa(u), g = {
      x: n,
      y: o
    }, h = Go(r), p = Ko(h), v = await i.getDimensions(d), w = h === "y", C = w ? "top" : "left", b = w ? "bottom" : "right", y = w ? "clientHeight" : "clientWidth", M = a.reference[p] + a.reference[h] - g[h] - a.floating[p], S = g[h] - a.reference[h], R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(d));
    let D = R ? R[y] : 0;
    (!D || !await (i.isElement == null ? void 0 : i.isElement(R))) && (D = l.floating[y] || a.floating[p]);
    const P = M / 2 - S / 2, I = D / 2 - v[p] / 2 - 1, N = qt(f[C], I), B = qt(f[b], I), $ = N, V = D - v[p] - B, E = D / 2 - v[p] / 2 + P, A = Lo($, E, V), W = !c.arrow && Dn(r) != null && E !== A && a.reference[p] / 2 - (E < $ ? N : B) - v[p] / 2 < 0, z = W ? E < $ ? E - $ : E - V : 0;
    return {
      [h]: g[h] + z,
      data: {
        [h]: A,
        centerOffset: E - A - z,
        ...W && {
          alignmentOffset: z
        }
      },
      reset: W
    };
  }
}), U4 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: l,
        platform: c,
        elements: d
      } = e, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: g,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: v = !0,
        ...w
      } = kn(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const C = Yt(r), b = Pt(l), y = Yt(l) === l, M = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), S = g || (y || !v ? [k1(l)] : a4(l)), R = p !== "none";
      !g && R && S.push(...c4(l, v, p, M));
      const D = [l, ...S], P = await Zo(e, w), I = [];
      let N = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (u && I.push(P[C]), f) {
        const E = r4(r, i, M);
        I.push(P[E[0]], P[E[1]]);
      }
      if (N = [...N, {
        placement: r,
        overflows: I
      }], !I.every((E) => E <= 0)) {
        var B, $;
        const E = (((B = a.flip) == null ? void 0 : B.index) || 0) + 1, A = D[E];
        if (A && (!(f === "alignment" ? b !== Pt(A) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        N.every((k) => k.overflows[0] > 0 && Pt(k.placement) === b)))
          return {
            data: {
              index: E,
              overflows: N
            },
            reset: {
              placement: A
            }
          };
        let W = ($ = N.filter((z) => z.overflows[0] <= 0).sort((z, k) => z.overflows[1] - k.overflows[1])[0]) == null ? void 0 : $.placement;
        if (!W)
          switch (h) {
            case "bestFit": {
              var V;
              const z = (V = N.filter((k) => {
                if (R) {
                  const O = Pt(k.placement);
                  return O === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  O === "y";
                }
                return !0;
              }).map((k) => [k.placement, k.overflows.filter((O) => O > 0).reduce((O, H) => O + H, 0)]).sort((k, O) => k[1] - O[1])[0]) == null ? void 0 : V[0];
              z && (W = z);
              break;
            }
            case "initialPlacement":
              W = l;
              break;
          }
        if (r !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
}, K4 = /* @__PURE__ */ new Set(["left", "top"]);
async function G4(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = Yt(n), l = Dn(n), c = Pt(n) === "y", d = K4.has(i) ? -1 : 1, u = a && c ? -1 : 1, f = kn(e, t);
  let {
    mainAxis: g,
    crossAxis: h,
    alignmentAxis: p
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof p == "number" && (h = l === "end" ? p * -1 : p), c ? {
    x: h * u,
    y: g * d
  } : {
    x: g * d,
    y: h * u
  };
}
const J4 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: l
      } = e, c = await G4(e, t);
      return i === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Z4 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r
      } = e, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (w) => {
            let {
              x: C,
              y: b
            } = w;
            return {
              x: C,
              y: b
            };
          }
        },
        ...c
      } = kn(t, e), d = {
        x: n,
        y: o
      }, u = await Zo(e, c), f = Pt(Yt(r)), g = Ha(f);
      let h = d[g], p = d[f];
      if (a) {
        const w = g === "y" ? "top" : "left", C = g === "y" ? "bottom" : "right", b = h + u[w], y = h - u[C];
        h = Lo(b, h, y);
      }
      if (i) {
        const w = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", b = p + u[w], y = p - u[C];
        p = Lo(b, p, y);
      }
      const v = l.fn({
        ...e,
        [g]: h,
        [f]: p
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - o,
          enabled: {
            [g]: a,
            [f]: i
          }
        }
      };
    }
  };
}, X4 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: a,
        platform: i,
        elements: l
      } = e, {
        apply: c = () => {
        },
        ...d
      } = kn(t, e), u = await Zo(e, d), f = Yt(r), g = Dn(r), h = Pt(r) === "y", {
        width: p,
        height: v
      } = a.floating;
      let w, C;
      f === "top" || f === "bottom" ? (w = f, C = g === (await (i.isRTL == null ? void 0 : i.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (C = f, w = g === "end" ? "top" : "bottom");
      const b = v - u.top - u.bottom, y = p - u.left - u.right, M = qt(v - u[w], b), S = qt(p - u[C], y), R = !e.middlewareData.shift;
      let D = M, P = S;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (P = y), (o = e.middlewareData.shift) != null && o.enabled.y && (D = b), R && !g) {
        const N = Ze(u.left, 0), B = Ze(u.right, 0), $ = Ze(u.top, 0), V = Ze(u.bottom, 0);
        h ? P = p - 2 * (N !== 0 || B !== 0 ? N + B : Ze(u.left, u.right)) : D = v - 2 * ($ !== 0 || V !== 0 ? $ + V : Ze(u.top, u.bottom));
      }
      await c({
        ...e,
        availableWidth: P,
        availableHeight: D
      });
      const I = await i.getDimensions(l.floating);
      return p !== I.width || v !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ri(t) {
  const e = Xe(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = Me(t), a = r ? t.offsetWidth : n, i = r ? t.offsetHeight : o, l = S1(n) !== a || S1(o) !== i;
  return l && (n = a, o = i), {
    width: n,
    height: o,
    $: l
  };
}
function Xo(t) {
  return fe(t) ? t : t.contextElement;
}
function xn(t) {
  const e = Xo(t);
  if (!Me(e))
    return _t(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = ri(e);
  let i = (a ? S1(n.width) : n.width) / o, l = (a ? S1(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const Q4 = /* @__PURE__ */ _t(0);
function ai(t) {
  const e = Ue(t);
  return !U1() || !e.visualViewport ? Q4 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function e3(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Ue(t) ? !1 : e;
}
function sn(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), a = Xo(t);
  let i = _t(1);
  e && (o ? fe(o) && (i = xn(o)) : i = xn(t));
  const l = e3(a, n, o) ? ai(a) : _t(0);
  let c = (r.left + l.x) / i.x, d = (r.top + l.y) / i.y, u = r.width / i.x, f = r.height / i.y;
  if (a) {
    const g = Ue(a), h = o && fe(o) ? Ue(o) : o;
    let p = g, v = Eo(p);
    for (; v && o && h !== p; ) {
      const w = xn(v), C = v.getBoundingClientRect(), b = Xe(v), y = C.left + (v.clientLeft + parseFloat(b.paddingLeft)) * w.x, M = C.top + (v.clientTop + parseFloat(b.paddingTop)) * w.y;
      c *= w.x, d *= w.y, u *= w.x, f *= w.y, c += y, d += M, p = Ue(v), v = Eo(p);
    }
  }
  return D1({
    width: u,
    height: f,
    x: c,
    y: d
  });
}
function Qo(t, e) {
  const n = K1(t).scrollLeft;
  return e ? e.left + n : sn(Rt(t)).left + n;
}
function ii(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), r = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Qo(t, o)
  )), a = o.top + e.scrollTop;
  return {
    x: r,
    y: a
  };
}
function t3(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const a = r === "fixed", i = Rt(o), l = e ? Y1(e.floating) : !1;
  if (o === i || l && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = _t(1);
  const u = _t(0), f = Me(o);
  if ((f || !f && !a) && ((Ut(o) !== "body" || Xn(i)) && (c = K1(o)), Me(o))) {
    const h = sn(o);
    d = xn(o), u.x = h.x + o.clientLeft, u.y = h.y + o.clientTop;
  }
  const g = i && !f && !a ? ii(i, c, !0) : _t(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + u.x + g.x,
    y: n.y * d.y - c.scrollTop * d.y + u.y + g.y
  };
}
function n3(t) {
  return Array.from(t.getClientRects());
}
function o3(t) {
  const e = Rt(t), n = K1(t), o = t.ownerDocument.body, r = Ze(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), a = Ze(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + Qo(t);
  const l = -n.scrollTop;
  return Xe(o).direction === "rtl" && (i += Ze(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: l
  };
}
function r3(t, e) {
  const n = Ue(t), o = Rt(t), r = n.visualViewport;
  let a = o.clientWidth, i = o.clientHeight, l = 0, c = 0;
  if (r) {
    a = r.width, i = r.height;
    const d = U1();
    (!d || d && e === "fixed") && (l = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: l,
    y: c
  };
}
const a3 = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function i3(t, e) {
  const n = sn(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, a = Me(t) ? xn(t) : _t(1), i = t.clientWidth * a.x, l = t.clientHeight * a.y, c = r * a.x, d = o * a.y;
  return {
    width: i,
    height: l,
    x: c,
    y: d
  };
}
function xr(t, e, n) {
  let o;
  if (e === "viewport")
    o = r3(t, n);
  else if (e === "document")
    o = o3(Rt(t));
  else if (fe(e))
    o = i3(e, n);
  else {
    const r = ai(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return D1(o);
}
function si(t, e) {
  const n = Tt(t);
  return n === e || !fe(n) || Lt(n) ? !1 : Xe(n).position === "fixed" || si(n, e);
}
function s3(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = jt(t, [], !1).filter((l) => fe(l) && Ut(l) !== "body"), r = null;
  const a = Xe(t).position === "fixed";
  let i = a ? Tt(t) : t;
  for (; fe(i) && !Lt(i); ) {
    const l = Xe(i), c = Uo(i);
    !c && l.position === "fixed" && (r = null), (a ? !c && !r : !c && l.position === "static" && !!r && a3.has(r.position) || Xn(i) && !c && si(t, i)) ? o = o.filter((u) => u !== i) : r = l, i = Tt(i);
  }
  return e.set(t, o), o;
}
function l3(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const i = [...n === "clippingAncestors" ? Y1(e) ? [] : s3(e, this._c) : [].concat(n), o], l = i[0], c = i.reduce((d, u) => {
    const f = xr(e, u, r);
    return d.top = Ze(f.top, d.top), d.right = qt(f.right, d.right), d.bottom = qt(f.bottom, d.bottom), d.left = Ze(f.left, d.left), d;
  }, xr(e, l, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function c3(t) {
  const {
    width: e,
    height: n
  } = ri(t);
  return {
    width: e,
    height: n
  };
}
function d3(t, e, n) {
  const o = Me(e), r = Rt(e), a = n === "fixed", i = sn(t, !0, a, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = _t(0);
  function d() {
    c.x = Qo(r);
  }
  if (o || !o && !a)
    if ((Ut(e) !== "body" || Xn(r)) && (l = K1(e)), o) {
      const h = sn(e, !0, a, e);
      c.x = h.x + e.clientLeft, c.y = h.y + e.clientTop;
    } else r && d();
  a && !o && r && d();
  const u = r && !o && !a ? ii(r, l) : _t(0), f = i.left + l.scrollLeft - c.x - u.x, g = i.top + l.scrollTop - c.y - u.y;
  return {
    x: f,
    y: g,
    width: i.width,
    height: i.height
  };
}
function go(t) {
  return Xe(t).position === "static";
}
function Mr(t, e) {
  if (!Me(t) || Xe(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return Rt(t) === n && (n = n.ownerDocument.body), n;
}
function li(t, e) {
  const n = Ue(t);
  if (Y1(t))
    return n;
  if (!Me(t)) {
    let r = Tt(t);
    for (; r && !Lt(r); ) {
      if (fe(r) && !go(r))
        return r;
      r = Tt(r);
    }
    return n;
  }
  let o = Mr(t, e);
  for (; o && Kh(o) && go(o); )
    o = Mr(o, e);
  return o && Lt(o) && go(o) && !Uo(o) ? n : o || Qh(t) || n;
}
const u3 = async function(t) {
  const e = this.getOffsetParent || li, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: d3(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function f3(t) {
  return Xe(t).direction === "rtl";
}
const h3 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: t3,
  getDocumentElement: Rt,
  getClippingRect: l3,
  getOffsetParent: li,
  getElementRects: u3,
  getClientRects: n3,
  getDimensions: c3,
  getScale: xn,
  isElement: fe,
  isRTL: f3
};
function ci(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function g3(t, e) {
  let n = null, o;
  const r = Rt(t);
  function a() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function i(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), a();
    const d = t.getBoundingClientRect(), {
      left: u,
      top: f,
      width: g,
      height: h
    } = d;
    if (l || e(), !g || !h)
      return;
    const p = Cn(f), v = Cn(r.clientWidth - (u + g)), w = Cn(r.clientHeight - (f + h)), C = Cn(u), y = {
      rootMargin: -p + "px " + -v + "px " + -w + "px " + -C + "px",
      threshold: Ze(0, qt(1, c)) || 1
    };
    let M = !0;
    function S(R) {
      const D = R[0].intersectionRatio;
      if (D !== c) {
        if (!M)
          return i();
        D ? i(!1, D) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      D === 1 && !ci(d, t.getBoundingClientRect()) && i(), M = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, y);
    }
    n.observe(t);
  }
  return i(!0), a;
}
function dn(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, d = Xo(t), u = r || a ? [...d ? jt(d) : [], ...jt(e)] : [];
  u.forEach((C) => {
    r && C.addEventListener("scroll", n, {
      passive: !0
    }), a && C.addEventListener("resize", n);
  });
  const f = d && l ? g3(d, n) : null;
  let g = -1, h = null;
  i && (h = new ResizeObserver((C) => {
    let [b] = C;
    b && b.target === d && h && (h.unobserve(e), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var y;
      (y = h) == null || y.observe(e);
    })), n();
  }), d && !c && h.observe(d), h.observe(e));
  let p, v = c ? sn(t) : null;
  c && w();
  function w() {
    const C = sn(t);
    v && !ci(v, C) && n(), v = C, p = requestAnimationFrame(w);
  }
  return n(), () => {
    var C;
    u.forEach((b) => {
      r && b.removeEventListener("scroll", n), a && b.removeEventListener("resize", n);
    }), f?.(), (C = h) == null || C.disconnect(), h = null, c && cancelAnimationFrame(p);
  };
}
const p3 = J4, m3 = Z4, v3 = U4, w3 = X4, _r = Y4, b3 = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: h3,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return q4(t, e, {
    ...r,
    platform: a
  });
};
var y3 = typeof document < "u", C3 = function() {
}, _1 = y3 ? qo : C3;
function E1(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!E1(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && t.$$typeof) && !E1(t[a], e[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function di(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Rr(t, e) {
  const n = di(t);
  return Math.round(e * n) / n;
}
function po(t) {
  const e = _.useRef(t);
  return _1(() => {
    e.current = t;
  }), e;
}
function x3(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: d
  } = t, [u, f] = _.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [g, h] = _.useState(o);
  E1(g, o) || h(o);
  const [p, v] = _.useState(null), [w, C] = _.useState(null), b = _.useCallback((k) => {
    k !== R.current && (R.current = k, v(k));
  }, []), y = _.useCallback((k) => {
    k !== D.current && (D.current = k, C(k));
  }, []), M = a || p, S = i || w, R = _.useRef(null), D = _.useRef(null), P = _.useRef(u), I = c != null, N = po(c), B = po(r), $ = po(d), V = _.useCallback(() => {
    if (!R.current || !D.current)
      return;
    const k = {
      placement: e,
      strategy: n,
      middleware: g
    };
    B.current && (k.platform = B.current), b3(R.current, D.current, k).then((O) => {
      const H = {
        ...O,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: $.current !== !1
      };
      E.current && !E1(P.current, H) && (P.current = H, Aa.flushSync(() => {
        f(H);
      }));
    });
  }, [g, e, n, B, $]);
  _1(() => {
    d === !1 && P.current.isPositioned && (P.current.isPositioned = !1, f((k) => ({
      ...k,
      isPositioned: !1
    })));
  }, [d]);
  const E = _.useRef(!1);
  _1(() => (E.current = !0, () => {
    E.current = !1;
  }), []), _1(() => {
    if (M && (R.current = M), S && (D.current = S), M && S) {
      if (N.current)
        return N.current(M, S, V);
      V();
    }
  }, [M, S, V, N, I]);
  const A = _.useMemo(() => ({
    reference: R,
    floating: D,
    setReference: b,
    setFloating: y
  }), [b, y]), W = _.useMemo(() => ({
    reference: M,
    floating: S
  }), [M, S]), z = _.useMemo(() => {
    const k = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return k;
    const O = Rr(W.floating, u.x), H = Rr(W.floating, u.y);
    return l ? {
      ...k,
      transform: "translate(" + O + "px, " + H + "px)",
      ...di(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: O,
      top: H
    };
  }, [n, l, W.floating, u.x, u.y]);
  return _.useMemo(() => ({
    ...u,
    update: V,
    refs: A,
    elements: W,
    floatingStyles: z
  }), [u, V, A, W, z]);
}
const M3 = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? _r({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? _r({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, An = (t, e) => ({
  ...p3(t),
  options: [t, e]
}), On = (t, e) => ({
  ...m3(t),
  options: [t, e]
}), Pn = (t, e) => ({
  ...v3(t),
  options: [t, e]
}), er = (t, e) => ({
  ...w3(t),
  options: [t, e]
}), _3 = (t, e) => ({
  ...M3(t),
  options: [t, e]
});
function e1(t) {
  const e = _.useRef(void 0), n = _.useCallback((o) => {
    const r = t.map((a) => {
      if (a != null) {
        if (typeof a == "function") {
          const i = a, l = i(o);
          return typeof l == "function" ? l : () => {
            i(null);
          };
        }
        return a.current = o, () => {
          a.current = null;
        };
      }
    });
    return () => {
      r.forEach((a) => a?.());
    };
  }, t);
  return _.useMemo(() => t.every((o) => o == null) ? null : (o) => {
    e.current && (e.current(), e.current = void 0), o != null && (e.current = n(o));
  }, t);
}
function R3(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const ui = /* @__PURE__ */ _.createContext({
  register: () => {
  },
  unregister: () => {
  },
  map: /* @__PURE__ */ new Map(),
  elementsRef: {
    current: []
  }
});
function Kt(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o
  } = t, [r, a] = _.useState(() => /* @__PURE__ */ new Set()), i = _.useCallback((d) => {
    a((u) => new Set(u).add(d));
  }, []), l = _.useCallback((d) => {
    a((u) => {
      const f = new Set(u);
      return f.delete(d), f;
    });
  }, []), c = _.useMemo(() => {
    const d = /* @__PURE__ */ new Map();
    return Array.from(r.keys()).sort(R3).forEach((f, g) => {
      d.set(f, g);
    }), d;
  }, [r]);
  return /* @__PURE__ */ s(ui.Provider, {
    value: _.useMemo(() => ({
      register: i,
      unregister: l,
      map: c,
      elementsRef: n,
      labelsRef: o
    }), [i, l, c, n, o]),
    children: e
  });
}
function fi(t) {
  t === void 0 && (t = {});
  const {
    label: e
  } = t, {
    register: n,
    unregister: o,
    map: r,
    elementsRef: a,
    labelsRef: i
  } = _.useContext(ui), [l, c] = _.useState(null), d = _.useRef(null), u = _.useCallback((f) => {
    if (d.current = f, l !== null && (a.current[l] = f, i)) {
      var g;
      const h = e !== void 0;
      i.current[l] = h ? e : (g = f?.textContent) != null ? g : null;
    }
  }, [l, a, i, e]);
  return ve(() => {
    const f = d.current;
    if (f)
      return n(f), () => {
        o(f);
      };
  }, [n, o]), ve(() => {
    const f = d.current ? r.get(d.current) : null;
    f != null && c(f);
  }, [r]), _.useMemo(() => ({
    ref: u,
    index: l ?? -1
  }), [l, u]);
}
const S3 = "data-floating-ui-focusable", Sr = "active", kr = "selected", t1 = "ArrowLeft", n1 = "ArrowRight", hi = "ArrowUp", J1 = "ArrowDown", k3 = {
  ..._
};
let Dr = !1, D3 = 0;
const Ar = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + D3++
);
function A3() {
  const [t, e] = _.useState(() => Dr ? Ar() : void 0);
  return ve(() => {
    t == null && e(Ar());
  }, []), _.useEffect(() => {
    Dr = !0;
  }, []), t;
}
const O3 = k3.useId, Z1 = O3 || A3;
let Yn;
process.env.NODE_ENV !== "production" && (Yn = /* @__PURE__ */ new Set());
function R1() {
  for (var t, e = arguments.length, n = new Array(e), o = 0; o < e; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((t = Yn) != null && t.has(r))) {
    var a;
    (a = Yn) == null || a.add(r), console.warn(r);
  }
}
function P3() {
  for (var t, e = arguments.length, n = new Array(e), o = 0; o < e; o++)
    n[o] = arguments[o];
  const r = "Floating UI: " + n.join(" ");
  if (!((t = Yn) != null && t.has(r))) {
    var a;
    (a = Yn) == null || a.add(r), console.error(r);
  }
}
const N3 = /* @__PURE__ */ _.forwardRef(function(e, n) {
  const {
    context: {
      placement: o,
      elements: {
        floating: r
      },
      middlewareData: {
        arrow: a,
        shift: i
      }
    },
    width: l = 14,
    height: c = 7,
    tipRadius: d = 0,
    strokeWidth: u = 0,
    staticOffset: f,
    stroke: g,
    d: h,
    style: {
      transform: p,
      ...v
    } = {},
    ...w
  } = e;
  process.env.NODE_ENV !== "production" && (n || R1("The `ref` prop is required for `FloatingArrow`."));
  const C = Z1(), [b, y] = _.useState(!1);
  if (ve(() => {
    if (!r) return;
    Xe(r).direction === "rtl" && y(!0);
  }, [r]), !r)
    return null;
  const [M, S] = o.split("-"), R = M === "top" || M === "bottom";
  let D = f;
  (R && i != null && i.x || !R && i != null && i.y) && (D = null);
  const P = u * 2, I = P / 2, N = l / 2 * (d / -8 + 1), B = c / 2 * d / 4, $ = !!h, V = D && S === "end" ? "bottom" : "top";
  let E = D && S === "end" ? "right" : "left";
  D && b && (E = S === "end" ? "left" : "right");
  const A = a?.x != null ? D || a.x : "", W = a?.y != null ? D || a.y : "", z = h || "M0,0" + (" H" + l) + (" L" + (l - N) + "," + (c - B)) + (" Q" + l / 2 + "," + c + " " + N + "," + (c - B)) + " Z", k = {
    top: $ ? "rotate(180deg)" : "",
    left: $ ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: $ ? "" : "rotate(180deg)",
    right: $ ? "rotate(-90deg)" : "rotate(90deg)"
  }[M];
  return /* @__PURE__ */ x("svg", {
    ...w,
    "aria-hidden": !0,
    ref: n,
    width: $ ? l : l + P,
    height: l,
    viewBox: "0 0 " + l + " " + (c > l ? c : l),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [E]: A,
      [V]: W,
      [M]: R || $ ? "100%" : "calc(100% - " + P / 2 + "px)",
      transform: [k, p].filter((O) => !!O).join(" "),
      ...v
    },
    children: [P > 0 && /* @__PURE__ */ s("path", {
      clipPath: "url(#" + C + ")",
      fill: "none",
      stroke: g,
      strokeWidth: P + (h ? 0 : 1),
      d: z
    }), /* @__PURE__ */ s("path", {
      stroke: P && !h ? w.fill : "none",
      d: z
    }), /* @__PURE__ */ s("clipPath", {
      id: C,
      children: /* @__PURE__ */ s("rect", {
        x: -I,
        y: I * ($ ? -1 : 1),
        width: l + P,
        height: l
      })
    })]
  });
});
function E3() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      var o;
      (o = t.get(e)) == null || o.forEach((r) => r(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      var o;
      (o = t.get(e)) == null || o.delete(n);
    }
  };
}
const L3 = /* @__PURE__ */ _.createContext(null), z3 = /* @__PURE__ */ _.createContext(null), X1 = () => {
  var t;
  return ((t = _.useContext(L3)) == null ? void 0 : t.id) || null;
}, o1 = () => _.useContext(z3);
function ln(t) {
  return "data-floating-ui-" + t;
}
function Ge(t) {
  t.current !== -1 && (clearTimeout(t.current), t.current = -1);
}
const Or = /* @__PURE__ */ ln("safe-polygon");
function mo(t, e, n) {
  if (n && !qn(n))
    return 0;
  if (typeof t == "number")
    return t;
  if (typeof t == "function") {
    const o = t();
    return typeof o == "number" ? o : o?.[e];
  }
  return t?.[e];
}
function vo(t) {
  return typeof t == "function" ? t() : t;
}
function T3(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    events: a,
    elements: i
  } = t, {
    enabled: l = !0,
    delay: c = 0,
    handleClose: d = null,
    mouseOnly: u = !1,
    restMs: f = 0,
    move: g = !0
  } = e, h = o1(), p = X1(), v = tt(d), w = tt(c), C = tt(n), b = tt(f), y = _.useRef(), M = _.useRef(-1), S = _.useRef(), R = _.useRef(-1), D = _.useRef(!0), P = _.useRef(!1), I = _.useRef(() => {
  }), N = _.useRef(!1), B = Te(() => {
    var z;
    const k = (z = r.current.openEvent) == null ? void 0 : z.type;
    return k?.includes("mouse") && k !== "mousedown";
  });
  _.useEffect(() => {
    if (!l) return;
    function z(k) {
      let {
        open: O
      } = k;
      O || (Ge(M), Ge(R), D.current = !0, N.current = !1);
    }
    return a.on("openchange", z), () => {
      a.off("openchange", z);
    };
  }, [l, a]), _.useEffect(() => {
    if (!l || !v.current || !n) return;
    function z(O) {
      B() && o(!1, O, "hover");
    }
    const k = ze(i.floating).documentElement;
    return k.addEventListener("mouseleave", z), () => {
      k.removeEventListener("mouseleave", z);
    };
  }, [i.floating, n, o, l, v, B]);
  const $ = _.useCallback(function(z, k, O) {
    k === void 0 && (k = !0), O === void 0 && (O = "hover");
    const H = mo(w.current, "close", y.current);
    H && !S.current ? (Ge(M), M.current = window.setTimeout(() => o(!1, z, O), H)) : k && (Ge(M), o(!1, z, O));
  }, [w, o]), V = Te(() => {
    I.current(), S.current = void 0;
  }), E = Te(() => {
    if (P.current) {
      const z = ze(i.floating).body;
      z.style.pointerEvents = "", z.removeAttribute(Or), P.current = !1;
    }
  }), A = Te(() => r.current.openEvent ? ["click", "mousedown"].includes(r.current.openEvent.type) : !1);
  _.useEffect(() => {
    if (!l) return;
    function z(L) {
      if (Ge(M), D.current = !1, u && !qn(y.current) || vo(b.current) > 0 && !mo(w.current, "open"))
        return;
      const J = mo(w.current, "open", y.current);
      J ? M.current = window.setTimeout(() => {
        C.current || o(!0, L, "hover");
      }, J) : n || o(!0, L, "hover");
    }
    function k(L) {
      if (A()) {
        E();
        return;
      }
      I.current();
      const J = ze(i.floating);
      if (Ge(R), N.current = !1, v.current && r.current.floatingContext) {
        n || Ge(M), S.current = v.current({
          ...r.current.floatingContext,
          tree: h,
          x: L.clientX,
          y: L.clientY,
          onClose() {
            E(), V(), A() || $(L, !0, "safe-polygon");
          }
        });
        const de = S.current;
        J.addEventListener("mousemove", de), I.current = () => {
          J.removeEventListener("mousemove", de);
        };
        return;
      }
      (y.current === "touch" ? !Ee(i.floating, L.relatedTarget) : !0) && $(L);
    }
    function O(L) {
      A() || r.current.floatingContext && (v.current == null || v.current({
        ...r.current.floatingContext,
        tree: h,
        x: L.clientX,
        y: L.clientY,
        onClose() {
          E(), V(), A() || $(L);
        }
      })(L));
    }
    function H() {
      Ge(M);
    }
    function Y(L) {
      A() || $(L, !1);
    }
    if (fe(i.domReference)) {
      const L = i.domReference, J = i.floating;
      return n && L.addEventListener("mouseleave", O), g && L.addEventListener("mousemove", z, {
        once: !0
      }), L.addEventListener("mouseenter", z), L.addEventListener("mouseleave", k), J && (J.addEventListener("mouseleave", O), J.addEventListener("mouseenter", H), J.addEventListener("mouseleave", Y)), () => {
        n && L.removeEventListener("mouseleave", O), g && L.removeEventListener("mousemove", z), L.removeEventListener("mouseenter", z), L.removeEventListener("mouseleave", k), J && (J.removeEventListener("mouseleave", O), J.removeEventListener("mouseenter", H), J.removeEventListener("mouseleave", Y));
      };
    }
  }, [i, l, t, u, g, $, V, E, o, n, C, h, w, v, r, A, b]), ve(() => {
    var z;
    if (l && n && (z = v.current) != null && (z = z.__options) != null && z.blockPointerEvents && B()) {
      P.current = !0;
      const O = i.floating;
      if (fe(i.domReference) && O) {
        var k;
        const H = ze(i.floating).body;
        H.setAttribute(Or, "");
        const Y = i.domReference, L = h == null || (k = h.nodesRef.current.find((J) => J.id === p)) == null || (k = k.context) == null ? void 0 : k.elements.floating;
        return L && (L.style.pointerEvents = ""), H.style.pointerEvents = "none", Y.style.pointerEvents = "auto", O.style.pointerEvents = "auto", () => {
          H.style.pointerEvents = "", Y.style.pointerEvents = "", O.style.pointerEvents = "";
        };
      }
    }
  }, [l, n, p, i, h, v, B]), ve(() => {
    n || (y.current = void 0, N.current = !1, V(), E());
  }, [n, V, E]), _.useEffect(() => () => {
    V(), Ge(M), Ge(R), E();
  }, [l, i.domReference, V, E]);
  const W = _.useMemo(() => {
    function z(k) {
      y.current = k.pointerType;
    }
    return {
      onPointerDown: z,
      onPointerEnter: z,
      onMouseMove(k) {
        const {
          nativeEvent: O
        } = k;
        function H() {
          !D.current && !C.current && o(!0, O, "hover");
        }
        u && !qn(y.current) || n || vo(b.current) === 0 || N.current && k.movementX ** 2 + k.movementY ** 2 < 2 || (Ge(R), y.current === "touch" ? H() : (N.current = !0, R.current = window.setTimeout(H, vo(b.current))));
      }
    };
  }, [u, o, n, C, b]);
  return _.useMemo(() => l ? {
    reference: W
  } : {}, [l, W]);
}
let Pr = 0;
function en(t, e) {
  e === void 0 && (e = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(Pr);
  const a = () => t?.focus({
    preventScroll: n
  });
  r ? a() : Pr = requestAnimationFrame(a);
}
function I3(t) {
  return t?.ownerDocument || document;
}
const Mn = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function Nr(t) {
  return t === "inert" ? Mn.inert : t === "aria-hidden" ? Mn["aria-hidden"] : Mn.none;
}
let v1 = /* @__PURE__ */ new WeakSet(), w1 = {}, wo = 0;
const B3 = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, gi = (t) => t && (t.host || gi(t.parentNode)), $3 = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = gi(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null);
function H3(t, e, n, o) {
  const r = "data-floating-ui-inert", a = o ? "inert" : n ? "aria-hidden" : null, i = $3(e, t), l = /* @__PURE__ */ new Set(), c = new Set(i), d = [];
  w1[r] || (w1[r] = /* @__PURE__ */ new WeakMap());
  const u = w1[r];
  i.forEach(f), g(e), l.clear();
  function f(h) {
    !h || l.has(h) || (l.add(h), h.parentNode && f(h.parentNode));
  }
  function g(h) {
    !h || c.has(h) || [].forEach.call(h.children, (p) => {
      if (Ut(p) !== "script")
        if (l.has(p))
          g(p);
        else {
          const v = a ? p.getAttribute(a) : null, w = v !== null && v !== "false", C = Nr(a), b = (C.get(p) || 0) + 1, y = (u.get(p) || 0) + 1;
          C.set(p, b), u.set(p, y), d.push(p), b === 1 && w && v1.add(p), y === 1 && p.setAttribute(r, ""), !w && a && p.setAttribute(a, a === "inert" ? "" : "true");
        }
    });
  }
  return wo++, () => {
    d.forEach((h) => {
      const p = Nr(a), w = (p.get(h) || 0) - 1, C = (u.get(h) || 0) - 1;
      p.set(h, w), u.set(h, C), w || (!v1.has(h) && a && h.removeAttribute(a), v1.delete(h)), C || h.removeAttribute(r);
    }), wo--, wo || (Mn.inert = /* @__PURE__ */ new WeakMap(), Mn["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Mn.none = /* @__PURE__ */ new WeakMap(), v1 = /* @__PURE__ */ new WeakSet(), w1 = {});
  };
}
function Er(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const o = I3(t[0]).body;
  return H3(t.concat(Array.from(o.querySelectorAll('[aria-live],[role="status"],output'))), o, e, n);
}
const Q1 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, L1 = /* @__PURE__ */ _.forwardRef(function(e, n) {
  const [o, r] = _.useState();
  ve(() => {
    Za() && r("button");
  }, []);
  const a = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: o,
    "aria-hidden": o ? void 0 : !0,
    [ln("focus-guard")]: "",
    style: Q1
  };
  return /* @__PURE__ */ s("span", {
    ...e,
    ...a
  });
}), pi = /* @__PURE__ */ _.createContext(null), Lr = /* @__PURE__ */ ln("portal");
function F3(t) {
  t === void 0 && (t = {});
  const {
    id: e,
    root: n
  } = t, o = Z1(), r = mi(), [a, i] = _.useState(null), l = _.useRef(null);
  return ve(() => () => {
    a?.remove(), queueMicrotask(() => {
      l.current = null;
    });
  }, [a]), ve(() => {
    if (!o || l.current) return;
    const c = e ? document.getElementById(e) : null;
    if (!c) return;
    const d = document.createElement("div");
    d.id = o, d.setAttribute(Lr, ""), c.appendChild(d), l.current = d, i(d);
  }, [e, o]), ve(() => {
    if (n === null || !o || l.current) return;
    let c = n || r?.portalNode;
    c && !fe(c) && (c = c.current), c = c || document.body;
    let d = null;
    e && (d = document.createElement("div"), d.id = e, c.appendChild(d));
    const u = document.createElement("div");
    u.id = o, u.setAttribute(Lr, ""), c = d || c, c.appendChild(u), l.current = u, i(u);
  }, [e, n, o, r]), a;
}
function St(t) {
  const {
    children: e,
    id: n,
    root: o,
    preserveTabOrder: r = !0
  } = t, a = F3({
    id: n,
    root: o
  }), [i, l] = _.useState(null), c = _.useRef(null), d = _.useRef(null), u = _.useRef(null), f = _.useRef(null), g = i?.modal, h = i?.open, p = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!i && // Guards are only for non-modal focus management.
    !i.modal && // Don't render if unmount is transitioning.
    i.open && r && !!(o || a)
  );
  return _.useEffect(() => {
    if (!a || !r || g)
      return;
    function v(w) {
      a && Vn(w) && (w.type === "focusin" ? yr : j4)(a);
    }
    return a.addEventListener("focusin", v, !0), a.addEventListener("focusout", v, !0), () => {
      a.removeEventListener("focusin", v, !0), a.removeEventListener("focusout", v, !0);
    };
  }, [a, r, g]), _.useEffect(() => {
    a && (h || yr(a));
  }, [h, a]), /* @__PURE__ */ x(pi.Provider, {
    value: _.useMemo(() => ({
      preserveTabOrder: r,
      beforeOutsideRef: c,
      afterOutsideRef: d,
      beforeInsideRef: u,
      afterInsideRef: f,
      portalNode: a,
      setFocusManagerState: l
    }), [r, a]),
    children: [p && a && /* @__PURE__ */ s(L1, {
      "data-type": "outside",
      ref: c,
      onFocus: (v) => {
        if (Vn(v, a)) {
          var w;
          (w = u.current) == null || w.focus();
        } else {
          const C = i ? i.domReference : null, b = oi(C);
          b?.focus();
        }
      }
    }), p && a && /* @__PURE__ */ s("span", {
      "aria-owns": a.id,
      style: Q1
    }), a && /* @__PURE__ */ Aa.createPortal(e, a), p && a && /* @__PURE__ */ s(L1, {
      "data-type": "outside",
      ref: d,
      onFocus: (v) => {
        if (Vn(v, a)) {
          var w;
          (w = f.current) == null || w.focus();
        } else {
          const C = i ? i.domReference : null, b = ni(C);
          b?.focus(), i?.closeOnFocusOut && i?.onOpenChange(!1, v.nativeEvent, "focus-out");
        }
      }
    })]
  });
}
const mi = () => _.useContext(pi);
function zr(t) {
  return _.useMemo(() => (e) => {
    t.forEach((n) => {
      n && (n.current = e);
    });
  }, t);
}
const V3 = 20;
let tn = [];
function W3(t) {
  tn = tn.filter((e) => e.isConnected), t && Ut(t) !== "body" && (tn.push(t), tn.length > V3 && (tn = tn.slice(-20)));
}
function Tr() {
  return tn.slice().reverse().find((t) => t.isConnected);
}
function j3(t) {
  const e = Qn();
  return Ka(t, e) ? t : G1(t, e)[0] || t;
}
function Ir(t, e) {
  var n;
  if (!e.current.includes("floating") && !((n = t.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const o = Qn(), a = S4(t, o).filter((l) => {
    const c = l.getAttribute("data-tabindex") || "";
    return Ka(l, o) || l.hasAttribute("data-tabindex") && !c.startsWith("-");
  }), i = t.getAttribute("tabindex");
  e.current.includes("floating") || a.length === 0 ? i !== "0" && t.setAttribute("tabindex", "0") : (i !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
const q3 = /* @__PURE__ */ _.forwardRef(function(e, n) {
  return /* @__PURE__ */ s("button", {
    ...e,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: Q1
  });
});
function Gt(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    order: r = ["content"],
    guards: a = !0,
    initialFocus: i = 0,
    returnFocus: l = !0,
    restoreFocus: c = !1,
    modal: d = !0,
    visuallyHiddenDismiss: u = !1,
    closeOnFocusOut: f = !0,
    outsideElementsInert: g = !1,
    getInsideElements: h = () => []
  } = t, {
    open: p,
    onOpenChange: v,
    events: w,
    dataRef: C,
    elements: {
      domReference: b,
      floating: y
    }
  } = e, M = Te(() => {
    var te;
    return (te = C.current.floatingContext) == null ? void 0 : te.nodeId;
  }), S = Te(h), R = typeof i == "number" && i < 0, D = $o(b) && R, P = B3(), I = P ? a : !0, N = !I || P && g, B = tt(r), $ = tt(i), V = tt(l), E = o1(), A = mi(), W = _.useRef(null), z = _.useRef(null), k = _.useRef(!1), O = _.useRef(!1), H = _.useRef(-1), Y = A != null, L = N1(y), J = Te(function(te) {
    return te === void 0 && (te = L), te ? G1(te, Qn()) : [];
  }), K = Te((te) => {
    const oe = J(te);
    return B.current.map((ee) => b && ee === "reference" ? b : L && ee === "floating" ? L : oe).filter(Boolean).flat();
  });
  _.useEffect(() => {
    if (o || !d) return;
    function te(ee) {
      if (ee.key === "Tab") {
        Ee(L, wt(ze(L))) && J().length === 0 && !D && We(ee);
        const Z = K(), Ce = Ot(ee);
        B.current[0] === "reference" && Ce === b && (We(ee), ee.shiftKey ? en(Z[Z.length - 1]) : en(Z[1])), B.current[1] === "floating" && Ce === L && ee.shiftKey && (We(ee), en(Z[0]));
      }
    }
    const oe = ze(L);
    return oe.addEventListener("keydown", te), () => {
      oe.removeEventListener("keydown", te);
    };
  }, [o, b, L, d, B, D, J, K]), _.useEffect(() => {
    if (o || !y) return;
    function te(oe) {
      const ee = Ot(oe), Ce = J().indexOf(ee);
      Ce !== -1 && (H.current = Ce);
    }
    return y.addEventListener("focusin", te), () => {
      y.removeEventListener("focusin", te);
    };
  }, [o, y, J]), _.useEffect(() => {
    if (o || !f) return;
    function te() {
      O.current = !0, setTimeout(() => {
        O.current = !1;
      });
    }
    function oe(ee) {
      const Z = ee.relatedTarget, Ce = ee.currentTarget, we = Ot(ee);
      queueMicrotask(() => {
        const Oe = M(), Pe = !(Ee(b, Z) || Ee(y, Z) || Ee(Z, y) || Ee(A?.portalNode, Z) || Z != null && Z.hasAttribute(ln("focus-guard")) || E && (rn(E.nodesRef.current, Oe).find((se) => {
          var he, Ke;
          return Ee((he = se.context) == null ? void 0 : he.elements.floating, Z) || Ee((Ke = se.context) == null ? void 0 : Ke.elements.domReference, Z);
        }) || wr(E.nodesRef.current, Oe).find((se) => {
          var he, Ke, q;
          return [(he = se.context) == null ? void 0 : he.elements.floating, N1((Ke = se.context) == null ? void 0 : Ke.elements.floating)].includes(Z) || ((q = se.context) == null ? void 0 : q.elements.domReference) === Z;
        })));
        if (Ce === b && L && Ir(L, B), c && Ce !== b && !(we != null && we.isConnected) && wt(ze(L)) === ze(L).body) {
          Me(L) && L.focus();
          const se = H.current, he = J(), Ke = he[se] || he[he.length - 1] || L;
          Me(Ke) && Ke.focus();
        }
        if (C.current.insideReactTree) {
          C.current.insideReactTree = !1;
          return;
        }
        (D || !d) && Z && Pe && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        Z !== Tr() && (k.current = !0, v(!1, ee, "focus-out"));
      });
    }
    if (y && Me(b))
      return b.addEventListener("focusout", oe), b.addEventListener("pointerdown", te), y.addEventListener("focusout", oe), () => {
        b.removeEventListener("focusout", oe), b.removeEventListener("pointerdown", te), y.removeEventListener("focusout", oe);
      };
  }, [o, b, y, L, d, E, A, v, f, c, J, D, M, B, C]);
  const de = _.useRef(null), ue = _.useRef(null), Ae = zr([de, A?.beforeInsideRef]), Qe = zr([ue, A?.afterInsideRef]);
  _.useEffect(() => {
    var te, oe;
    if (o || !y) return;
    const ee = Array.from((A == null || (te = A.portalNode) == null ? void 0 : te.querySelectorAll("[" + ln("portal") + "]")) || []), Z = E ? wr(E.nodesRef.current, M()) : [], Ce = E && !d ? Z.map((se) => {
      var he;
      return (he = se.context) == null ? void 0 : he.elements.floating;
    }) : [], we = (oe = Z.find((se) => {
      var he;
      return $o(((he = se.context) == null ? void 0 : he.elements.domReference) || null);
    })) == null || (oe = oe.context) == null ? void 0 : oe.elements.domReference, Oe = [y, we, ...ee, ...Ce, ...S(), W.current, z.current, de.current, ue.current, A?.beforeOutsideRef.current, A?.afterOutsideRef.current, B.current.includes("reference") || D ? b : null].filter((se) => se != null), Pe = d || D ? Er(Oe, !N, N) : Er(Oe);
    return () => {
      Pe();
    };
  }, [o, b, y, d, B, A, D, I, N, E, M, S]), ve(() => {
    if (o || !Me(L)) return;
    const te = ze(L), oe = wt(te);
    queueMicrotask(() => {
      const ee = K(L), Z = $.current, Ce = (typeof Z == "number" ? ee[Z] : Z.current) || L, we = Ee(L, oe);
      !R && !we && p && en(Ce, {
        preventScroll: Ce === L
      });
    });
  }, [o, p, L, R, K, $]), ve(() => {
    if (o || !L) return;
    const te = ze(L), oe = wt(te);
    W3(oe);
    function ee(we) {
      let {
        reason: Oe,
        event: Pe,
        nested: se
      } = we;
      if (["hover", "safe-polygon"].includes(Oe) && Pe.type === "mouseleave" && (k.current = !0), Oe === "outside-press")
        if (se)
          k.current = !1;
        else if (Qa(Pe) || ei(Pe))
          k.current = !1;
        else {
          let he = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return he = !0, !1;
            }
          }), he ? k.current = !1 : k.current = !0;
        }
    }
    w.on("openchange", ee);
    const Z = te.createElement("span");
    Z.setAttribute("tabindex", "-1"), Z.setAttribute("aria-hidden", "true"), Object.assign(Z.style, Q1), Y && b && b.insertAdjacentElement("afterend", Z);
    function Ce() {
      if (typeof V.current == "boolean") {
        const we = b || Tr();
        return we && we.isConnected ? we : Z;
      }
      return V.current.current || Z;
    }
    return () => {
      w.off("openchange", ee);
      const we = wt(te), Oe = Ee(y, we) || E && rn(E.nodesRef.current, M(), !1).some((se) => {
        var he;
        return Ee((he = se.context) == null ? void 0 : he.elements.floating, we);
      }), Pe = Ce();
      queueMicrotask(() => {
        const se = j3(Pe);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        V.current && !k.current && Me(se) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(se !== we && we !== te.body) || Oe) && se.focus({
          preventScroll: !0
        }), Z.remove();
      });
    };
  }, [o, y, L, V, C, w, E, Y, b, M]), _.useEffect(() => {
    queueMicrotask(() => {
      k.current = !1;
    });
  }, [o]), ve(() => {
    if (!o && A)
      return A.setFocusManagerState({
        modal: d,
        closeOnFocusOut: f,
        open: p,
        onOpenChange: v,
        domReference: b
      }), () => {
        A.setFocusManagerState(null);
      };
  }, [o, A, d, p, v, f, b]), ve(() => {
    o || L && Ir(L, B);
  }, [o, L, B]);
  function et(te) {
    return o || !u || !d ? null : /* @__PURE__ */ s(q3, {
      ref: te === "start" ? W : z,
      onClick: (oe) => v(!1, oe.nativeEvent),
      children: typeof u == "string" ? u : "Dismiss"
    });
  }
  const rt = !o && I && (d ? !D : !0) && (Y || d);
  return /* @__PURE__ */ x(It, {
    children: [rt && /* @__PURE__ */ s(L1, {
      "data-type": "inside",
      ref: Ae,
      onFocus: (te) => {
        if (d) {
          const ee = K();
          en(r[0] === "reference" ? ee[0] : ee[ee.length - 1]);
        } else if (A != null && A.preserveTabOrder && A.portalNode)
          if (k.current = !1, Vn(te, A.portalNode)) {
            const ee = ni(b);
            ee?.focus();
          } else {
            var oe;
            (oe = A.beforeOutsideRef.current) == null || oe.focus();
          }
      }
    }), !D && et("start"), n, et("end"), rt && /* @__PURE__ */ s(L1, {
      "data-type": "inside",
      ref: Qe,
      onFocus: (te) => {
        if (d)
          en(K()[0]);
        else if (A != null && A.preserveTabOrder && A.portalNode)
          if (f && (k.current = !0), Vn(te, A.portalNode)) {
            const ee = oi(b);
            ee?.focus();
          } else {
            var oe;
            (oe = A.afterOutsideRef.current) == null || oe.focus();
          }
      }
    })]
  });
}
function Br(t) {
  return Me(t.target) && t.target.tagName === "BUTTON";
}
function Y3(t) {
  return Me(t.target) && t.target.tagName === "A";
}
function $r(t) {
  return Jo(t);
}
function eo(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: o,
    dataRef: r,
    elements: {
      domReference: a
    }
  } = t, {
    enabled: i = !0,
    event: l = "click",
    toggle: c = !0,
    ignoreMouse: d = !1,
    keyboardHandlers: u = !0,
    stickIfOpen: f = !0
  } = e, g = _.useRef(), h = _.useRef(!1), p = _.useMemo(() => ({
    onPointerDown(v) {
      g.current = v.pointerType;
    },
    onMouseDown(v) {
      const w = g.current;
      v.button === 0 && l !== "click" && (qn(w, !0) && d || (n && c && (!(r.current.openEvent && f) || r.current.openEvent.type === "mousedown") ? o(!1, v.nativeEvent, "click") : (v.preventDefault(), o(!0, v.nativeEvent, "click"))));
    },
    onClick(v) {
      const w = g.current;
      if (l === "mousedown" && g.current) {
        g.current = void 0;
        return;
      }
      qn(w, !0) && d || (n && c && (!(r.current.openEvent && f) || r.current.openEvent.type === "click") ? o(!1, v.nativeEvent, "click") : o(!0, v.nativeEvent, "click"));
    },
    onKeyDown(v) {
      g.current = void 0, !(v.defaultPrevented || !u || Br(v)) && (v.key === " " && !$r(a) && (v.preventDefault(), h.current = !0), !Y3(v) && v.key === "Enter" && o(!(n && c), v.nativeEvent, "click"));
    },
    onKeyUp(v) {
      v.defaultPrevented || !u || Br(v) || $r(a) || v.key === " " && h.current && (h.current = !1, o(!(n && c), v.nativeEvent, "click"));
    }
  }), [r, a, l, d, u, o, n, f, c]);
  return _.useMemo(() => i ? {
    reference: p
  } : {}, [i, p]);
}
const U3 = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, K3 = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Hr = (t) => {
  var e, n;
  return {
    escapeKey: typeof t == "boolean" ? t : (e = t?.escapeKey) != null ? e : !1,
    outsidePress: typeof t == "boolean" ? t : (n = t?.outsidePress) != null ? n : !0
  };
};
function r1(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: o,
    elements: r,
    dataRef: a
  } = t, {
    enabled: i = !0,
    escapeKey: l = !0,
    outsidePress: c = !0,
    outsidePressEvent: d = "pointerdown",
    referencePress: u = !1,
    referencePressEvent: f = "pointerdown",
    ancestorScroll: g = !1,
    bubbles: h,
    capture: p
  } = e, v = o1(), w = Te(typeof c == "function" ? c : () => !1), C = typeof c == "function" ? w : c, b = _.useRef(!1), {
    escapeKey: y,
    outsidePress: M
  } = Hr(h), {
    escapeKey: S,
    outsidePress: R
  } = Hr(p), D = _.useRef(!1), P = _.useRef(-1), I = Te((A) => {
    var W;
    if (!n || !i || !l || A.key !== "Escape" || D.current)
      return;
    const z = (W = a.current.floatingContext) == null ? void 0 : W.nodeId, k = v ? rn(v.nodesRef.current, z) : [];
    if (!y && (A.stopPropagation(), k.length > 0)) {
      let O = !0;
      if (k.forEach((H) => {
        var Y;
        if ((Y = H.context) != null && Y.open && !H.context.dataRef.current.__escapeKeyBubbles) {
          O = !1;
          return;
        }
      }), !O)
        return;
    }
    o(!1, L4(A) ? A.nativeEvent : A, "escape-key");
  }), N = Te((A) => {
    var W;
    const z = () => {
      var k;
      I(A), (k = Ot(A)) == null || k.removeEventListener("keydown", z);
    };
    (W = Ot(A)) == null || W.addEventListener("keydown", z);
  }), B = Te((A) => {
    var W;
    const z = a.current.insideReactTree;
    a.current.insideReactTree = !1;
    const k = b.current;
    if (b.current = !1, d === "click" && k || z || typeof C == "function" && !C(A))
      return;
    const O = Ot(A), H = "[" + ln("inert") + "]", Y = ze(r.floating).querySelectorAll(H);
    let L = fe(O) ? O : null;
    for (; L && !Lt(L); ) {
      const ue = Tt(L);
      if (Lt(ue) || !fe(ue))
        break;
      L = ue;
    }
    if (Y.length && fe(O) && !P4(O) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Ee(O, r.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(Y).every((ue) => !Ee(L, ue)))
      return;
    if (Me(O) && E) {
      const ue = Lt(O), Ae = Xe(O), Qe = /auto|scroll/, et = ue || Qe.test(Ae.overflowX), rt = ue || Qe.test(Ae.overflowY), te = et && O.clientWidth > 0 && O.scrollWidth > O.clientWidth, oe = rt && O.clientHeight > 0 && O.scrollHeight > O.clientHeight, ee = Ae.direction === "rtl", Z = oe && (ee ? A.offsetX <= O.offsetWidth - O.clientWidth : A.offsetX > O.clientWidth), Ce = te && A.offsetY > O.clientHeight;
      if (Z || Ce)
        return;
    }
    const J = (W = a.current.floatingContext) == null ? void 0 : W.nodeId, K = v && rn(v.nodesRef.current, J).some((ue) => {
      var Ae;
      return fo(A, (Ae = ue.context) == null ? void 0 : Ae.elements.floating);
    });
    if (fo(A, r.floating) || fo(A, r.domReference) || K)
      return;
    const de = v ? rn(v.nodesRef.current, J) : [];
    if (de.length > 0) {
      let ue = !0;
      if (de.forEach((Ae) => {
        var Qe;
        if ((Qe = Ae.context) != null && Qe.open && !Ae.context.dataRef.current.__outsidePressBubbles) {
          ue = !1;
          return;
        }
      }), !ue)
        return;
    }
    o(!1, A, "outside-press");
  }), $ = Te((A) => {
    var W;
    const z = () => {
      var k;
      B(A), (k = Ot(A)) == null || k.removeEventListener(d, z);
    };
    (W = Ot(A)) == null || W.addEventListener(d, z);
  });
  _.useEffect(() => {
    if (!n || !i)
      return;
    a.current.__escapeKeyBubbles = y, a.current.__outsidePressBubbles = M;
    let A = -1;
    function W(Y) {
      o(!1, Y, "ancestor-scroll");
    }
    function z() {
      window.clearTimeout(A), D.current = !0;
    }
    function k() {
      A = window.setTimeout(
        () => {
          D.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        U1() ? 5 : 0
      );
    }
    const O = ze(r.floating);
    l && (O.addEventListener("keydown", S ? N : I, S), O.addEventListener("compositionstart", z), O.addEventListener("compositionend", k)), C && O.addEventListener(d, R ? $ : B, R);
    let H = [];
    return g && (fe(r.domReference) && (H = jt(r.domReference)), fe(r.floating) && (H = H.concat(jt(r.floating))), !fe(r.reference) && r.reference && r.reference.contextElement && (H = H.concat(jt(r.reference.contextElement)))), H = H.filter((Y) => {
      var L;
      return Y !== ((L = O.defaultView) == null ? void 0 : L.visualViewport);
    }), H.forEach((Y) => {
      Y.addEventListener("scroll", W, {
        passive: !0
      });
    }), () => {
      l && (O.removeEventListener("keydown", S ? N : I, S), O.removeEventListener("compositionstart", z), O.removeEventListener("compositionend", k)), C && O.removeEventListener(d, R ? $ : B, R), H.forEach((Y) => {
        Y.removeEventListener("scroll", W);
      }), window.clearTimeout(A);
    };
  }, [a, r, l, C, d, n, o, g, i, y, M, I, S, N, B, R, $]), _.useEffect(() => {
    a.current.insideReactTree = !1;
  }, [a, C, d]);
  const V = _.useMemo(() => ({
    onKeyDown: I,
    ...u && {
      [U3[f]]: (A) => {
        o(!1, A.nativeEvent, "reference-press");
      },
      ...f !== "click" && {
        onClick(A) {
          o(!1, A.nativeEvent, "reference-press");
        }
      }
    }
  }), [I, o, u, f]), E = _.useMemo(() => ({
    onKeyDown: I,
    onMouseDown() {
      b.current = !0;
    },
    onMouseUp() {
      b.current = !0;
    },
    [K3[d]]: () => {
      a.current.insideReactTree = !0;
    },
    onBlurCapture() {
      v || (Ge(P), a.current.insideReactTree = !0, P.current = window.setTimeout(() => {
        a.current.insideReactTree = !1;
      }));
    }
  }), [I, d, a, v]);
  return _.useMemo(() => i ? {
    reference: V,
    floating: E
  } : {}, [i, V, E]);
}
function G3(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o
  } = t, r = Z1(), a = _.useRef({}), [i] = _.useState(() => E3()), l = X1() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = o.reference;
    h && !fe(h) && P3("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [c, d] = _.useState(o.reference), u = Te((h, p, v) => {
    a.current.openEvent = h ? p : void 0, i.emit("openchange", {
      open: h,
      event: p,
      reason: v,
      nested: l
    }), n?.(h, p, v);
  }), f = _.useMemo(() => ({
    setPositionReference: d
  }), []), g = _.useMemo(() => ({
    reference: c || o.reference || null,
    floating: o.floating || null,
    domReference: o.reference
  }), [c, o.reference, o.floating]);
  return _.useMemo(() => ({
    dataRef: a,
    open: e,
    onOpenChange: u,
    elements: g,
    events: i,
    floatingId: r,
    refs: f
  }), [e, u, g, i, r, f]);
}
function un(t) {
  t === void 0 && (t = {});
  const {
    nodeId: e
  } = t, n = G3({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), o = t.rootContext || n, r = o.elements, [a, i] = _.useState(null), [l, c] = _.useState(null), u = r?.domReference || a, f = _.useRef(null), g = o1();
  ve(() => {
    u && (f.current = u);
  }, [u]);
  const h = x3({
    ...t,
    elements: {
      ...r,
      ...l && {
        reference: l
      }
    }
  }), p = _.useCallback((y) => {
    const M = fe(y) ? {
      getBoundingClientRect: () => y.getBoundingClientRect(),
      getClientRects: () => y.getClientRects(),
      contextElement: y
    } : y;
    c(M), h.refs.setReference(M);
  }, [h.refs]), v = _.useCallback((y) => {
    (fe(y) || y === null) && (f.current = y, i(y)), (fe(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    y !== null && !fe(y)) && h.refs.setReference(y);
  }, [h.refs]), w = _.useMemo(() => ({
    ...h.refs,
    setReference: v,
    setPositionReference: p,
    domReference: f
  }), [h.refs, v, p]), C = _.useMemo(() => ({
    ...h.elements,
    domReference: u
  }), [h.elements, u]), b = _.useMemo(() => ({
    ...h,
    ...o,
    refs: w,
    elements: C,
    nodeId: e
  }), [h, w, C, e, o]);
  return ve(() => {
    o.dataRef.current.floatingContext = b;
    const y = g?.nodesRef.current.find((M) => M.id === e);
    y && (y.context = b);
  }), _.useMemo(() => ({
    ...h,
    context: b,
    refs: w,
    elements: C
  }), [h, w, C, b]);
}
function bo() {
  return k4() && Za();
}
function J3(t, e) {
  e === void 0 && (e = {});
  const {
    open: n,
    onOpenChange: o,
    events: r,
    dataRef: a,
    elements: i
  } = t, {
    enabled: l = !0,
    visibleOnly: c = !0
  } = e, d = _.useRef(!1), u = _.useRef(-1), f = _.useRef(!0);
  _.useEffect(() => {
    if (!l) return;
    const h = Ue(i.domReference);
    function p() {
      !n && Me(i.domReference) && i.domReference === wt(ze(i.domReference)) && (d.current = !0);
    }
    function v() {
      f.current = !0;
    }
    function w() {
      f.current = !1;
    }
    return h.addEventListener("blur", p), bo() && (h.addEventListener("keydown", v, !0), h.addEventListener("pointerdown", w, !0)), () => {
      h.removeEventListener("blur", p), bo() && (h.removeEventListener("keydown", v, !0), h.removeEventListener("pointerdown", w, !0));
    };
  }, [i.domReference, n, l]), _.useEffect(() => {
    if (!l) return;
    function h(p) {
      let {
        reason: v
      } = p;
      (v === "reference-press" || v === "escape-key") && (d.current = !0);
    }
    return r.on("openchange", h), () => {
      r.off("openchange", h);
    };
  }, [r, l]), _.useEffect(() => () => {
    Ge(u);
  }, []);
  const g = _.useMemo(() => ({
    onMouseLeave() {
      d.current = !1;
    },
    onFocus(h) {
      if (d.current) return;
      const p = Ot(h.nativeEvent);
      if (c && fe(p)) {
        if (bo() && !h.relatedTarget) {
          if (!f.current && !Jo(p))
            return;
        } else if (!N4(p))
          return;
      }
      o(!0, h.nativeEvent, "focus");
    },
    onBlur(h) {
      d.current = !1;
      const p = h.relatedTarget, v = h.nativeEvent, w = fe(p) && p.hasAttribute(ln("focus-guard")) && p.getAttribute("data-type") === "outside";
      u.current = window.setTimeout(() => {
        var C;
        const b = wt(i.domReference ? i.domReference.ownerDocument : document);
        !p && b === i.domReference || Ee((C = a.current.floatingContext) == null ? void 0 : C.refs.floating.current, b) || Ee(i.domReference, b) || w || o(!1, v, "focus");
      });
    }
  }), [a, i.domReference, o, c]);
  return _.useMemo(() => l ? {
    reference: g
  } : {}, [l, g]);
}
function yo(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item";
  let a = t;
  if (r && t) {
    const {
      [Sr]: i,
      [kr]: l,
      ...c
    } = t;
    a = c;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [S3]: ""
    },
    ...a,
    ...e.map((i) => {
      const l = i ? i[n] : null;
      return typeof l == "function" ? t ? l(t) : null : l;
    }).concat(t).reduce((i, l) => (l && Object.entries(l).forEach((c) => {
      let [d, u] = c;
      if (!(r && [Sr, kr].includes(d)))
        if (d.indexOf("on") === 0) {
          if (o.has(d) || o.set(d, []), typeof u == "function") {
            var f;
            (f = o.get(d)) == null || f.push(u), i[d] = function() {
              for (var g, h = arguments.length, p = new Array(h), v = 0; v < h; v++)
                p[v] = arguments[v];
              return (g = o.get(d)) == null ? void 0 : g.map((w) => w(...p)).find((w) => w !== void 0);
            };
          }
        } else
          i[d] = u;
    }), i), {})
  };
}
function Nn(t) {
  t === void 0 && (t = []);
  const e = t.map((l) => l?.reference), n = t.map((l) => l?.floating), o = t.map((l) => l?.item), r = _.useCallback(
    (l) => yo(l, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), a = _.useCallback(
    (l) => yo(l, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = _.useCallback(
    (l) => yo(l, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  );
  return _.useMemo(() => ({
    getReferenceProps: r,
    getFloatingProps: a,
    getItemProps: i
  }), [r, a, i]);
}
const Z3 = "Escape";
function to(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function b1(t, e) {
  return to(e, t === hi || t === J1, t === t1 || t === n1);
}
function Co(t, e, n) {
  return to(e, t === J1, n ? t === t1 : t === n1) || t === "Enter" || t === " " || t === "";
}
function Fr(t, e, n) {
  return to(e, n ? t === t1 : t === n1, t === J1);
}
function Vr(t, e, n, o) {
  const r = n ? t === n1 : t === t1, a = t === hi;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === Z3 : to(e, r, a);
}
function a1(t, e) {
  const {
    open: n,
    onOpenChange: o,
    elements: r,
    floatingId: a
  } = t, {
    listRef: i,
    activeIndex: l,
    onNavigate: c = () => {
    },
    enabled: d = !0,
    selectedIndex: u = null,
    allowEscape: f = !1,
    loop: g = !1,
    nested: h = !1,
    rtl: p = !1,
    virtual: v = !1,
    focusItemOnOpen: w = "auto",
    focusItemOnHover: C = !0,
    openOnArrowKeyDown: b = !0,
    disabledIndices: y = void 0,
    orientation: M = "vertical",
    parentOrientation: S,
    cols: R = 1,
    scrollItemIntoView: D = !0,
    virtualItemRef: P,
    itemSizes: I,
    dense: N = !1
  } = e;
  process.env.NODE_ENV !== "production" && (f && (g || R1("`useListNavigation` looping must be enabled to allow escaping."), v || R1("`useListNavigation` must be virtual to allow escaping.")), M === "vertical" && R > 1 && R1("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const B = N1(r.floating), $ = tt(B), V = X1(), E = o1();
  ve(() => {
    t.dataRef.current.orientation = M;
  }, [t, M]);
  const A = Te(() => {
    c(k.current === -1 ? null : k.current);
  }), W = $o(r.domReference), z = _.useRef(w), k = _.useRef(u ?? -1), O = _.useRef(null), H = _.useRef(!0), Y = _.useRef(A), L = _.useRef(!!r.floating), J = _.useRef(n), K = _.useRef(!1), de = _.useRef(!1), ue = tt(y), Ae = tt(n), Qe = tt(D), et = tt(u), [rt, te] = _.useState(), [oe, ee] = _.useState(), Z = Te(() => {
    function q(pe) {
      if (v) {
        var xe;
        (xe = pe.id) != null && xe.endsWith("-fui-option") && (pe.id = a + "-" + Math.random().toString(16).slice(2, 10)), te(pe.id), E?.events.emit("virtualfocus", pe), P && (P.current = pe);
      } else
        en(pe, {
          sync: K.current,
          preventScroll: !0
        });
    }
    const ae = i.current[k.current], U = de.current;
    ae && q(ae), (K.current ? (pe) => pe() : requestAnimationFrame)(() => {
      const pe = i.current[k.current] || ae;
      if (!pe) return;
      ae || q(pe);
      const xe = Qe.current;
      xe && we && (U || !H.current) && (pe.scrollIntoView == null || pe.scrollIntoView(typeof xe == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : xe));
    });
  });
  ve(() => {
    d && (n && r.floating ? z.current && u != null && (de.current = !0, k.current = u, A()) : L.current && (k.current = -1, Y.current()));
  }, [d, n, r.floating, u, A]), ve(() => {
    if (d && n && r.floating)
      if (l == null) {
        if (K.current = !1, et.current != null)
          return;
        if (L.current && (k.current = -1, Z()), (!J.current || !L.current) && z.current && (O.current != null || z.current === !0 && O.current == null)) {
          let q = 0;
          const ae = () => {
            i.current[0] == null ? (q < 2 && (q ? requestAnimationFrame : queueMicrotask)(ae), q++) : (k.current = O.current == null || Co(O.current, M, p) || h ? ho(i, ue.current) : br(i, ue.current), O.current = null, A());
          };
          ae();
        }
      } else Fn(i, l) || (k.current = l, Z(), de.current = !1);
  }, [d, n, r.floating, l, et, h, i, M, p, A, Z, ue]), ve(() => {
    var q;
    if (!d || r.floating || !E || v || !L.current)
      return;
    const ae = E.nodesRef.current, U = (q = ae.find((xe) => xe.id === V)) == null || (q = q.context) == null ? void 0 : q.elements.floating, ge = wt(ze(r.floating)), pe = ae.some((xe) => xe.context && Ee(xe.context.elements.floating, ge));
    U && !pe && H.current && U.focus({
      preventScroll: !0
    });
  }, [d, r.floating, E, V, v]), ve(() => {
    if (!d || !E || !v || V) return;
    function q(ae) {
      ee(ae.id), P && (P.current = ae);
    }
    return E.events.on("virtualfocus", q), () => {
      E.events.off("virtualfocus", q);
    };
  }, [d, E, v, V, P]), ve(() => {
    Y.current = A, J.current = n, L.current = !!r.floating;
  }), ve(() => {
    n || (O.current = null, z.current = w);
  }, [n, w]);
  const Ce = l != null, we = _.useMemo(() => {
    function q(U) {
      if (!Ae.current) return;
      const ge = i.current.indexOf(U);
      ge !== -1 && k.current !== ge && (k.current = ge, A());
    }
    return {
      onFocus(U) {
        let {
          currentTarget: ge
        } = U;
        K.current = !0, q(ge);
      },
      onClick: (U) => {
        let {
          currentTarget: ge
        } = U;
        return ge.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...C && {
        onMouseMove(U) {
          let {
            currentTarget: ge
          } = U;
          K.current = !0, de.current = !1, q(ge);
        },
        onPointerLeave(U) {
          let {
            pointerType: ge
          } = U;
          if (!(!H.current || ge === "touch") && (K.current = !0, k.current = -1, A(), !v)) {
            var pe;
            (pe = $.current) == null || pe.focus({
              preventScroll: !0
            });
          }
        }
      }
    };
  }, [Ae, $, C, i, A, v]), Oe = _.useCallback(() => {
    var q;
    return S ?? (E == null || (q = E.nodesRef.current.find((ae) => ae.id === V)) == null || (q = q.context) == null || (q = q.dataRef) == null ? void 0 : q.current.orientation);
  }, [V, E, S]), Pe = Te((q) => {
    if (H.current = !1, K.current = !0, q.which === 229 || !Ae.current && q.currentTarget === $.current)
      return;
    if (h && Vr(q.key, M, p, R)) {
      b1(q.key, Oe()) || We(q), o(!1, q.nativeEvent, "list-navigation"), Me(r.domReference) && (v ? E?.events.emit("virtualfocus", r.domReference) : r.domReference.focus());
      return;
    }
    const ae = k.current, U = ho(i, y), ge = br(i, y);
    if (W || (q.key === "Home" && (We(q), k.current = U, A()), q.key === "End" && (We(q), k.current = ge, A())), R > 1) {
      const pe = I || Array.from({
        length: i.current.length
      }, () => ({
        width: 1,
        height: 1
      })), xe = F4(pe, R, N), Jt = xe.findIndex((Ye) => Ye != null && !M1(i, Ye, y)), fn = xe.reduce((Ye, Dt, hn) => Dt != null && !M1(i, Dt, y) ? hn : Ye, -1), Zt = xe[H4({
        current: xe.map((Ye) => Ye != null ? i.current[Ye] : null)
      }, {
        event: q,
        orientation: M,
        loop: g,
        rtl: p,
        cols: R,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: W4([...(typeof y != "function" ? y : null) || i.current.map((Ye, Dt) => M1(i, Dt, y) ? Dt : void 0), void 0], xe),
        minIndex: Jt,
        maxIndex: fn,
        prevIndex: V4(
          k.current > ge ? U : k.current,
          pe,
          xe,
          R,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          q.key === J1 ? "bl" : q.key === (p ? t1 : n1) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Zt != null && (k.current = Zt, A()), M === "both")
        return;
    }
    if (b1(q.key, M)) {
      if (We(q), n && !v && wt(q.currentTarget.ownerDocument) === q.currentTarget) {
        k.current = Co(q.key, M, p) ? U : ge, A();
        return;
      }
      Co(q.key, M, p) ? g ? k.current = ae >= ge ? f && ae !== i.current.length ? -1 : U : $e(i, {
        startingIndex: ae,
        disabledIndices: y
      }) : k.current = Math.min(ge, $e(i, {
        startingIndex: ae,
        disabledIndices: y
      })) : g ? k.current = ae <= U ? f && ae !== -1 ? i.current.length : ge : $e(i, {
        startingIndex: ae,
        decrement: !0,
        disabledIndices: y
      }) : k.current = Math.max(U, $e(i, {
        startingIndex: ae,
        decrement: !0,
        disabledIndices: y
      })), Fn(i, k.current) && (k.current = -1), A();
    }
  }), se = _.useMemo(() => v && n && Ce && {
    "aria-activedescendant": oe || rt
  }, [v, n, Ce, oe, rt]), he = _.useMemo(() => ({
    "aria-orientation": M === "both" ? void 0 : M,
    ...W ? {} : se,
    onKeyDown: Pe,
    onPointerMove() {
      H.current = !0;
    }
  }), [se, Pe, M, W]), Ke = _.useMemo(() => {
    function q(U) {
      w === "auto" && Qa(U.nativeEvent) && (z.current = !0);
    }
    function ae(U) {
      z.current = w, w === "auto" && ei(U.nativeEvent) && (z.current = !0);
    }
    return {
      ...se,
      onKeyDown(U) {
        H.current = !1;
        const ge = U.key.startsWith("Arrow"), pe = ["Home", "End"].includes(U.key), xe = ge || pe, Jt = Fr(U.key, M, p), fn = Vr(U.key, M, p, R), Zt = Fr(U.key, Oe(), p), Ye = b1(U.key, M), Dt = (h ? Zt : Ye) || U.key === "Enter" || U.key.trim() === "";
        if (v && n) {
          const Xt = E?.nodesRef.current.find((X) => X.parentId == null), ut = E && Xt ? E4(E.nodesRef.current, Xt.id) : null;
          if (xe && ut && P) {
            const X = new KeyboardEvent("keydown", {
              key: U.key,
              bubbles: !0
            });
            if (Jt || fn) {
              var hn, h1;
              const me = ((hn = ut.context) == null ? void 0 : hn.elements.domReference) === U.currentTarget, le = fn && !me ? (h1 = ut.context) == null ? void 0 : h1.elements.domReference : Jt ? i.current.find((at) => at?.id === rt) : null;
              le && (We(U), le.dispatchEvent(X), ee(void 0));
            }
            if ((Ye || pe) && ut.context && ut.context.open && ut.parentId && U.currentTarget !== ut.context.elements.domReference) {
              var g1;
              We(U), (g1 = ut.context.elements.domReference) == null || g1.dispatchEvent(X);
              return;
            }
          }
          return Pe(U);
        }
        if (!(!n && !b && ge)) {
          if (Dt) {
            const Xt = b1(U.key, Oe());
            O.current = h && Xt ? null : U.key;
          }
          if (h) {
            Zt && (We(U), n ? (k.current = ho(i, ue.current), A()) : o(!0, U.nativeEvent, "list-navigation"));
            return;
          }
          Ye && (u != null && (k.current = u), We(U), !n && b ? o(!0, U.nativeEvent, "list-navigation") : Pe(U), n && A());
        }
      },
      onFocus() {
        n && !v && (k.current = -1, A());
      },
      onPointerDown: ae,
      onPointerEnter: ae,
      onMouseDown: q,
      onClick: q
    };
  }, [rt, se, R, Pe, ue, w, i, h, A, o, n, b, M, Oe, p, u, E, v, P]);
  return _.useMemo(() => d ? {
    reference: Ke,
    floating: he,
    item: we
  } : {}, [d, Ke, he, we]);
}
const X3 = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function no(t, e) {
  var n, o;
  e === void 0 && (e = {});
  const {
    open: r,
    elements: a,
    floatingId: i
  } = t, {
    enabled: l = !0,
    role: c = "dialog"
  } = e, d = Z1(), u = ((n = a.domReference) == null ? void 0 : n.id) || d, f = _.useMemo(() => {
    var b;
    return ((b = N1(a.floating)) == null ? void 0 : b.id) || i;
  }, [a.floating, i]), g = (o = X3.get(c)) != null ? o : c, p = X1() != null, v = _.useMemo(() => g === "tooltip" || c === "label" ? {
    ["aria-" + (c === "label" ? "labelledby" : "describedby")]: r ? f : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": g === "alertdialog" ? "dialog" : g,
    "aria-controls": r ? f : void 0,
    ...g === "listbox" && {
      role: "combobox"
    },
    ...g === "menu" && {
      id: u
    },
    ...g === "menu" && p && {
      role: "menuitem"
    },
    ...c === "select" && {
      "aria-autocomplete": "none"
    },
    ...c === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [g, f, p, r, u, c]), w = _.useMemo(() => {
    const b = {
      id: f,
      ...g && {
        role: g
      }
    };
    return g === "tooltip" || c === "label" ? b : {
      ...b,
      ...g === "menu" && {
        "aria-labelledby": u
      }
    };
  }, [g, f, u, c]), C = _.useCallback((b) => {
    let {
      active: y,
      selected: M
    } = b;
    const S = {
      role: "option",
      ...y && {
        id: f + "-fui-option"
      }
    };
    switch (c) {
      case "select":
        return {
          ...S,
          "aria-selected": y && M
        };
      case "combobox":
        return {
          ...S,
          "aria-selected": M
        };
    }
    return {};
  }, [f, c]);
  return _.useMemo(() => l ? {
    reference: v,
    floating: w,
    item: C
  } : {}, [l, v, w, C]);
}
const Q3 = "_unstyledButton_1vnyr_1", eg = {
  unstyledButton: Q3
}, Ie = m(({ className: t, type: e = "button", ...n }, o) => /* @__PURE__ */ s(
  "button",
  {
    ...n,
    ref: o,
    type: e,
    className: T(eg.unstyledButton, t)
  }
));
Ie.displayName = "UnstyledButton";
const tg = "_ellipsis_1dbo4_1", tr = {
  ellipsis: tg
}, oo = m(
  ({
    leading: t,
    trailing: e,
    label: n,
    disabled: o = !1,
    className: r,
    role: a = "menuitem",
    ...i
  }, l) => {
    const { ref: c } = fi();
    return /* @__PURE__ */ x(
      Ie,
      {
        ...i,
        role: a,
        ref: e1([c, l]),
        disabled: o,
        className: T(
          r,
          Fe.commonItem,
          t && e && Fe.commonItemLeadingTrailing,
          !t && e && Fe.commonItemTrailing,
          !e && t && Fe.commonItemLeading
        ),
        children: [
          t,
          /* @__PURE__ */ s("span", { className: T(tr.ellipsis, Fe.label), children: n }),
          e
        ]
      }
    );
  }
);
oo.displayName = "CommonItem";
const ng = m(
  ({ className: t, critical: e, ...n }, o) => /* @__PURE__ */ s(
    oo,
    {
      ...n,
      className: T(t, e && Fe.critical),
      ref: o
    }
  )
);
ng.displayName = "ActionItem";
const ry = () => /* @__PURE__ */ s("div", { className: Fe.divider }), ay = ({
  children: t,
  className: e,
  label: n
}) => /* @__PURE__ */ x(It, { children: [
  /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
    qe,
    {
      size: "sm",
      color: "reduced",
      className: T(Fe.actionItemGroup, e),
      children: n
    }
  ) }),
  t
] }), vi = ({
  selected: t,
  leading: e
}) => /* @__PURE__ */ x(
  "span",
  {
    className: T(
      Fe.leadingWrapper,
      t && e && Fe.leadingWrapperGap
    ),
    children: [
      t,
      " ",
      e
    ]
  }
), og = ({ selected: t = !1 }) => /* @__PURE__ */ s(
  "div",
  {
    className: T(
      Fe.checkbox,
      t ? Fe.checkboxChecked : Fe.checkboxUnchecked
    ),
    children: t && /* @__PURE__ */ s(Na, {})
  }
), wi = m(({ className: t, selected: e = !1, leading: n, role: o, ...r }, a) => /* @__PURE__ */ s(
  oo,
  {
    ...r,
    leading: /* @__PURE__ */ s(
      vi,
      {
        selected: /* @__PURE__ */ s(og, { selected: e }),
        leading: n
      }
    ),
    "aria-selected": o === "option" ? e : void 0,
    className: T(t, e && Fe.selected),
    ref: a,
    role: o
  }
));
wi.displayName = "ActionItemMultiSelect";
const rg = m(({ className: t, selected: e = !1, leading: n, ...o }, r) => /* @__PURE__ */ s(
  oo,
  {
    ...o,
    leading: /* @__PURE__ */ s(
      vi,
      {
        selected: e ? /* @__PURE__ */ s(P2, {}) : /* @__PURE__ */ s("div", { className: Fe.unselectedPlaceholder }),
        leading: n
      }
    ),
    className: T(t, e && Fe.selected),
    ref: r
  }
));
rg.displayName = "ActionItemSingleSelect";
const bi = 1500, Bt = 9999, ag = "_actionMenu_1e8s0_1", ig = {
  actionMenu: ag
}, Un = ({
  placement: t = "bottom-start",
  isOpen: e,
  setIsOpen: n
}) => {
  const [o, r] = Q(null), a = ye([]), { floatingStyles: i, refs: l, context: c } = un({
    open: e,
    onOpenChange: n,
    placement: t,
    middleware: [An({ mainAxis: 4, alignmentAxis: 0 }), Pn(), On()],
    whileElementsMounted: dn
  }), d = no(c, { role: "menu" }), u = r1(c), f = eo(c), g = a1(c, {
    listRef: a,
    activeIndex: o,
    onNavigate: r
  }), { getFloatingProps: h, getReferenceProps: p } = Nn([
    d,
    u,
    f,
    g
  ]);
  return {
    getReferenceProps: p,
    getFloatingProps: h,
    refs: l,
    floatingStyles: i,
    context: c,
    listRef: a
  };
}, iy = ({
  children: t,
  fullWidth: e = !1,
  floatingStyles: n,
  refs: o,
  context: r,
  getFloatingProps: a,
  listRef: i,
  zIndex: l = Bt
}) => {
  const { open: c } = r;
  return /* @__PURE__ */ s(It, { children: c && /* @__PURE__ */ s(Kt, { elementsRef: i, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
    Gt,
    {
      initialFocus: -1,
      modal: !1,
      context: r,
      children: /* @__PURE__ */ s(
        "div",
        {
          ref: o.setFloating,
          style: {
            ...n,
            zIndex: l,
            // prevents flicker if the position is not calculated yet
            opacity: n.transform ? 1 : 0,
            width: e ? o.reference.current?.getBoundingClientRect().width : void 0
          },
          ...a(),
          children: /* @__PURE__ */ s("div", { className: ig.actionMenu, children: t })
        }
      )
    }
  ) }) }) });
}, sg = "_avatar_131k1_1", lg = "_hasInteraction_131k1_15", cg = "_initials_131k1_29", y1 = {
  avatar: sg,
  hasInteraction: lg,
  initials: cg,
  "size-20": "_size-20_131k1_33",
  "size-24": "_size-24_131k1_37",
  "size-32": "_size-32_131k1_41",
  "size-40": "_size-40_131k1_45"
};
function dg(t, e) {
  if (!t) return "";
  const n = t.trim().split(" "), o = n[0].charAt(0), r = n[n.length - 1].charAt(0);
  return n.length === 1 || e <= 24 ? o.toUpperCase() : (o + r).toUpperCase();
}
const ug = m(
  ({ name: t, className: e, src: n, size: o = 32, onClick: r, ...a }, i) => {
    const [l, c] = Q(!1), d = !n || l;
    return (
      /* biome-ignore lint/a11y/noStaticElementInteractions: this is fine */
      /* @__PURE__ */ s(
        "div",
        {
          ref: i,
          className: T(
            e,
            y1.avatar,
            y1[`size-${o}`],
            r !== void 0 && y1.hasInteraction
          ),
          onClick: r,
          ...a,
          children: d ? /* @__PURE__ */ s(
            qe,
            {
              size: o === 40 ? "md" : "sm",
              weight: "emphasized",
              className: y1.initials,
              children: dg(t, o)
            }
          ) : /* @__PURE__ */ s("img", { src: n, alt: t, onError: () => c(!0) })
        }
      )
    );
  }
);
ug.displayName = "Avatar";
const fg = "_badge_atukz_1", hg = "_icon_atukz_14", gg = "_neutral_atukz_21", pg = "_success_atukz_26", mg = "_critical_atukz_31", vg = "_warning_atukz_36", C1 = {
  badge: fg,
  icon: hg,
  neutral: gg,
  success: pg,
  critical: mg,
  warning: vg
}, wg = m(
  ({ variant: t = "neutral", label: e, icon: n, ariaLabel: o }, r) => /* @__PURE__ */ x(
    "div",
    {
      ref: r,
      className: T(C1.badge, C1[t]),
      "aria-label": o ?? e,
      role: "status",
      children: [
        n && /* @__PURE__ */ s("span", { className: C1.icon, children: n }),
        /* @__PURE__ */ s("span", { className: C1.label, children: e })
      ]
    }
  )
);
wg.displayName = "Badge";
const bg = "_button_anz23_1", yg = "_primary_anz23_44", Cg = "_secondary_anz23_63", xg = "_critical_anz23_84", Mg = "_plain_anz23_123", _g = "_compact_anz23_143", Rg = "_iconButton_anz23_146", Sg = "_dropDown_anz23_159", nt = {
  button: bg,
  primary: yg,
  secondary: Cg,
  critical: xg,
  plain: Mg,
  compact: _g,
  iconButton: Rg,
  default: "_default_anz23_151",
  dropDown: Sg
}, nr = m(
  ({ variant: t = "primary", size: e = "default", children: n, ...o }, r) => /* @__PURE__ */ s(
    "button",
    {
      ref: r,
      type: "button",
      className: T(nt.button, nt[t], nt[e]),
      ...o,
      children: n
    }
  )
);
nr.displayName = "BaseButton";
const kg = m(
  ({
    variant: t = "primary",
    size: e = "default",
    label: n,
    icon: o,
    className: r,
    hasDropdown: a,
    ...i
  }, l) => /* @__PURE__ */ x(
    nr,
    {
      ref: l,
      variant: t,
      size: e,
      className: T(
        nt.button,
        nt[t],
        nt[e],
        r
      ),
      ...i,
      children: [
        o && o,
        n && n,
        a && /* @__PURE__ */ s(Pf, { className: nt.dropDown })
      ]
    }
  )
);
kg.displayName = "Button";
const z1 = m(
  ({ variant: t = "primary", size: e = "default", label: n, icon: o, className: r, ...a }, i) => /* @__PURE__ */ s(
    nr,
    {
      ref: i,
      variant: t,
      size: e,
      "aria-label": n,
      className: T(
        nt.button,
        nt.iconButton,
        nt[t],
        nt[e],
        r
      ),
      ...a,
      children: /* @__PURE__ */ s("span", { className: nt.icon, children: o })
    }
  )
);
z1.displayName = "IconButton";
const Dg = "_buttonGroup_4mo53_1", Ag = {
  buttonGroup: Dg
}, sy = ({ children: t }) => /* @__PURE__ */ s("div", { className: Ag.buttonGroup, children: t }), Og = "_card_198qa_2", Pg = "_dropShadow_198qa_18", Ng = "_outline_198qa_22", zn = {
  card: Og,
  "corner-radius-small": "_corner-radius-small_198qa_9",
  "corner-radius-medium": "_corner-radius-medium_198qa_13",
  dropShadow: Pg,
  outline: Ng,
  "padding-none": "_padding-none_198qa_27",
  "padding-small": "_padding-small_198qa_31",
  "padding-medium": "_padding-medium_198qa_35",
  "padding-large": "_padding-large_198qa_39"
}, or = ({
  children: t,
  cornerRadius: e = "medium",
  outline: n = !1,
  padding: o = "medium",
  className: r
}) => /* @__PURE__ */ s(
  "div",
  {
    className: T(
      r,
      zn.card,
      zn[`corner-radius-${e}`],
      zn[`padding-${o}`],
      n ? zn.outline : zn.dropShadow
    ),
    children: t
  }
), Eg = "_backdrop_1fn3q_1", Lg = "_dialog_1fn3q_10", zg = "_dialogHeader_1fn3q_25", Tg = "_dialogHeaderTitle_1fn3q_34", Ig = "_closeButton_1fn3q_40", Bg = "_closeIcon_1fn3q_48", $g = "_dialogContent_1fn3q_54", Hg = "_dialogFooter_1fn3q_65", Fg = "_dialogActionFooter_1fn3q_71", Vg = "_small_1fn3q_79", Wg = "_medium_1fn3q_84", jg = "_large_1fn3q_89", Ct = {
  backdrop: Eg,
  dialog: Lg,
  dialogHeader: zg,
  dialogHeaderTitle: Tg,
  closeButton: Ig,
  closeIcon: Bg,
  dialogContent: $g,
  dialogFooter: Hg,
  dialogActionFooter: Fg,
  small: Vg,
  medium: Wg,
  large: jg
}, qg = ({ children: t }) => (
  // tabIndex is needed to allow the user to scroll the content of the dialog by keyboard
  // biome-ignore lint/a11y/noNoninteractiveTabindex: see above
  /* @__PURE__ */ s("div", { tabIndex: 0, className: Ct.dialogContent, children: t })
), Yg = ({ children: t }) => /* @__PURE__ */ s("div", { className: Ct.dialogActionFooter, children: t }), Wr = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Ug = (t, e, n) => {
  let o;
  const r = n?.addSuffix ? Wr[t].withPreposition : Wr[t].standalone;
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", String(e)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : "vor " + o : o;
};
function zt(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const Kg = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Gg = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Jg = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Zg = {
  date: zt({
    formats: Kg,
    defaultWidth: "full"
  }),
  time: zt({
    formats: Gg,
    defaultWidth: "full"
  }),
  dateTime: zt({
    formats: Jg,
    defaultWidth: "full"
  })
}, Xg = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, Qg = (t, e, n, o) => Xg[t];
function bt(t) {
  return (e, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && t.formattingValues) {
      const i = t.defaultFormattingWidth || t.defaultWidth, l = n?.width ? String(n.width) : i;
      r = t.formattingValues[l] || t.formattingValues[i];
    } else {
      const i = t.defaultWidth, l = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[l] || t.values[i];
    }
    const a = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[a];
  };
}
const ep = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, tp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, Ho = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, np = {
  narrow: Ho.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: Ho.wide
}, op = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, rp = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, ap = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, ip = (t) => Number(t) + ".", sp = {
  ordinalNumber: ip,
  era: bt({
    values: ep,
    defaultWidth: "wide"
  }),
  quarter: bt({
    values: tp,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: bt({
    values: Ho,
    formattingValues: np,
    defaultWidth: "wide"
  }),
  day: bt({
    values: op,
    defaultWidth: "wide"
  }),
  dayPeriod: bt({
    values: rp,
    defaultWidth: "wide",
    formattingValues: ap,
    defaultFormattingWidth: "wide"
  })
};
function yt(t) {
  return (e, n = {}) => {
    const o = n.width, r = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], a = e.match(r);
    if (!a)
      return null;
    const i = a[0], l = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], c = Array.isArray(l) ? cp(l, (f) => f.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      lp(l, (f) => f.test(i))
    );
    let d;
    d = t.valueCallback ? t.valueCallback(c) : c, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const u = e.slice(i.length);
    return { value: d, rest: u };
  };
}
function lp(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function cp(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function yi(t) {
  return (e, n = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const r = o[0], a = e.match(t.parsePattern);
    if (!a) return null;
    let i = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const l = e.slice(r.length);
    return { value: i, rest: l };
  };
}
const dp = /^(\d+)(\.)?/i, up = /\d+/i, fp = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, hp = {
  any: [/^v/i, /^n/i]
}, gp = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, pp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, vp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, wp = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, bp = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, yp = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Cp = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, xp = {
  ordinalNumber: yi({
    matchPattern: dp,
    parsePattern: up,
    valueCallback: (t) => parseInt(t)
  }),
  era: yt({
    matchPatterns: fp,
    defaultMatchWidth: "wide",
    parsePatterns: hp,
    defaultParseWidth: "any"
  }),
  quarter: yt({
    matchPatterns: gp,
    defaultMatchWidth: "wide",
    parsePatterns: pp,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: yt({
    matchPatterns: mp,
    defaultMatchWidth: "wide",
    parsePatterns: vp,
    defaultParseWidth: "any"
  }),
  day: yt({
    matchPatterns: wp,
    defaultMatchWidth: "wide",
    parsePatterns: bp,
    defaultParseWidth: "any"
  }),
  dayPeriod: yt({
    matchPatterns: yp,
    defaultMatchWidth: "wide",
    parsePatterns: Cp,
    defaultParseWidth: "any"
  })
}, Mp = {
  code: "de",
  formatDistance: Ug,
  formatLong: Zg,
  formatRelative: Qg,
  localize: sp,
  match: xp,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, _p = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ci = (t, e, n) => {
  let o;
  const r = _p[t];
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
}, Rp = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, xi = (t, e, n, o) => Rp[t], Sp = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, kp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Dp = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ap = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Op = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Np = (t, e) => {
  const n = Number(t), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Mi = {
  ordinalNumber: Np,
  era: bt({
    values: Sp,
    defaultWidth: "wide"
  }),
  quarter: bt({
    values: kp,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: bt({
    values: Dp,
    defaultWidth: "wide"
  }),
  day: bt({
    values: Ap,
    defaultWidth: "wide"
  }),
  dayPeriod: bt({
    values: Op,
    defaultWidth: "wide",
    formattingValues: Pp,
    defaultFormattingWidth: "wide"
  })
}, Ep = /^(\d+)(th|st|nd|rd)?/i, Lp = /\d+/i, zp = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Tp = {
  any: [/^b/i, /^(a|c)/i]
}, Ip = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Bp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $p = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Hp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Fp = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Vp = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Wp = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jp = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, _i = {
  ordinalNumber: yi({
    matchPattern: Ep,
    parsePattern: Lp,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: yt({
    matchPatterns: zp,
    defaultMatchWidth: "wide",
    parsePatterns: Tp,
    defaultParseWidth: "any"
  }),
  quarter: yt({
    matchPatterns: Ip,
    defaultMatchWidth: "wide",
    parsePatterns: Bp,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: yt({
    matchPatterns: $p,
    defaultMatchWidth: "wide",
    parsePatterns: Hp,
    defaultParseWidth: "any"
  }),
  day: yt({
    matchPatterns: Fp,
    defaultMatchWidth: "wide",
    parsePatterns: Vp,
    defaultParseWidth: "any"
  }),
  dayPeriod: yt({
    matchPatterns: Wp,
    defaultMatchWidth: "any",
    parsePatterns: jp,
    defaultParseWidth: "any"
  })
}, qp = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Yp = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Up = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kp = {
  date: zt({
    formats: qp,
    defaultWidth: "full"
  }),
  time: zt({
    formats: Yp,
    defaultWidth: "full"
  }),
  dateTime: zt({
    formats: Up,
    defaultWidth: "full"
  })
}, Gp = {
  code: "en-GB",
  formatDistance: Ci,
  formatLong: Kp,
  formatRelative: xi,
  localize: Mi,
  match: _i,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, G = (t) => typeof t == "string", Tn = () => {
  let t, e;
  const n = new Promise((o, r) => {
    t = o, e = r;
  });
  return n.resolve = t, n.reject = e, n;
}, jr = (t) => t == null ? "" : "" + t, Jp = (t, e, n) => {
  t.forEach((o) => {
    e[o] && (n[o] = e[o]);
  });
}, Zp = /###/g, qr = (t) => t && t.indexOf("###") > -1 ? t.replace(Zp, ".") : t, Yr = (t) => !t || G(t), Wn = (t, e, n) => {
  const o = G(e) ? e.split(".") : e;
  let r = 0;
  for (; r < o.length - 1; ) {
    if (Yr(t)) return {};
    const a = qr(o[r]);
    !t[a] && n && (t[a] = new n()), Object.prototype.hasOwnProperty.call(t, a) ? t = t[a] : t = {}, ++r;
  }
  return Yr(t) ? {} : {
    obj: t,
    k: qr(o[r])
  };
}, Ur = (t, e, n) => {
  const {
    obj: o,
    k: r
  } = Wn(t, e, Object);
  if (o !== void 0 || e.length === 1) {
    o[r] = n;
    return;
  }
  let a = e[e.length - 1], i = e.slice(0, e.length - 1), l = Wn(t, i, Object);
  for (; l.obj === void 0 && i.length; )
    a = `${i[i.length - 1]}.${a}`, i = i.slice(0, i.length - 1), l = Wn(t, i, Object), l?.obj && typeof l.obj[`${l.k}.${a}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${a}`] = n;
}, Xp = (t, e, n, o) => {
  const {
    obj: r,
    k: a
  } = Wn(t, e, Object);
  r[a] = r[a] || [], r[a].push(n);
}, T1 = (t, e) => {
  const {
    obj: n,
    k: o
  } = Wn(t, e);
  if (n && Object.prototype.hasOwnProperty.call(n, o))
    return n[o];
}, Qp = (t, e, n) => {
  const o = T1(t, n);
  return o !== void 0 ? o : T1(e, n);
}, Ri = (t, e, n) => {
  for (const o in e)
    o !== "__proto__" && o !== "constructor" && (o in t ? G(t[o]) || t[o] instanceof String || G(e[o]) || e[o] instanceof String ? n && (t[o] = e[o]) : Ri(t[o], e[o], n) : t[o] = e[o]);
  return t;
}, pn = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var em = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const tm = (t) => G(t) ? t.replace(/[&<>"'\/]/g, (e) => em[e]) : t;
class nm {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const n = this.regExpMap.get(e);
    if (n !== void 0)
      return n;
    const o = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, o), this.regExpQueue.push(e), o;
  }
}
const om = [" ", ",", "?", "!", ";"], rm = new nm(20), am = (t, e, n) => {
  e = e || "", n = n || "";
  const o = om.filter((i) => e.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const r = rm.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let a = !r.test(t);
  if (!a) {
    const i = t.indexOf(n);
    i > 0 && !r.test(t.substring(0, i)) && (a = !0);
  }
  return a;
}, Fo = (t, e, n = ".") => {
  if (!t) return;
  if (t[e])
    return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  const o = e.split(n);
  let r = t;
  for (let a = 0; a < o.length; ) {
    if (!r || typeof r != "object")
      return;
    let i, l = "";
    for (let c = a; c < o.length; ++c)
      if (c !== a && (l += n), l += o[c], i = r[l], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && c < o.length - 1)
          continue;
        a += c - a + 1;
        break;
      }
    r = i;
  }
  return r;
}, Kn = (t) => t?.replace("_", "-"), im = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console?.[t]?.apply?.(console, e);
  }
};
class I1 {
  constructor(e, n = {}) {
    this.init(e, n);
  }
  init(e, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = e || im, this.options = n, this.debug = n.debug;
  }
  log(...e) {
    return this.forward(e, "log", "", !0);
  }
  warn(...e) {
    return this.forward(e, "warn", "", !0);
  }
  error(...e) {
    return this.forward(e, "error", "");
  }
  deprecate(...e) {
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, n, o, r) {
    return r && !this.debug ? null : (G(e[0]) && (e[0] = `${o}${this.prefix} ${e[0]}`), this.logger[n](e));
  }
  create(e) {
    return new I1(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new I1(this.logger, e);
  }
}
var xt = new I1();
class ro {
  constructor() {
    this.observers = {};
  }
  on(e, n) {
    return e.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const r = this.observers[o].get(n) || 0;
      this.observers[o].set(n, r + 1);
    }), this;
  }
  off(e, n) {
    if (this.observers[e]) {
      if (!n) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(n);
    }
  }
  emit(e, ...n) {
    this.observers[e] && Array.from(this.observers[e].entries()).forEach(([r, a]) => {
      for (let i = 0; i < a; i++)
        r(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([r, a]) => {
      for (let i = 0; i < a; i++)
        r.apply(r, [e, ...n]);
    });
  }
}
class Kr extends ro {
  constructor(e, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = e || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const n = this.options.ns.indexOf(e);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(e, n, o, r = {}) {
    const a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, i = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    e.indexOf(".") > -1 ? l = e.split(".") : (l = [e, n], o && (Array.isArray(o) ? l.push(...o) : G(o) && a ? l.push(...o.split(a)) : l.push(o)));
    const c = T1(this.data, l);
    return !c && !n && !o && e.indexOf(".") > -1 && (e = l[0], n = l[1], o = l.slice(2).join(".")), c || !i || !G(o) ? c : Fo(this.data?.[e]?.[n], o, a);
  }
  addResource(e, n, o, r, a = {
    silent: !1
  }) {
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let l = [e, n];
    o && (l = l.concat(i ? o.split(i) : o)), e.indexOf(".") > -1 && (l = e.split("."), r = n, n = l[1]), this.addNamespaces(n), Ur(this.data, l, r), a.silent || this.emit("added", e, n, o, r);
  }
  addResources(e, n, o, r = {
    silent: !1
  }) {
    for (const a in o)
      (G(o[a]) || Array.isArray(o[a])) && this.addResource(e, n, a, o[a], {
        silent: !0
      });
    r.silent || this.emit("added", e, n, o);
  }
  addResourceBundle(e, n, o, r, a, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let l = [e, n];
    e.indexOf(".") > -1 && (l = e.split("."), r = o, o = n, n = l[1]), this.addNamespaces(n);
    let c = T1(this.data, l) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), r ? Ri(c, o, a) : c = {
      ...c,
      ...o
    }, Ur(this.data, l, c), i.silent || this.emit("added", e, n, o);
  }
  removeResourceBundle(e, n) {
    this.hasResourceBundle(e, n) && delete this.data[e][n], this.removeNamespaces(n), this.emit("removed", e, n);
  }
  hasResourceBundle(e, n) {
    return this.getResource(e, n) !== void 0;
  }
  getResourceBundle(e, n) {
    return n || (n = this.options.defaultNS), this.getResource(e, n);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const n = this.getDataByLanguage(e);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Si = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, n, o, r) {
    return t.forEach((a) => {
      e = this.processors[a]?.process(e, n, o, r) ?? e;
    }), e;
  }
};
const Gr = {}, Jr = (t) => !G(t) && typeof t != "boolean" && typeof t != "number";
class B1 extends ro {
  constructor(e, n = {}) {
    super(), Jp(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = xt.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e, n = {
    interpolation: {}
  }) {
    const o = {
      ...n
    };
    return e == null ? !1 : this.resolve(e, o)?.res !== void 0;
  }
  extractFromKey(e, n) {
    let o = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let a = n.ns || this.options.defaultNS || [];
    const i = o && e.indexOf(o) > -1, l = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !am(e, o, r);
    if (i && !l) {
      const c = e.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: e,
          namespaces: G(a) ? [a] : a
        };
      const d = e.split(o);
      (o !== r || o === r && this.options.ns.indexOf(d[0]) > -1) && (a = d.shift()), e = d.join(r);
    }
    return {
      key: e,
      namespaces: G(a) ? [a] : a
    };
  }
  translate(e, n, o) {
    let r = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof options == "object" && (r = {
      ...r
    }), r || (r = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const a = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: l,
      namespaces: c
    } = this.extractFromKey(e[e.length - 1], r), d = c[c.length - 1];
    let u = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const f = r.lng || this.language, g = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (f?.toLowerCase() === "cimode")
      return g ? a ? {
        res: `${d}${u}${l}`,
        usedKey: l,
        exactUsedKey: l,
        usedLng: f,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(r)
      } : `${d}${u}${l}` : a ? {
        res: l,
        usedKey: l,
        exactUsedKey: l,
        usedLng: f,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(r)
      } : l;
    const h = this.resolve(e, r);
    let p = h?.res;
    const v = h?.usedKey || l, w = h?.exactUsedKey || l, C = ["[object Number]", "[object Function]", "[object RegExp]"], b = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, M = r.count !== void 0 && !G(r.count), S = B1.hasDefaultValue(r), R = M ? this.pluralResolver.getSuffix(f, r.count, r) : "", D = r.ordinal && M ? this.pluralResolver.getSuffix(f, r.count, {
      ordinal: !1
    }) : "", P = M && !r.ordinal && r.count === 0, I = P && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${R}`] || r[`defaultValue${D}`] || r.defaultValue;
    let N = p;
    y && !p && S && (N = I);
    const B = Jr(N), $ = Object.prototype.toString.apply(N);
    if (y && N && B && C.indexOf($) < 0 && !(G(b) && Array.isArray(N))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const V = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(v, N, {
          ...r,
          ns: c
        }) : `key '${l} (${this.language})' returned an object instead of string.`;
        return a ? (h.res = V, h.usedParams = this.getUsedParamsDetails(r), h) : V;
      }
      if (i) {
        const V = Array.isArray(N), E = V ? [] : {}, A = V ? w : v;
        for (const W in N)
          if (Object.prototype.hasOwnProperty.call(N, W)) {
            const z = `${A}${i}${W}`;
            S && !p ? E[W] = this.translate(z, {
              ...r,
              defaultValue: Jr(I) ? I[W] : void 0,
              joinArrays: !1,
              ns: c
            }) : E[W] = this.translate(z, {
              ...r,
              joinArrays: !1,
              ns: c
            }), E[W] === z && (E[W] = N[W]);
          }
        p = E;
      }
    } else if (y && G(b) && Array.isArray(p))
      p = p.join(b), p && (p = this.extendTranslation(p, e, r, o));
    else {
      let V = !1, E = !1;
      !this.isValidLookup(p) && S && (V = !0, p = I), this.isValidLookup(p) || (E = !0, p = l);
      const W = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && E ? void 0 : p, z = S && I !== p && this.options.updateMissing;
      if (E || V || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", f, d, l, z ? I : p), i) {
          const Y = this.resolve(l, {
            ...r,
            keySeparator: !1
          });
          Y && Y.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let k = [];
        const O = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && O && O[0])
          for (let Y = 0; Y < O.length; Y++)
            k.push(O[Y]);
        else this.options.saveMissingTo === "all" ? k = this.languageUtils.toResolveHierarchy(r.lng || this.language) : k.push(r.lng || this.language);
        const H = (Y, L, J) => {
          const K = S && J !== p ? J : W;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(Y, d, L, K, z, r) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(Y, d, L, K, z, r), this.emit("missingKey", Y, d, L, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && M ? k.forEach((Y) => {
          const L = this.pluralResolver.getSuffixes(Y, r);
          P && r[`defaultValue${this.options.pluralSeparator}zero`] && L.indexOf(`${this.options.pluralSeparator}zero`) < 0 && L.push(`${this.options.pluralSeparator}zero`), L.forEach((J) => {
            H([Y], l + J, r[`defaultValue${J}`] || I);
          });
        }) : H(k, l, I));
      }
      p = this.extendTranslation(p, e, r, h, o), E && p === l && this.options.appendNamespaceToMissingKey && (p = `${d}${u}${l}`), (E || V) && this.options.parseMissingKeyHandler && (p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${d}${u}${l}` : l, V ? p : void 0, r));
    }
    return a ? (h.res = p, h.usedParams = this.getUsedParamsDetails(r), h) : p;
  }
  extendTranslation(e, n, o, r, a) {
    if (this.i18nFormat?.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const c = G(e) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (c) {
        const f = e.match(this.interpolator.nestingRegexp);
        d = f && f.length;
      }
      let u = o.replace && !G(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), e = this.interpolator.interpolate(e, u, o.lng || this.language || r.usedLng, o), c) {
        const f = e.match(this.interpolator.nestingRegexp), g = f && f.length;
        d < g && (o.nest = !1);
      }
      !o.lng && r && r.res && (o.lng = this.language || r.usedLng), o.nest !== !1 && (e = this.interpolator.nest(e, (...f) => a?.[0] === f[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${n[0]}`), null) : this.translate(...f, n), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, l = G(i) ? [i] : i;
    return e != null && l?.length && o.applyPostProcessor !== !1 && (e = Si.handle(l, e, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), e;
  }
  resolve(e, n = {}) {
    let o, r, a, i, l;
    return G(e) && (e = [e]), e.forEach((c) => {
      if (this.isValidLookup(o)) return;
      const d = this.extractFromKey(c, n), u = d.key;
      r = u;
      let f = d.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const g = n.count !== void 0 && !G(n.count), h = g && !n.ordinal && n.count === 0, p = n.context !== void 0 && (G(n.context) || typeof n.context == "number") && n.context !== "", v = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      f.forEach((w) => {
        this.isValidLookup(o) || (l = w, !Gr[`${v[0]}-${w}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(l) && (Gr[`${v[0]}-${w}`] = !0, this.logger.warn(`key "${r}" for languages "${v.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), v.forEach((C) => {
          if (this.isValidLookup(o)) return;
          i = C;
          const b = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(b, u, C, w, n);
          else {
            let M;
            g && (M = this.pluralResolver.getSuffix(C, n.count, n));
            const S = `${this.options.pluralSeparator}zero`, R = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (g && (b.push(u + M), n.ordinal && M.indexOf(R) === 0 && b.push(u + M.replace(R, this.options.pluralSeparator)), h && b.push(u + S)), p) {
              const D = `${u}${this.options.contextSeparator}${n.context}`;
              b.push(D), g && (b.push(D + M), n.ordinal && M.indexOf(R) === 0 && b.push(D + M.replace(R, this.options.pluralSeparator)), h && b.push(D + S));
            }
          }
          let y;
          for (; y = b.pop(); )
            this.isValidLookup(o) || (a = y, o = this.getResource(C, w, y, n));
        }));
      });
    }), {
      res: o,
      usedKey: r,
      exactUsedKey: a,
      usedLng: i,
      usedNS: l
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, n, o, r = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(e, n, o, r) : this.resourceStore.getResource(e, n, o, r);
  }
  getUsedParamsDetails(e = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = e.replace && !G(e.replace);
    let r = o ? e.replace : e;
    if (o && typeof e.count < "u" && (r.count = e.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !o) {
      r = {
        ...r
      };
      for (const a of n)
        delete r[a];
    }
    return r;
  }
  static hasDefaultValue(e) {
    const n = "defaultValue";
    for (const o in e)
      if (Object.prototype.hasOwnProperty.call(e, o) && n === o.substring(0, n.length) && e[o] !== void 0)
        return !0;
    return !1;
  }
}
class Zr {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = xt.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Kn(e), !e || e.indexOf("-") < 0) return null;
    const n = e.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Kn(e), !e || e.indexOf("-") < 0) return e;
    const n = e.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(e) {
    if (G(e) && e.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let n;
    return e.forEach((o) => {
      if (n) return;
      const r = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (n = r);
    }), !n && this.options.supportedLngs && e.forEach((o) => {
      if (n) return;
      const r = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(r)) return n = r;
      const a = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(a)) return n = a;
      n = this.options.supportedLngs.find((i) => {
        if (i === a) return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(e, n) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(n)), G(e) && (e = [e]), Array.isArray(e)) return e;
    if (!n) return e.default || [];
    let o = e[n];
    return o || (o = e[this.getScriptPartFromCode(n)]), o || (o = e[this.formatLanguageCode(n)]), o || (o = e[this.getLanguagePartFromCode(n)]), o || (o = e.default), o || [];
  }
  toResolveHierarchy(e, n) {
    const o = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], e), r = [], a = (i) => {
      i && (this.isSupportedCode(i) ? r.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return G(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && a(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && a(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && a(this.getLanguagePartFromCode(e))) : G(e) && a(this.formatLanguageCode(e)), o.forEach((i) => {
      r.indexOf(i) < 0 && a(this.formatLanguageCode(i));
    }), r;
  }
}
const Xr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Qr = {
  select: (t) => t === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class sm {
  constructor(e, n = {}) {
    this.languageUtils = e, this.options = n, this.logger = xt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, n) {
    this.rules[e] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e, n = {}) {
    const o = Kn(e === "dev" ? "en" : e), r = n.ordinal ? "ordinal" : "cardinal", a = JSON.stringify({
      cleanedCode: o,
      type: r
    });
    if (a in this.pluralRulesCache)
      return this.pluralRulesCache[a];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: r
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Qr;
      if (!e.match(/-|_/)) return Qr;
      const c = this.languageUtils.getLanguagePartFromCode(e);
      i = this.getRule(c, n);
    }
    return this.pluralRulesCache[a] = i, i;
  }
  needsPlural(e, n = {}) {
    let o = this.getRule(e, n);
    return o || (o = this.getRule("dev", n)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(e, n, o = {}) {
    return this.getSuffixes(e, o).map((r) => `${n}${r}`);
  }
  getSuffixes(e, n = {}) {
    let o = this.getRule(e, n);
    return o || (o = this.getRule("dev", n)), o ? o.resolvedOptions().pluralCategories.sort((r, a) => Xr[r] - Xr[a]).map((r) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : [];
  }
  getSuffix(e, n, o = {}) {
    const r = this.getRule(e, o);
    return r ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(n)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", n, o));
  }
}
const ea = (t, e, n, o = ".", r = !0) => {
  let a = Qp(t, e, n);
  return !a && r && G(n) && (a = Fo(t, n, o), a === void 0 && (a = Fo(e, n, o))), a;
}, xo = (t) => t.replace(/\$/g, "$$$$");
class lm {
  constructor(e = {}) {
    this.logger = xt.create("interpolator"), this.options = e, this.format = e?.interpolation?.format || ((n) => n), this.init(e);
  }
  init(e = {}) {
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: o,
      useRawValueToEscape: r,
      prefix: a,
      prefixEscaped: i,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: d,
      unescapeSuffix: u,
      unescapePrefix: f,
      nestingPrefix: g,
      nestingPrefixEscaped: h,
      nestingSuffix: p,
      nestingSuffixEscaped: v,
      nestingOptionsSeparator: w,
      maxReplaces: C,
      alwaysFormat: b
    } = e.interpolation;
    this.escape = n !== void 0 ? n : tm, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = a ? pn(a) : i || "{{", this.suffix = l ? pn(l) : c || "}}", this.formatSeparator = d || ",", this.unescapePrefix = u ? "" : f || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = g ? pn(g) : h || pn("$t("), this.nestingSuffix = p ? pn(p) : v || pn(")"), this.nestingOptionsSeparator = w || ",", this.maxReplaces = C || 1e3, this.alwaysFormat = b !== void 0 ? b : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (n, o) => n?.source === o ? (n.lastIndex = 0, n) : new RegExp(o, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, n, o, r) {
    let a, i, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, d = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const C = ea(n, c, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(C, void 0, o, {
          ...r,
          ...n,
          interpolationkey: h
        }) : C;
      }
      const p = h.split(this.formatSeparator), v = p.shift().trim(), w = p.join(this.formatSeparator).trim();
      return this.format(ea(n, c, v, this.options.keySeparator, this.options.ignoreJSONStructure), w, o, {
        ...r,
        ...n,
        interpolationkey: v
      });
    };
    this.resetRegExp();
    const u = r?.missingInterpolationHandler || this.options.missingInterpolationHandler, f = r?.interpolation?.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => xo(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? xo(this.escape(h)) : xo(h)
    }].forEach((h) => {
      for (l = 0; a = h.regex.exec(e); ) {
        const p = a[1].trim();
        if (i = d(p), i === void 0)
          if (typeof u == "function") {
            const w = u(e, a, r);
            i = G(w) ? w : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, p))
            i = "";
          else if (f) {
            i = a[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), i = "";
        else !G(i) && !this.useRawValueToEscape && (i = jr(i));
        const v = h.safeValue(i);
        if (e = e.replace(a[0], v), f ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= a[0].length) : h.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, n, o = {}) {
    let r, a, i;
    const l = (c, d) => {
      const u = this.nestingOptionsSeparator;
      if (c.indexOf(u) < 0) return c;
      const f = c.split(new RegExp(`${u}[ ]*{`));
      let g = `{${f[1]}`;
      c = f[0], g = this.interpolate(g, i);
      const h = g.match(/'/g), p = g.match(/"/g);
      ((h?.length ?? 0) % 2 === 0 && !p || p.length % 2 !== 0) && (g = g.replace(/'/g, '"'));
      try {
        i = JSON.parse(g), d && (i = {
          ...d,
          ...i
        });
      } catch (v) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, v), `${c}${u}${g}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, c;
    };
    for (; r = this.nestingRegexp.exec(e); ) {
      let c = [];
      i = {
        ...o
      }, i = i.replace && !G(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const d = /{.*}/.test(r[1]) ? r[1].lastIndexOf("}") + 1 : r[1].indexOf(this.formatSeparator);
      if (d !== -1 && (c = r[1].slice(d).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), r[1] = r[1].slice(0, d)), a = n(l.call(this, r[1].trim(), i), i), a && r[0] === e && !G(a)) return a;
      G(a) || (a = jr(a)), a || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${e}`), a = ""), c.length && (a = c.reduce((u, f) => this.format(u, f, o.lng, {
        ...o,
        interpolationkey: r[1].trim()
      }), a.trim())), e = e.replace(r[0], a), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const cm = (t) => {
  let e = t.toLowerCase().trim();
  const n = {};
  if (t.indexOf("(") > -1) {
    const o = t.split("(");
    e = o[0].toLowerCase().trim();
    const r = o[1].substring(0, o[1].length - 1);
    e === "currency" && r.indexOf(":") < 0 ? n.currency || (n.currency = r.trim()) : e === "relativetime" && r.indexOf(":") < 0 ? n.range || (n.range = r.trim()) : r.split(";").forEach((i) => {
      if (i) {
        const [l, ...c] = i.split(":"), d = c.join(":").trim().replace(/^'+|'+$/g, ""), u = l.trim();
        n[u] || (n[u] = d), d === "false" && (n[u] = !1), d === "true" && (n[u] = !0), isNaN(d) || (n[u] = parseInt(d, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: n
  };
}, ta = (t) => {
  const e = {};
  return (n, o, r) => {
    let a = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (a = {
      ...a,
      [r.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(a);
    let l = e[i];
    return l || (l = t(Kn(o), r), e[i] = l), l(n);
  };
}, dm = (t) => (e, n, o) => t(Kn(n), o)(e);
class um {
  constructor(e = {}) {
    this.logger = xt.create("formatter"), this.options = e, this.init(e);
  }
  init(e, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const o = n.cacheInBuiltFormats ? ta : dm;
    this.formats = {
      number: o((r, a) => {
        const i = new Intl.NumberFormat(r, {
          ...a
        });
        return (l) => i.format(l);
      }),
      currency: o((r, a) => {
        const i = new Intl.NumberFormat(r, {
          ...a,
          style: "currency"
        });
        return (l) => i.format(l);
      }),
      datetime: o((r, a) => {
        const i = new Intl.DateTimeFormat(r, {
          ...a
        });
        return (l) => i.format(l);
      }),
      relativetime: o((r, a) => {
        const i = new Intl.RelativeTimeFormat(r, {
          ...a
        });
        return (l) => i.format(l, a.range || "day");
      }),
      list: o((r, a) => {
        const i = new Intl.ListFormat(r, {
          ...a
        });
        return (l) => i.format(l);
      })
    };
  }
  add(e, n) {
    this.formats[e.toLowerCase().trim()] = n;
  }
  addCached(e, n) {
    this.formats[e.toLowerCase().trim()] = ta(n);
  }
  format(e, n, o, r = {}) {
    const a = n.split(this.formatSeparator);
    if (a.length > 1 && a[0].indexOf("(") > 1 && a[0].indexOf(")") < 0 && a.find((l) => l.indexOf(")") > -1)) {
      const l = a.findIndex((c) => c.indexOf(")") > -1);
      a[0] = [a[0], ...a.splice(1, l)].join(this.formatSeparator);
    }
    return a.reduce((l, c) => {
      const {
        formatName: d,
        formatOptions: u
      } = cm(c);
      if (this.formats[d]) {
        let f = l;
        try {
          const g = r?.formatParams?.[r.interpolationkey] || {}, h = g.locale || g.lng || r.locale || r.lng || o;
          f = this.formats[d](l, h, {
            ...u,
            ...r,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${d}`);
      return l;
    }, e);
  }
}
const fm = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class hm extends ro {
  constructor(e, n, o, r = {}) {
    super(), this.backend = e, this.store = n, this.services = o, this.languageUtils = o.languageUtils, this.options = r, this.logger = xt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, r.backend, r);
  }
  queueLoad(e, n, o, r) {
    const a = {}, i = {}, l = {}, c = {};
    return e.forEach((d) => {
      let u = !0;
      n.forEach((f) => {
        const g = `${d}|${f}`;
        !o.reload && this.store.hasResourceBundle(d, f) ? this.state[g] = 2 : this.state[g] < 0 || (this.state[g] === 1 ? i[g] === void 0 && (i[g] = !0) : (this.state[g] = 1, u = !1, i[g] === void 0 && (i[g] = !0), a[g] === void 0 && (a[g] = !0), c[f] === void 0 && (c[f] = !0)));
      }), u || (l[d] = !0);
    }), (Object.keys(a).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(a),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(e, n, o) {
    const r = e.split("|"), a = r[0], i = r[1];
    n && this.emit("failedLoading", a, i, n), !n && o && this.store.addResourceBundle(a, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = n ? -1 : 2, n && o && (this.state[e] = 0);
    const l = {};
    this.queue.forEach((c) => {
      Xp(c.loaded, [a], i), fm(c, e), n && c.errors.push(n), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((d) => {
        l[d] || (l[d] = {});
        const u = c.loaded[d];
        u.length && u.forEach((f) => {
          l[d][f] === void 0 && (l[d][f] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(e, n, o, r = 0, a = this.retryTimeout, i) {
    if (!e.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: n,
        fcName: o,
        tried: r,
        wait: a,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const l = (d, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (d && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, n, o, r + 1, a * 2, i);
        }, a);
        return;
      }
      i(d, u);
    }, c = this.backend[o].bind(this.backend);
    if (c.length === 2) {
      try {
        const d = c(e, n);
        d && typeof d.then == "function" ? d.then((u) => l(null, u)).catch(l) : l(null, d);
      } catch (d) {
        l(d);
      }
      return;
    }
    return c(e, n, l);
  }
  prepareLoading(e, n, o = {}, r) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    G(e) && (e = this.languageUtils.toResolveHierarchy(e)), G(n) && (n = [n]);
    const a = this.queueLoad(e, n, o, r);
    if (!a.toLoad.length)
      return a.pending.length || r(), null;
    a.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(e, n, o) {
    this.prepareLoading(e, n, {}, o);
  }
  reload(e, n, o) {
    this.prepareLoading(e, n, {
      reload: !0
    }, o);
  }
  loadOne(e, n = "") {
    const o = e.split("|"), r = o[0], a = o[1];
    this.read(r, a, "read", void 0, void 0, (i, l) => {
      i && this.logger.warn(`${n}loading namespace ${a} for language ${r} failed`, i), !i && l && this.logger.log(`${n}loaded namespace ${a} for language ${r}`, l), this.loaded(e, i, l);
    });
  }
  saveMissing(e, n, o, r, a, i = {}, l = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const c = {
          ...i,
          isUpdate: a
        }, d = this.backend.create.bind(this.backend);
        if (d.length < 6)
          try {
            let u;
            d.length === 5 ? u = d(e, n, o, r, c) : u = d(e, n, o, r), u && typeof u.then == "function" ? u.then((f) => l(null, f)).catch(l) : l(null, u);
          } catch (u) {
            l(u);
          }
        else
          d(e, n, o, r, l, c);
      }
      !e || !e[0] || this.store.addResource(e[0], n, o, r);
    }
  }
}
const na = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), G(t[1]) && (e.defaultValue = t[1]), G(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const n = t[3] || t[2];
      Object.keys(n).forEach((o) => {
        e[o] = n[o];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), oa = (t) => (G(t.ns) && (t.ns = [t.ns]), G(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), G(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs?.indexOf?.("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), typeof t.initImmediate == "boolean" && (t.initAsync = t.initImmediate), t), x1 = () => {
}, gm = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((n) => {
    typeof t[n] == "function" && (t[n] = t[n].bind(t));
  });
};
class Gn extends ro {
  constructor(e = {}, n) {
    if (super(), this.options = oa(e), this.services = {}, this.logger = xt, this.modules = {
      external: []
    }, gm(this), n && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, n), this;
      setTimeout(() => {
        this.init(e, n);
      }, 0);
    }
  }
  init(e = {}, n) {
    this.isInitializing = !0, typeof e == "function" && (n = e, e = {}), e.defaultNS == null && e.ns && (G(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const o = na();
    this.options = {
      ...o,
      ...this.options,
      ...oa(e)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const r = (d) => d ? typeof d == "function" ? new d() : d : null;
    if (!this.options.isClone) {
      this.modules.logger ? xt.init(r(this.modules.logger), this.options) : xt.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : d = um;
      const u = new Zr(this.options);
      this.store = new Kr(this.options.resources, this.options);
      const f = this.services;
      f.logger = xt, f.resourceStore = this.store, f.languageUtils = u, f.pluralResolver = new sm(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), d && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (f.formatter = r(d), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new lm(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new hm(r(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", (g, ...h) => {
        this.emit(g, ...h);
      }), this.modules.languageDetector && (f.languageDetector = r(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = r(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new B1(this.services, this.options), this.translator.on("*", (g, ...h) => {
        this.emit(g, ...h);
      }), this.modules.external.forEach((g) => {
        g.init && g.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = x1), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = (...u) => this.store[d](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = (...u) => (this.store[d](...u), this);
    });
    const l = Tn(), c = () => {
      const d = (u, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), n(u, f);
      };
      if (this.languages && !this.isInitialized) return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), l;
  }
  loadResources(e, n = x1) {
    let o = n;
    const r = G(e) ? e : this.language;
    if (typeof e == "function" && (o = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (r?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const a = [], i = (l) => {
        if (!l || l === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((d) => {
          d !== "cimode" && a.indexOf(d) < 0 && a.push(d);
        });
      };
      r ? i(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => i(c)), this.options.preload?.forEach?.((l) => i(l)), this.services.backendConnector.load(a, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(l);
      });
    } else
      o(null);
  }
  reloadResources(e, n, o) {
    const r = Tn();
    return typeof e == "function" && (o = e, e = void 0), typeof n == "function" && (o = n, n = void 0), e || (e = this.languages), n || (n = this.options.ns), o || (o = x1), this.services.backendConnector.reload(e, n, (a) => {
      r.resolve(), o(a);
    }), r;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Si.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const o = this.languages[n];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(e) < 0 && this.store.hasLanguageSomeTranslations(e) && (this.resolvedLanguage = e, this.languages.unshift(e));
    }
  }
  changeLanguage(e, n) {
    this.isLanguageChangingTo = e;
    const o = Tn();
    this.emit("languageChanging", e);
    const r = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? this.isLanguageChangingTo === e && (r(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, o.resolve((...d) => this.t(...d)), n && n(l, (...d) => this.t(...d));
    }, i = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = G(l) ? l : l && l[0], d = this.store.hasLanguageSomeTranslations(c) ? c : this.services.languageUtils.getBestMatchFromCodes(G(l) ? [l] : l);
      d && (this.language || r(d), this.translator.language || this.translator.changeLanguage(d), this.services.languageDetector?.cacheUserLanguage?.(d)), this.loadResources(d, (u) => {
        a(u, d);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(e), o;
  }
  getFixedT(e, n, o) {
    const r = (a, i, ...l) => {
      let c;
      typeof i != "object" ? c = this.options.overloadTranslationOptionHandler([a, i].concat(l)) : c = {
        ...i
      }, c.lng = c.lng || r.lng, c.lngs = c.lngs || r.lngs, c.ns = c.ns || r.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || o || r.keyPrefix);
      const d = this.options.keySeparator || ".";
      let u;
      return c.keyPrefix && Array.isArray(a) ? u = a.map((f) => `${c.keyPrefix}${d}${f}`) : u = c.keyPrefix ? `${c.keyPrefix}${d}${a}` : a, this.t(u, c);
    };
    return G(e) ? r.lng = e : r.lngs = e, r.ns = n, r.keyPrefix = o, r;
  }
  t(...e) {
    return this.translator?.translate(...e);
  }
  exists(...e) {
    return this.translator?.exists(...e);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = n.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (l, c) => {
      const d = this.services.backendConnector.state[`${l}|${c}`];
      return d === -1 || d === 0 || d === 2;
    };
    if (n.precheck) {
      const l = n.precheck(this, i);
      if (l !== void 0) return l;
    }
    return !!(this.hasResourceBundle(o, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, e) && (!r || i(a, e)));
  }
  loadNamespaces(e, n) {
    const o = Tn();
    return this.options.ns ? (G(e) && (e = [e]), e.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      o.resolve(), n && n(r);
    }), o) : (n && n(), Promise.resolve());
  }
  loadLanguages(e, n) {
    const o = Tn();
    G(e) && (e = [e]);
    const r = this.options.preload || [], a = e.filter((i) => r.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return a.length ? (this.options.preload = r.concat(a), this.loadResources((i) => {
      o.resolve(), n && n(i);
    }), o) : (n && n(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    if (Intl.Locale) {
      const r = new Intl.Locale(e);
      if (r && r.getTextInfo) {
        const a = r.getTextInfo();
        if (a && a.direction) return a.direction;
      }
    }
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new Zr(na());
    return e.toLowerCase().indexOf("-latn") > 1 ? "ltr" : n.indexOf(o.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(e = {}, n) {
    return new Gn(e, n);
  }
  cloneInstance(e = {}, n = x1) {
    const o = e.forkResourceStore;
    o && delete e.forkResourceStore;
    const r = {
      ...this.options,
      ...e,
      isClone: !0
    }, a = new Gn(r);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (a.logger = a.logger.clone(e)), ["store", "services", "language"].forEach((l) => {
      a[l] = this[l];
    }), a.services = {
      ...this.services
    }, a.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, o) {
      const l = Object.keys(this.store.data).reduce((c, d) => (c[d] = {
        ...this.store.data[d]
      }, c[d] = Object.keys(c[d]).reduce((u, f) => (u[f] = {
        ...c[d][f]
      }, u), c[d]), c), {});
      a.store = new Kr(l, r), a.services.resourceStore = a.store;
    }
    return a.translator = new B1(a.services, r), a.translator.on("*", (l, ...c) => {
      a.emit(l, ...c);
    }), a.init(r, n), a.translator.options = r, a.translator.backendConnector.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, a;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Ve = Gn.createInstance();
Ve.createInstance = Gn.createInstance;
Ve.createInstance;
Ve.dir;
Ve.init;
Ve.loadResources;
Ve.reloadResources;
Ve.use;
Ve.changeLanguage;
Ve.getFixedT;
Ve.t;
Ve.exists;
Ve.setDefaultNamespace;
Ve.hasLoadedNamespace;
Ve.loadNamespaces;
Ve.loadLanguages;
const {
  slice: pm,
  forEach: mm
} = [];
function vm(t) {
  return mm.call(pm.call(arguments, 1), (e) => {
    if (e)
      for (const n in e)
        t[n] === void 0 && (t[n] = e[n]);
  }), t;
}
function wm(t) {
  return typeof t != "string" ? !1 : [/<\s*script.*?>/i, /<\s*\/\s*script\s*>/i, /<\s*img.*?on\w+\s*=/i, /<\s*\w+\s*on\w+\s*=.*?>/i, /javascript\s*:/i, /vbscript\s*:/i, /expression\s*\(/i, /eval\s*\(/i, /alert\s*\(/i, /document\.cookie/i, /document\.write\s*\(/i, /window\.location/i, /innerHTML/i].some((n) => n.test(t));
}
const ra = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, bm = function(t, e) {
  const o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    path: "/"
  }, r = encodeURIComponent(e);
  let a = `${t}=${r}`;
  if (o.maxAge > 0) {
    const i = o.maxAge - 0;
    if (Number.isNaN(i)) throw new Error("maxAge should be a Number");
    a += `; Max-Age=${Math.floor(i)}`;
  }
  if (o.domain) {
    if (!ra.test(o.domain))
      throw new TypeError("option domain is invalid");
    a += `; Domain=${o.domain}`;
  }
  if (o.path) {
    if (!ra.test(o.path))
      throw new TypeError("option path is invalid");
    a += `; Path=${o.path}`;
  }
  if (o.expires) {
    if (typeof o.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    a += `; Expires=${o.expires.toUTCString()}`;
  }
  if (o.httpOnly && (a += "; HttpOnly"), o.secure && (a += "; Secure"), o.sameSite)
    switch (typeof o.sameSite == "string" ? o.sameSite.toLowerCase() : o.sameSite) {
      case !0:
        a += "; SameSite=Strict";
        break;
      case "lax":
        a += "; SameSite=Lax";
        break;
      case "strict":
        a += "; SameSite=Strict";
        break;
      case "none":
        a += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return o.partitioned && (a += "; Partitioned"), a;
}, aa = {
  create(t, e, n, o) {
    let r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    n && (r.expires = /* @__PURE__ */ new Date(), r.expires.setTime(r.expires.getTime() + n * 60 * 1e3)), o && (r.domain = o), document.cookie = bm(t, e, r);
  },
  read(t) {
    const e = `${t}=`, n = document.cookie.split(";");
    for (let o = 0; o < n.length; o++) {
      let r = n[o];
      for (; r.charAt(0) === " "; ) r = r.substring(1, r.length);
      if (r.indexOf(e) === 0) return r.substring(e.length, r.length);
    }
    return null;
  },
  remove(t, e) {
    this.create(t, "", -1, e);
  }
};
var ym = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(t) {
    let {
      lookupCookie: e
    } = t;
    if (e && typeof document < "u")
      return aa.read(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(t, e) {
    let {
      lookupCookie: n,
      cookieMinutes: o,
      cookieDomain: r,
      cookieOptions: a
    } = e;
    n && typeof document < "u" && aa.create(n, t, o, r, a);
  }
}, Cm = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(t) {
    let {
      lookupQuerystring: e
    } = t, n;
    if (typeof window < "u") {
      let {
        search: o
      } = window.location;
      !window.location.search && window.location.hash?.indexOf("?") > -1 && (o = window.location.hash.substring(window.location.hash.indexOf("?")));
      const a = o.substring(1).split("&");
      for (let i = 0; i < a.length; i++) {
        const l = a[i].indexOf("=");
        l > 0 && a[i].substring(0, l) === e && (n = a[i].substring(l + 1));
      }
    }
    return n;
  }
}, xm = {
  name: "hash",
  // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
  lookup(t) {
    let {
      lookupHash: e,
      lookupFromHashIndex: n
    } = t, o;
    if (typeof window < "u") {
      const {
        hash: r
      } = window.location;
      if (r && r.length > 2) {
        const a = r.substring(1);
        if (e) {
          const i = a.split("&");
          for (let l = 0; l < i.length; l++) {
            const c = i[l].indexOf("=");
            c > 0 && i[l].substring(0, c) === e && (o = i[l].substring(c + 1));
          }
        }
        if (o) return o;
        if (!o && n > -1) {
          const i = r.match(/\/([a-zA-Z-]*)/g);
          return Array.isArray(i) ? i[typeof n == "number" ? n : 0]?.replace("/", "") : void 0;
        }
      }
    }
    return o;
  }
};
let mn = null;
const ia = () => {
  if (mn !== null) return mn;
  try {
    if (mn = typeof window < "u" && window.localStorage !== null, !mn)
      return !1;
    const t = "i18next.translate.boo";
    window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
  } catch {
    mn = !1;
  }
  return mn;
};
var Mm = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(t) {
    let {
      lookupLocalStorage: e
    } = t;
    if (e && ia())
      return window.localStorage.getItem(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(t, e) {
    let {
      lookupLocalStorage: n
    } = e;
    n && ia() && window.localStorage.setItem(n, t);
  }
};
let vn = null;
const sa = () => {
  if (vn !== null) return vn;
  try {
    if (vn = typeof window < "u" && window.sessionStorage !== null, !vn)
      return !1;
    const t = "i18next.translate.boo";
    window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
  } catch {
    vn = !1;
  }
  return vn;
};
var _m = {
  name: "sessionStorage",
  lookup(t) {
    let {
      lookupSessionStorage: e
    } = t;
    if (e && sa())
      return window.sessionStorage.getItem(e) || void 0;
  },
  cacheUserLanguage(t, e) {
    let {
      lookupSessionStorage: n
    } = e;
    n && sa() && window.sessionStorage.setItem(n, t);
  }
}, Rm = {
  name: "navigator",
  lookup(t) {
    const e = [];
    if (typeof navigator < "u") {
      const {
        languages: n,
        userLanguage: o,
        language: r
      } = navigator;
      if (n)
        for (let a = 0; a < n.length; a++)
          e.push(n[a]);
      o && e.push(o), r && e.push(r);
    }
    return e.length > 0 ? e : void 0;
  }
}, Sm = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(t) {
    let {
      htmlTag: e
    } = t, n;
    const o = e || (typeof document < "u" ? document.documentElement : null);
    return o && typeof o.getAttribute == "function" && (n = o.getAttribute("lang")), n;
  }
}, km = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(t) {
    let {
      lookupFromPathIndex: e
    } = t;
    if (typeof window > "u") return;
    const n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(n) ? n[typeof e == "number" ? e : 0]?.replace("/", "") : void 0;
  }
}, Dm = {
  name: "subdomain",
  lookup(t) {
    let {
      lookupFromSubdomainIndex: e
    } = t;
    const n = typeof e == "number" ? e + 1 : 1, o = typeof window < "u" && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (o)
      return o[n];
  }
};
let ki = !1;
try {
  document.cookie, ki = !0;
} catch {
}
const Di = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
ki || Di.splice(1, 1);
const Am = () => ({
  order: Di,
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
  // cache user language
  caches: ["localStorage"],
  excludeCacheFor: ["cimode"],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'
  convertDetectedLanguage: (t) => t
});
class Ai {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(e, n);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      languageUtils: {}
    }, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = e, this.options = vm(n, this.options || {}, Am()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (r) => r.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = o, this.addDetector(ym), this.addDetector(Cm), this.addDetector(Mm), this.addDetector(_m), this.addDetector(Rm), this.addDetector(Sm), this.addDetector(km), this.addDetector(Dm), this.addDetector(xm);
  }
  addDetector(e) {
    return this.detectors[e.name] = e, this;
  }
  detect() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.order, n = [];
    return e.forEach((o) => {
      if (this.detectors[o]) {
        let r = this.detectors[o].lookup(this.options);
        r && typeof r == "string" && (r = [r]), r && (n = n.concat(r));
      }
    }), n = n.filter((o) => o != null && !wm(o)).map((o) => this.options.convertDetectedLanguage(o)), this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes ? n : n.length > 0 ? n[0] : null;
  }
  cacheUserLanguage(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.options.caches;
    n && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || n.forEach((o) => {
      this.detectors[o] && this.detectors[o].cacheUserLanguage(e, this.options);
    }));
  }
}
Ai.type = "languageDetector";
const Om = (t, e, n, o) => {
  const r = [n, {
    code: e,
    ...o || {}
  }];
  if (t?.services?.logger?.forward)
    return t.services.logger.forward(r, "warn", "react-i18next::", !0);
  an(r[0]) && (r[0] = `react-i18next:: ${r[0]}`), t?.services?.logger?.warn ? t.services.logger.warn(...r) : console?.warn && console.warn(...r);
}, la = {}, Vo = (t, e, n, o) => {
  an(n) && la[n] || (an(n) && (la[n] = /* @__PURE__ */ new Date()), Om(t, e, n, o));
}, Oi = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const n = () => {
      setTimeout(() => {
        t.off("initialized", n);
      }, 0), e();
    };
    t.on("initialized", n);
  }
}, Wo = (t, e, n) => {
  t.loadNamespaces(e, Oi(t, n));
}, ca = (t, e, n, o) => {
  if (an(n) && (n = [n]), t.options.preload && t.options.preload.indexOf(e) > -1) return Wo(t, n, o);
  n.forEach((r) => {
    t.options.ns.indexOf(r) < 0 && t.options.ns.push(r);
  }), t.loadLanguages(e, Oi(t, o));
}, Pm = (t, e, n = {}) => !e.languages || !e.languages.length ? (Vo(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(t, {
  lng: n.lng,
  precheck: (o, r) => {
    if (n.bindI18n?.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !r(o.isLanguageChangingTo, t)) return !1;
  }
}), an = (t) => typeof t == "string", Nm = (t) => typeof t == "object" && t !== null, Em = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Lm = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, zm = (t) => Lm[t], Tm = (t) => t.replace(Em, zm);
let Im = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Tm
};
const Bm = () => Im;
let $m;
const Hm = () => $m, Fm = W1();
class Vm {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Wm = (t, e) => {
  const n = ye();
  return je(() => {
    n.current = t;
  }, [t, e]), n.current;
}, Pi = (t, e, n, o) => t.getFixedT(e, n, o), jm = (t, e, n, o) => _e(Pi(t, e, n, o), [t, e, n, o]), qm = (t, e = {}) => {
  const {
    i18n: n
  } = e, {
    i18n: o,
    defaultNS: r
  } = j1(Fm) || {}, a = n || o || Hm();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new Vm()), !a) {
    Vo(a, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const M = (R, D) => an(D) ? D : Nm(D) && an(D.defaultValue) ? D.defaultValue : Array.isArray(R) ? R[R.length - 1] : R, S = [M, {}, !1];
    return S.t = M, S.i18n = {}, S.ready = !1, S;
  }
  a.options.react?.wait && Vo(a, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Bm(),
    ...a.options.react,
    ...e
  }, {
    useSuspense: l,
    keyPrefix: c
  } = i;
  let d = r || a.options?.defaultNS;
  d = an(d) ? [d] : d || ["translation"], a.reportNamespaces.addUsedNamespaces?.(d);
  const u = (a.isInitialized || a.initializedStoreOnce) && d.every((M) => Pm(M, a, i)), f = jm(a, e.lng || null, i.nsMode === "fallback" ? d : d[0], c), g = () => f, h = () => Pi(a, e.lng || null, i.nsMode === "fallback" ? d : d[0], c), [p, v] = Q(g);
  let w = d.join();
  e.lng && (w = `${e.lng}${w}`);
  const C = Wm(w), b = ye(!0);
  je(() => {
    const {
      bindI18n: M,
      bindI18nStore: S
    } = i;
    b.current = !0, !u && !l && (e.lng ? ca(a, e.lng, d, () => {
      b.current && v(h);
    }) : Wo(a, d, () => {
      b.current && v(h);
    })), u && C && C !== w && b.current && v(h);
    const R = () => {
      b.current && v(h);
    };
    return M && a?.on(M, R), S && a?.store.on(S, R), () => {
      b.current = !1, a && M?.split(" ").forEach((D) => a.off(D, R)), S && a && S.split(" ").forEach((D) => a.store.off(D, R));
    };
  }, [a, w]), je(() => {
    b.current && u && v(g);
  }, [a, c, u]);
  const y = [p, a, u];
  if (y.t = p, y.i18n = a, y.ready = u, u || !u && !l) return y;
  throw new Promise((M) => {
    e.lng ? ca(a, e.lng, d, () => M()) : Wo(a, d, () => M());
  });
}, Ym = { closeButton: "Schließen" }, Um = { header: { closeButton: "Dialog schließen" } }, Km = { removeButton: "{{label}} entfernen" }, Gm = { characterCountLabel: "max. Zeichenzahl" }, Jm = { label: "Lädt" }, Zm = { row: { showLessButton: "weniger anzeigen", showMoreButton: "… mehr" } }, Xm = { defaultInputLabel: "Passwort-Eingabefeld", hideButton: "Passwort verbergen", showButton: "Passwort anzeigen" }, Qm = { clearButton: "Suche löschen", defaultPlaceholder: "Suchen" }, e5 = { closeButton: "{{title}} schließen", filterInput: "Optionen filtern", label: "Auswahlmenü" }, t5 = { header: { sortAscending: "Aufsteigend", sortDescending: "Absteigend", sortUnsorted: "Spalte sortieren" }, pagination: { goToPageButton: "Gehe zu Seite {{page}}", nextPageButton: "Nächste Seite", previousPageButton: "Vorherige Seite" } }, n5 = { removeButton: "{{label}} entfernen" }, o5 = {
  callout: Ym,
  dialog: Um,
  filterbutton: Km,
  formfield: Gm,
  loadingindicator: Jm,
  minitable: Zm,
  password: Xm,
  search: Qm,
  selectionmenu: e5,
  table: t5,
  tag: n5
}, r5 = { closeButton: "Close" }, a5 = { header: { closeButton: "Close dialog" } }, i5 = { removeButton: "Remove {{label}}" }, s5 = { characterCountLabel: "max. character count" }, l5 = { label: "Loading" }, c5 = { row: { showLessButton: "show less", showMoreButton: "… more" } }, d5 = { defaultInputLabel: "Password input field", hideButton: "Hide password", showButton: "Show password" }, u5 = { clearButton: "Clear search", defaultPlaceholder: "Search" }, f5 = { closeButton: "Close {{title}}", filterInput: "Filter options", label: "Selection menu" }, h5 = { header: { sortAscending: "Ascending", sortDescending: "Descending", sortUnsorted: "Sort column" }, pagination: { goToPageButton: "Go to page {{page}}", nextPageButton: "Next page", previousPageButton: "Previous page" } }, g5 = { removeButton: "Remove {{label}}" }, p5 = {
  callout: r5,
  dialog: a5,
  filterbutton: i5,
  formfield: s5,
  loadingindicator: l5,
  minitable: c5,
  password: d5,
  search: u5,
  selectionmenu: f5,
  table: h5,
  tag: g5
}, m5 = {
  de: Mp,
  en: Gp
}, v5 = {
  en: {
    translation: p5
  },
  de: {
    translation: o5
  }
}, rr = Ve.createInstance();
rr.use(Ai).init({
  resources: v5,
  // lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  fallbackLng: "en",
  supportedLngs: ["en", "de"],
  interpolation: {
    escapeValue: !1
  },
  load: "all",
  lowerCaseLng: !0,
  debug: !1
});
const ar = () => m5[rr.language], ot = () => qm(void 0, { i18n: rr }), w5 = ({
  title: t,
  onClose: e,
  caption: n
}) => {
  const { t: o } = ot();
  return /* @__PURE__ */ x("div", { className: Ct.dialogHeader, children: [
    /* @__PURE__ */ s("span", { className: Ct.dialogHeaderTitle, children: t }),
    e ? /* @__PURE__ */ s(
      Ie,
      {
        className: Ct.closeButton,
        onClick: e,
        "aria-label": o("dialog.header.closeButton", { title: t }),
        children: /* @__PURE__ */ s(Sn, { className: Ct.closeIcon })
      }
    ) : (
      // placeholder element so the CSS grid layout structure doesn't get lost
      /* @__PURE__ */ s("span", {})
    ),
    n && /* @__PURE__ */ s(qe, { color: "reduced", children: n })
  ] });
}, Ni = (t) => `dialog-${t}`, ly = (t, e) => {
  const o = V1(), [r, a] = Q(!1), i = Ni(o), l = () => {
    if (!document.getElementById(i)) {
      const u = document.createElement("div");
      u.id = i, u.style.position = "relative", u.style.zIndex = `${e ?? 100}`, document.body.appendChild(u), document.body.addEventListener("keydown", d), a(!0);
    }
  }, c = _e(() => {
    t?.(), a(!1);
  }, [t]), d = _e(
    (u) => {
      u.key === "Escape" && c();
    },
    [c]
  );
  return je(() => {
    const u = document.getElementById(i);
    !r && u && (document.body.removeEventListener("keydown", d), document.body.removeChild(u));
  }, [i, d, r]), { id: o, isOpen: r, openDialog: l, closeDialog: c };
}, cy = m(
  ({
    id: t,
    children: e,
    className: n,
    actions: o,
    title: r,
    onClose: a,
    caption: i,
    footer: l,
    size: c = "medium"
  }, d) => {
    const u = Ni(t), f = document.getElementById(u);
    return f ? gs(
      /* @__PURE__ */ s("div", { className: Ct.backdrop, children: /* @__PURE__ */ x(
        "div",
        {
          ref: d,
          className: T(n, Ct[c], Ct.dialog),
          role: "dialog",
          "aria-label": r,
          children: [
            /* @__PURE__ */ s(w5, { caption: i, title: r, onClose: a }),
            /* @__PURE__ */ s(qg, { children: e }),
            /* @__PURE__ */ s("div", { className: Ct.dialogFooter, children: l || /* @__PURE__ */ s(Yg, { children: o }) })
          ]
        }
      ) }),
      f
    ) : null;
  }
), b5 = "_tooltip_1vdkh_1", y5 = "_arrow_1vdkh_20", da = {
  tooltip: b5,
  arrow: y5
}, C5 = ({
  initialOpen: t = !1,
  placement: e = "top",
  open: n,
  onOpenChange: o,
  disabled: r,
  delay: a = 500
  // biome-ignore lint/suspicious/noExplicitAny: returns hook
} = {}) => {
  const [i, l] = Q(t), c = ye(null), d = r ? !1 : n ?? i, u = o ?? l, f = un({
    placement: e,
    open: d,
    onOpenChange: u,
    whileElementsMounted: dn,
    middleware: [
      An(5),
      Pn({
        crossAxis: e.includes("-"),
        fallbackAxisSideDirection: "start",
        padding: 5
      }),
      On({ padding: 5 }),
      _3({
        element: c
      })
    ]
  }), g = f.context, h = T3(g, {
    delay: a,
    move: !1,
    enabled: n == null
  }), p = J3(g, {
    enabled: n == null
  }), v = r1(g), w = no(g, { role: "tooltip" }), C = Nn([h, p, v, w]);
  return Hn(
    () => ({
      open: d,
      setOpen: u,
      ...C,
      ...f,
      arrowRef: c
    }),
    [d, u, C, f]
  );
}, Ei = W1(null), Li = () => {
  const t = j1(Ei);
  return t == null && console.error("Tooltip components must be wrapped in <Tooltip />"), t;
}, i1 = ({
  children: t,
  ...e
}) => {
  const n = C5(e);
  return /* @__PURE__ */ s(Ei.Provider, { value: n, children: t });
}, s1 = m(
  ({ children: t, ...e }, n) => {
    const o = Li(), r = t.ref, a = e1([o?.refs.setReference, n, r]), i = t.props;
    return Da(t) ? hs(
      t,
      o?.getReferenceProps({
        ref: a,
        ...e,
        ...i
      })
    ) : /* @__PURE__ */ s("span", { ref: a, ...o?.getReferenceProps(e), children: t });
  }
), l1 = m(({ style: t, children: e, ...n }, o) => {
  const r = Li(), a = e1([r?.refs.setFloating, o]);
  return r?.open ? /* @__PURE__ */ s(St, { children: /* @__PURE__ */ x(
    "div",
    {
      ref: a,
      style: {
        ...r.floatingStyles,
        ...t
      },
      ...r.getFloatingProps(n),
      className: T(da.tooltip, n.className),
      children: [
        /* @__PURE__ */ s(
          N3,
          {
            className: da.arrow,
            context: r.context,
            ref: r.arrowRef
          }
        ),
        e
      ]
    }
  ) }) : null;
}), x5 = "_tag_1lf2r_1", M5 = "_filtersCount_1lf2r_12", ua = {
  tag: x5,
  filtersCount: M5
}, fa = ({
  option: t,
  filtersCount: e,
  className: n
}) => /* @__PURE__ */ x("span", { className: T(ua.tag, n), children: [
  e && /* @__PURE__ */ s("span", { className: ua.filtersCount, children: e }),
  /* @__PURE__ */ s("span", { children: t })
] }), _5 = "_filterButton_1b5j1_1", R5 = "_disabled_1b5j1_22", S5 = "_borderSolid_1b5j1_43", k5 = "_label_1b5j1_47", D5 = "_colorUnselected_1b5j1_57", A5 = "_selectedOptions_1b5j1_72", O5 = "_deleteButton_1b5j1_81", P5 = "_disabledTag_1b5j1_110", N5 = "_tooltipFix_1b5j1_115", ht = {
  filterButton: _5,
  disabled: R5,
  borderSolid: S5,
  label: k5,
  colorUnselected: D5,
  selectedOptions: A5,
  deleteButton: O5,
  disabledTag: P5,
  tooltipFix: N5
}, dy = m(
  ({
    selectedOptions: t,
    label: e,
    id: n,
    onClick: o,
    onDelete: r,
    selectedCountLabel: a = "Selected",
    disabled: i = !1,
    tooltip: l,
    ...c
  }, d) => {
    const { t: u } = ot(), f = t.length > 0, g = /* @__PURE__ */ x(
      Ie,
      {
        className: T(
          ht.filterButton,
          i ? ht.disabled : f ? ht.borderSolid : ht.colorUnselected
        ),
        ref: d,
        onClick: i ? void 0 : o,
        ...c,
        children: [
          /* @__PURE__ */ s("span", { className: ht.label, children: e }),
          f && /* @__PURE__ */ s("span", { className: T(ht.selectedOptions), children: t.length < 3 ? t.map((h) => /* @__PURE__ */ s(
            fa,
            {
              option: h,
              className: i ? ht.disabledTag : void 0
            },
            h
          )) : /* @__PURE__ */ s(
            fa,
            {
              filtersCount: t.length,
              option: a,
              className: i ? ht.disabledTag : void 0
            }
          ) }),
          r && // nesting buttons is not valid html and in general not really recommended, but if we want to implement this behaviour I can't think of any other way
          /* @__PURE__ */ s(
            "div",
            {
              "aria-label": u("filterbutton.removeButton", {
                label: e
              }),
              className: ht.deleteButton,
              onClick: i ? void 0 : () => r(n ?? e),
              role: "button",
              tabIndex: 0,
              onKeyDown: i ? void 0 : (h) => {
                (h.key === "Enter" || h.key === " ") && (h.preventDefault(), r(n ?? e));
              },
              children: /* @__PURE__ */ s(Sn, {})
            }
          )
        ]
      }
    );
    return l ? /* @__PURE__ */ x(i1, { children: [
      /* @__PURE__ */ s(s1, { children: /* @__PURE__ */ s("span", { className: ht.tooltipFix, children: g }) }),
      /* @__PURE__ */ s(l1, { children: l })
    ] }) : g;
  }
), E5 = "_base_1s977_1", L5 = "_FormFieldGrid_1s977_11", z5 = "_labelWrapper_1s977_16", T5 = "_infoIconWrapper_1s977_21", I5 = "_required_1s977_27", B5 = "_sm_1s977_32", $5 = "_regular_1s977_38", H5 = "_maxLength_1s977_42", Ht = {
  base: E5,
  FormFieldGrid: L5,
  labelWrapper: z5,
  infoIconWrapper: T5,
  required: I5,
  sm: B5,
  regular: $5,
  maxLength: H5
}, uy = ({
  label: t,
  htmlFor: e,
  caption: n,
  children: o,
  validation: r,
  required: a,
  id: i,
  maxLength: l,
  hideCharCount: c,
  value: d,
  className: u,
  info: f
}) => {
  const { t: g } = ot();
  return /* @__PURE__ */ x("div", { className: T(Ht.FormFieldGrid, u), children: [
    /* @__PURE__ */ x(
      "label",
      {
        id: i,
        className: T(Ht.sm, Ht.regular, Ht.base),
        htmlFor: e,
        children: [
          /* @__PURE__ */ x("span", { className: Ht.labelWrapper, children: [
            /* @__PURE__ */ s("span", { children: t }),
            f && /* @__PURE__ */ x(i1, { children: [
              /* @__PURE__ */ s(s1, { children: /* @__PURE__ */ s("span", { className: Ht.infoIconWrapper, children: /* @__PURE__ */ s(De, { size: 16, children: /* @__PURE__ */ s(Ta, {}) }) }) }),
              /* @__PURE__ */ s(l1, { children: f })
            ] }),
            a && /* @__PURE__ */ s("span", { className: Ht.required, children: "*" })
          ] }),
          !c && typeof l == "number" && // biome-ignore lint/a11y/useAriaPropsSupportedByRole: needed
          /* @__PURE__ */ x(
            "span",
            {
              className: Ht.maxLength,
              "aria-label": g("formfield.characterCountLabel"),
              children: [
                d?.length ?? 0,
                "/",
                l
              ]
            }
          )
        ]
      }
    ),
    o,
    n && /* @__PURE__ */ s(qe, { size: "sm", weight: "regular", color: "reduced", children: n }),
    r && r
  ] });
}, fy = ({
  type: t = "success",
  children: e
}) => /* @__PURE__ */ s(
  qe,
  {
    size: "sm",
    weight: "regular",
    color: t === "error" ? "critical" : "success",
    children: e
  }
), F5 = "_wrapper_1mkwl_1", V5 = "_label_1mkwl_6", W5 = "_control_1mkwl_12", j5 = "_content_1mkwl_16", q5 = "_disabled_1mkwl_23", Y5 = "_toggle_1mkwl_23", U5 = "_unchecked_1mkwl_23", K5 = "_input_1mkwl_29", G5 = "_checked_1mkwl_49", J5 = "_checkbox_1mkwl_54", Z5 = "_radio_1mkwl_68", X5 = "_radioIcon_1mkwl_73", Q5 = "_textDisabled_1mkwl_98", Le = {
  wrapper: F5,
  label: V5,
  control: W5,
  content: j5,
  disabled: q5,
  toggle: Y5,
  unchecked: U5,
  input: K5,
  checked: G5,
  checkbox: J5,
  radio: Z5,
  radioIcon: X5,
  textDisabled: Q5
}, ev = ({
  checked: t = !1,
  indeterminate: e = !1
}) => {
  const n = e ? au : Na;
  return /* @__PURE__ */ s(
    "div",
    {
      className: T(
        Le.checkbox,
        Le.toggle,
        t ? Le.checked : Le.unchecked
      ),
      children: t && /* @__PURE__ */ s(n, {})
    }
  );
}, tv = ({ checked: t = !1 }) => /* @__PURE__ */ s(
  "div",
  {
    className: T(
      Le.radio,
      Le.toggle,
      t ? Le.checked : Le.unchecked
    ),
    children: t && /* @__PURE__ */ s("div", { className: Le.radioIcon })
  }
), zi = m(
  ({
    id: t,
    label: e,
    caption: n,
    checked: o,
    indeterminate: r = !1,
    disabled: a,
    type: i,
    ...l
  }, c) => {
    const d = V1(), u = t ?? d, f = ye(null), g = e1([c, f]);
    return je(() => {
      i !== "radio" && (r && f.current ? f.current.indeterminate = !0 : f.current && !r && (f.current.indeterminate = !1));
    }, [r, i]), /* @__PURE__ */ x("div", { className: T(Le.wrapper, a && Le.disabled), children: [
      /* @__PURE__ */ s(
        "input",
        {
          ref: g,
          className: Le.input,
          id: u,
          type: i,
          checked: o,
          disabled: a,
          ...l
        }
      ),
      /* @__PURE__ */ x("label", { htmlFor: u, className: Le.label, children: [
        /* @__PURE__ */ s("div", { className: Le.control, children: i === "checkbox" ? /* @__PURE__ */ s(ev, { checked: o, indeterminate: r }) : /* @__PURE__ */ s(tv, { checked: o }) }),
        /* @__PURE__ */ x("div", { className: Le.content, children: [
          /* @__PURE__ */ s(qe, { className: T(a && Le.textDisabled), size: "md", children: e }),
          n && /* @__PURE__ */ s(
            qe,
            {
              color: "reduced",
              size: "sm",
              className: T(a && Le.textDisabled),
              children: n
            }
          )
        ] })
      ] })
    ] });
  }
), hy = m(
  (t, e) => /* @__PURE__ */ s(zi, { ...t, type: "checkbox", ref: e })
), gy = m((t, e) => /* @__PURE__ */ s(zi, { ...t, type: "radio", ref: e })), py = (t) => /* @__PURE__ */ s("div", { ...t, role: "radiogroup" }), nv = "_wrapper_2d32d_1", ov = "_arrow_2d32d_7", rv = "_arrowDisabled_2d32d_13", av = "_inputWrapper_2d32d_17", iv = "_wrapperDisabled_2d32d_33", sv = "_hasFocus_2d32d_39", lv = "_critical_2d32d_43", cv = "_comboInput_2d32d_47", dv = "_comboButton_2d32d_66", uv = "_flipIcon_2d32d_76", fv = "_options_2d32d_86", hv = "_list_2d32d_98", gv = "_overflow_2d32d_111", pv = "_hidden_2d32d_116", mv = "_emptyState_2d32d_121", vv = "_option_2d32d_86", wv = "_selected_2d32d_140", bv = "_disabled_2d32d_144", yv = "_compact_2d32d_154", ke = {
  wrapper: nv,
  arrow: ov,
  arrowDisabled: rv,
  inputWrapper: av,
  wrapperDisabled: iv,
  hasFocus: sv,
  critical: lv,
  comboInput: cv,
  comboButton: dv,
  flipIcon: uv,
  options: fv,
  list: hv,
  overflow: gv,
  hidden: pv,
  emptyState: mv,
  option: vv,
  selected: wv,
  disabled: bv,
  default: "_default_2d32d_150",
  compact: yv
}, Cv = (t, e, n) => {
  const o = e.at(t);
  if (o)
    return n?.(o);
};
function xv({
  id: t,
  optionToId: e,
  placeholder: n,
  options: o = [],
  optionToQuery: r,
  setSelectedOption: a,
  query: i,
  setQuery: l,
  labelId: c,
  disabled: d = !1
}) {
  const [u, f] = Q(!1), [g, h] = Q(-1), p = (P) => {
    a(P), l(r?.(P) ?? "");
  }, v = () => {
    f(!1), h(-1);
  }, w = (P) => {
    const { value: I } = P.target;
    !u && I === "" && i.length > 0 && f(!0), l(I);
  }, C = `${t}-menu`, b = `${t}-toggle-button`;
  return {
    closeMenu: v,
    getComboBoxProps: () => ({ role: "group" }),
    getInputProps: ({ onBlur: P, onFocus: I }) => ({
      "aria-activedescendant": u ? Cv(g, o, e) : void 0,
      "aria-autocomplete": "list",
      "aria-controls": u ? C : void 0,
      "aria-expanded": u,
      "aria-haspopup": "listbox",
      "aria-labelledby": c,
      "aria-label": t ? void 0 : n,
      onBlur: P,
      onFocus: () => {
        I?.(), u || f(!0);
      },
      autoComplete: "off",
      id: t,
      onClick: () => {
        f(!0);
      },
      onChange: w,
      onKeyDown: (N) => {
        if (/ArrowDown|ArrowUp/.test(N.key)) {
          u || f(!0), N.preventDefault();
          const B = N.key === "ArrowDown" ? 1 : -1, $ = (g + B) % o.length;
          h($);
        }
        N.key === "Enter" && (N.preventDefault(), p(o[g === -1 ? 0 : g]), v()), N.key === "Escape" && v(), N.key === "Tab" && v();
      },
      placeholder: n,
      role: "combobox",
      value: i
    }),
    getOptionProps: ({ option: P, index: I }) => ({
      "aria-selected": I === g,
      id: e?.(P) ?? "",
      onClick: () => {
        v(), p(P);
      },
      role: "option"
    }),
    getMenuProps: () => ({
      id: C,
      role: "listbox"
    }),
    getToggleButtonProps: () => ({
      "aria-controls": u ? C : void 0,
      "aria-expanded": u,
      id: b,
      tabIndex: -1,
      type: "button",
      onClick: (P) => {
        P.preventDefault(), d || f(!u);
      }
    }),
    isOpen: u
  };
}
const Mv = (t, e) => {
  const n = (o) => {
    t.current && !t.current.contains(o?.target ?? null) && e();
  };
  je(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
}, Mo = (t) => t === null ? "" : `${t}`, my = ({
  className: t,
  emptyState: e,
  selectedOption: n,
  setSelectedOption: o,
  renderOption: r = Mo,
  optionToQuery: a = Mo,
  formatOption: i = a,
  options: l,
  optionToId: c = Mo,
  onBlur: d,
  error: u,
  name: f,
  id: g,
  labelId: h,
  size: p = "default",
  query: v,
  placeholder: w,
  setQuery: C,
  disabled: b,
  maxHeight: y,
  portalId: M
}) => {
  const [S, R] = Q(!1), D = V1(), { floatingStyles: P, refs: I } = un({
    placement: "bottom-start",
    middleware: [
      er({
        apply({ rects: H, elements: Y }) {
          Object.assign(Y.floating.style, {
            width: `${H.reference.width}px`
          });
        }
      })
    ],
    whileElementsMounted: dn
  }), {
    getToggleButtonProps: N,
    getMenuProps: B,
    getInputProps: $,
    getOptionProps: V,
    getComboBoxProps: E,
    closeMenu: A,
    isOpen: W
  } = xv({
    setQuery: (H) => C?.(H ?? ""),
    id: g ?? D,
    options: l,
    optionToQuery: a,
    query: v,
    labelId: h,
    optionToId: c,
    placeholder: w,
    setSelectedOption: o,
    disabled: b
  }), z = ye(null);
  Mv(z, () => {
    A();
  });
  const k = $({
    onFocus: () => R(!0),
    onBlur: () => {
      d?.(), R(!1);
    }
  }), O = W && !(l.length === 0 && e === void 0);
  return /* @__PURE__ */ x("div", { ref: z, className: ke.wrapper, children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: T([
          t,
          u && ke.critical,
          S && ke.hasFocus,
          ke.inputWrapper,
          ke[p],
          b && ke.wrapperDisabled
        ]),
        ...E(),
        ref: I.setReference,
        children: [
          /* @__PURE__ */ s(
            "input",
            {
              name: f,
              type: "text",
              disabled: b,
              className: ke.comboInput,
              ...k,
              value: !S && n ? i(n) : k.value
            }
          ),
          /* @__PURE__ */ s(
            "button",
            {
              "aria-hidden": "true",
              className: ke.comboButton,
              ...N(),
              children: /* @__PURE__ */ s(
                Zn,
                {
                  className: T(
                    ke.arrow,
                    O && ke.flipIcon,
                    b && ke.arrowDisabled
                  )
                }
              )
            }
          )
        ]
      }
    ),
    W && /* @__PURE__ */ s(St, { id: M, children: /* @__PURE__ */ s(
      "ul",
      {
        className: T(
          ke.list,
          ke.options,
          O || ke.hidden,
          ke.overflow
        ),
        ...B(),
        style: { maxHeight: y, zIndex: Bt, ...P },
        ref: I.setFloating,
        children: O && (l.length === 0 ? /* @__PURE__ */ s("li", { className: ke.emptyState, children: e }) : l.map((H, Y) => {
          const L = V({ option: H, index: Y });
          return /* @__PURE__ */ s(
            "li",
            {
              className: T([
                ke.option,
                n && c(n) === c(H) && ke.selected
              ]),
              ...L,
              children: r(H)
            },
            `${c(H)}-${Y}`
          );
        }))
      }
    ) })
  ] });
}, _v = "_inputWrapper_69jkw_3", Rv = "_compact_69jkw_27", Sv = "_input_69jkw_3", kv = "_hasFocus_69jkw_43", Dv = "_wrapperDisabled_69jkw_48", Av = "_critical_69jkw_64", Ov = "_hasPrefix_69jkw_76", Pv = "_hasSuffix_69jkw_80", Nv = "_hasPreAndSuffix_69jkw_84", Ev = "_adornment_69jkw_88", Lv = "_trailing_69jkw_112", Re = {
  inputWrapper: _v,
  default: "_default_69jkw_23",
  compact: Rv,
  input: Sv,
  hasFocus: kv,
  wrapperDisabled: Dv,
  critical: Av,
  hasPrefix: Ov,
  hasSuffix: Pv,
  hasPreAndSuffix: Nv,
  adornment: Ev,
  trailing: Lv
}, dt = m(
  ({
    className: t,
    error: e,
    size: n = "default",
    leading: o,
    trailing: r,
    onFocus: a,
    onBlur: i,
    disabled: l = !1,
    ...c
  }, d) => {
    const [u, f] = Q(!1);
    return /* @__PURE__ */ x(
      "div",
      {
        className: T(
          Re.inputWrapper,
          t,
          Re[n],
          e && Re.critical,
          u && Re.hasFocus,
          l && Re.wrapperDisabled,
          o && r && Re.hasPreAndSuffix,
          o && !r && Re.hasPrefix,
          !o && r && Re.hasSuffix
        ),
        children: [
          o && /* @__PURE__ */ s("span", { className: Re.adornment, children: o }),
          /* @__PURE__ */ s(
            "input",
            {
              disabled: l,
              ref: d,
              className: Re.input,
              onBlur: (g) => {
                i?.(g), f(!1);
              },
              onFocus: (g) => {
                a?.(g), f(!0);
              },
              ...c
            }
          ),
          r && /* @__PURE__ */ s("span", { className: T(Re.adornment, Re.trailing), children: r })
        ]
      }
    );
  }
);
dt.displayName = "Input";
const zv = "_wrapper_qjlyw_1", Tv = "_arrow_qjlyw_7", Iv = "_arrowDisabled_qjlyw_15", Bv = "_comboButton_qjlyw_21", $v = "_flipIcon_qjlyw_31", Hv = "_options_qjlyw_35", Fv = "_list_qjlyw_47", Vv = "_overflow_qjlyw_56", Wv = "_hidden_qjlyw_61", jv = "_emptyState_qjlyw_66", gt = {
  wrapper: zv,
  arrow: Tv,
  arrowDisabled: Iv,
  comboButton: Bv,
  flipIcon: $v,
  options: Hv,
  list: Fv,
  overflow: Vv,
  hidden: Wv,
  emptyState: jv
}, ha = (t) => t === null ? "" : `${t}`, qv = 52;
function Yv({
  className: t,
  emptyState: e,
  selectedOptions: n,
  setSelectedOption: o,
  renderOption: r = ha,
  options: a,
  optionToId: i = ha,
  onBlur: l,
  onFocus: c,
  error: d,
  name: u,
  id: f,
  labelId: g,
  size: h = "default",
  query: p,
  placeholder: v,
  setQuery: w,
  disabled: C,
  maxHeight: b,
  menuItem: y
}, M) {
  const [S, R] = Q(null), [D, P] = Q(!1), I = ye([]), { floatingStyles: N, refs: B, context: $ } = un({
    open: D,
    onOpenChange: P,
    placement: "bottom-start",
    middleware: [
      An({ mainAxis: 16, alignmentAxis: -12 }),
      Pn(),
      On(),
      er({
        apply({ rects: K, availableHeight: de, elements: ue }) {
          Object.assign(ue.floating.style, {
            width: `${K.reference.width + qv}px`,
            maxHeight: `${de}px`
          });
        }
      })
    ],
    whileElementsMounted: dn
  }), V = no($, { role: "listbox" }), E = r1($), A = a1($, {
    listRef: I,
    activeIndex: S,
    onNavigate: R,
    virtual: !0,
    loop: !0
  }), { getFloatingProps: W, getReferenceProps: z, getItemProps: k } = Nn(
    [V, E, A]
  ), O = (K) => !!n.find(
    (de) => i(de) === i(K)
  ), H = (K) => {
    o(
      n.filter(
        (de) => i(de) !== i(K)
      )
    );
  }, Y = (K) => {
    O(K) ? H(K) : o([...n, K]), w(""), R(null), P(!1);
  }, L = D && !(a.length === 0 && e === void 0), J = e1([B.setReference, M]);
  return /* @__PURE__ */ x("div", { className: gt.wrapper, children: [
    /* @__PURE__ */ s(
      dt,
      {
        ref: J,
        size: h,
        className: t,
        autoComplete: "off",
        name: u,
        placeholder: v,
        type: "text",
        "aria-labelledby": g,
        error: d,
        disabled: C,
        ...z({
          id: f,
          onClick: () => {
            P(!0);
          },
          onFocus: () => {
            c?.();
          },
          onBlur: () => {
            l?.();
          },
          onKeyDown(K) {
            K.key === "Enter" && K.preventDefault(), K.key === "Enter" && S != null && a[S] && Y(a[S]);
          }
        }),
        value: p,
        onChange: (K) => {
          const de = K.target.value;
          de ? (P(!0), R(0)) : P(!1), w(de);
        },
        trailing: /* @__PURE__ */ s(
          "button",
          {
            tabIndex: -1,
            className: gt.comboButton,
            type: "button",
            onClick: (K) => {
              K.preventDefault(), C || P(!D);
            },
            children: /* @__PURE__ */ s(
              Zn,
              {
                className: T(
                  gt.arrow,
                  L && gt.flipIcon,
                  C && gt.arrowDisabled
                )
              }
            )
          }
        )
      }
    ),
    D && /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(Kt, { elementsRef: I, children: /* @__PURE__ */ s(
      Gt,
      {
        returnFocus: !0,
        initialFocus: -1,
        context: $,
        children: /* @__PURE__ */ s(
          "div",
          {
            ...W(),
            style: {
              ...N,
              // makes sure that it displays on top of other elements (modals, sidebars, etc.)
              zIndex: Bt
            },
            ref: B.setFloating,
            children: /* @__PURE__ */ x(
              "ul",
              {
                className: T(
                  gt.list,
                  gt.options,
                  L || gt.hidden,
                  gt.overflow
                ),
                style: { maxHeight: b },
                children: [
                  L && (a.length === 0 ? /* @__PURE__ */ s("li", { className: gt.emptyState, children: e }) : a.map((K) => {
                    const de = k({
                      onClick: () => Y(K)
                    });
                    return /* @__PURE__ */ s(
                      wi,
                      {
                        role: "option",
                        label: r(K),
                        selected: O(K),
                        ...de
                      },
                      i(K)
                    );
                  })),
                  y
                ]
              }
            )
          }
        )
      }
    ) }) })
  ] });
}
const vy = m(Yv), Uv = {}, $n = {};
function jn(t, e) {
  try {
    const o = (Uv[t] ||= new Intl.DateTimeFormat("en-GB", {
      timeZone: t,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1] || "";
    return o in $n ? $n[o] : ga(o, o.split(":"));
  } catch {
    if (t in $n) return $n[t];
    const n = t?.match(Kv);
    return n ? ga(t, n.slice(1)) : NaN;
  }
}
const Kv = /([+-]\d\d):?(\d\d)?/;
function ga(t, e) {
  const n = +e[0], o = +(e[1] || 0);
  return $n[t] = n > 0 ? n * 60 + o : n * 60 - o;
}
class Mt extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(jn(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Ti(this), jo(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new Mt(...n, e) : new Mt(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new Mt(+this, e);
  }
  getTimezoneOffset() {
    return -jn(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), jo(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new Mt(+new Date(e), this.timeZone);
  }
  //#endregion
}
const pa = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!pa.test(t)) return;
  const e = t.replace(pa, "$1UTC");
  Mt.prototype[e] && (t.startsWith("get") ? Mt.prototype[t] = function() {
    return this.internal[e]();
  } : (Mt.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), Gv(this), +this;
  }, Mt.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), jo(this), +this;
  }));
});
function jo(t) {
  t.internal.setTime(+t), t.internal.setUTCMinutes(t.internal.getUTCMinutes() - t.getTimezoneOffset());
}
function Gv(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), Ti(t);
}
function Ti(t) {
  const e = jn(t.timeZone, t), n = /* @__PURE__ */ new Date(+t);
  n.setUTCHours(n.getUTCHours() - 1);
  const o = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), r = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), a = o - r, i = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  a && i && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + a);
  const l = o - e;
  l && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + l);
  const c = jn(t.timeZone, t), u = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - c, f = c !== e, g = u - l;
  if (f && g) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + g);
    const h = jn(t.timeZone, t), p = c - h;
    p && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + p), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + p));
  }
}
class He extends Mt {
  //#region static
  static tz(e, ...n) {
    return n.length ? new He(...n, e) : new He(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, o] = this.tzComponents(), r = `${e}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, o, r] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${e} GMT${n}${o}${r} (${Jv(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", o = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(e) {
    return new He(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new He(+new Date(e), this.timeZone);
  }
  //#endregion
}
function Jv(t, e) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: t,
    timeZoneName: "long"
  }).format(e).slice(12);
}
var j;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(j || (j = {}));
var be;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(be || (be = {}));
var ct;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(ct || (ct = {}));
var Je;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(Je || (Je = {}));
const Ii = 6048e5, Zv = 864e5, ma = Symbol.for("constructDateFrom");
function Se(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && ma in t ? t[ma](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function re(t, e) {
  return Se(e || t, t);
}
function Bi(t, e, n) {
  const o = re(t, n?.in);
  return isNaN(e) ? Se(t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function $1(t, e, n) {
  const o = re(t, n?.in);
  if (isNaN(e)) return Se(t, NaN);
  if (!e)
    return o;
  const r = o.getDate(), a = Se(t, o.getTime());
  a.setMonth(o.getMonth() + e + 1, 0);
  const i = a.getDate();
  return r >= i ? a : (o.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    r
  ), o);
}
let Xv = {};
function c1() {
  return Xv;
}
function Rn(t, e) {
  const n = c1(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = re(t, e?.in), a = r.getDay(), i = (a < o ? 7 : 0) + a - o;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function Jn(t, e) {
  return Rn(t, { ...e, weekStartsOn: 1 });
}
function $i(t, e) {
  const n = re(t, e?.in), o = n.getFullYear(), r = Se(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const a = Jn(r), i = Se(n, 0);
  i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0);
  const l = Jn(i);
  return n.getTime() >= a.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function va(t) {
  const e = re(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function En(t, ...e) {
  const n = Se.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(n);
}
function cn(t, e) {
  const n = re(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Hi(t, e, n) {
  const [o, r] = En(
    n?.in,
    t,
    e
  ), a = cn(o), i = cn(r), l = +a - va(a), c = +i - va(i);
  return Math.round((l - c) / Zv);
}
function Qv(t, e) {
  const n = $i(t, e), o = Se(t, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), Jn(o);
}
function e7(t, e, n) {
  return Bi(t, e * 7, n);
}
function t7(t, e, n) {
  return $1(t, e * 12, n);
}
function n7(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Se.bind(null, r));
    const a = re(r, o);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), Se(o, n || NaN);
}
function o7(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Se.bind(null, r));
    const a = re(r, o);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), Se(o, n || NaN);
}
function r7(t, e, n) {
  const [o, r] = En(
    n?.in,
    t,
    e
  );
  return +cn(o) == +cn(r);
}
function d1(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function ao(t) {
  return !(!d1(t) && typeof t != "number" || isNaN(+re(t)));
}
function a7(t, e, n) {
  const [o, r] = En(
    n?.in,
    t,
    e
  ), a = o.getFullYear() - r.getFullYear(), i = o.getMonth() - r.getMonth();
  return a * 12 + i;
}
function wa(t, e) {
  const n = re(t, e?.in);
  return n.setHours(23, 59, 59, 999), n;
}
function i7(t, e) {
  const n = re(t, e?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function s7(t, e) {
  const [n, o] = En(t, e.start, e.end);
  return { start: n, end: o };
}
function l7(t, e) {
  const { start: n, end: o } = s7(e?.in, t);
  let r = +n > +o;
  const a = r ? +n : +o, i = r ? o : n;
  i.setHours(0, 0, 0, 0), i.setDate(1);
  let l = 1;
  const c = [];
  for (; +i <= a; )
    c.push(Se(n, i)), i.setMonth(i.getMonth() + l);
  return r ? c.reverse() : c;
}
function c7(t, e) {
  const n = re(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function d7(t, e) {
  const n = re(t, e?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Fi(t, e) {
  const n = re(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Vi(t, e) {
  const n = c1(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = re(t, e?.in), a = r.getDay(), i = (a < o ? -7 : 0) + 6 - (a - o);
  return r.setDate(r.getDate() + i), r.setHours(23, 59, 59, 999), r;
}
function u7(t, e) {
  return Vi(t, { ...e, weekStartsOn: 1 });
}
const f7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, h7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, g7 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, p7 = {
  date: zt({
    formats: f7,
    defaultWidth: "full"
  }),
  time: zt({
    formats: h7,
    defaultWidth: "full"
  }),
  dateTime: zt({
    formats: g7,
    defaultWidth: "full"
  })
}, ir = {
  code: "en-US",
  formatDistance: Ci,
  formatLong: p7,
  formatRelative: xi,
  localize: Mi,
  match: _i,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function m7(t, e) {
  const n = re(t, e?.in);
  return Hi(n, Fi(n)) + 1;
}
function Wi(t, e) {
  const n = re(t, e?.in), o = +Jn(n) - +Qv(n);
  return Math.round(o / Ii) + 1;
}
function ji(t, e) {
  const n = re(t, e?.in), o = n.getFullYear(), r = c1(), a = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = Se(e?.in || t, 0);
  i.setFullYear(o + 1, 0, a), i.setHours(0, 0, 0, 0);
  const l = Rn(i, e), c = Se(e?.in || t, 0);
  c.setFullYear(o, 0, a), c.setHours(0, 0, 0, 0);
  const d = Rn(c, e);
  return +n >= +l ? o + 1 : +n >= +d ? o : o - 1;
}
function v7(t, e) {
  const n = c1(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = ji(t, e), a = Se(e?.in || t, 0);
  return a.setFullYear(r, 0, o), a.setHours(0, 0, 0, 0), Rn(a, e);
}
function qi(t, e) {
  const n = re(t, e?.in), o = +Rn(n, e) - +v7(n, e);
  return Math.round(o / Ii) + 1;
}
function ie(t, e) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return n + o;
}
const Ft = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), o = n > 0 ? n : 1 - n;
    return ie(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : ie(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return ie(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return ie(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return ie(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return ie(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return ie(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, o = t.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return ie(r, e.length);
  }
}, wn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ba = {
  // Era
  G: function(t, e, n) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const o = t.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Ft.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, o) {
    const r = ji(t, o), a = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const i = a % 100;
      return ie(i, 2);
    }
    return e === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : ie(a, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = $i(t);
    return ie(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return ie(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return ie(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return ie(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Ft.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return ie(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, o) {
    const r = qi(t, o);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : ie(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const o = Wi(t);
    return e === "Io" ? n.ordinalNumber(o, { unit: "week" }) : ie(o, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Ft.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const o = m7(t);
    return e === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : ie(o, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, o) {
    const r = t.getDay(), a = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return ie(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, o) {
    const r = t.getDay(), a = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return ie(a, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const o = t.getDay(), r = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return ie(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o === 12 ? r = wn.noon : o === 0 ? r = wn.midnight : r = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o >= 17 ? r = wn.evening : o >= 12 ? r = wn.afternoon : o >= 4 ? r = wn.morning : r = wn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return Ft.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Ft.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const o = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : ie(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : ie(o, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Ft.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Ft.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Ft.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Ca(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return nn(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return nn(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Ca(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return nn(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return nn(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ya(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + nn(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ya(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + nn(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const o = Math.trunc(+t / 1e3);
    return ie(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return ie(+t, e.length);
  }
};
function ya(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Math.trunc(o / 60), a = o % 60;
  return a === 0 ? n + String(r) : n + String(r) + e + ie(a, 2);
}
function Ca(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + ie(Math.abs(t) / 60, 2) : nn(t, e);
}
function nn(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = ie(Math.trunc(o / 60), 2), a = ie(o % 60, 2);
  return n + r + e + a;
}
const xa = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Yi = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, w7 = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return xa(t, e);
  let a;
  switch (o) {
    case "P":
      a = e.dateTime({ width: "short" });
      break;
    case "PP":
      a = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = e.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", xa(o, e)).replace("{{time}}", Yi(r, e));
}, b7 = {
  p: Yi,
  P: w7
}, y7 = /^D+$/, C7 = /^Y+$/, x7 = ["D", "DD", "YY", "YYYY"];
function M7(t) {
  return y7.test(t);
}
function _7(t) {
  return C7.test(t);
}
function R7(t, e, n) {
  const o = S7(t, e, n);
  if (console.warn(o), x7.includes(t)) throw new RangeError(o);
}
function S7(t, e, n) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const k7 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, D7 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, A7 = /^'([^]*?)'?$/, O7 = /''/g, P7 = /[a-zA-Z]/;
function N7(t, e, n) {
  const o = c1(), r = n?.locale ?? o.locale ?? ir, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, l = re(t, n?.in);
  if (!ao(l))
    throw new RangeError("Invalid time value");
  let c = e.match(D7).map((u) => {
    const f = u[0];
    if (f === "p" || f === "P") {
      const g = b7[f];
      return g(u, r.formatLong);
    }
    return u;
  }).join("").match(k7).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const f = u[0];
    if (f === "'")
      return { isToken: !1, value: E7(u) };
    if (ba[f])
      return { isToken: !0, value: u };
    if (f.match(P7))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: u };
  });
  r.localize.preprocessor && (c = r.localize.preprocessor(l, c));
  const d = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: r
  };
  return c.map((u) => {
    if (!u.isToken) return u.value;
    const f = u.value;
    (!n?.useAdditionalWeekYearTokens && _7(f) || !n?.useAdditionalDayOfYearTokens && M7(f)) && R7(f, e, String(t));
    const g = ba[f[0]];
    return g(l, f, r.localize, d);
  }).join("");
}
function E7(t) {
  const e = t.match(A7);
  return e ? e[1].replace(O7, "'") : t;
}
function L7(t, e) {
  const n = re(t, e?.in);
  if (isNaN(+n))
    throw new RangeError("Invalid time value");
  const o = e?.format ?? "extended";
  let r = "";
  const a = o === "extended" ? "-" : "";
  {
    const i = ie(n.getDate(), 2), l = ie(n.getMonth() + 1, 2);
    r = `${ie(n.getFullYear(), 4)}${a}${l}${a}${i}`;
  }
  return r;
}
function z7(t, e) {
  const n = re(t, e?.in), o = n.getFullYear(), r = n.getMonth(), a = Se(n, 0);
  return a.setFullYear(o, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function T7(t, e) {
  return re(t, e?.in).getHours();
}
function I7(t, e) {
  return re(t, e?.in).getMinutes();
}
function B7(t, e) {
  return re(t, e?.in).getMonth();
}
function $7(t, e) {
  return re(t, e?.in).getFullYear();
}
function H7(t, e) {
  return +re(t) > +re(e);
}
function F7(t, e) {
  return +re(t) < +re(e);
}
function V7(t, e, n) {
  const [o, r] = En(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function W7(t, e, n) {
  const [o, r] = En(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear();
}
function j7(t, e, n) {
  const o = re(t, n?.in), r = o.getFullYear(), a = o.getDate(), i = Se(t, 0);
  i.setFullYear(r, e, 15), i.setHours(0, 0, 0, 0);
  const l = z7(i);
  return o.setMonth(e, Math.min(a, l)), o;
}
function _o(t, e, n) {
  const o = re(t, n?.in);
  return o.setHours(e), o;
}
function Ro(t, e, n) {
  const o = re(t, n?.in);
  return o.setMinutes(e), o;
}
function q7(t, e, n) {
  const o = re(t, n?.in);
  return isNaN(+o) ? Se(t, NaN) : (o.setFullYear(e), o);
}
const Ma = 5, Y7 = 4;
function U7(t, e) {
  const n = e.startOfMonth(t), o = n.getDay() > 0 ? n.getDay() : 7, r = e.addDays(t, -o + 1), a = e.addDays(r, Ma * 7 - 1);
  return e.getMonth(t) === e.getMonth(a) ? Ma : Y7;
}
function Ui(t, e) {
  const n = e.startOfMonth(t), o = n.getDay();
  return o === 1 ? n : o === 0 ? e.addDays(n, -1 * 6) : e.addDays(n, -1 * (o - 1));
}
function K7(t, e) {
  const n = Ui(t, e), o = U7(t, e);
  return e.addDays(n, o * 7 - 1);
}
class $t {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? He.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, a) => this.overrides?.newDate ? this.overrides.newDate(o, r, a) : this.options.timeZone ? new He(o, r, a, this.options.timeZone) : new Date(o, r, a), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : Bi(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : $1(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : e7(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : t7(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : Hi(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : a7(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : l7(o), this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : K7(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : u7(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : i7(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : Vi(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : d7(o), this.format = (o, r, a) => {
      const i = this.overrides?.format ? this.overrides.format(o, r, this.options) : N7(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(i) : i;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : Wi(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : B7(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : $7(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : qi(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : H7(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : F7(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : d1(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : r7(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : V7(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : W7(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : n7(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : o7(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : j7(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : q7(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : Ui(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : cn(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : Jn(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : c7(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : Rn(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : Fi(o), this.options = { locale: ir, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
}
const kt = new $t();
class Ki {
  constructor(e, n, o = kt) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(e, n)), this.dateLib = o;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class G7 {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class J7 {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function Nt(t, e, n = !1, o = kt) {
  let { from: r, to: a } = t;
  const { differenceInCalendarDays: i, isSameDay: l } = o;
  return r && a ? (i(a, r) < 0 && ([r, a] = [a, r]), i(e, r) >= (n ? 1 : 0) && i(a, e) >= (n ? 1 : 0)) : !n && a ? l(a, e) : !n && r ? l(r, e) : !1;
}
function Gi(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function sr(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function Ji(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function Zi(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Xi(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function Qi(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function Et(t, e, n = kt) {
  const o = Array.isArray(e) ? e : [e], { isSameDay: r, differenceInCalendarDays: a, isAfter: i } = n;
  return o.some((l) => {
    if (typeof l == "boolean")
      return l;
    if (n.isDate(l))
      return r(t, l);
    if (Qi(l, n))
      return l.includes(t);
    if (sr(l))
      return Nt(l, t, !1, n);
    if (Xi(l))
      return Array.isArray(l.dayOfWeek) ? l.dayOfWeek.includes(t.getDay()) : l.dayOfWeek === t.getDay();
    if (Gi(l)) {
      const c = a(l.before, t), d = a(l.after, t), u = c > 0, f = d < 0;
      return i(l.before, l.after) ? f && u : u || f;
    }
    return Ji(l) ? a(t, l.after) > 0 : Zi(l) ? a(l.before, t) > 0 : typeof l == "function" ? l(t) : !1;
  });
}
function Z7(t, e, n) {
  const { disabled: o, hidden: r, modifiers: a, showOutsideDays: i, broadcastCalendar: l, today: c } = e, { isSameDay: d, isSameMonth: u, startOfMonth: f, isBefore: g, endOfMonth: h, isAfter: p } = n, v = e.startMonth && f(e.startMonth), w = e.endMonth && h(e.endMonth), C = {
    [be.focused]: [],
    [be.outside]: [],
    [be.disabled]: [],
    [be.hidden]: [],
    [be.today]: []
  }, b = {};
  for (const y of t) {
    const { date: M, displayMonth: S } = y, R = !!(S && !u(M, S)), D = !!(v && g(M, v)), P = !!(w && p(M, w)), I = !!(o && Et(M, o, n)), N = !!(r && Et(M, r, n)) || D || P || // Broadcast calendar will show outside days as default
    !l && !i && R || l && i === !1 && R, B = d(M, c ?? n.today());
    R && C.outside.push(y), I && C.disabled.push(y), N && C.hidden.push(y), B && C.today.push(y), a && Object.keys(a).forEach(($) => {
      const V = a?.[$];
      V && Et(M, V, n) && (b[$] ? b[$].push(y) : b[$] = [y]);
    });
  }
  return (y) => {
    const M = {
      [be.focused]: !1,
      [be.disabled]: !1,
      [be.hidden]: !1,
      [be.outside]: !1,
      [be.today]: !1
    }, S = {};
    for (const R in C) {
      const D = C[R];
      M[R] = D.some((P) => P === y);
    }
    for (const R in b)
      S[R] = b[R].some((D) => D === y);
    return {
      ...M,
      // custom modifiers should override all the previous ones
      ...S
    };
  };
}
function X7(t, e, n = {}) {
  return Object.entries(t).filter(([, r]) => r === !0).reduce((r, [a]) => (n[a] ? r.push(n[a]) : e[be[a]] ? r.push(e[be[a]]) : e[ct[a]] && r.push(e[ct[a]]), r), [e[j.Day]]);
}
function Q7(t) {
  return F.createElement("button", { ...t });
}
function e9(t) {
  return F.createElement("span", { ...t });
}
function t9(t) {
  const { size: e = 24, orientation: n = "left", className: o } = t;
  return F.createElement(
    "svg",
    { className: o, width: e, height: e, viewBox: "0 0 24 24" },
    n === "up" && F.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && F.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && F.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && F.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function n9(t) {
  const { day: e, modifiers: n, ...o } = t;
  return F.createElement("td", { ...o });
}
function o9(t) {
  const { day: e, modifiers: n, ...o } = t, r = F.useRef(null);
  return F.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), F.createElement("button", { ref: r, ...o });
}
function r9(t) {
  const { options: e, className: n, components: o, classNames: r, ...a } = t, i = [r[j.Dropdown], n].join(" "), l = e?.find(({ value: c }) => c === a.value);
  return F.createElement(
    "span",
    { "data-disabled": a.disabled, className: r[j.DropdownRoot] },
    F.createElement(o.Select, { className: i, ...a }, e?.map(({ value: c, label: d, disabled: u }) => F.createElement(o.Option, { key: c, value: c, disabled: u }, d))),
    F.createElement(
      "span",
      { className: r[j.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      F.createElement(o.Chevron, { orientation: "down", size: 18, className: r[j.Chevron] })
    )
  );
}
function a9(t) {
  return F.createElement("div", { ...t });
}
function i9(t) {
  return F.createElement("div", { ...t });
}
function s9(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return F.createElement("div", { ...o }, t.children);
}
function l9(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return F.createElement("div", { ...o });
}
function c9(t) {
  return F.createElement("table", { ...t });
}
function d9(t) {
  return F.createElement("div", { ...t });
}
const es = W1(void 0);
function u1() {
  const t = j1(es);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function u9(t) {
  const { components: e } = u1();
  return F.createElement(e.Dropdown, { ...t });
}
function f9(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: o, nextMonth: r, ...a } = t, { components: i, classNames: l, labels: { labelPrevious: c, labelNext: d } } = u1(), u = _e((g) => {
    r && n?.(g);
  }, [r, n]), f = _e((g) => {
    o && e?.(g);
  }, [o, e]);
  return F.createElement(
    "nav",
    { ...a },
    F.createElement(
      i.PreviousMonthButton,
      { type: "button", className: l[j.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: f },
      F.createElement(i.Chevron, { disabled: o ? void 0 : !0, className: l[j.Chevron], orientation: "left" })
    ),
    F.createElement(
      i.NextMonthButton,
      { type: "button", className: l[j.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": d(r), onClick: u },
      F.createElement(i.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: l[j.Chevron] })
    )
  );
}
function h9(t) {
  const { components: e } = u1();
  return F.createElement(e.Button, { ...t });
}
function g9(t) {
  return F.createElement("option", { ...t });
}
function p9(t) {
  const { components: e } = u1();
  return F.createElement(e.Button, { ...t });
}
function m9(t) {
  const { rootRef: e, ...n } = t;
  return F.createElement("div", { ...n, ref: e });
}
function v9(t) {
  return F.createElement("select", { ...t });
}
function w9(t) {
  const { week: e, ...n } = t;
  return F.createElement("tr", { ...n });
}
function b9(t) {
  return F.createElement("th", { ...t });
}
function y9(t) {
  return F.createElement(
    "thead",
    { "aria-hidden": !0 },
    F.createElement("tr", { ...t })
  );
}
function C9(t) {
  const { week: e, ...n } = t;
  return F.createElement("th", { ...n });
}
function x9(t) {
  return F.createElement("th", { ...t });
}
function M9(t) {
  return F.createElement("tbody", { ...t });
}
function _9(t) {
  const { components: e } = u1();
  return F.createElement(e.Dropdown, { ...t });
}
const R9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Q7,
  CaptionLabel: e9,
  Chevron: t9,
  Day: n9,
  DayButton: o9,
  Dropdown: r9,
  DropdownNav: a9,
  Footer: i9,
  Month: s9,
  MonthCaption: l9,
  MonthGrid: c9,
  Months: d9,
  MonthsDropdown: u9,
  Nav: f9,
  NextMonthButton: h9,
  Option: g9,
  PreviousMonthButton: p9,
  Root: m9,
  Select: v9,
  Week: w9,
  WeekNumber: C9,
  WeekNumberHeader: x9,
  Weekday: b9,
  Weekdays: y9,
  Weeks: M9,
  YearsDropdown: _9
}, Symbol.toStringTag, { value: "Module" }));
function S9(t) {
  return {
    ...R9,
    ...t
  };
}
function k9(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, o]) => {
    n.startsWith("data-") && (e[n] = o);
  }), e;
}
function D9() {
  const t = {};
  for (const e in j)
    t[j[e]] = `rdp-${j[e]}`;
  for (const e in be)
    t[be[e]] = `rdp-${be[e]}`;
  for (const e in ct)
    t[ct[e]] = `rdp-${ct[e]}`;
  for (const e in Je)
    t[Je[e]] = `rdp-${Je[e]}`;
  return t;
}
function ts(t, e, n) {
  return (n ?? new $t(e)).format(t, "LLLL y");
}
const A9 = ts;
function O9(t, e, n) {
  return (n ?? new $t(e)).format(t, "d");
}
function P9(t, e = kt) {
  return e.format(t, "LLLL");
}
function N9(t, e = kt) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function E9() {
  return "";
}
function L9(t, e, n) {
  return (n ?? new $t(e)).format(t, "cccccc");
}
function ns(t, e = kt) {
  return e.format(t, "yyyy");
}
const z9 = ns, T9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: ts,
  formatDay: O9,
  formatMonthCaption: A9,
  formatMonthDropdown: P9,
  formatWeekNumber: N9,
  formatWeekNumberHeader: E9,
  formatWeekdayName: L9,
  formatYearCaption: z9,
  formatYearDropdown: ns
}, Symbol.toStringTag, { value: "Module" }));
function I9(t) {
  return t?.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t?.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...T9,
    ...t
  };
}
function B9(t, e, n, o, r) {
  const { startOfMonth: a, startOfYear: i, endOfYear: l, eachMonthOfInterval: c, getMonth: d } = r;
  return c({
    start: i(t),
    end: l(t)
  }).map((g) => {
    const h = o.formatMonthDropdown(g, r), p = d(g), v = e && g < a(e) || n && g > a(n) || !1;
    return { value: p, label: h, disabled: v };
  });
}
function $9(t, e = {}, n = {}) {
  let o = { ...e?.[j.Day] };
  return Object.entries(t).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function H9(t, e, n) {
  const o = t.today(), r = e ? t.startOfISOWeek(o) : t.startOfWeek(o), a = [];
  for (let i = 0; i < 7; i++) {
    const l = t.addDays(r, i);
    a.push(l);
  }
  return a;
}
function F9(t, e, n, o) {
  if (!t || !e)
    return;
  const { startOfYear: r, endOfYear: a, addYears: i, getYear: l, isBefore: c, isSameYear: d } = o, u = r(t), f = a(e), g = [];
  let h = u;
  for (; c(h, f) || d(h, f); )
    g.push(h), h = i(h, 1);
  return g.map((p) => {
    const v = n.formatYearDropdown(p, o);
    return {
      value: l(p),
      label: v,
      disabled: !1
    };
  });
}
function os(t, e, n) {
  return (n ?? new $t(e)).format(t, "LLLL y");
}
const V9 = os;
function W9(t, e, n, o) {
  let r = (o ?? new $t(n)).format(t, "PPPP");
  return e?.today && (r = `Today, ${r}`), r;
}
function rs(t, e, n, o) {
  let r = (o ?? new $t(n)).format(t, "PPPP");
  return e.today && (r = `Today, ${r}`), e.selected && (r = `${r}, selected`), r;
}
const j9 = rs;
function q9() {
  return "";
}
function Y9(t) {
  return "Choose the Month";
}
function U9(t) {
  return "Go to the Next Month";
}
function K9(t) {
  return "Go to the Previous Month";
}
function G9(t, e, n) {
  return (n ?? new $t(e)).format(t, "cccc");
}
function J9(t, e) {
  return `Week ${t}`;
}
function Z9(t) {
  return "Week Number";
}
function X9(t) {
  return "Choose the Year";
}
const Q9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: V9,
  labelDay: j9,
  labelDayButton: rs,
  labelGrid: os,
  labelGridcell: W9,
  labelMonthDropdown: Y9,
  labelNav: q9,
  labelNext: U9,
  labelPrevious: K9,
  labelWeekNumber: J9,
  labelWeekNumberHeader: Z9,
  labelWeekday: G9,
  labelYearDropdown: X9
}, Symbol.toStringTag, { value: "Module" })), f1 = (t) => t instanceof HTMLElement ? t : null, So = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], ew = (t) => f1(t.querySelector("[data-animated-month]")), ko = (t) => f1(t.querySelector("[data-animated-caption]")), Do = (t) => f1(t.querySelector("[data-animated-weeks]")), tw = (t) => f1(t.querySelector("[data-animated-nav]")), nw = (t) => f1(t.querySelector("[data-animated-weekdays]"));
function ow(t, e, { classNames: n, months: o, focused: r, dateLib: a }) {
  const i = ye(null), l = ye(o), c = ye(!1);
  qo(() => {
    const d = l.current;
    if (l.current = o, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || d.length === 0 || o.length !== d.length)
      return;
    const u = a.isSameMonth(o[0].date, d[0].date), f = a.isAfter(o[0].date, d[0].date), g = f ? n[Je.caption_after_enter] : n[Je.caption_before_enter], h = f ? n[Je.weeks_after_enter] : n[Je.weeks_before_enter], p = i.current, v = t.current.cloneNode(!0);
    if (v instanceof HTMLElement ? (So(v).forEach((y) => {
      if (!(y instanceof HTMLElement))
        return;
      const M = ew(y);
      M && y.contains(M) && y.removeChild(M);
      const S = ko(y);
      S && S.classList.remove(g);
      const R = Do(y);
      R && R.classList.remove(h);
    }), i.current = v) : i.current = null, c.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const w = p instanceof HTMLElement ? So(p) : [], C = So(t.current);
    if (C && C.every((b) => b instanceof HTMLElement) && w && w.every((b) => b instanceof HTMLElement)) {
      c.current = !0, t.current.style.isolation = "isolate";
      const b = tw(t.current);
      b && (b.style.zIndex = "1"), C.forEach((y, M) => {
        const S = w[M];
        if (!S)
          return;
        y.style.position = "relative", y.style.overflow = "hidden";
        const R = ko(y);
        R && R.classList.add(g);
        const D = Do(y);
        D && D.classList.add(h);
        const P = () => {
          c.current = !1, t.current && (t.current.style.isolation = ""), b && (b.style.zIndex = ""), R && R.classList.remove(g), D && D.classList.remove(h), y.style.position = "", y.style.overflow = "", y.contains(S) && y.removeChild(S);
        };
        S.style.pointerEvents = "none", S.style.position = "absolute", S.style.overflow = "hidden", S.setAttribute("aria-hidden", "true");
        const I = nw(S);
        I && (I.style.opacity = "0");
        const N = ko(S);
        N && (N.classList.add(f ? n[Je.caption_before_exit] : n[Je.caption_after_exit]), N.addEventListener("animationend", P));
        const B = Do(S);
        B && B.classList.add(f ? n[Je.weeks_before_exit] : n[Je.weeks_after_exit]), y.insertBefore(S, y.firstChild);
      });
    }
  });
}
function rw(t, e, n, o) {
  const r = t[0], a = t[t.length - 1], { ISOWeek: i, fixedWeeks: l, broadcastCalendar: c } = n ?? {}, { addDays: d, differenceInCalendarDays: u, differenceInCalendarMonths: f, endOfBroadcastWeek: g, endOfISOWeek: h, endOfMonth: p, endOfWeek: v, isAfter: w, startOfBroadcastWeek: C, startOfISOWeek: b, startOfWeek: y } = o, M = c ? C(r, o) : i ? b(r) : y(r), S = c ? g(a) : i ? h(p(a)) : v(p(a)), R = u(S, M), D = f(a, r) + 1, P = [];
  for (let B = 0; B <= R; B++) {
    const $ = d(M, B);
    if (e && w($, e))
      break;
    P.push($);
  }
  const N = (c ? 35 : 42) * D;
  if (l && P.length < N) {
    const B = N - P.length;
    for (let $ = 0; $ < B; $++) {
      const V = d(P[P.length - 1], 1);
      P.push(V);
    }
  }
  return P;
}
function aw(t) {
  const e = [];
  return t.reduce((n, o) => {
    const r = o.weeks.reduce((a, i) => [...a, ...i.days], e);
    return [...n, ...r];
  }, e);
}
function iw(t, e, n, o) {
  const { numberOfMonths: r = 1 } = n, a = [];
  for (let i = 0; i < r; i++) {
    const l = o.addMonths(t, i);
    if (e && l > e)
      break;
    a.push(l);
  }
  return a;
}
function _a(t, e) {
  const { month: n, defaultMonth: o, today: r = e.today(), numberOfMonths: a = 1, endMonth: i, startMonth: l } = t;
  let c = n || o || r;
  const { differenceInCalendarMonths: d, addMonths: u, startOfMonth: f } = e;
  if (i && d(i, c) < 0) {
    const g = -1 * (a - 1);
    c = u(i, g);
  }
  return l && d(c, l) < 0 && (c = l), f(c);
}
function sw(t, e, n, o) {
  const { addDays: r, endOfBroadcastWeek: a, endOfISOWeek: i, endOfMonth: l, endOfWeek: c, getISOWeek: d, getWeek: u, startOfBroadcastWeek: f, startOfISOWeek: g, startOfWeek: h } = o, p = t.reduce((v, w) => {
    const C = n.broadcastCalendar ? f(w, o) : n.ISOWeek ? g(w) : h(w), b = n.broadcastCalendar ? a(w) : n.ISOWeek ? i(l(w)) : c(l(w)), y = e.filter((D) => D >= C && D <= b), M = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && y.length < M) {
      const D = e.filter((P) => {
        const I = M - y.length;
        return P > b && P <= r(b, I);
      });
      y.push(...D);
    }
    const S = y.reduce((D, P) => {
      const I = n.ISOWeek ? d(P) : u(P), N = D.find(($) => $.weekNumber === I), B = new Ki(P, w, o);
      return N ? N.days.push(B) : D.push(new J7(I, [B])), D;
    }, []), R = new G7(w, S);
    return v.push(R), v;
  }, []);
  return n.reverseMonths ? p.reverse() : p;
}
function lw(t, e) {
  let { startMonth: n, endMonth: o } = t;
  const { startOfYear: r, startOfDay: a, startOfMonth: i, endOfMonth: l, addYears: c, endOfYear: d, newDate: u, today: f } = e, { fromYear: g, toYear: h, fromMonth: p, toMonth: v } = t;
  !n && p && (n = p), !n && g && (n = e.newDate(g, 0, 1)), !o && v && (o = v), !o && h && (o = u(h, 11, 31));
  const w = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = i(n) : g ? n = u(g, 0, 1) : !n && w && (n = r(c(t.today ?? f(), -100))), o ? o = l(o) : h ? o = u(h, 11, 31) : !o && w && (o = d(t.today ?? f())), [
    n && a(n),
    o && a(o)
  ];
}
function cw(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: a = 1 } = n, { startOfMonth: i, addMonths: l, differenceInCalendarMonths: c } = o, d = r ? a : 1, u = i(t);
  if (!e)
    return l(u, d);
  if (!(c(e, t) < a))
    return l(u, d);
}
function dw(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: a } = n, { startOfMonth: i, addMonths: l, differenceInCalendarMonths: c } = o, d = r ? a ?? 1 : 1, u = i(t);
  if (!e)
    return l(u, -d);
  if (!(c(u, e) <= 0))
    return l(u, -d);
}
function uw(t) {
  const e = [];
  return t.reduce((n, o) => [...n, ...o.weeks], e);
}
function io(t, e) {
  const [n, o] = Q(t);
  return [e === void 0 ? n : e, o];
}
function fw(t, e) {
  const [n, o] = lw(t, e), { startOfMonth: r, endOfMonth: a } = e, i = _a(t, e), [l, c] = io(
    i,
    // initialMonth is always computed from props.month if provided
    t.month ? i : void 0
  );
  je(() => {
    const R = _a(t, e);
    c(R);
  }, [t.timeZone]);
  const d = iw(l, o, t, e), u = rw(d, t.endMonth ? a(t.endMonth) : void 0, t, e), f = sw(d, u, t, e), g = uw(f), h = aw(f), p = dw(l, n, t, e), v = cw(l, o, t, e), { disableNavigation: w, onMonthChange: C } = t, b = (R) => g.some((D) => D.days.some((P) => P.isEqualTo(R))), y = (R) => {
    if (w)
      return;
    let D = r(R);
    n && D < r(n) && (D = r(n)), o && D > r(o) && (D = r(o)), c(D), C?.(D);
  };
  return {
    months: f,
    weeks: g,
    days: h,
    navStart: n,
    navEnd: o,
    previousMonth: p,
    nextMonth: v,
    goToMonth: y,
    goToDay: (R) => {
      b(R) || y(R.date);
    }
  };
}
var mt;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(mt || (mt = {}));
function Ra(t) {
  return !t[be.disabled] && !t[be.hidden] && !t[be.outside];
}
function hw(t, e, n, o) {
  let r, a = -1;
  for (const i of t) {
    const l = e(i);
    Ra(l) && (l[be.focused] && a < mt.FocusedModifier ? (r = i, a = mt.FocusedModifier) : o?.isEqualTo(i) && a < mt.LastFocused ? (r = i, a = mt.LastFocused) : n(i.date) && a < mt.Selected ? (r = i, a = mt.Selected) : l[be.today] && a < mt.Today && (r = i, a = mt.Today));
  }
  return r || (r = t.find((i) => Ra(e(i)))), r;
}
function gw(t, e, n, o, r, a, i) {
  const { ISOWeek: l, broadcastCalendar: c } = a, { addDays: d, addMonths: u, addWeeks: f, addYears: g, endOfBroadcastWeek: h, endOfISOWeek: p, endOfWeek: v, max: w, min: C, startOfBroadcastWeek: b, startOfISOWeek: y, startOfWeek: M } = i;
  let R = {
    day: d,
    week: f,
    month: u,
    year: g,
    startOfWeek: (D) => c ? b(D, i) : l ? y(D) : M(D),
    endOfWeek: (D) => c ? h(D) : l ? p(D) : v(D)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && o ? R = w([o, R]) : e === "after" && r && (R = C([r, R])), R;
}
function as(t, e, n, o, r, a, i, l = 0) {
  if (l > 365)
    return;
  const c = gw(t, e, n.date, o, r, a, i), d = !!(a.disabled && Et(c, a.disabled, i)), u = !!(a.hidden && Et(c, a.hidden, i)), f = c, g = new Ki(c, f, i);
  return !d && !u ? g : as(t, e, g, o, r, a, i, l + 1);
}
function pw(t, e, n, o, r) {
  const { autoFocus: a } = t, [i, l] = Q(), c = hw(e.days, n, o || (() => !1), i), [d, u] = Q(a ? c : void 0);
  return {
    isFocusTarget: (v) => !!c?.isEqualTo(v),
    setFocused: u,
    focused: d,
    blur: () => {
      l(d), u(void 0);
    },
    moveFocus: (v, w) => {
      if (!d)
        return;
      const C = as(v, w, d, e.navStart, e.navEnd, t, r);
      C && (e.goToDay(C), u(C));
    }
  };
}
function mw(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [a, i] = io(n, r ? n : void 0), l = r ? n : a, { isSameDay: c } = e, d = (h) => l?.some((p) => c(p, h)) ?? !1, { min: u, max: f } = t;
  return {
    selected: l,
    select: (h, p, v) => {
      let w = [...l ?? []];
      if (d(h)) {
        if (l?.length === u || o && l?.length === 1)
          return;
        w = l?.filter((C) => !c(C, h));
      } else
        l?.length === f ? w = [h] : w = [...w, h];
      return r || i(w), r?.(w, h, p, v), w;
    },
    isSelected: d
  };
}
function vw(t, e, n = 0, o = 0, r = !1, a = kt) {
  const { from: i, to: l } = e || {}, { isSameDay: c, isAfter: d, isBefore: u } = a;
  let f;
  if (!i && !l)
    f = { from: t, to: n > 0 ? void 0 : t };
  else if (i && !l)
    c(i, t) ? r ? f = { from: i, to: void 0 } : f = void 0 : u(t, i) ? f = { from: t, to: i } : f = { from: i, to: t };
  else if (i && l)
    if (c(i, t) && c(l, t))
      r ? f = { from: i, to: l } : f = void 0;
    else if (c(i, t))
      f = { from: i, to: n > 0 ? void 0 : t };
    else if (c(l, t))
      f = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, i))
      f = { from: t, to: l };
    else if (d(t, i))
      f = { from: i, to: t };
    else if (d(t, l))
      f = { from: i, to: t };
    else
      throw new Error("Invalid range");
  if (f?.from && f?.to) {
    const g = a.differenceInCalendarDays(f.to, f.from);
    o > 0 && g > o ? f = { from: t, to: void 0 } : n > 1 && g < n && (f = { from: t, to: void 0 });
  }
  return f;
}
function ww(t, e, n = kt) {
  const o = Array.isArray(e) ? e : [e];
  let r = t.from;
  const a = n.differenceInCalendarDays(t.to, t.from), i = Math.min(a, 6);
  for (let l = 0; l <= i; l++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function Sa(t, e, n = kt) {
  return Nt(t, e.from, !1, n) || Nt(t, e.to, !1, n) || Nt(e, t.from, !1, n) || Nt(e, t.to, !1, n);
}
function bw(t, e, n = kt) {
  const o = Array.isArray(e) ? e : [e];
  if (o.filter((l) => typeof l != "function").some((l) => typeof l == "boolean" ? l : n.isDate(l) ? Nt(t, l, !1, n) : Qi(l, n) ? l.some((c) => Nt(t, c, !1, n)) : sr(l) ? l.from && l.to ? Sa(t, { from: l.from, to: l.to }, n) : !1 : Xi(l) ? ww(t, l.dayOfWeek, n) : Gi(l) ? n.isAfter(l.before, l.after) ? Sa(t, {
    from: n.addDays(l.after, 1),
    to: n.addDays(l.before, -1)
  }, n) : Et(t.from, l, n) || Et(t.to, l, n) : Ji(l) || Zi(l) ? Et(t.from, l, n) || Et(t.to, l, n) : !1))
    return !0;
  const i = o.filter((l) => typeof l == "function");
  if (i.length) {
    let l = t.from;
    const c = n.differenceInCalendarDays(t.to, t.from);
    for (let d = 0; d <= c; d++) {
      if (i.some((u) => u(l)))
        return !0;
      l = n.addDays(l, 1);
    }
  }
  return !1;
}
function yw(t, e) {
  const { disabled: n, excludeDisabled: o, selected: r, required: a, onSelect: i } = t, [l, c] = io(r, i ? r : void 0), d = i ? r : l;
  return {
    selected: d,
    select: (g, h, p) => {
      const { min: v, max: w } = t, C = g ? vw(g, d, v, w, a, e) : void 0;
      return o && n && C?.from && C.to && bw({ from: C.from, to: C.to }, n, e) && (C.from = g, C.to = void 0), i || c(C), i?.(C, g, h, p), C;
    },
    isSelected: (g) => d && Nt(d, g, !1, e)
  };
}
function Cw(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [a, i] = io(n, r ? n : void 0), l = r ? n : a, { isSameDay: c } = e;
  return {
    selected: l,
    select: (f, g, h) => {
      let p = f;
      return !o && l && l && c(f, l) && (p = void 0), r || i(p), r?.(p, f, g, h), p;
    },
    isSelected: (f) => l ? c(l, f) : !1
  };
}
function xw(t, e) {
  const n = Cw(t, e), o = mw(t, e), r = yw(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function lr(t) {
  let e = t;
  e.timeZone && (e = {
    ...t
  }, e.today && (e.today = new He(e.today, e.timeZone)), e.month && (e.month = new He(e.month, e.timeZone)), e.defaultMonth && (e.defaultMonth = new He(e.defaultMonth, e.timeZone)), e.startMonth && (e.startMonth = new He(e.startMonth, e.timeZone)), e.endMonth && (e.endMonth = new He(e.endMonth, e.timeZone)), e.mode === "single" && e.selected ? e.selected = new He(e.selected, e.timeZone) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((X) => new He(X, e.timeZone)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? new He(e.selected.from, e.timeZone) : void 0,
    to: e.selected.to ? new He(e.selected.to, e.timeZone) : void 0
  }));
  const { components: n, formatters: o, labels: r, dateLib: a, locale: i, classNames: l } = Hn(() => {
    const X = { ...ir, ...e.locale };
    return {
      dateLib: new $t({
        locale: X,
        weekStartsOn: e.broadcastCalendar ? 1 : e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
        timeZone: e.timeZone,
        numerals: e.numerals
      }, e.dateLib),
      components: S9(e.components),
      formatters: I9(e.formatters),
      labels: { ...Q9, ...e.labels },
      locale: X,
      classNames: { ...D9(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]), { captionLayout: c, mode: d, navLayout: u, numberOfMonths: f = 1, onDayBlur: g, onDayClick: h, onDayFocus: p, onDayKeyDown: v, onDayMouseEnter: w, onDayMouseLeave: C, onNextClick: b, onPrevClick: y, showWeekNumber: M, styles: S } = e, { formatCaption: R, formatDay: D, formatMonthDropdown: P, formatWeekNumber: I, formatWeekNumberHeader: N, formatWeekdayName: B, formatYearDropdown: $ } = o, V = fw(e, a), { days: E, months: A, navStart: W, navEnd: z, previousMonth: k, nextMonth: O, goToMonth: H } = V, Y = Z7(E, e, a), { isSelected: L, select: J, selected: K } = xw(e, a) ?? {}, { blur: de, focused: ue, isFocusTarget: Ae, moveFocus: Qe, setFocused: et } = pw(e, V, Y, L ?? (() => !1), a), { labelDayButton: rt, labelGridcell: te, labelGrid: oe, labelMonthDropdown: ee, labelNav: Z, labelPrevious: Ce, labelNext: we, labelWeekday: Oe, labelWeekNumber: Pe, labelWeekNumberHeader: se, labelYearDropdown: he } = r, Ke = Hn(() => H9(a, e.ISOWeek), [a, e.ISOWeek]), q = d !== void 0 || h !== void 0, ae = _e(() => {
    k && (H(k), y?.(k));
  }, [k, H, y]), U = _e(() => {
    O && (H(O), b?.(O));
  }, [H, O, b]), ge = _e((X, me) => (le) => {
    le.preventDefault(), le.stopPropagation(), et(X), J?.(X.date, me, le), h?.(X.date, me, le);
  }, [J, h, et]), pe = _e((X, me) => (le) => {
    et(X), p?.(X.date, me, le);
  }, [p, et]), xe = _e((X, me) => (le) => {
    de(), g?.(X.date, me, le);
  }, [de, g]), Jt = _e((X, me) => (le) => {
    const at = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [le.shiftKey ? "year" : "month", "before"],
      PageDown: [le.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (at[le.key]) {
      le.preventDefault(), le.stopPropagation();
      const [it, p1] = at[le.key];
      Qe(it, p1);
    }
    v?.(X.date, me, le);
  }, [Qe, v, e.dir]), fn = _e((X, me) => (le) => {
    w?.(X.date, me, le);
  }, [w]), Zt = _e((X, me) => (le) => {
    C?.(X.date, me, le);
  }, [C]), Ye = _e((X) => (me) => {
    const le = Number(me.target.value), at = a.setMonth(a.startOfMonth(X), le);
    H(at);
  }, [a, H]), Dt = _e((X) => (me) => {
    const le = Number(me.target.value), at = a.setYear(a.startOfMonth(X), le);
    H(at);
  }, [a, H]), { className: hn, style: h1 } = Hn(() => ({
    className: [l[j.Root], e.className].filter(Boolean).join(" "),
    style: { ...S?.[j.Root], ...e.style }
  }), [l, e.className, e.style, S]), g1 = k9(e), Xt = ye(null);
  ow(Xt, !!e.animate, {
    classNames: l,
    months: A,
    focused: ue,
    dateLib: a
  });
  const ut = {
    dayPickerProps: e,
    selected: K,
    select: J,
    isSelected: L,
    months: A,
    nextMonth: O,
    previousMonth: k,
    goToMonth: H,
    getModifiers: Y,
    components: n,
    classNames: l,
    styles: S,
    labels: r,
    formatters: o
  };
  return F.createElement(
    es.Provider,
    { value: ut },
    F.createElement(
      n.Root,
      { rootRef: e.animate ? Xt : void 0, className: hn, style: h1, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], ...g1 },
      F.createElement(
        n.Months,
        { className: l[j.Months], style: S?.[j.Months] },
        !e.hideNavigation && !u && F.createElement(n.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: l[j.Nav], style: S?.[j.Nav], "aria-label": Z(), onPreviousClick: ae, onNextClick: U, previousMonth: k, nextMonth: O }),
        A.map((X, me) => {
          const le = B9(X.date, W, z, o, a), at = F9(W, z, o, a);
          return F.createElement(
            n.Month,
            { "data-animated-month": e.animate ? "true" : void 0, className: l[j.Month], style: S?.[j.Month], key: me, displayIndex: me, calendarMonth: X },
            u === "around" && !e.hideNavigation && me === 0 && F.createElement(
              n.PreviousMonthButton,
              { type: "button", className: l[j.PreviousMonthButton], tabIndex: k ? void 0 : -1, "aria-disabled": k ? void 0 : !0, "aria-label": Ce(k), onClick: ae, "data-animated-button": e.animate ? "true" : void 0 },
              F.createElement(n.Chevron, { disabled: k ? void 0 : !0, className: l[j.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
            ),
            F.createElement(n.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: l[j.MonthCaption], style: S?.[j.MonthCaption], calendarMonth: X, displayIndex: me }, c?.startsWith("dropdown") ? F.createElement(
              n.DropdownNav,
              { className: l[j.Dropdowns], style: S?.[j.Dropdowns] },
              c === "dropdown" || c === "dropdown-months" ? F.createElement(n.MonthsDropdown, { className: l[j.MonthsDropdown], "aria-label": ee(), classNames: l, components: n, disabled: !!e.disableNavigation, onChange: Ye(X.date), options: le, style: S?.[j.Dropdown], value: a.getMonth(X.date) }) : F.createElement("span", null, P(X.date, a)),
              c === "dropdown" || c === "dropdown-years" ? F.createElement(n.YearsDropdown, { className: l[j.YearsDropdown], "aria-label": he(a.options), classNames: l, components: n, disabled: !!e.disableNavigation, onChange: Dt(X.date), options: at, style: S?.[j.Dropdown], value: a.getYear(X.date) }) : F.createElement("span", null, $(X.date, a)),
              F.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, R(X.date, a.options, a))
            ) : F.createElement(n.CaptionLabel, { className: l[j.CaptionLabel], role: "status", "aria-live": "polite" }, R(X.date, a.options, a))),
            u === "around" && !e.hideNavigation && me === f - 1 && F.createElement(
              n.NextMonthButton,
              { type: "button", className: l[j.NextMonthButton], tabIndex: O ? void 0 : -1, "aria-disabled": O ? void 0 : !0, "aria-label": we(O), onClick: U, "data-animated-button": e.animate ? "true" : void 0 },
              F.createElement(n.Chevron, { disabled: O ? void 0 : !0, className: l[j.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
            ),
            me === f - 1 && u === "after" && !e.hideNavigation && F.createElement(n.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: l[j.Nav], style: S?.[j.Nav], "aria-label": Z(), onPreviousClick: ae, onNextClick: U, previousMonth: k, nextMonth: O }),
            F.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": d === "multiple" || d === "range", "aria-label": oe(X.date, a.options, a) || void 0, className: l[j.MonthGrid], style: S?.[j.MonthGrid] },
              !e.hideWeekdays && F.createElement(
                n.Weekdays,
                { "data-animated-weekdays": e.animate ? "true" : void 0, className: l[j.Weekdays], style: S?.[j.Weekdays] },
                M && F.createElement(n.WeekNumberHeader, { "aria-label": se(a.options), className: l[j.WeekNumberHeader], style: S?.[j.WeekNumberHeader], scope: "col" }, N()),
                Ke.map((it, p1) => F.createElement(n.Weekday, { "aria-label": Oe(it, a.options, a), className: l[j.Weekday], key: p1, style: S?.[j.Weekday], scope: "col" }, B(it, a.options, a)))
              ),
              F.createElement(n.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: l[j.Weeks], style: S?.[j.Weeks] }, X.weeks.map((it, p1) => F.createElement(
                n.Week,
                { className: l[j.Week], key: it.weekNumber, style: S?.[j.Week], week: it },
                M && F.createElement(n.WeekNumber, { week: it, style: S?.[j.WeekNumber], "aria-label": Pe(it.weekNumber, {
                  locale: i
                }), className: l[j.WeekNumber], scope: "row", role: "rowheader" }, I(it.weekNumber, a)),
                it.days.map((Be) => {
                  const { date: ft } = Be, ce = Y(Be);
                  if (ce[be.focused] = !ce.hidden && !!ue?.isEqualTo(Be), ce[ct.selected] = L?.(ft) || ce.selected, sr(K)) {
                    const { from: so, to: lo } = K;
                    ce[ct.range_start] = !!(so && lo && a.isSameDay(ft, so)), ce[ct.range_end] = !!(so && lo && a.isSameDay(ft, lo)), ce[ct.range_middle] = Nt(K, ft, !0, a);
                  }
                  const ds = $9(ce, S, e.modifiersStyles), us = X7(ce, l, e.modifiersClassNames), fs = !q && !ce.hidden ? te(ft, ce, a.options, a) : void 0;
                  return F.createElement(n.Day, { key: `${a.format(ft, "yyyy-MM-dd")}_${a.format(Be.displayMonth, "yyyy-MM")}`, day: Be, modifiers: ce, className: us.join(" "), style: ds, role: "gridcell", "aria-selected": ce.selected || void 0, "aria-label": fs, "data-day": a.format(ft, "yyyy-MM-dd"), "data-month": Be.outside ? a.format(ft, "yyyy-MM") : void 0, "data-selected": ce.selected || void 0, "data-disabled": ce.disabled || void 0, "data-hidden": ce.hidden || void 0, "data-outside": Be.outside || void 0, "data-focused": ce.focused || void 0, "data-today": ce.today || void 0 }, !ce.hidden && q ? F.createElement(n.DayButton, { className: l[j.DayButton], style: S?.[j.DayButton], type: "button", day: Be, modifiers: ce, disabled: ce.disabled || void 0, tabIndex: Ae(Be) ? 0 : -1, "aria-label": rt(ft, ce, a.options, a), onClick: ge(Be, ce), onBlur: xe(Be, ce), onFocus: pe(Be, ce), onKeyDown: Jt(Be, ce), onMouseEnter: fn(Be, ce), onMouseLeave: Zt(Be, ce) }, D(ft, a.options, a)) : !ce.hidden && D(Be.date, a.options, a));
                })
              )))
            )
          );
        })
      ),
      e.footer && F.createElement(n.Footer, { className: l[j.Footer], style: S?.[j.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const Mw = "_root_ywypx_1", _w = "_nav_ywypx_27", Rw = "_months_ywypx_38", Sw = "_month_ywypx_38", kw = "_month_grid_ywypx_46", Dw = "_month_caption_ywypx_66", Aw = "_week_ywypx_75", Ow = "_weekdays_ywypx_79", Pw = "_day_ywypx_85", Nw = "_selected_ywypx_117", Ew = "_day_disabled_ywypx_131", Lw = "_range_middle_ywypx_136", zw = "_today_ywypx_136", Tw = "_outside_ywypx_148", Iw = "_range_start_ywypx_156", Bw = "_hidden_ywypx_161", $w = "_range_end_ywypx_162", Hw = "_cell_ywypx_228", cr = {
  root: Mw,
  nav: _w,
  months: Rw,
  month: Sw,
  month_grid: kw,
  month_caption: Dw,
  week: Aw,
  weekdays: Ow,
  day: Pw,
  selected: Nw,
  day_disabled: Ew,
  range_middle: Lw,
  today: zw,
  outside: Tw,
  range_start: Iw,
  hidden: Bw,
  range_end: $w,
  cell: Hw
}, Fw = "_datePicker_m0aoc_1", Vw = "_dateRangePicker_m0aoc_5", Ww = "_dateRangePickerCompact_m0aoc_23", jw = "_datePickerArrowRightIcon_m0aoc_36", qw = "_datePickerCalendarIcon_m0aoc_40", Yw = "_dateRangePickerDisabled_m0aoc_45", Uw = "_dateRangePickerError_m0aoc_66", Kw = "_dateRangePickerErrorFocus_m0aoc_72", lt = {
  datePicker: Fw,
  dateRangePicker: Vw,
  dateRangePickerCompact: Ww,
  datePickerArrowRightIcon: jw,
  datePickerCalendarIcon: qw,
  dateRangePickerDisabled: Yw,
  dateRangePickerError: Uw,
  dateRangePickerErrorFocus: Kw
}, Gw = "_navMonths_1jl8b_1", Jw = {
  navMonths: Gw
}, dr = ({ setMonth: t, month: e }) => /* @__PURE__ */ x("nav", { className: Jw.navMonths, children: [
  /* @__PURE__ */ s(
    z1,
    {
      icon: /* @__PURE__ */ s(Zc, {}),
      variant: "plain",
      size: "compact",
      onClick: () => t($1(e, -1))
    }
  ),
  /* @__PURE__ */ s(
    z1,
    {
      icon: /* @__PURE__ */ s(Oa, {}),
      variant: "plain",
      size: "compact",
      onClick: () => t($1(e, 1))
    }
  )
] }), H1 = (t) => {
  if (d1(t) && ao(t)) {
    const e = t.getTimezoneOffset() * 6e4;
    return new Date(t.getTime() - e).toISOString().split("T")[0];
  }
  return "";
}, F1 = (t) => {
  const e = new Date(t);
  if (ao(e)) {
    const n = L7(e, {});
    if (/^\d{4}-\d{2}-\d{2}$/.test(n))
      return !0;
  }
  return !1;
}, wy = ({
  disabledDates: t,
  onChange: e,
  value: n,
  className: o,
  mobile: r,
  ...a
}) => {
  const [i, l] = Q(), [c, d] = Q(/* @__PURE__ */ new Date()), [u, f] = Q(!1), { getReferenceProps: g, ...h } = Un({
    isOpen: u,
    setIsOpen: f
  }), p = ar(), v = navigator.userAgent.toLowerCase().includes("firefox");
  return je(() => {
    n ? (l(n), d(n)) : l(void 0);
  }, [n]), /* @__PURE__ */ x(It, { children: [
    /* @__PURE__ */ s(
      dt,
      {
        className: T(
          lt.datePicker,
          u && Re.hasFocus,
          o
        ),
        ref: h.refs.setReference,
        type: "date",
        role: "textbox",
        ...g({
          onChange: (w) => {
            if (f(!1), F1(w.target.value)) {
              const C = new Date(w.target.value);
              l(C), d(C), e?.(C);
            }
          },
          onClick: (w) => w.preventDefault()
        }),
        value: H1(i),
        trailing: !v && /* @__PURE__ */ s(
          Ie,
          {
            disabled: a.disabled,
            onClick: (w) => {
              w.preventDefault(), f(!0), h.refs.domReference.current?.focus();
            },
            children: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(Yo, {}) })
          }
        ),
        ...a
      }
    ),
    !r && u && /* @__PURE__ */ s(Kt, { elementsRef: h.listRef, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
      Gt,
      {
        initialFocus: -1,
        context: h.context,
        children: /* @__PURE__ */ s(
          "div",
          {
            ref: h.refs.setFloating,
            style: {
              ...h.floatingStyles,
              opacity: h.floatingStyles.transform ? 1 : 0,
              zIndex: Bt,
              top: "12px",
              left: "-12px"
            },
            ...h.getFloatingProps(),
            children: /* @__PURE__ */ s(
              lr,
              {
                classNames: cr,
                locale: p,
                showOutsideDays: !0,
                mode: "single",
                defaultMonth: i,
                selected: i,
                disabled: t,
                onSelect: (w) => {
                  w && (l(w), d(w), e?.(w)), f(!1);
                },
                month: c,
                components: {
                  /* biome-ignore lint/nursery/noNestedComponentDefinitions: TODO */
                  Nav: () => /* @__PURE__ */ s(dr, { setMonth: d, month: c })
                }
              }
            )
          }
        )
      }
    ) }) })
  ] });
}, by = ({
  disabledDates: t,
  onChange: e,
  value: n,
  disabled: o,
  error: r,
  size: a = "default",
  mobile: i,
  allowOpenEnd: l = !1,
  className: c
}) => {
  const [d, u] = Q(), [f, g] = Q(/* @__PURE__ */ new Date()), [h, p] = Q(!1), { getReferenceProps: v, ...w } = Un({
    isOpen: h,
    setIsOpen: p
  }), [C, b] = Q(!1), y = ar(), M = ye(null), S = navigator.userAgent.toLowerCase().includes("firefox");
  return je(() => {
    u(n), d1(n?.from) && g(n.from);
  }, [n]), /* @__PURE__ */ x(It, { children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: T(
          lt.dateRangePicker,
          (C || h) && Re.hasFocus,
          (C || h) && r && lt.dateRangePickerErrorFocus,
          o && lt.dateRangePickerDisabled,
          r && lt.dateRangePickerError,
          a === "compact" && lt.dateRangePickerCompact,
          c
        ),
        children: [
          /* @__PURE__ */ s(
            dt,
            {
              className: T(lt.datePicker, h && Re.hasFocus),
              ref: w.refs.setReference,
              type: "date",
              role: "textbox",
              disabled: o,
              ...v({
                onFocus: (R) => {
                  R.preventDefault(), b(!0);
                },
                onBlur: (R) => {
                  R.preventDefault(), b(!1);
                },
                onChange: (R) => {
                  if (p(!1), F1(R.target.value)) {
                    const D = cn(new Date(R.target.value));
                    u({ from: D, to: d?.to }), g(D), e?.({ from: D, to: d?.to });
                  }
                },
                onClick: (R) => R.preventDefault()
              }),
              value: H1(d?.from)
            }
          ),
          /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(Oa, { className: T(lt.datePickerArrowRightIcon) }) }),
          /* @__PURE__ */ s(
            dt,
            {
              className: T(lt.datePicker, h && Re.hasFocus),
              type: "date",
              role: "textbox",
              value: H1(d?.to || void 0),
              ref: M,
              disabled: o,
              ...v({
                onFocus: (R) => {
                  R.preventDefault(), b(!0);
                },
                onBlur: (R) => {
                  R.preventDefault(), b(!1);
                },
                onChange: (R) => {
                  if (p(!1), F1(R.target.value)) {
                    const D = wa(new Date(R.target.value));
                    u({ from: d?.from, to: D }), g(D), e?.({ from: d?.from, to: D });
                  }
                },
                onClick: (R) => R.preventDefault()
              })
            }
          ),
          !S && /* @__PURE__ */ s(
            Ie,
            {
              disabled: o,
              onClick: (R) => {
                R.preventDefault(), p(!0);
              },
              style: { display: "flex" },
              children: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(
                Yo,
                {
                  className: T(lt.datePickerCalendarIcon)
                }
              ) })
            }
          )
        ]
      }
    ),
    !i && h && /* @__PURE__ */ s(Kt, { elementsRef: w.listRef, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
      Gt,
      {
        initialFocus: -1,
        context: w.context,
        children: /* @__PURE__ */ s(
          "div",
          {
            ref: w.refs.setFloating,
            style: {
              ...w.floatingStyles,
              opacity: w.floatingStyles.transform ? 1 : 0,
              zIndex: Bt,
              top: "12px",
              left: "-12px"
            },
            ...w.getFloatingProps(),
            children: /* @__PURE__ */ s(or, { padding: "none", children: /* @__PURE__ */ s(
              lr,
              {
                classNames: cr,
                locale: y,
                mode: "range",
                defaultMonth: d?.from,
                showOutsideDays: !1,
                numberOfMonths: 2,
                selected: d,
                fixedWeeks: !0,
                disabled: t,
                className: "DayRangePicker",
                min: l ? 1 : void 0,
                onSelect: (R) => {
                  if (R) {
                    const D = R.from ? cn(R.from) : void 0, P = R.to ? wa(R.to) : void 0;
                    u({
                      from: D,
                      to: P
                    }), e?.({
                      from: D,
                      to: P
                    }), l && D && P && p(!1);
                  }
                },
                month: f,
                components: {
                  /* biome-ignore lint/nursery/noNestedComponentDefinitions: TODO */
                  Nav: () => /* @__PURE__ */ s(dr, { setMonth: g, month: f })
                }
              }
            ) })
          }
        )
      }
    ) }) })
  ] });
}, Zw = "_timePicker_6rkl6_1", Xw = "_timePickerCard_6rkl6_5", Qw = "_timeValue_6rkl6_28", e6 = "_timeValueSelected_6rkl6_41", on = {
  timePicker: Zw,
  timePickerCard: Xw,
  timeValue: Qw,
  timeValueSelected: e6
}, is = ({
  actionMenuProps: t,
  setTimeValue: e,
  timeValue: n,
  onChange: o,
  setIsTimeSelectorOpen: r
}) => {
  const a = ye(null), i = ye(null), l = ye([]), c = ye([]);
  l.current.length !== 24 && (l.current = Array(24).fill(null).map(
    (g, h) => l.current[h] || hr()
  )), c.current.length !== 60 && (c.current = Array(60).fill(null).map(
    (g, h) => c.current[h] || hr()
  ));
  const d = _e((g) => {
    g?.current && g.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, []), u = _e(
    () => Number(n.substring(0, 2)),
    [n]
  ), f = _e(
    () => Number(n.slice(-2)),
    [n]
  );
  return n && (d(l.current[u() || 0]), d(c.current[f() || 0])), /* @__PURE__ */ s(Kt, { elementsRef: t.listRef, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
    Gt,
    {
      initialFocus: -1,
      context: t.context,
      children: /* @__PURE__ */ s(
        "div",
        {
          ref: t.refs.setFloating,
          style: {
            ...t.floatingStyles,
            opacity: t.floatingStyles.transform ? 1 : 0,
            zIndex: Bt,
            top: "12px",
            left: "-12px"
          },
          ...t.getFloatingProps(),
          children: /* @__PURE__ */ x(
            or,
            {
              className: T(on.timePickerCard),
              padding: "none",
              children: [
                /* @__PURE__ */ s("div", { ref: a, children: [...Array(24)].map((g, h) => /* @__PURE__ */ s(
                  "button",
                  {
                    className: T(
                      on.timeValue,
                      u() === h && on.timeValueSelected
                    ),
                    ref: l.current[h],
                    onClick: () => {
                      const p = `${String(h).padStart(
                        2,
                        "0"
                      )}:${String(f()).padStart(2, "0")}`;
                      e(p), o?.(p);
                    },
                    children: String(h).padStart(2, "0")
                  },
                  String(h)
                )) }),
                /* @__PURE__ */ s("div", { ref: i, children: [...Array(60)].map((g, h) => /* @__PURE__ */ s(
                  "button",
                  {
                    className: T(
                      on.timeValue,
                      h === f() && on.timeValueSelected
                    ),
                    ref: c.current[h],
                    onClick: () => {
                      const p = `${String(u()).padStart(
                        2,
                        "0"
                      )}:${String(h).padStart(2, "0")}`;
                      e(p), o?.(p), r(!1);
                    },
                    children: String(h).padStart(2, "0")
                  },
                  String(h)
                )) })
              ]
            }
          )
        }
      )
    }
  ) }) });
}, t6 = "_dateTimePicker_85opx_1", n6 = "_dateTimePickerDisabled_85opx_10", o6 = "_dateTimePickerInputError_85opx_33", r6 = "_dateTimePickerError_85opx_37", In = {
  dateTimePicker: t6,
  dateTimePickerDisabled: n6,
  dateTimePickerInputError: o6,
  dateTimePickerError: r6
}, yy = ({
  disabledDates: t,
  onChange: e,
  value: n,
  className: o,
  mobile: r,
  error: a,
  ...i
}) => {
  const [l, c] = Q(), [d, u] = Q(/* @__PURE__ */ new Date()), [f, g] = Q(""), [h, p] = Q(!1), [v, w] = Q(!1), {
    getReferenceProps: C,
    ...b
  } = Un({
    isOpen: h,
    setIsOpen: p
  }), { getReferenceProps: y, ...M } = Un({
    isOpen: v,
    setIsOpen: w
  }), S = ar(), R = ye(!1), D = navigator.userAgent.toLowerCase().includes("firefox");
  je(() => {
    n ? (c(n), u(n), g(
      `${String(n.getHours()).padStart(2, "0")}:${String(
        n.getMinutes()
      ).padStart(2, "0")}`
    )) : c(void 0);
  }, [n]);
  const P = _e(
    (N) => {
      if (l) {
        const [B, $] = N.split(":").map((E) => Number.parseInt(E, 10)), V = _o(
          Ro(l, $ || 0),
          B || 0
        );
        c(V), e?.(V);
      }
    },
    [l, e]
  ), I = (N) => {
    if (!l) {
      g(N);
      return;
    }
    P(N), g(N);
  };
  return je(() => {
    d1(l) && ao(l) && I7(l) === 0 && T7(l) === 0 && !R.current && (R.current = !0, P(f));
  }, [l, f, P]), /* @__PURE__ */ x(It, { children: [
    /* @__PURE__ */ x(
      "div",
      {
        className: T(
          In.dateTimePicker,
          i.disabled && In.dateTimePickerDisabled,
          a && In.dateTimePickerError,
          o
        ),
        children: [
          /* @__PURE__ */ s(
            dt,
            {
              className: T(
                lt.datePicker,
                h && Re.hasFocus,
                h && a && In.dateTimePickerInputError
              ),
              ref: b.refs.setReference,
              type: "date",
              role: "textbox",
              error: a,
              ...C({
                onChange: (N) => {
                  if (p(!1), F1(N.target.value)) {
                    const B = new Date(N.target.value);
                    u(B);
                    const $ = _o(
                      B,
                      l?.getHours() || 0
                    ), V = Ro(
                      $,
                      l?.getMinutes() || 0
                    );
                    c(V), e?.(V);
                  }
                },
                onClick: (N) => N.preventDefault()
              }),
              value: H1(l),
              trailing: !D && /* @__PURE__ */ s(
                Ie,
                {
                  disabled: i.disabled,
                  onClick: (N) => {
                    N.preventDefault(), p(!0), b.refs.domReference.current?.focus();
                  },
                  children: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(Yo, {}) })
                }
              ),
              ...i
            }
          ),
          /* @__PURE__ */ s(
            dt,
            {
              className: T(
                on.timePicker,
                v && Re.hasFocus,
                v && a && In.dateTimePickerInputError
              ),
              ref: M.refs.setReference,
              type: "time",
              role: "textbox",
              error: a,
              ...y({
                onChange: (N) => {
                  w(!1), I(N.target.value);
                },
                onClick: (N) => N.preventDefault()
              }),
              value: f,
              trailing: !D && /* @__PURE__ */ s(
                Ie,
                {
                  disabled: i.disabled,
                  onClick: (N) => {
                    N.preventDefault(), w(!0), M.refs.domReference.current?.focus();
                  },
                  children: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(Ea, {}) })
                }
              ),
              ...i
            }
          )
        ]
      }
    ),
    !r && h && /* @__PURE__ */ s(Kt, { elementsRef: b.listRef, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
      Gt,
      {
        initialFocus: -1,
        context: b.context,
        children: /* @__PURE__ */ s(
          "div",
          {
            ref: b.refs.setFloating,
            style: {
              ...b.floatingStyles,
              opacity: b.floatingStyles.transform ? 1 : 0,
              zIndex: Bt,
              top: "12px",
              left: "-12px"
            },
            ...b.getFloatingProps(),
            children: /* @__PURE__ */ s(or, { padding: "none", children: /* @__PURE__ */ s(
              lr,
              {
                classNames: cr,
                locale: S,
                showOutsideDays: !0,
                mode: "single",
                defaultMonth: l,
                selected: l,
                disabled: t,
                onSelect: (N) => {
                  if (N) {
                    u(N);
                    const B = _o(
                      N,
                      l?.getHours() || 0
                    ), $ = Ro(
                      B,
                      l?.getMinutes() || 0
                    );
                    c($), e?.($);
                  }
                  p(!1);
                },
                month: d,
                components: {
                  /* biome-ignore lint/nursery/noNestedComponentDefinitions: TODO */
                  Nav: () => /* @__PURE__ */ s(dr, { setMonth: u, month: d })
                }
              }
            ) })
          }
        )
      }
    ) }) }),
    !r && v && /* @__PURE__ */ s(
      is,
      {
        onChange: I,
        actionMenuProps: M,
        timeValue: f,
        setTimeValue: g,
        setIsTimeSelectorOpen: w
      }
    )
  ] });
}, a6 = "_toggleButton_11azm_1", i6 = {
  toggleButton: a6
}, s6 = m(
  ({ "aria-label": t, className: e, disabled: n, value: o, ...r }, a) => {
    const { t: i } = ot(), [l, c] = Q(!1);
    return /* @__PURE__ */ s(
      dt,
      {
        ref: a,
        type: l ? "text" : "password",
        "aria-label": t || i("password.defaultInputLabel"),
        trailing: /* @__PURE__ */ s(
          Ie,
          {
            disabled: n,
            onClick: () => c(!l),
            "aria-label": i(l ? "password.hideButton" : "password.showButton"),
            className: i6.toggleButton,
            children: /* @__PURE__ */ s(De, { size: 20, children: l ? /* @__PURE__ */ s(fd, {}) : /* @__PURE__ */ s(gd, {}) })
          }
        ),
        disabled: n,
        value: o,
        ...r
      }
    );
  }
);
s6.displayName = "Password";
const l6 = "_clearButton_9xbja_1", c6 = {
  clearButton: l6
}, d6 = m(
  ({ onClear: t, disabled: e, placeholder: n, value: o, ...r }, a) => {
    const { t: i } = ot();
    return /* @__PURE__ */ s(
      dt,
      {
        ref: a,
        leading: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(ef, {}) }),
        trailing: t && o && /* @__PURE__ */ s(
          Ie,
          {
            disabled: e,
            onClick: t,
            "aria-label": i("search.clearButton"),
            className: c6.clearButton,
            children: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(Sn, {}) })
          }
        ),
        disabled: e,
        placeholder: n ?? i("search.defaultPlaceholder"),
        value: o,
        ...r
      }
    );
  }
);
d6.displayName = "Search";
const ss = W1({}), u6 = ({
  value: t,
  children: e
}) => /* @__PURE__ */ s(ss.Provider, { value: t, children: e }), f6 = "_wrapper_o31lq_1", h6 = "_placeholder_o31lq_9", g6 = "_placeholderDisabled_o31lq_13", p6 = "_button_o31lq_17", m6 = "_selectDisabled_o31lq_17", v6 = "_arrow_o31lq_24", w6 = "_arrowDisabled_o31lq_28", b6 = "_critical_o31lq_54", y6 = "_options_o31lq_64", C6 = "_list_o31lq_73", x6 = "_option_o31lq_64", M6 = "_optionDisabled_o31lq_92", _6 = "_selected_o31lq_101", R6 = "_active_o31lq_105", S6 = "_compact_o31lq_119", k6 = "_optionGroupLabel_o31lq_124", D6 = "_optionGroupOptions_o31lq_128", Ne = {
  wrapper: f6,
  placeholder: h6,
  placeholderDisabled: g6,
  button: p6,
  selectDisabled: m6,
  arrow: v6,
  arrowDisabled: w6,
  critical: b6,
  options: y6,
  list: C6,
  option: x6,
  optionDisabled: M6,
  selected: _6,
  active: R6,
  default: "_default_o31lq_115",
  compact: S6,
  optionGroupLabel: k6,
  optionGroupOptions: D6
}, A6 = ({
  children: t,
  value: e,
  disabled: n,
  onFocus: o,
  onBlur: r,
  ...a
}) => {
  const { ref: i, index: l } = fi(), { activeIndex: c, selectedIndex: d, getItemProps: u, handleSelect: f } = j1(ss), g = c === l, h = d === l;
  return /* @__PURE__ */ s(
    "li",
    {
      ref: i,
      className: T([
        Ne.option,
        g && Ne.active,
        n && Ne.optionDisabled,
        h && Ne.selected
      ]),
      role: "option",
      "aria-selected": g && h,
      tabIndex: g ? 0 : -1,
      ...u?.({
        onFocus: o,
        onBlur: r,
        onClick: () => {
          n || f?.(l, e);
        }
      }),
      onKeyDown: (p) => {
        p.code === "Enter" && !n && f?.(l, e);
      },
      ...a,
      children: t
    }
  );
}, Cy = ({
  children: t,
  className: e,
  label: n
}) => /* @__PURE__ */ x("li", { children: [
  /* @__PURE__ */ s("div", { className: Ne.optionGroupLabel, children: /* @__PURE__ */ s(qe, { color: "reduced", size: "sm", className: e, children: n }) }),
  /* @__PURE__ */ s("ul", { className: Ne.optionGroupOptions, children: t })
] }), O6 = (t) => `${t}`, P6 = ({
  className: t,
  selectedOption: e,
  setSelectedOption: n,
  renderValue: o = O6,
  options: r,
  error: a,
  id: i,
  placeholder: l,
  size: c = "default",
  disabled: d,
  onFocus: u,
  onBlur: f,
  onClick: g,
  "aria-label": h
}, p) => {
  const [v, w] = Q(null), [C, b] = Q(null), [y, M] = Q(!1), S = ye([]), R = _e(
    (k, O) => {
      b(k), M(!1), k !== null && n(O);
    },
    [n]
  ), { floatingStyles: D, refs: P, context: I } = un({
    open: y,
    onOpenChange: M,
    placement: "bottom-start",
    middleware: [
      An({ mainAxis: 4, alignmentAxis: 0 }),
      Pn({ fallbackStrategy: "initialPlacement" }),
      On(),
      er({
        apply({ rects: k, elements: O, availableHeight: H }) {
          Object.assign(O.floating.style, {
            width: `${k.reference.width}px`,
            maxHeight: `${H}px`
          });
        }
      })
    ],
    whileElementsMounted: dn
  }), N = no(I, { role: "listbox" }), B = r1(I), $ = eo(I), V = a1(I, {
    listRef: S,
    activeIndex: v,
    onNavigate: w
  }), { getFloatingProps: E, getReferenceProps: A, getItemProps: W } = Nn(
    [N, B, $, V]
  ), z = Hn(
    () => ({
      activeIndex: v,
      selectedIndex: C,
      getItemProps: W,
      handleSelect: R
    }),
    [v, C, W, R]
  );
  return /* @__PURE__ */ x("div", { className: Ne.wrapper, ref: p, children: [
    /* @__PURE__ */ x(
      "button",
      {
        id: i,
        type: "button",
        className: T([
          t,
          a && Ne.critical,
          Ne.button,
          Ne[c],
          d && Ne.selectDisabled
        ]),
        ...A({ role: "button", onFocus: u, onBlur: f, onClick: g }),
        ref: P.setReference,
        disabled: d,
        "aria-label": h,
        children: [
          o(e) ? /* @__PURE__ */ s("span", { className: tr.ellipsis, children: o(e) }) : /* @__PURE__ */ s(
            "span",
            {
              className: T(
                Ne.placeholder,
                d && Ne.placeholderDisabled
              ),
              children: l
            }
          ),
          /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(
            Zn,
            {
              className: T(Ne.arrow, d && Ne.arrowDisabled)
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ s(u6, { value: z, children: y && E6(r) && /* @__PURE__ */ s(Kt, { elementsRef: S, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
      Gt,
      {
        initialFocus: -1,
        modal: !1,
        context: I,
        children: /* @__PURE__ */ s(
          "ul",
          {
            "aria-label": h,
            className: T(Ne.list, Ne.options),
            ref: P.setFloating,
            style: {
              ...D,
              // makes sure that it displays on top of other elements (modals, sidebars, etc.)
              zIndex: Bt,
              // prevents flicker if the position is not calculated yet
              opacity: D.transform ? 1 : 0
            },
            ...E(),
            children: r
          }
        )
      }
    ) }) }) })
  ] });
}, N6 = m(P6), E6 = (t) => Po.count(t) === 0 ? !1 : Po.toArray(t).some((n) => Da(n) ? n.props.children != null && n.props.children !== "" : n != null), L6 = "_label_115i0_7", z6 = "_button_115i0_24", T6 = "_small_115i0_33", I6 = "_disabled_115i0_54", B6 = "_checked_115i0_65", Qt = {
  switch: "_switch_115i0_1",
  label: L6,
  button: z6,
  small: T6,
  default: "_default_115i0_38",
  disabled: I6,
  checked: B6
}, $6 = m(
  ({
    size: t = "default",
    checked: e,
    disabled: n,
    onChange: o,
    onBlur: r,
    onFocus: a,
    ariaLabelledby: i,
    name: l,
    id: c,
    className: d
  }, u) => {
    const f = () => {
      n || o(!e);
    };
    return /* @__PURE__ */ x(
      "span",
      {
        ref: u,
        onKeyDown: (g) => {
          g.code === "Space" && f();
        },
        tabIndex: 0,
        role: "switch",
        "aria-disabled": n,
        "aria-labelledby": i,
        "aria-checked": e,
        onFocus: a,
        onBlur: r,
        onClick: f,
        className: T([
          d,
          `${Qt[T(t)]}`,
          Qt.label,
          n && Qt.disabled,
          e && Qt.checked
        ]),
        children: [
          /* @__PURE__ */ s(
            "input",
            {
              id: c,
              disabled: n,
              className: Qt.switch,
              name: l,
              onChange: (g) => {
                n || o(g.target.checked);
              },
              checked: e,
              type: "checkbox"
            }
          ),
          /* @__PURE__ */ s("span", { className: T(Qt.button, e && Qt.checked) })
        ]
      }
    );
  }
);
$6.displayName = "Switch";
const H6 = "_base_10c1h_1", F6 = "_critical_10c1h_27", V6 = "_compact_10c1h_50", Ao = {
  base: H6,
  critical: F6,
  default: "_default_10c1h_47",
  compact: V6
}, W6 = m(
  ({ className: t, error: e, size: n = "default", ...o }, r) => /* @__PURE__ */ s(
    "textarea",
    {
      ref: r,
      className: T(
        t,
        Ao.base,
        Ao[n],
        e && Ao.critical
      ),
      ...o
    }
  )
);
W6.displayName = "TextArea";
const xy = ({
  onChange: t,
  value: e,
  className: n,
  mobile: o,
  error: r,
  ...a
}) => {
  const [i, l] = Q(""), [c, d] = Q(!1), { getReferenceProps: u, ...f } = Un({
    isOpen: c,
    setIsOpen: d
  }), g = navigator.userAgent.toLowerCase().includes("firefox");
  je(() => {
    e && l(e);
  }, [e]);
  const h = (p) => {
    const v = p.target.value;
    l(v);
  };
  return /* @__PURE__ */ x(It, { children: [
    /* @__PURE__ */ s(
      dt,
      {
        className: T(
          on.timePicker,
          c && Re.hasFocus,
          n
        ),
        ref: f.refs.setReference,
        type: "time",
        role: "textbox",
        error: r,
        ...u({
          onChange: (p) => {
            d(!1), h(p);
          },
          onClick: (p) => p.preventDefault()
        }),
        value: i,
        trailing: !g && /* @__PURE__ */ s(
          Ie,
          {
            disabled: a.disabled,
            onClick: (p) => {
              p.preventDefault(), d(!0), f.refs.domReference.current?.focus();
            },
            children: /* @__PURE__ */ s(De, { size: 20, children: /* @__PURE__ */ s(Ea, {}) })
          }
        ),
        ...a
      }
    ),
    !o && c && /* @__PURE__ */ s(
      is,
      {
        actionMenuProps: f,
        timeValue: i,
        setTimeValue: l,
        setIsTimeSelectorOpen: d
      }
    )
  ] });
}, j6 = "_animation_1v5he_13", q6 = "_two_1v5he_17", Y6 = "_three_1v5he_21", U6 = "_size16_1v5he_25", K6 = "_size20_1v5he_30", G6 = "_size24_1v5he_35", J6 = "_size32_1v5he_40", Vt = {
  animation: j6,
  two: q6,
  three: Y6,
  size16: U6,
  size20: K6,
  size24: G6,
  size32: J6
}, My = ({ size: t = 24 }) => {
  const { t: e } = ot();
  return /* @__PURE__ */ x(
    "svg",
    {
      width: "100%",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "var(--color-content-default)",
      xmlns: "http://www.w3.org/2000/svg",
      className: T(Vt.animation, {
        [Vt.size16]: t === 16,
        [Vt.size20]: t === 20,
        [Vt.size24]: t === 24,
        [Vt.size32]: t === 32
      }),
      role: "img",
      "aria-label": e("loadingindicator.label"),
      children: [
        /* @__PURE__ */ s(
          "path",
          {
            className: Vt.one,
            d: "M4 9.5C2.61929 9.5 1.5 10.6193 1.5 12C1.5 13.3807 2.61929 14.5 4 14.5C5.38071 14.5 6.5 13.3807 6.5 12C6.5 10.6193 5.38071 9.5 4 9.5Z"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            className: Vt.two,
            d: "M12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5Z"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            className: Vt.three,
            d: "M20 9.5C18.6193 9.5 17.5 10.6193 17.5 12C17.5 13.3807 18.6193 14.5 20 14.5C21.3807 14.5 22.5 13.3807 22.5 12C22.5 10.6193 21.3807 9.5 20 9.5Z"
          }
        )
      ]
    }
  );
}, Z6 = "_skeleton_irbq8_1", X6 = {
  skeleton: Z6
}, ur = ({ className: t }) => /* @__PURE__ */ s("div", { className: T(t, X6.skeleton), children: " " }), Q6 = "_base_vi4q6_1", e8 = "_heading_vi4q6_8", t8 = "_xl4_vi4q6_12", n8 = "_xl3_vi4q6_17", o8 = "_xl2_vi4q6_22", r8 = "_xl_vi4q6_12", a8 = "_lg_vi4q6_32", i8 = "_md_vi4q6_37", s8 = "_sm_vi4q6_42", l8 = "_xs_vi4q6_47", bn = {
  base: Q6,
  heading: e8,
  xl4: t8,
  xl3: n8,
  xl2: o8,
  xl: r8,
  lg: a8,
  md: i8,
  sm: s8,
  xs: l8
}, c8 = (t) => {
  switch (t) {
    case "xl":
      return "h2";
    case "lg":
      return "h3";
    case "md":
      return "h4";
    case "sm":
      return "h5";
    case "xs":
      return "h6";
    default:
      return "h1";
  }
}, ls = ({ size: t = "xl", className: e, ...n }) => {
  const o = c8(t);
  return /* @__PURE__ */ s(
    o,
    {
      className: T([
        e,
        bn.base,
        bn.heading,
        // css classes should not begin with a number https://www.w3.org/TR/CSS21/syndata.html#:~:text=In%20CSS%2C%20identifiers%20(including%20element,hyphen%20followed%20by%20a%20digit.
        t === "4xl" && bn.xl4,
        t === "3xl" && bn.xl3,
        t === "2xl" && bn.xl2,
        bn[t]
      ]),
      ...n
    }
  );
}, d8 = "_header_93cd6_1", u8 = "_title_93cd6_5", f8 = "_icon_93cd6_10", h8 = "_action_93cd6_16", g8 = "_description_93cd6_20", Bn = {
  header: d8,
  title: u8,
  icon: f8,
  action: h8,
  description: g8
}, _y = ({
  children: t,
  className: e,
  icon: n,
  title: o,
  action: r,
  description: a
}) => /* @__PURE__ */ x("div", { className: e, children: [
  (o || a) && /* @__PURE__ */ x("div", { className: Bn.header, children: [
    o && /* @__PURE__ */ x("div", { className: Bn.title, children: [
      n && /* @__PURE__ */ s("div", { className: Bn.icon, children: n }),
      /* @__PURE__ */ s(ls, { size: "md", children: o }),
      r && /* @__PURE__ */ s("div", { className: Bn.action, children: r })
    ] }),
    a && /* @__PURE__ */ s(qe, { size: "sm", color: "reduced", className: Bn.description, children: a })
  ] }),
  /* @__PURE__ */ s("div", { children: t })
] }), Ry = ({
  content: t,
  copySuccessMessage: e,
  onClick: n
}) => {
  const [o, r] = Q(!1);
  return /* @__PURE__ */ x(i1, { placement: "top", open: o, children: [
    /* @__PURE__ */ s(s1, { children: /* @__PURE__ */ s(Ie, { onClick: (i) => {
      navigator.clipboard.writeText(t), e && (r(!0), setTimeout(() => {
        r(!1);
      }, bi)), n?.(i);
    }, children: /* @__PURE__ */ s(De, { size: 16, children: /* @__PURE__ */ s(La, {}) }) }) }),
    /* @__PURE__ */ s(l1, { children: e })
  ] });
}, p8 = "_miniTableRow_1qm43_1", m8 = "_labelWrapper_1qm43_12", v8 = "_contentWrapper_1qm43_17", w8 = "_contentWrapperLoading_1qm43_23", b8 = "_content_1qm43_17", y8 = "_expanded_1qm43_41", C8 = "_showMore_1qm43_46", x8 = "_showLess_1qm43_47", M8 = "_action_1qm43_65", _8 = "_compact_1qm43_77", pt = {
  miniTableRow: p8,
  labelWrapper: m8,
  contentWrapper: v8,
  contentWrapperLoading: w8,
  content: b8,
  expanded: y8,
  showMore: C8,
  showLess: x8,
  action: M8,
  default: "_default_1qm43_73",
  compact: _8
}, R8 = 60, Sy = ({
  label: t,
  description: e,
  content: n,
  action: o,
  loading: r = !1,
  size: a = "default"
}) => {
  const { t: i } = ot(), [l, c] = Q(!1), [d, u] = Q(!1), f = ye(null);
  return je(() => {
    const g = Math.ceil(
      f.current?.getBoundingClientRect().height || 0
    );
    g > 0 && c(g >= R8);
  }, []), /* @__PURE__ */ x("div", { className: T(pt.miniTableRow, pt[a]), children: [
    /* @__PURE__ */ x("div", { className: pt.labelWrapper, children: [
      /* @__PURE__ */ s(qe, { color: "reduced", children: t }),
      e && /* @__PURE__ */ s(qe, { color: "reduced", size: "sm", children: e })
    ] }),
    /* @__PURE__ */ x(
      "div",
      {
        className: T(
          pt.contentWrapper,
          r && pt.contentWrapperLoading
        ),
        children: [
          r ? /* @__PURE__ */ s(ur, {}) : /* @__PURE__ */ x(
            "div",
            {
              className: T(pt.content, d && pt.expanded),
              ref: f,
              children: [
                n,
                l && !d && /* @__PURE__ */ s(
                  "button",
                  {
                    className: pt.showMore,
                    onClick: () => u(!0),
                    children: i("minitable.row.showMoreButton")
                  }
                ),
                d && /* @__PURE__ */ s(
                  "button",
                  {
                    className: pt.showLess,
                    onClick: () => u(!1),
                    children: i("minitable.row.showLessButton")
                  }
                )
              ]
            }
          ),
          o && /* @__PURE__ */ s("div", { className: pt.action, children: o })
        ]
      }
    )
  ] });
}, S8 = "_callout_k9wrm_2", k8 = "_topAligned_k9wrm_16", D8 = "_content_k9wrm_20", A8 = "_title_k9wrm_25", O8 = "_closeButton_k9wrm_29", P8 = "_iconWrapper_k9wrm_40", N8 = "_closeIcon_k9wrm_46", E8 = "_neutral_k9wrm_53", L8 = "_icon_k9wrm_40", z8 = "_success_k9wrm_62", T8 = "_warning_k9wrm_71", I8 = "_critical_k9wrm_80", vt = {
  callout: S8,
  topAligned: k8,
  content: D8,
  title: A8,
  closeButton: O8,
  iconWrapper: P8,
  closeIcon: N8,
  neutral: E8,
  icon: L8,
  success: z8,
  warning: T8,
  critical: I8
}, B8 = m(
  ({
    variant: t = "neutral",
    title: e,
    children: n,
    hideIcon: o = !1,
    hideDismiss: r = !1
  }, a) => {
    const { t: i } = ot(), [l, c] = Q(!1), d = ye(null), [u, f] = Q(!1);
    return je(() => {
      const g = d?.current?.getBoundingClientRect().height;
      g && g > 40 && f(!0);
    }, []), l ? null : /* @__PURE__ */ x(
      "div",
      {
        ref: a,
        className: T(
          vt.callout,
          vt[t],
          u && vt.topAligned
        ),
        children: [
          !o && /* @__PURE__ */ s($8, { variant: t }),
          /* @__PURE__ */ x("div", { className: vt.content, ref: d, children: [
            e && /* @__PURE__ */ s("div", { className: vt.title, children: e }),
            /* @__PURE__ */ s("div", { children: n })
          ] }),
          !r && /* @__PURE__ */ s(
            "button",
            {
              className: vt.closeButton,
              onClick: () => c(!0),
              "aria-label": i("callout.closeButton"),
              children: /* @__PURE__ */ s(Sn, { className: vt.closeIcon })
            }
          )
        ]
      }
    );
  }
);
B8.displayName = "Callout";
const $8 = ({
  variant: t = "neutral"
}) => {
  const e = {
    className: T(vt.iconWrapper, vt.icon, vt[t]),
    "aria-label": "Callout icon"
  };
  switch (t) {
    case "success":
      return /* @__PURE__ */ s(Pa, { ...e });
    case "warning":
      return /* @__PURE__ */ s(Kf, { ...e });
    case "critical":
      return /* @__PURE__ */ s(za, { ...e });
    default:
      return /* @__PURE__ */ s(Ed, { ...e });
  }
}, H8 = "_toast_5agr4_2", F8 = "_topAligned_5agr4_16", V8 = "_content_5agr4_20", W8 = "_title_5agr4_25", j8 = "_iconWrapper_5agr4_29", q8 = "_action_5agr4_36", Y8 = "_icon_5agr4_29", U8 = "_neutral_5agr4_51", K8 = "_success_5agr4_55", G8 = "_critical_5agr4_59", At = {
  toast: H8,
  topAligned: F8,
  content: V8,
  title: W8,
  iconWrapper: j8,
  action: q8,
  icon: Y8,
  neutral: U8,
  success: K8,
  critical: G8
}, J8 = ({
  variant: t = "neutral"
}) => {
  const e = {
    className: T(At.iconWrapper, At.icon, At[t]),
    "aria-label": "Toast icon"
  };
  switch (t) {
    case "success":
      return /* @__PURE__ */ s(Pa, { ...e });
    case "critical":
      return /* @__PURE__ */ s(za, { ...e });
    default:
      return /* @__PURE__ */ s(Ta, { ...e });
  }
}, ky = ({
  variant: t = "neutral",
  title: e,
  children: n,
  actionLabel: o,
  action: r
}) => {
  const a = o && r, i = ye(null), [l, c] = Q(!1);
  return je(() => {
    const d = i?.current?.getBoundingClientRect().height;
    d && d > 40 && c(!0);
  }, []), r && !o && console.info("Toast component is missing the 'actionLabel' prop"), !r && o && console.info("Toast component is missing the 'action' prop"), /* @__PURE__ */ x(
    "div",
    {
      className: T(
        At.toast,
        At[t],
        l && At.topAligned
      ),
      children: [
        /* @__PURE__ */ s(J8, { variant: t }),
        /* @__PURE__ */ x("div", { className: At.content, ref: i, children: [
          e && /* @__PURE__ */ s("div", { className: At.title, children: e }),
          /* @__PURE__ */ s("div", { children: n })
        ] }),
        a && /* @__PURE__ */ s("button", { className: At.action, onClick: r, children: o })
      ]
    }
  );
}, Z8 = "_selectionMenu_1liqv_1", X8 = "_header_1liqv_7", Q8 = "_noCaption_1liqv_16", eb = "_search_1liqv_20", tb = "_options_1liqv_25", nb = "_footer_1liqv_32", yn = {
  selectionMenu: Z8,
  header: X8,
  noCaption: Q8,
  search: eb,
  options: tb,
  footer: nb
}, Dy = ({
  placement: t = "bottom-start",
  isOpen: e,
  setIsOpen: n
}) => {
  const [o, r] = Q(null), a = ye([]), { floatingStyles: i, refs: l, context: c } = un({
    open: e,
    onOpenChange: n,
    placement: t,
    middleware: [An({ mainAxis: 4, alignmentAxis: 0 }), Pn(), On()],
    whileElementsMounted: dn
  }), d = eo(c), u = a1(c, {
    listRef: a,
    activeIndex: o,
    onNavigate: r
  }), { getFloatingProps: f, getReferenceProps: g } = Nn([
    d,
    u
  ]);
  return {
    getReferenceProps: g,
    getFloatingProps: f,
    refs: l,
    floatingStyles: i,
    context: c,
    listRef: a
  };
}, Ay = ({
  placement: t = "bottom-start",
  isOpen: e,
  setIsOpen: n
}) => {
  const [o, r] = Q(null), a = ye([]), { floatingStyles: i, refs: l, context: c } = un({
    open: e,
    onOpenChange: n,
    placement: t,
    middleware: [An({ mainAxis: 4, alignmentAxis: 0 }), Pn(), On()],
    whileElementsMounted: dn
  }), d = eo(c), u = r1(c), f = a1(c, {
    listRef: a,
    activeIndex: o,
    onNavigate: r
  }), { getFloatingProps: g, getReferenceProps: h } = Nn([
    d,
    u,
    f
  ]);
  return {
    getReferenceProps: h,
    getFloatingProps: g,
    refs: l,
    floatingStyles: i,
    context: c,
    listRef: a
  };
}, Oy = ({
  children: t,
  fullWidth: e = !1,
  floatingStyles: n,
  refs: o,
  context: r,
  getFloatingProps: a,
  listRef: i,
  zIndex: l = Bt,
  title: c,
  caption: d,
  footer: u,
  query: f = "",
  setQuery: g,
  filterInputPlaceholder: h = ""
}) => {
  const { t: p } = ot(), v = d ? /* @__PURE__ */ s(qe, { size: "sm", color: "reduced", children: d }) : null, { open: w, onOpenChange: C } = r, { "aria-orientation": b, ...y } = a();
  return /* @__PURE__ */ s(It, { children: w && /* @__PURE__ */ s(Kt, { elementsRef: i, children: /* @__PURE__ */ s(St, { children: /* @__PURE__ */ s(
    Gt,
    {
      initialFocus: -1,
      modal: !1,
      context: r,
      children: /* @__PURE__ */ s(
        "div",
        {
          ref: o.setFloating,
          style: {
            ...n,
            zIndex: l,
            // prevents flicker if the position is not calculated yet
            opacity: n.transform ? 1 : 0,
            width: e ? o.reference.current?.getBoundingClientRect().width : void 0,
            maxWidth: e ? void 0 : 480,
            minWidth: e ? void 0 : 240
          },
          "aria-label": p("selectionmenu.label"),
          ...y,
          children: /* @__PURE__ */ x("div", { className: yn.selectionMenu, children: [
            /* @__PURE__ */ x("div", { className: yn.header, children: [
              /* @__PURE__ */ x("div", { ...d ? {} : { className: yn.noCaption }, children: [
                /* @__PURE__ */ s(ls, { size: "sm", children: c }),
                v
              ] }),
              /* @__PURE__ */ s(
                z1,
                {
                  icon: /* @__PURE__ */ s(Sn, {}),
                  variant: "plain",
                  size: "compact",
                  onClick: () => C(!1),
                  "aria-label": p("selectionmenu.closeButton", { title: c })
                }
              )
            ] }),
            g && /* @__PURE__ */ s("div", { className: yn.search, children: /* @__PURE__ */ s(
              dt,
              {
                size: "compact",
                autoFocus: !0,
                value: f,
                onChange: (M) => g(M.target.value),
                placeholder: h,
                "aria-label": p("selectionmenu.filterInput")
              }
            ) }),
            ob(t) && /* @__PURE__ */ s("div", { className: yn.options, role: "menu", children: t }),
            u && /* @__PURE__ */ s("div", { className: yn.footer, children: u })
          ] })
        }
      )
    }
  ) }) }) });
}, ob = (t) => Po.toArray(t).some((e) => e != null), rb = "_tbody_rvjpd_1", ab = "_row_rvjpd_8", ib = "_td_rvjpd_23", sb = "_button_rvjpd_33", lb = "_virtual_rvjpd_56", cb = "_childrenGrid_rvjpd_63", db = "_ellipsis_rvjpd_72", ub = "_columnHeader_rvjpd_79", fb = "_hasInteraction_rvjpd_83", hb = "_rowHasFocus_rvjpd_87", gb = "_buttonHasFocus_rvjpd_87", pb = "_compact_rvjpd_102", mb = "_thead_rvjpd_107", vb = "_th_rvjpd_107", wb = "_hasSort_rvjpd_134", bb = "_sortIcon_rvjpd_140", yb = "_isSorted_rvjpd_145", Cb = "_tfoot_rvjpd_150", xb = "_footerContent_rvjpd_158", Mb = "_pagination_rvjpd_167", _b = "_paginationRowInfo_rvjpd_175", Rb = "_paginationLeft_rvjpd_187", Sb = "_paginationRight_rvjpd_194", kb = "_paginationItems_rvjpd_199", Db = "_page_rvjpd_208", Ab = "_truncated_rvjpd_221", Ob = "_currentPage_rvjpd_225", Pb = "_mobileOnly_rvjpd_237", Nb = "_chevron_rvjpd_248", Eb = "_loadingSkeleton_rvjpd_252", ne = {
  tbody: rb,
  row: ab,
  td: ib,
  button: sb,
  virtual: lb,
  childrenGrid: cb,
  ellipsis: db,
  columnHeader: ub,
  hasInteraction: fb,
  rowHasFocus: hb,
  buttonHasFocus: gb,
  default: "_default_rvjpd_98",
  compact: pb,
  thead: mb,
  th: vb,
  hasSort: wb,
  sortIcon: bb,
  isSorted: yb,
  tfoot: Cb,
  footerContent: xb,
  pagination: Mb,
  paginationRowInfo: _b,
  paginationLeft: Rb,
  paginationRight: Sb,
  paginationItems: kb,
  page: Db,
  truncated: Ab,
  currentPage: Ob,
  mobileOnly: Pb,
  chevron: Nb,
  loadingSkeleton: Eb
}, Lb = m(
  ({
    children: t,
    onClick: e,
    loading: n = !1,
    className: o,
    hasSort: r = !1,
    isSorted: a = !1,
    ...i
  }, l) => {
    const { t: c } = ot();
    return t === null ? /* @__PURE__ */ s("div", { className: T(ne.th, o), ...i }) : /* @__PURE__ */ s("div", { className: T(ne.th, o), ...i, children: /* @__PURE__ */ s(
      Ie,
      {
        onClick: e,
        className: T(
          Wt.base,
          Wt.md,
          r && ne.hasInteraction,
          r && ne.hasSort,
          a && ne.isSorted,
          ne.default
        ),
        ref: l,
        children: n ? /* @__PURE__ */ s(ur, { className: ne.loadingSkeleton }) : /* @__PURE__ */ x("span", { className: T(ne.childrenGrid, ne.columnHeader), children: [
          /* @__PURE__ */ s("span", { className: ne.ellipsis, children: t }),
          r && Tb(a, c)
        ] })
      }
    ) });
  }
), Oo = ({
  isSorted: t,
  tooltipContent: e
}) => /* @__PURE__ */ s(i1, { children: /* @__PURE__ */ x(s1, { children: [
  /* @__PURE__ */ s(zb, { isSorted: t, className: ne.sortIcon }),
  /* @__PURE__ */ s(l1, { children: e })
] }) }), zb = ({ className: t, isSorted: e }) => {
  const n = "var(--color-content-default)", o = "var(--color-content-disabled)";
  return /* @__PURE__ */ x(
    "svg",
    {
      className: t,
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ s(
          "path",
          {
            d: "M6.38412 1.17991C6.28912 1.06591 6.1484 1 6.00001 1C5.85162 1 5.71089 1.06591 5.6159 1.17991L3.1159 4.17991C2.99169 4.32895 2.96492 4.53639 3.04721 4.71208C3.1295 4.88777 3.306 5 3.50001 5H8.50001C8.69402 5 8.87051 4.88777 8.9528 4.71208C9.03509 4.53639 9.00832 4.32895 8.88412 4.17991L6.38412 1.17991Z",
            fill: e === "asc" ? n : o
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M6.38412 10.8201C6.28912 10.9341 6.1484 11 6.00001 11C5.85162 11 5.71089 10.9341 5.6159 10.8201L3.1159 7.82009C2.99169 7.67105 2.96492 7.46361 3.04721 7.28792C3.1295 7.11223 3.306 7 3.50001 7H8.50001C8.69402 7 8.87051 7.11223 8.9528 7.28792C9.03509 7.46361 9.00832 7.67105 8.88412 7.82009L6.38412 10.8201Z",
            fill: e === "desc" ? n : o
          }
        )
      ]
    }
  );
}, Tb = (t, e) => {
  switch (t) {
    case "asc":
      return /* @__PURE__ */ s(
        Oo,
        {
          isSorted: t,
          tooltipContent: e("table.header.sortAscending")
        }
      );
    case "desc":
      return /* @__PURE__ */ s(
        Oo,
        {
          isSorted: t,
          tooltipContent: e("table.header.sortDescending")
        }
      );
    default:
      return /* @__PURE__ */ s(
        Oo,
        {
          isSorted: t,
          tooltipContent: e("table.header.sortUnsorted")
        }
      );
  }
};
Lb.displayName = "ColumnHeader";
const fr = m(
  ({
    children: t,
    hasFocus: e = !1,
    onClick: n,
    icon: o,
    chevron: r = !1,
    trailingIcon: a,
    loading: i = !1,
    className: l,
    ...c
  }, d) => {
    const u = ["string", "number"].includes(typeof t);
    return /* @__PURE__ */ s(
      Ie,
      {
        onClick: n,
        className: T(
          l,
          ne.button,
          Wt.base,
          Wt.md,
          e && !i && ne.buttonHasFocus,
          n && !i && ne.hasInteraction
        ),
        ref: d,
        ...c,
        children: i ? /* @__PURE__ */ s(ur, { className: ne.loadingSkeleton }) : /* @__PURE__ */ x("span", { className: ne.childrenGrid, children: [
          o && o,
          u ? /* @__PURE__ */ s("span", { className: ne.ellipsis, children: t }) : t,
          a && a,
          r && /* @__PURE__ */ s(De, { size: 16, className: ne.chevron, children: /* @__PURE__ */ s(Zn, {}) })
        ] })
      }
    );
  }
);
fr.displayName = "TableButton";
const cs = m(({ children: t, className: e, ...n }, o) => /* @__PURE__ */ s("div", { className: T(ne.td, e), ...n, ref: o, children: t }));
cs.displayName = "TableCell";
const Ib = m(
  ({
    children: t,
    hasFocus: e = !1,
    onClick: n,
    icon: o,
    chevron: r = !1,
    loading: a = !1,
    ...i
  }, l) => /* @__PURE__ */ s(cs, { ...i, children: /* @__PURE__ */ s(
    fr,
    {
      hasFocus: e,
      icon: o,
      chevron: r,
      ref: l,
      loading: a,
      onClick: n,
      children: t
    }
  ) })
);
Ib.displayName = "StaticTableCell";
const Bb = m(
  ({ children: t, className: e, size: n = "default", ...o }, r) => /* @__PURE__ */ s(
    "div",
    {
      ref: r,
      className: T(
        n === "compact" ? ne.compact : ne.default,
        e
      ),
      ...o,
      children: t
    }
  )
);
Bb.displayName = "Table";
const $b = m(
  ({ children: t, className: e, ...n }, o) => /* @__PURE__ */ s("div", { className: T(ne.tbody, e), ...n, ref: o, children: t })
);
$b.displayName = "TableBody";
const Py = ({
  content: t,
  copySuccessMessage: e,
  onClick: n,
  ...o
}) => {
  const [r, a] = Q(!1);
  return /* @__PURE__ */ x(i1, { placement: "top", open: r, children: [
    /* @__PURE__ */ s(s1, { children: /* @__PURE__ */ s(
      fr,
      {
        trailingIcon: /* @__PURE__ */ s(De, { size: 16, children: /* @__PURE__ */ s(La, {}) }),
        onClick: (l) => {
          navigator.clipboard.writeText(t), e && (a(!0), setTimeout(() => {
            a(!1);
          }, bi)), n?.(l);
        },
        ...o,
        children: t
      }
    ) }),
    /* @__PURE__ */ s(l1, { children: e })
  ] });
}, Ny = ({ className: t, children: e }) => /* @__PURE__ */ s("div", { className: T(ne.tfoot, t), children: /* @__PURE__ */ s("div", { className: ne.footerContent, children: e }) }), Hb = m(
  ({ children: t, className: e, ...n }, o) => /* @__PURE__ */ s("div", { className: T(ne.thead, e), ...n, ref: o, children: t })
);
Hb.displayName = "TableHeader";
const ka = 50, Fb = ({
  t,
  currentPage: e,
  totalPages: n,
  setPageIndex: o
}) => Array.from({ length: n }, (r, a) => {
  const i = a === 0, l = a + 1 === n, c = e === a, d = a === e - 1 || a === e + 1, u = a === e - 2 || a === e + 2;
  return i || l || c || d ? /* @__PURE__ */ s(
    Ie,
    {
      onClick: () => o(a),
      className: T(ne.page, c && ne.currentPage),
      "aria-label": t("table.pagination.goToPageButton", {
        page: a + 1
      }),
      children: a + 1
    },
    a
  ) : u ? (
    // biome-ignore lint/suspicious/noArrayIndexKey: numbered buttons, index is fine
    /* @__PURE__ */ s("span", { className: T(ne.page, ne.truncated), children: "…" }, a)
  ) : null;
}), Ey = ({
  additionalMobileComponent: t,
  totalRows: e = 0,
  // props below are provided by the usePaginatedTable hook
  pageSize: n = ka,
  pageIndex: o = 0,
  setPageIndex: r,
  setPageSize: a,
  getCanNextPage: i,
  getCanPreviousPage: l,
  startingRowIndex: c = 0,
  endingRowIndex: d = ka - 1
}) => {
  const { t: u } = ot(), f = 1, g = [50, 100, 200, 500], h = Math.ceil(e / n);
  return /* @__PURE__ */ x("div", { className: ne.pagination, children: [
    /* @__PURE__ */ x("div", { className: ne.paginationLeft, children: [
      /* @__PURE__ */ s(
        N6,
        {
          options: g.map((p) => /* @__PURE__ */ s(A6, { value: p, children: p }, `${p}`)),
          setSelectedOption: (p) => a(p),
          selectedOption: n,
          size: "compact"
        }
      ),
      /* @__PURE__ */ x("span", { className: ne.paginationRowInfo, children: [
        c + f,
        "-",
        d + f,
        " /",
        " ",
        e
      ] })
    ] }),
    /* @__PURE__ */ x("div", { className: ne.paginationRight, children: [
      l() && /* @__PURE__ */ s(
        Ie,
        {
          onClick: () => r(o - 1),
          "aria-label": u("table.pagination.previousPageButton"),
          children: /* @__PURE__ */ s(De, { size: 24, children: /* @__PURE__ */ s(L2, {}) })
        }
      ),
      /* @__PURE__ */ s("span", { className: ne.paginationItems, children: Fb({
        t: u,
        currentPage: o,
        totalPages: h,
        setPageIndex: r
      }) }),
      i() && /* @__PURE__ */ s(
        Ie,
        {
          onClick: () => r(o + 1),
          "aria-label": u("table.pagination.nextPageButton"),
          children: /* @__PURE__ */ s(De, { size: 24, children: /* @__PURE__ */ s(T2, {}) })
        }
      ),
      t && /* @__PURE__ */ s("span", { className: ne.mobileOnly, children: t })
    ] })
  ] });
}, Vb = m(
  ({ children: t, className: e, hasFocus: n = !1, virtual: o = !1, ...r }, a) => /* @__PURE__ */ s(
    "div",
    {
      className: T(
        ne.row,
        e,
        n && ne.rowHasFocus,
        o && ne.virtual
      ),
      ...r,
      ref: a,
      children: t
    }
  )
);
Vb.displayName = "TableRow";
const Wb = "_tag_1kqbu_1", jb = "_large_1kqbu_17", qb = "_withLeading_1kqbu_24", Yb = "_withDelete_1kqbu_33", Ub = "_withLeadingAndDelete_1kqbu_42", Kb = "_leading_1kqbu_53", Gb = "_label_1kqbu_58", Jb = "_link_1kqbu_62", Zb = "_closeButton_1kqbu_72", st = {
  tag: Wb,
  large: jb,
  withLeading: qb,
  withDelete: Yb,
  withLeadingAndDelete: Ub,
  leading: Kb,
  label: Gb,
  link: Jb,
  closeButton: Zb
}, Ly = ({
  label: t,
  href: e,
  id: n,
  leading: o,
  onDelete: r,
  size: a = "default"
}) => {
  const { t: i } = ot(), l = (u) => {
    u.preventDefault(), r?.(n ?? t);
  }, c = (() => {
    if (o && r) return st.withLeadingAndDelete;
    if (o) return st.withLeading;
    if (r) return st.withDelete;
  })(), d = /* @__PURE__ */ x(It, { children: [
    o && /* @__PURE__ */ s("div", { className: st.leading, children: o }),
    /* @__PURE__ */ s("span", { className: T(st.label, tr.ellipsis), children: t }),
    r && /* @__PURE__ */ s(
      "button",
      {
        className: st.closeButton,
        onClick: l,
        "aria-label": i("tag.removeButton", { label: t }),
        children: /* @__PURE__ */ s(De, { size: 16, children: /* @__PURE__ */ s(Sn, {}) })
      }
    )
  ] });
  return e ? /* @__PURE__ */ s(
    "a",
    {
      href: e,
      className: T(
        st.tag,
        a === "large" && st.large,
        c,
        st.link
      ),
      tabIndex: 0,
      children: d
    }
  ) : /* @__PURE__ */ s(
    "div",
    {
      className: T(st.tag, a === "large" && st.large, c),
      title: t,
      children: d
    }
  );
};
typeof window > "u" && (F.useLayoutEffect = F.useEffect);
const zy = ({ theme: t }) => (F.useLayoutEffect(() => {
  document.documentElement.setAttribute("data-theme", t);
}, [t]), null);
export {
  oy as Accordion,
  ng as ActionItem,
  ry as ActionItemDivider,
  ay as ActionItemGroup,
  wi as ActionItemMultiSelect,
  rg as ActionItemSingleSelect,
  iy as ActionMenu,
  ug as Avatar,
  wg as Badge,
  kg as Button,
  sy as ButtonGroup,
  B8 as Callout,
  or as Card,
  hy as Checkbox,
  Lb as ColumnHeader,
  my as ComboBox,
  wy as DatePicker,
  by as DateRangePicker,
  yy as DateTimePicker,
  cy as Dialog,
  dy as FilterButton,
  uy as FormField,
  fy as FormFieldValidation,
  ls as Heading,
  De as Icon,
  z1 as IconButton,
  zy as IncludeTheme,
  dt as Input,
  My as LoadingIndicator,
  ur as LoadingSkeleton,
  _y as MiniTable,
  Ry as MiniTableCopyButton,
  Sy as MiniTableRow,
  vy as MultiSelectComboBox,
  A6 as Option,
  Cy as OptionGroup,
  s6 as Password,
  gy as Radio,
  py as RadioGroup,
  d6 as Search,
  N6 as Select,
  Oy as SelectionMenu,
  Ib as StaticTableCell,
  $6 as Switch,
  Bb as Table,
  $b as TableBody,
  fr as TableButton,
  cs as TableCell,
  Py as TableCopyButton,
  Ny as TableFooter,
  Hb as TableHeader,
  Ey as TablePagination,
  Vb as TableRow,
  Ly as Tag,
  qe as Text,
  W6 as TextArea,
  xy as TimePicker,
  ky as Toast,
  i1 as Tooltip,
  l1 as TooltipContent,
  s1 as TooltipTrigger,
  ar as getLocale,
  rr as i18n,
  ty as paceColorsDark,
  ny as paceColorsLight,
  Un as useActionMenu,
  ly as useDialog,
  Dy as useSelectionMenu,
  Ay as useSelectionMenuSingleSelect,
  Li as useTooltipContext
};
